(function() {
  angular.module('onify');

  function appConfig($locationProvider) {
    // use the HTML5 History API
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: false
    });
  }

  function run($q, $rootScope, config, userService, $templateRequest, itemHtmlTemplates, getItemTemplate) {
    //load user settings
    if (Cookies.get('Auth')) {
      userService.loadUserSettings();
    }

    $rootScope.closeModal = function(modal) {
      angular.element('#' + modal).modal('hide');
    };

    $rootScope.appVersion = config.version;

    $rootScope.getPartialPath = function(path) {
      return path + '?v=' + config.version;
    };

    const shouldLoadTemplates = window.location.pathname.indexOf('/form/') === -1;

    //render default item template
    const version = '?v=' + new Date().getTime();
    let templateFiles = $('#itemTemplateFiles').val();
    if (templateFiles && shouldLoadTemplates) {
      try {
        templateFiles = JSON.parse(templateFiles);
        if (templateFiles.length) {
          const getTemplates = [];
          for (let i = 0; i < templateFiles.length; i++) {
            getTemplates.push($templateRequest(templateFiles[i].path + '/' + templateFiles[i].name + version));
          }

          $q.all(getTemplates).then((results) => {
            for (let i = 0; i < templateFiles.length; i++) {
              itemHtmlTemplates.setHtml(results[i], templateFiles[i].type, templateFiles[i].name.replace('.html', ''));
            }

            //item templates are loaded notify service
            getItemTemplate.templatesLoaded();
          });
        }
      } catch (e) {
        console.log('--error loading template files--');
        console.log(e);
      }
    }
  }

  angular
    .module('onify')
    .config(['$locationProvider', appConfig])
    .run(['$q', '$rootScope', 'config', 'userService', '$templateRequest', 'itemHtmlTemplates', 'getItemTemplate', run]);
})();

/**
 * author Christopher Blum
 *    - based on the idea of Remy Sharp, http://remysharp.com/2009/01/26/element-in-view-event-plugin/
 *    - forked from http://github.com/zuk/jquery.inview/
 */
(function (factory) {
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  var inviewObjects = [], viewportSize, viewportOffset,
    d = document, w = window, documentElement = d.documentElement, timer;

  $.event.special.inview = {
    add: function(data) {
      inviewObjects.push({ data: data, $element: $(this), element: this });
      // Use setInterval in order to also make sure this captures elements within
      // "overflow:scroll" elements or elements that appeared in the dom tree due to
      // dom manipulation and reflow
      // old: $(window).scroll(checkInView);
      //
      // By the way, iOS (iPad, iPhone, ...) seems to not execute, or at least delays
      // intervals while the user scrolls. Therefore the inview event might fire a bit late there
      //
      // Don't waste cycles with an interval until we get at least one element that
      // has bound to the inview event.
      if (!timer && inviewObjects.length) {
        timer = setInterval(checkInView, 250);
      }
    },

    remove: function(data) {
      for (var i=0; i<inviewObjects.length; i++) {
        var inviewObject = inviewObjects[i];
        if (inviewObject.element === this && inviewObject.data.guid === data.guid) {
          inviewObjects.splice(i, 1);
          break;
        }
      }

      // Clear interval when we no longer have any elements listening
      if (!inviewObjects.length) {
        clearInterval(timer);
        timer = null;
      }
    }
  };

  function getViewportSize() {
    var mode, domObject, size = { height: w.innerHeight, width: w.innerWidth };

    // if this is correct then return it. iPad has compat Mode, so will
    // go into check clientHeight/clientWidth (which has the wrong value).
    if (!size.height) {
      mode = d.compatMode;
      if (mode || !$.support.boxModel) { // IE, Gecko
        domObject = mode === 'CSS1Compat' ?
          documentElement : // Standards
          d.body; // Quirks
        size = {
          height: domObject.clientHeight,
          width:  domObject.clientWidth
        };
      }
    }

    return size;
  }

  function getViewportOffset() {
    return {
      top:  w.pageYOffset || documentElement.scrollTop   || d.body.scrollTop,
      left: w.pageXOffset || documentElement.scrollLeft  || d.body.scrollLeft
    };
  }

  function checkInView() {
    if (!inviewObjects.length) {
      return;
    }

    var i = 0, $elements = $.map(inviewObjects, function(inviewObject) {
      var selector  = inviewObject.data.selector,
        $element  = inviewObject.$element;
      return selector ? $element.find(selector) : $element;
    });

    viewportSize   = viewportSize   || getViewportSize();
    viewportOffset = viewportOffset || getViewportOffset();

    for (; i<inviewObjects.length; i++) {
      // Ignore elements that are not in the DOM tree
      if (!$.contains(documentElement, $elements[i][0])) {
        continue;
      }

      var $element      = $($elements[i]),
        elementSize   = { height: $element[0].offsetHeight, width: $element[0].offsetWidth },
        elementOffset = $element.offset(),
        inView        = $element.data('inview');

      // Don't ask me why because I haven't figured out yet:
      // viewportOffset and viewportSize are sometimes suddenly null in Firefox 5.
      // Even though it sounds weird:
      // It seems that the execution of this function is interferred by the onresize/onscroll event
      // where viewportOffset and viewportSize are unset
      if (!viewportOffset || !viewportSize) {
        return;
      }

      if (elementOffset.top + elementSize.height > viewportOffset.top &&
        elementOffset.top < viewportOffset.top + viewportSize.height &&
        elementOffset.left + elementSize.width > viewportOffset.left &&
        elementOffset.left < viewportOffset.left + viewportSize.width) {
        if (!inView) {
          $element.data('inview', true).trigger('inview', [true]);
        }
      } else if (inView) {
        $element.data('inview', false).trigger('inview', [false]);
      }
    }
  }

  $(w).on("scroll resize scrollstop", function() {
    viewportSize = viewportOffset = null;
  });

  // IE < 9 scrolls to focused elements without firing the "scroll" event
  if (!documentElement.addEventListener && documentElement.attachEvent) {
    documentElement.attachEvent("onfocusin", function() {
      viewportOffset = null;
    });
  }
}));
(function() {
  var apibaseurl = $('#apibaseurl').attr('url');
  var version  = $('#appVersion').val();
  var workspaceResultsPageSize  = $('#workspaceResultsPageSize').val();

  angular
    .module('onify')
    .constant('config', appConfig());

  function appConfig() {
    return {
      'workspaceResultsPageSize': (workspaceResultsPageSize) ? workspaceResultsPageSize : false,
      'version': (version) ? version : new Date().getTime(),
      'errorPage': 'error',
      'excludeCustomParams': ['widgets', 'itemtemplate'],
      'apiBaseUrl': apibaseurl,
      'autocompletePagesize': 5,
      'defaultItemTempalte': 'defaultitem',
      'defaultTableItemTempalte': '_default',
      'defaultItemHtmlTempalte': 'items.template',
      'defaultAutocompleteItemHtmlTempalte': 'autocomplete.items.template',
      'widgetsTemplatesPath': 'app/common/directives/widgets/custom-templates/',
      'configDirPath': 'app/config/',
      'topNavWigets': ['filters', 'selected', 'actions'],
      'templatesPath': 'app/templates',
      'dashboardGridPath': 'app/templates/dashboard/grid',
      'dashboardWidgetPath': 'app/templates/dashboard/widget',
      'dashboardElementsPath': 'app/templates/dashboard/element',
      'domElements': {
        'loader': '#loaderContainer',
        'loadMoreBookamrks': '#loadMoreBookamrks',
        'sidebar': '.sidebar',
        'searchItemsInput': '.search-items',
        'loadMoreId': '#loadMoreItems',
        'currentWorkspaceId': '#currentWorkspace',
        'localeId': '#currentLocale',
        'defaultLanguage': '#defaultLanguage',
        'appDefaultLanguage': '#appDefaultLanguage'
      }
    }
  }
})();
(function() {
  angular
    .module('onify')
    .constant('itemHtmlTemplates', itemHtmlTemplates());

  itemHtmlTemplates.$inject = [];
  function itemHtmlTemplates() {
    const defaultName = 'items.template';
    const defaultType = 'templates';
    let htmlTemplates = {};

    const setHtml = (tpl, type, name) => {
      if (!htmlTemplates[type]) {
        htmlTemplates[type] = {};
      }
      if (type) {
        htmlTemplates[type][name] = tpl;
      } else {
        htmlTemplates[defaultType][name] = tpl;
      }
    };

    const getHtml = (type, name, defaultTemplate) => {
      if (!defaultTemplate) defaultTemplate = defaultName;
      return (htmlTemplates[type] && htmlTemplates[type][name]) ? htmlTemplates[type][name] : htmlTemplates[type][defaultTemplate];
    };

    const getCustomHtml = (type, name) => {
      return (htmlTemplates[type] && htmlTemplates[type][name]) ? htmlTemplates[type][name] : false;
    };


    return {
      setHtml: setHtml,
      getHtml: getHtml,
      getCustomHtml: getCustomHtml
    }
  }
})();
(function() {
  angular
    .module('onify')
    .controller('confirmModalController', [
      '$scope',
      'locales',
      '$uibModalInstance',
      'onConfirm',
      confirmModalController]);

  function confirmModalController($scope,
                                  locales,
                                  $uibModalInstance,
                                  onConfirm) {

    $scope.confirmmessage = locales.getLocaleByKey('confirm_message');
    $scope.oktext = locales.getLocaleByKey('ok');
    $scope.canceltext = locales.getLocaleByKey('cancel');

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.ok = function() {
      onConfirm(true);
      $uibModalInstance.dismiss('cancel');
    };
  }
})();
(function () {
  angular
    .module('onify')
    .controller('formController', formController);

  formController.$inject = ['$rootScope', '$scope', '$compile', '$timeout', '$location', '$window', '$q', 'config', 'locales', 'utils', 'itemHtmlTemplates', 'itemMapping', 'getItemTemplate', 'select2Utils', 'itemsData', 'errorService', 'barcodeService', 'optionsService', 'queryStringUtils', 'taskService', 'userService', 'itemSelection', 'markdownConverter'];

  function formController ($rootScope, $scope, $compile, $timeout, $location, $window, $q, config, locales, utils, itemHtmlTemplates, itemMapping, getItemTemplate, select2Utils, itemsData, errorService, barcodeService, optionsService, queryStringUtils, taskService, userService, itemSelection, markdownConverter) {
    let vm = $scope;
    let formUpdated = false;
    let formOnSubmit = false;
    let warningModal = true;
    let showWarningModal = false;
    let disableFormPrepopulate = false;
    let requireChangeToSubmit = false;
    let summaryCalculationInProgress = false;
    let templatesLoaded = false;
    let preInitializeElements = null;
    let onClickSubmitButton = null;
    const formSerializedFieldsOrder = [];

    const pathname = window.location.pathname;
    const formSlug = pathname.substring(pathname.lastIndexOf('/') + 1); // Problem if "/" is at end
    vm.multipleItems = {};
    vm.formData = {};
    vm.preventChange = false;
    vm.preventParamChange = {};
    vm.onLoadItemsData = {};
    vm.reloadedElements = {};
    vm.loadedItems = {};
    vm.selectedItems = {};
    vm.onLoadSelectedItemsKey = {};
    vm.excludeOnLoadElements = {};
    vm.defaultFormData = null;
    vm.defaultFormUrl = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : null;
    vm.selectEvent = {};
    vm.agentTaskResultsInProgress = {};
    vm.processOutputResultsInProgress = {};
    vm.selectedItemsAndOptions = {};
    vm.excludedParameters = {};
    vm.formInitialState = null;
    vm.checkDuplicateInProgress = {};

    numeral.register('locale', 'fi', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 'k',
        million: 'M',
        billion: 'G',
        trillion: 'T'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: '€'
      }
    });

    numeral.register('locale', 'sv', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 't',
        million: 'mn',
        billion: 'md',
        trillion: 'b'
      },
      ordinal: function (number) {
        return '.';
      },
      currency: {
        symbol: 'kr'
      }
    });

    numeral.register('locale', 'da', {
      delimiters: {
          thousands: '.',
          decimal: ','
      },
      abbreviations: {
          thousand: 'k',
          million: 'mio',
          billion: 'mia',
          trillion: 'b'
      },
      ordinal: function (number) {
          return '.';
      },
      currency: {
          symbol: 'DKK'
      }
    });    

    numeral.register('locale', 'no', {
      delimiters: {
          thousands: ' ',
          decimal: ','
      },
      abbreviations: {
          thousand: 'k',
          million: 'm',
          billion: 'b',
          trillion: 't'
      },
      ordinal: function (number) {
          return '.';
      },
      currency: {
          symbol: 'kr'
      }
    });

    vm.$on('form_data_request', (event, {input, requestedBy} = {}) => {
      if (!requestedBy) return;
      let parsed = null;
      let data = null;
      let error = null;

      try {
        data = convertStringToNumbers(utils.objectMarge(vm.formData || {}, vm.selectedItemsAndOptions || {}));
      } catch (e) {
        error = e;
      }

      if (input) {
        try {
          if (Array.isArray(input)) {
            parsed = input.map((value) => {
              return itemMapping.replaceCurlies(value, data, {
                allowEmpty: true,
                singleCurlies: true,
                curliesFirst: true,
              });
            });
          } else if (utils.isObject(input)) {
            parsed = {};
            for (const key in input) {
              parsed[key] = itemMapping.replaceCurlies(input[key], data, {
                allowEmpty: true,
                singleCurlies: true,
                curliesFirst: true,
              });
            }
          } else {
            parsed = itemMapping.replaceCurlies(input, data, {
              allowEmpty: true,
              singleCurlies: true,
              curliesFirst: true,
            });
          }
        } catch (e) {
          error = e;
        }
      }

      $rootScope.$broadcast(requestedBy, {
        formData: data,
        error,
        parsed,
      });
    });

    vm.$on('trigger_form_data_change', (event, {name, data, excludeAsParameter} = {}) => {
      if (name) {
        if (excludeAsParameter) {
          vm.excludedParameters[name] = true;
        }
        vm.formData[name] = data;
      }
    });

    vm.$on('agent_task_result', (event, {type, taskid}) => {
      if (type === 'completed') {
        vm.agentTaskResultsInProgress[taskid] = false;
      }
      if (type === 'inProgress') {
        vm.agentTaskResultsInProgress[taskid] = true;
      }
    });

    vm.$on('process_output_result', (event, {type, processid}) => {
      if (type === 'completed') {
        vm.processOutputResultsInProgress[processid] = false;
      }
      if (type === 'inProgress') {
        vm.processOutputResultsInProgress[processid] = true;
      }
    });

    vm.$on('star_rating_value', (event, {name, rating}) => {
      if (name) {
        vm.formData[name] = rating;
      }
    });

    const cloneObject = function (obj) {
      try {
        return JSON.parse(JSON.stringify(obj));
      } catch (e) {
        return obj;
      }
    };

    function isFormUpdated() {
      if (!formUpdated) return false;
      let isUpdated = false;

      function isUnDefined(value) {
        return (
          value === '' ||
          value === null ||
          value === 'undefined' ||
          value === undefined
        );
      }

      function getValue(value) {
        if (isUnDefined(value)) return undefined;
        if (utils.isObject(value) || Array.isArray(value)) {
          if (Array.isArray(value) && !value.length) return undefined;
          if (utils.isObject(value) && !Object.keys(value).length) return undefined;
          return JSON.stringify(value);
        }
        return value;
      }

      for (const key in vm.formData) {
        if (key in vm.formInitialState) {
          if (
            key in vm.formInitialState &&
            getValue(vm.formInitialState[key]) !== getValue(vm.formData[key])
          ) {
            isUpdated = true;
          }
        }
        if (!(key in vm.formInitialState) && !isUnDefined(vm.formData[key])) {
          isUpdated = true;
        }
      }

      return isUpdated;
    }

    const unloadEvent = function(e) {
      if (!warningModal) return;
      if ((isFormUpdated() && !formOnSubmit) || showWarningModal || vm.taskResultsInProgress() || vm.taskResultsInProgress()) {
        const confirmationMessage = true;
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };

    function getSelectedFields (obj) {
      if (obj && utils.isObject(obj)) {
        const temp = {};
        for (const field in obj) {
          if (field === 'element') {
            continue;
          }
          temp[field] = obj[field];
        }
        return temp;
      }

      return obj;
    }

    // fix single select element value
    const selectElementValue = function(selected, single){
      if (selected && utils.isArray(selected) && selected.length === 1 && single) {
        return getSelectedFields(selected[0]);
      }
      return getSelectedFields(selected);
    };

    window.addEventListener('beforeunload', unloadEvent);

    $scope.onLoadElementChange = function (selected, name, type) {
      if (name && type && type === 'radio') {
        storeSelectedItem(selectElementValue(selected, true), name);
      }
    };

    const containsValue = function (name) {
      return (vm.formData.hasOwnProperty(name) && vm.formData[name] !== '' &&
        vm.formData[name] !== ' ' &&
        vm.formData[name] !== null &&
        vm.formData[name] !== 'undefined'
      );
    };

    $scope.elementContainsValue = function (name, contains) {
      if (contains === false || contains === 'false') {
        return (!vm.formData.hasOwnProperty(name) || !containsValue(name));
      }
      if (contains === true || contains === 'true') {
        return containsValue(name);
      }
      return (!vm.formData.hasOwnProperty(name) ||
        (vm.formData.hasOwnProperty(name) &&
          (vm.formData[name] === '' &&
            vm.formData[name] === ' ' &&
            vm.formData[name] === null &&
            vm.formData[name] === 'undefined'
          )
        ));
    };

    vm.onFormSubmit = () => {
      formOnSubmit = true;
      $timeout(() => {
        formOnSubmit = false;
      }, 100);
    };

    vm.taskResultsInProgress = () => {
      let inProgress = false;
      for (const key in vm.agentTaskResultsInProgress) {
        if (vm.agentTaskResultsInProgress.hasOwnProperty(key)) {
          if (vm.agentTaskResultsInProgress[key]) {
            inProgress = true;
          }
        }
      }
      return inProgress;
    };

    vm.taskResultsInProgress = () => {
      let inProgress = false;
      for (const key in vm.processOutputResultsInProgress) {
        if (vm.processOutputResultsInProgress.hasOwnProperty(key)) {
          if (vm.processOutputResultsInProgress[key]) {
            inProgress = true;
          }
        }
      }
      return inProgress;
    };

    vm.initFormData = (data, elementsPrefix, warning, disablePrepopulate, requireChange, autoSubmit, onClickSubmitButtonStr) => {
      const queryParams = $location.search();
      disableFormPrepopulate = (disablePrepopulate && disablePrepopulate === 'true');
      requireChangeToSubmit = (requireChange && requireChange === 'true');

      if (requireChangeToSubmit) {
        $('button[name=\'submit\']').attr('disabled', 'disabled').addClass('disabled');
      }

      onClickSubmitButton = onClickSubmitButtonStr;
      vm.requireChangeToSubmit = requireChangeToSubmit;
      warningModal = (warning && warning === 'true');
      vm.formData = {};
      if (elementsPrefix && data) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const name = key.replace(elementsPrefix, '');
            vm.formData[name] = data[key];
          }
        }
      } else {
        vm.formData = data;
      }

      $timeout(() => {
        if ((autoSubmit && autoSubmit === 'true') || (queryParams._submit && queryParams._submit === 'true')) {
          $("button[type='submit']").click();
        }
      }, 1000);
    };

    vm.initConfirmationFormData = (warning, emptyCart) => {
      warningModal = showWarningModal = (warning && warning === 'true');
      if ((emptyCart && emptyCart === 'true')) {
        itemSelection.clearCart();
      }
    };

    vm.initElementValue = (field, value) => {
      if (formSerializedFieldsOrder.indexOf(field) === -1) {
        formSerializedFieldsOrder.push(field);
      }
      if (field && value !== '') {
        if (value === 'true') {
          vm.formData[field] = true;
        } else if (value === 'false') {
          vm.formData[field] = false;
        } else {
          const array = value.split(',');
          if (array.length > 1) {
            vm.formData[field] = array;
          } else {
            vm.formData[field] = value;
          }
        }
      }

      //initialize form elements after they are visible
      $timeout(() => {
        if (templatesLoaded) {
          loadElements({ changedFields: false, reloaded: false, initializeElements: { [field]: true }});
        } else {
          if (!preInitializeElements) preInitializeElements = {};
          preInitializeElements[field] = true;
        }
      }, 10);
    };

    vm.clearFormData = () => {
      if (!formUpdated && !vm.defaultFormData) return;

      $timeout(() => {
        $('.multitagselect2, .singleselect2, .select2element, .multipleselect2element').each(function () {
          const name = $(this).attr('data-name');
          if (vm.defaultFormData.hasOwnProperty(name)) {
            $(this).select2('val', vm.defaultFormData[name]);
          } else {
            $(this).select2('val', '');
          }
        });
      }, 0);

      $timeout(() => {
        vm.preventChange = true;
        vm.formData = cloneObject(vm.defaultFormData);
        formUpdated = false;
      }, 30);

      if (disableFormPrepopulate) return;

      const origin = window.location.origin;
      const currentUrl = window.location.href.split('?');
      let url = currentUrl[0];
      if (vm.defaultFormUrl) {
        url += '?' + vm.defaultFormUrl;
      }
      $location.url(url.replace(origin, ''));
      $location.replace();
      //change url parameters
      $window.history.replaceState({path: url}, '', url);
    };

    function isnum (string) {
      return !isNaN(string * 1);
    }

    function isDefaultFormState (obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    function numeralFormat (value, format, locale) {
      if (!isNaN(value * 1) && String(value * 1) === value) {
        value *= 1;
      }
      if (!locale) locale = 'en';
      numeral.locale(locale);
      return numeral(value).format(format);
    }

    function isValidValue (value) {
      return (
        value &&
        value !== '' &&
        value !== ' ' &&
        value !== null &&
        value !== 'undefined'
      );
    }

    function excludeTableElementsFromPrePopulate(obj) {
      for (const name in obj) {
        $('[data-name='+name+']').each(function () {
          const tableElement = $(this).attr('data-identifier');
          if (tableElement) {
            delete obj[name];
          }
        });
      }
      return obj;
    }

    $scope.$watch('onSubmit', function (newData, oldData) {
      const origin = window.location.origin;
      const currentUrl = window.location.href.split('?');
      let url = currentUrl[0];
      let urlData = {};
      let newValue = {};
      let oldValue = {};
      let changedFields = {};
      let updated = false;

      if (location.search) {
        urlData = utils.queryStringToJSON(location.search);
      }

      function getValue (obj) {
        if (!obj) return {};
        return utils.objectMarge(obj.items || {}, obj.user || {});
      }

      try {
        newValue = getValue(JSON.parse(newData));
      } catch (e) {}
      try {
        oldValue = getValue(JSON.parse(oldData));
      } catch (e) {}

      for (const name in newValue) {
        changedFields[name] = newValue[name].item ? newValue[name].item : newValue[name]
        updated = true;
      }

      for (const name in oldValue) {
        if (!(name in newValue)) {
          delete urlData[name];
          updated = true;
        }
      }

      if (!updated) {
        return;
      }

      const obj = utils.objectMarge(urlData, excludeTableElementsFromPrePopulate(changedFields) || {});
      const params = utils.createUriFromObject(obj, true, vm.excludedParameters);

      if (params) {
        url += '?' + params;
      }

      $location.url(url.replace(origin, ''));
      $location.replace();
    });

    function generateSerializedData() {
      const serialized = [];
      const headers = [];

      function isUsedHeader(element) {
        for(const h of headers) {
          if ($(element).is($(h))) return true;
        }
        return false;
      }

      function isHeader(element) {
        return (
          element.is('h1') ||
          element.hasClass('h1') ||
          element.is('h2') ||
          element.hasClass('h2') ||
          element.is('h3') ||
          element.hasClass('h3') ||
          element.is('h4') ||
          element.hasClass('h4') ||
          element.is('h5') ||
          element.hasClass('h5') ||
          element.is('h6') ||
          element.hasClass('h6')
        );
      }

      function getHeader(list, element) {
        let tempHeader = null;

        for (const el of list) {
          if (isHeader($(el))) {
            tempHeader = el;
          }

          if (element.is($(el))) {
            if (tempHeader && !isUsedHeader(tempHeader)) {
              return tempHeader;
            }
            break;
          }
        }
      }

      for (const key of formSerializedFieldsOrder) {
        let el = $(`[name="${key}"]`);
        let label = null;
        let helpText = null;
        let name = null;
        let lookup = null;
        let values = null;
        let elementKey = null;
        let type = null;

        const data = {
          name: key,
          value: null
        };

        if (!el.length) {
          console.log('Element not found', key);
          continue;
        }

        const form = $(el).closest('form');
        const formGroup = $(el).closest('.form-group');
        let select2 = $(el).data('select2');

        label = $(formGroup).find(`label[for="${key}"]`).text();
        helpText = $(formGroup).find('.help-block').text();

        if (el.length > 1) {
          const elementType = $(el[0]).attr('type');
          const elementDataType = $(el[0]).attr('data-type');

          type = elementDataType || elementType;

          if (elementType === 'radio') {
            const radio = $(`input[name=${key}]:checked`);
            const value = radio.val();
            if (value === vm.formData[key]) {
              name = $(radio).closest('div').find('label').text();
            }
          }
        } else {
          const elementType = $(el).attr('type');
          const elementDataType = $(el).attr('data-type');
          type = elementDataType || elementType;

          if (type === 'checkbox' && !label) {
            label = $(el).closest('.checkbox').find('.form-check-label').text();
          }
        }

        const select2Container = $(formGroup).find('.select2element');
        if (!select2 && select2Container.length) {
          el = select2Container[0];
          select2 = $(select2Container[0]).data('select2');
        }

        const nextElement = $(el).next();
        if (!select2 && nextElement && nextElement.data('select2')) {
          el = nextElement;
          select2 = nextElement.data('select2');
        }

        if (select2 && select2.$element) {
          const selected = $(el).select2('data');

          if (selected && selected[0]) {
            // Multiple selected values
            if (select2.options.options.multiple) {
              values = [];
              selected.forEach((obj) => {
                lookup = obj.type;

                const value = {
                  value: obj.value
                };
                if (obj.text) {
                  value.name = obj.text;
                }
                if (obj.key || obj.id) {
                  value.key = obj.key || obj.id;
                }

                values.push(value);
              });

              data.value = values;
            } else {
              name = selected[0].text;
              lookup = selected[0].type;
              elementKey = selected[0].key || selected[0].id;
              data.value = {
                value: vm.formData[key],
              };
              if (name) {
                data.value.name = name;
              }
              if (elementKey) {
                data.value.key = elementKey;
              }
            }
          }


          const elementLookup = $(el).attr('data-lookup');
          if (elementLookup) {
            try {
              const l = JSON.parse(elementLookup);
              if (l.type) {
                lookup = l.type;
              }
            } catch (e) {
              // Skip
            }
          }
        }

        const headerElement = getHeader($(form).find('*'), formGroup);
        if (headerElement) {
          const header = $(headerElement).text();
          if (header && header.length > 0) {
            serialized.push({
              type: 'header',
              label: header,
            });
            headers.push(headerElement);
          }
        }

        if (!data.value) {
          data.value = {
            value: vm.formData[key],
          };
          if (name) {
            data.value.name = name.trim();
          }
        }
        if (label) {
          data.label = label.replace(' *', '');
        }
        if (helpText) {
          data.helpText = helpText;
        }
        if (lookup) {
          data.lookup = lookup;
        }
        if (type) {
          if (type === 'options') {
            type = 'option';
          }
          data.type = type;
        }

        serialized.push(data);
      }

      $('input[name=_serialized]').val(JSON.stringify(serialized));
    }

    window.generateSerializedData = generateSerializedData;

    $scope.$watch('formData', function (newData, oldData) {
      const origin = window.location.origin;
      const currentUrl = window.location.href.split('?');
      let url = currentUrl[0];

      let urlData = {};
      if (location.search) {
        urlData = utils.queryStringToJSON(location.search);
      }

      if (vm.preventChange) {
        vm.preventChange = false;
        return false;
      }

      const changedFields = {};
      let update = false;
      for (let key in newData) {
        if (newData.hasOwnProperty(key)) {
          if (oldData[key] !== newData[key] && newData[key] !== 'undefined') {
            if (!vm.excludeOnLoadElements[key]) {
              changedFields[key] = newData[key];
            }
            update = true;
            //prevent url params update for async selects
            if ($scope.preventParamChange[key]) {
              update = false;
              delete $scope.preventParamChange[key];
            }
          }
        }
      }

      vm.reloadedElements = changedFields;

      if (!update) {
        return false;
      }

      if (!vm.defaultFormData) {
        vm.defaultFormData = cloneObject(oldData);
      }

      $timeout(() => {
        $('form').validator('update');
      }, 0);

      $timeout(() => {
        loadElements({ changedFields, reloaded: true });
      }, 0);

      vm.summaryCalculation('formData');

      formUpdated = true;

      if (!vm.formInitialState) {
        vm.formInitialState = oldData;
      }
      if (vm.requireChangeToSubmit) {
        vm.requireChangeToSubmit = false;
        $('button[name=\'submit\']').prop('disabled', false).removeClass('disabled');
      }

      $timeout(() => {
        $('form').validator('update');
        if (!vm.requireChangeToSubmit && requireChangeToSubmit && isDefaultFormState(vm.defaultFormData, vm.formData)) {
          $('button[name=\'submit\']').prop('disabled', true).addClass('disabled');
        }
      }, 300);

      if (disableFormPrepopulate) return;

      const obj = utils.objectMarge(urlData, changedFields || {});
      const params = utils.createUriFromObject(obj, true, vm.excludedParameters);

      if (params) {
        url += '?' + params;
      }

      $location.url(url.replace(origin, ''));
      $location.replace();
      //change url parameters
      // window.history.pushState(null,'any', $location.absUrl());
    }, true);

    $scope.handleSubmitClick = function() {
      try {
        if (onClickSubmitButton) {
          const functions = onClickSubmitButton.split(';');
          for (const func of functions) {
            if (func) {
              const tmpFunc = new Function(func);
              tmpFunc();
            }
          }
        }
      } catch (e) {
        console.log('Failed executing function: ', e.message);
      }
    };

    const formateItem = function (item) {
      if (item.loading) return item.text;
      vm.item = item;
      const tpl = `
        <div class='select2-result-item clearfix'>
            <div ng-if="item.mapping.image" class='select2-result-item__avatar'>
                <span ng-if="item.mapping.image"><img ng-src='{{item.mapping.image}}' /> </span>
            </div>
            <div class='select2-result-item__meta'>
                <div class='select2-result-item__title option-title-content {{item.mapping.customClass}}'>
                    <div ng-if="item.mapping.customName" ng-bind-html="item.mapping.customName | prepareDescription" class="inner-detail option-title"></div>
                    <div ng-if="!item.mapping.customName" ng-bind-html="item.mapping.title | prepareDescription" class="inner-detail option-title"></div>
                </div>
                <div ng-if="item.mapping.customDescription" class='select2-result-item__description'>
                    <div ng-bind-html="item.mapping.customDescription | prepareDescription" class="inner-detail"></div>
                </div>
            </div>
        </div>
        `;
      const template = angular.element(tpl);
      const linkFunction = $compile(template);
      linkFunction(vm);
      vm.$apply();

      return template.html();
    };

    function addQueryParams (obj) {
      let params = window.location.search;

      if (params && params.indexOf('?') !== -1) {
        params = params.replace('?', '');
        params = params.split('&');

        if (params && params.length) {
          for (let i = 0; i < params.length; i++) {
            const value = params[i].split('=');

            if (value.length && value[0] && value[1]) {
              obj[value[0]] = value[1];
            }
          }
        }
      }
    }

    function prepareItemTemplate (items, options) {
      const data = [];
      let customDescription = (options['custom-description']) ? (options['custom-description']) : false;
      let customName = (options['custom-name']) ? (options['custom-name']) : false;

      if (items && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          utils.safeApply(vm, () => {
            const item = itemMapping.itemMapping(items[i]);

            const constomField = itemMapping.mapData({
              customDescription,
              customName
            }, {
              item: items[i]
            }, {
              singleCurlies: true,
              allowEmpty: true,
              curliesFirst: true
            });

            item.mapping.customDescription = constomField.customDescription;
            item.mapping.customName = constomField.customName;

            item.id = items[i].key;
            item.text = (item.mapping.customName) ? item.mapping.customName : item.mapping.title;

            data.push(item);
          });
        }
      }
      return data;
    }

    const selectDefaults = {
      tags: false,
      multiple: true,
      // tokenSeparators: [','],
      minimumInputLength: 2,
      ajax: {
        url: '/form/ondemand/' + formSlug,
        dataType: 'json',
        type: 'GET',
        data: function (params) {
          let name = this.prop('name');
          if (!name) {
            name = $(this).attr('data-name');
          }
          const queryParameters = {
            demand: name,
            searchstring: params.term
          };
          addQueryParams(queryParameters);
          return queryParameters;
        },
        processResults: function (data) {
          return {
            results: prepareItemTemplate(data, this.options.options)
          };
        }
      },
      escapeMarkup: function (markup) {
        return markup;
      },
      templateResult: formateItem,
      language: select2Utils.language()
    };

    function getCustomSelectConfig (_this) {
      const selectConfig = $(_this).attr('config');
      return (selectConfig && utils.parseJson(selectConfig)) ? utils.parseJson(selectConfig) : {};
    }

    function isIE () {
      const ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      const is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
      return is_ie;
    }

    function selectOnFocusOut (_this) {
      const originalSearch = $(_this).data('select2').$element;
      const isRequired = $(originalSearch).attr('required');
      let isReadonly = $(originalSearch).attr('data-readonly');
      const searchField = $(_this).data('select2').dataAdapter.$search;
      const self = $(_this).data('select2');
      const formGroup = $(originalSearch).closest('.form-group');
      const tableItem = $(originalSearch).closest('.table-items-container');
      const disabled = $(_this).attr('disabled');

      if (disabled) return;

      if (isReadonly !== 'true' && tableItem.length > 0) {
        isReadonly = $(tableItem).attr('data-readonly');
      }

      if (isReadonly === 'true') {
        formGroup.addClass('form-readonly-element');
        $(_this).select2('enable', false);
        self.on('focus', function () {
          self.close();
        });
        self.on('blur', function () {
          self.close();
        });
        return;
      }

      $(searchField).focusout(function () {
        if (isRequired) {
          const value = $(originalSearch).val();
          if (value && ((utils.isArray(value) && value.length > 0) || (!utils.isArray(value) && value !== ''))) {
            formGroup.removeClass('select2-has-error');
          } else {
            formGroup.addClass('select2-has-error');
          }
        } else {
          formGroup.removeClass('select2-has-error');
        }
      });

      self.on('blur', function () {
        if (isRequired) {
          const value = $(originalSearch).val();
          if (value && ((utils.isArray(value) && value.length > 0) || (!utils.isArray(value) && value !== ''))) {
            formGroup.removeClass('select2-has-error');
          } else {
            formGroup.addClass('select2-has-error');
          }
        } else {
          formGroup.removeClass('select2-has-error');
        }
      });

      self.on('close', function () {
        vm.selectEvent = {
          [self.id]: 'close'
        };
      });
      self.on('open', function () {
        $(this.dropdown.$search).attr('aria-label', function() {
          return formGroup.children('label').text();
        });
        vm.selectEvent = {
          [self.id]: 'open'
        };
      });

      self.on('focus', function () {
        if (!isIE()) {
          self.open();
        } else {
          if (!vm.selectEvent[self.id]) {
            self.open();
          }
        }
      });
    }

    function selectOnChange (_this, e) {
      const isRequired = $(_this).attr('required');
      const value = $(_this).val();
      const formGroup = $(_this).closest('.form-group');

      if (isRequired) {
        if (value && ((utils.isArray(value) && value.length > 0) ||
          (!utils.isArray(value) && value !== ''))) {
          formGroup.removeClass('select2-has-error');
        } else {
          formGroup.addClass('select2-has-error');
        }
      } else {
        formGroup.removeClass('select2-has-error');
      }

      if (e) {
        utils.safeApply($scope, () => {
          const name = $(_this).attr('name');
          const customName = $(_this).attr('data-name');
          const index = $(_this).attr('data-index');
          const identifier = $(_this).attr('data-identifier');
          let elValue = $(e.currentTarget).val();
          const selectedData = $(_this).select2('data');

          if (customName && identifier && vm.multipleItems[identifier] &&
            vm.multipleItems[identifier][index]) {
            if (vm.multipleItems[identifier][index][customName] && vm.multipleItems[identifier][index][customName].hasOwnProperty('value')) {
              //update custom fields
              if (selectedData && selectedData.length > 0 && selectedData[0]) {
                for (const key in vm.multipleItems[identifier][index][customName]) {
                  if (vm.multipleItems[identifier][index][customName].hasOwnProperty(
                    key)) {
                    if (selectedData[0][key]) {
                      vm.multipleItems[identifier][index][customName][key] = selectedData[0][key];
                    }
                  }
                }
              }

              vm.multipleItems[identifier][index][customName].value = elValue;
            } else {
              if (!utils.isObject(
                vm.multipleItems[identifier][index][customName])) {
                vm.multipleItems[identifier][index][customName] = elValue;
              }
            }
          } else {
            if (name) {
              vm.formData[name] = elValue;
            } else if (customName) {
              vm.formData[customName] = elValue;
            }
          }

          const selected = $(_this).select2('data');
          const onloadElement = $(_this).attr('data-onload-element');

          if (selected && onloadElement) {
            if (selected.length > 0) {
              if ($(_this).data('select2') && $(_this).data('select2').options.options.multiple) {
                storeSelectedItem(selected, name || customName, _this);
              } else {
                storeSelectedItem(selected[0], name || customName, _this);
              }
            } else {
              removeOnLoadItemsAndOptions(name || customName);
            }
          }
        });
      }
    }

    function storeOnLoadItemsAndOptions (name, key, options, _this) {
      const {type, workspace} = options || {};
      let isTableElement = false;
      let elementTrackBy = null;

      if (_this) {
        const identifier = $(_this).attr('data-identifier');
        elementTrackBy = $(_this).attr('data-trackby');
        isTableElement = !!(identifier);
      }

      if (name && key && type) {
        if (!vm.onLoadSelectedItemsKey[type]) {
          vm.onLoadSelectedItemsKey[type] = {};
        }
        // Table element should be array of objects
        if (isTableElement && !vm.onLoadSelectedItemsKey[type][name]) {
          vm.onLoadSelectedItemsKey[type][name] = [];
        }
        if ((type === 'items' || type === 'ondemand') && !workspace) {
          console.log('workspace not set (store items)');
        }
        if (type === 'items') {
          if (workspace) {
            if (isTableElement) {
              vm.onLoadSelectedItemsKey[type][name].push({_trackBy: elementTrackBy, item: key, workspace});
            } else {
              vm.onLoadSelectedItemsKey[type][name] = {item: key, workspace};
            }
          }
        } else if (type === 'ondemand') {
          if (workspace) {
            if (!vm.onLoadSelectedItemsKey.items) {
              vm.onLoadSelectedItemsKey.items = {};
            }
            // Table element should be array of objects
            if (isTableElement && !vm.onLoadSelectedItemsKey.items[name]) {
              vm.onLoadSelectedItemsKey.items[name] = [];
            }
            if (key && key.length > 0) {
              if (isTableElement) {
                vm.onLoadSelectedItemsKey.items[name].push({
                  _trackBy: elementTrackBy,
                  item: key,
                  workspace: workspace,
                });
              } else {
                vm.onLoadSelectedItemsKey.items[name] = {
                  item: key,
                  workspace: workspace,
                };
              }
            } else {
              delete vm.onLoadSelectedItemsKey.items[name];
            }
          }
        } else {
          vm.onLoadSelectedItemsKey[type][name] = key;
        }
        updateOnloadItemsInput();
      }
    }

    function removeOnLoadItemsAndOptions (name) {
      if (name) {
        if (vm.onLoadSelectedItemsKey.items &&
          vm.onLoadSelectedItemsKey.items[name]) {
          delete vm.onLoadSelectedItemsKey.items[name];
        }
        if (vm.onLoadSelectedItemsKey.options &&
          vm.onLoadSelectedItemsKey.options[name]) {
          delete vm.onLoadSelectedItemsKey.options[name];
        }
        delete vm.selectedItemsAndOptions[name];
        vm.summaryCalculation('formData');
        updateOnloadItemsInput();
      }
    }

    function updateOnloadItemsInput() {
      const onSubmit = utils.clone(vm.onLoadSelectedItemsKey);

      for (const type in onSubmit) {
        for (const name in onSubmit[type]) {
          if (Array.isArray(onSubmit[type][name])) {
            onSubmit[type][name] = onSubmit[type][name].map((el) => {
              // eslint-disable-next-line no-unused-vars
              const {trackBy, _trackBy, ...other} = el;
              return utils.isObject(el) ? {...other} : el;
            });
          } else if (utils.isObject(onSubmit[type][name])) {
            // eslint-disable-next-line no-unused-vars
            const {trackBy, _trackBy, ...other} = onSubmit[type][name];
            onSubmit[type][name] = {...other};
          }
        }
      }

      $('input[name=onSubmit]').val(JSON.stringify(onSubmit));
      vm['onSubmit'] = JSON.stringify(onSubmit);
    }

    function storeSelectedItem (selected, name, _this) {
      const identifier = $(_this).attr('data-identifier');
      if (!_this || (_this && !identifier)) {
        vm.selectedItemsAndOptions[name] = selected;
      }
      vm.summaryCalculation('formData');

      if (utils.isArray(selected)) {
        const items = [];
        const loadedItems = {};
        for (let i = 0; i < selected.length; i++) {
          const key = (selected[i] && selected[i].key) ? selected[i].key : false;
          if (vm.loadedItems[name] && key) {
            for (let i = 0; i < vm.loadedItems[name].length; i++) {
              if (vm.loadedItems[name][i].key === key) {
                items.push(key);
                loadedItems[key] = vm.loadedItems[name][i];
              }
            }
          }
        }

        if (items.length) {
          vm.selectedItems[name] = loadedItems;
          storeOnLoadItemsAndOptions(name, items, selected[0], _this);
        } else {
          removeOnLoadItemsAndOptions(name);
        }
      } else {
        const key = (selected && selected.key) ? selected.key : false;
        if (vm.loadedItems[name] && key) {
          for (let i = 0; i < vm.loadedItems[name].length; i++) {
            if (vm.loadedItems[name][i].key === key) {
              vm.selectedItems[name] = vm.loadedItems[name][i];
              storeOnLoadItemsAndOptions(name, key, selected, _this);
            }
          }
        } else if (selected.id === '' && selected.text === '') {
          removeOnLoadItemsAndOptions(name);
        }
      }
    }

    function appendSelect2Value (_this) {
      const dataValue = $(_this).attr('data-value');
      const dataLabel = $(_this).attr('data-label');
      if (dataValue && dataLabel) {
        if (dataLabel.indexOf('{{') === -1 && dataValue.indexOf('{{') === -1) {
          $(_this).append('<option selected="selected" value="' + dataValue + '">' +
            dataLabel + '</option>');
        }
      }
    }

    function stripString (string) {
      const div = document.createElement('div');
      div.innerHTML = string;
      return div.textContent || div.innerText || '';
    }

    function multitagselect2 () {
      //multitag select2 elements
      $('.multitagselect2').each(function () {
        appendSelect2Value(this);

        $(this).select2(angular.extend(
          {},
          selectDefaults,
          getCustomSelectConfig(this),
        ));

        //on change if select does not have value show error
        $(this).on('change', function (e) {
          const _this = $(this);
          setTimeout(function () {
            const searchField = _this.data('select2').dataAdapter.$search;
            searchField.val(stripString(searchField.val()));
            const selection = _this.data('select2').$selection;

            $(selection).find('.select2-selection__choice').each(function () {
              $(this).attr('title', stripString($(this).attr('title')));
            });
          }, 0);
          selectOnChange(this, e);
        });

        //on tab if select does not have value show error
        selectOnFocusOut(this);
      });
    }

    function singleselect2 () {
      $('.singleselect2').each(function () {
        appendSelect2Value(this);
        $(this).select2(angular.extend(
          {},
          selectDefaults,
          {maximumSelectionLength: 1},
          getCustomSelectConfig(this),
        ));

        //on change if select does not have value show error
        $(this).on('change', function (e) {
          selectOnChange(this, e);
        });

        //on tab if select does not have value show error
        selectOnFocusOut(this);
      });
    }

    function defaultsingleselect2 () {
      $('.defaultsingleselect2').select2();
    }

    function checkIfItemExists (_this, value) {
      const workspace = _this.attr('data-workspace');
      let term = _this.attr('data-term');

      if (workspace && term) {
        term = itemMapping.parseFields(term,
          {searchtext: utils.getEscapedString(value.toLowerCase())}, {
            singleCurlies: true,
          });

        itemsData.items(vm, workspace, {term: term}).success((result) => {
          _this.attr('data-item-exists', result.records.length);
          const formGroup = _this.closest('.form-group');

          if (result.records.length > 0) {
            formGroup.addClass('has-error has-danger error-item-exist');
          } else {
            formGroup.removeClass('has-error has-danger error-item-exist');
          }
        }).error((error) => {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        });
      }
    }

    function checkifitemexistselement () {
      const checkifitemexistselement = $('.checkifitemexists');
      checkifitemexistselement.typeWatch({
        allowSubmit: false,
        captureLength: 1,
        wait: 400,
        callback: function (value) {
          const _this = $(this);
          checkIfItemExists(_this, value);
        },
      });

      checkifitemexistselement.each(function () {
        const _this = $(this);
        const value = _this.val();
        if (value) {
          checkIfItemExists(_this, value);
        }
      });
    }

    function getOptionsConfig (_this) {
      const config = {};
      config.tags = $(_this).attr('data-tags');
      config.sort = $(_this).attr('data-sort');
      config.showDescription = $(_this).attr('data-show-description');
      config.keyField = $(_this).attr('data-key-field');
      return config;
    }

    function getOptionsData (config, result) {
      const {showDescription, keyField} = config;
      const data = [];
      result.records.map((option) => {
        let key = (option.value) ? option.value : option.key;
        if (keyField && option[keyField]) {
          key = option[keyField];
        }

        data.push(utils.objectMarge(option, {
          id: key,
          text: option.name,
          description: (showDescription) ? option.description : '',
          optionValue: true,
          key: option.key,
          type: 'options',
        }));
      });
      return data;
    }

    function optionsTemplateFormat (data) {
      if (!data.optionValue && !data.loading) {
        return;
      }
      if (data.loading || !data.id) return data.text;
      let description = '';
      if (data.description) {
        description = '<span class="option-description">' + data.description +
          '</span>';
      }
      return '<div class="single-option"><span class="option-title">' +
        data.text + '</span>' + description + '</div>';
    }

    function optionsSimpleSelect () {
      $('.options-simple-select').each(function () {
        appendSelect2Value(this);

        const _this = this;
        const optionConfig = getOptionsConfig(_this);
        const {tags, sort} = optionConfig;
        const params = {};

        if (sort) {
          const sortValue = sort.split(',');
          params.sort = sortValue[0];
          if (sortValue[1]) {
            params.sortby = sortValue[1];
          }
        }

        optionsService.get(params, tags).success((result) => {
          $(_this).select2({
            data: getOptionsData(optionConfig, result),
            templateResult: optionsTemplateFormat,
            escapeMarkup: function (m) {
              return m;
            },
            language: select2Utils.language(),
          });
          //on change if select does not have value show error
          $(_this).on('change', function (e) {
            selectOnChange(_this, e);
          });
          //on tab if select does not have value show error
          selectOnFocusOut(_this);
        }).error((error) => {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        });
      });
    }

    function optionsSearchSelect () {
      $('.options-search-select').each(function () {
        appendSelect2Value(this);

        const _this = this;
        const optionConfig = getOptionsConfig(_this);
        const {tags, sort} = optionConfig;

        const url = `${config.apiBaseUrl}/my/options/tags/${tags}`;
        $(this).select2({
          tags: false,
          multiple: false,
          // tokenSeparators: [','],
          minimumInputLength: 2,
          ajax: {
            url: url,
            dataType: 'json',
            type: 'GET',
            headers: {
              Authorization: Cookies.get('Auth'),
            },
            data: function (params) {
              if (sort) {
                const sortValue = sort.split(',');
                params.sort = sortValue[0];
                if (sortValue[1]) {
                  params.sortby = sortValue[1];
                }
              }
              return params;
            },
            processResults: function (data) {
              return {
                results: getOptionsData(optionConfig, data),
              };
            },
          },
          escapeMarkup: function (m) {
            return m;
          },
          templateResult: optionsTemplateFormat,
          language: select2Utils.language(),
        });

        //on change if select does not have value show error
        $(this).on('change', function (e) {
          selectOnChange(this, e);
        });

        //on tab if select does not have value show error
        selectOnFocusOut(this);
      });
    }

    function datetimepicker() {
      $('.datetimepicker').each(function() {
        const dataFields = ['maxDate', 'minDate'];
        const dataOptions = $(this).data();
        /**
         * Date and time picker
         * @type {{icons: {time: string, date: string, up: string, down: string, previous: string, next: string, today: string, clear: string, close: string}}}
         */
        var datePickerOptions = {
          icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-angle-up',
            down: 'fa fa-angle-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-circle',
            clear: 'fa fa-trash',
            close: 'fa fa-minus-circle',
          },
        };

        const tooltips = locales.getLocaleObjectByKey(
          'app.datetimepicker.tooltips');
        let datetimepickerLocale = locales.getLocaleObjectByKey(
          'app.datetimepicker.locale');
        if (tooltips) {
          datePickerOptions.tooltips = tooltips;
        }

        if ('weekStart' in dataOptions) {
          if (!datetimepickerLocale) datetimepickerLocale = {};
          datetimepickerLocale.week = { dow: dataOptions.weekStart };
        }
        if (datetimepickerLocale) {
          moment.updateLocale('en', datetimepickerLocale);
        }

        dataFields.forEach((field) => {
          if (field in dataOptions) {
            datePickerOptions[field] = dataOptions[field];
          }
        });

        $(this).datetimepicker(datePickerOptions).on('dp.change', function() {
          $(this).trigger('change');
        });
      });
    }

    //onload and ondemand elements

    function getElementConfig (_this) {
      let preSelected;
      let lookup = $(_this).attr('data-lookup');
      const name = $(_this).attr('data-name');
      const loaded = $(_this).attr('data-loaded');
      let selected = $(_this).attr('data-selected');
      const value = $(_this).attr('data-value');
      const label = $(_this).attr('data-label');
      const formTableName = $(_this).attr('data-identifier');
      const formTableIndex = $(_this).attr('data-index');

      if (value && label) {
        preSelected = {
          value: value,
          label: label,
        };
        selected = value;
      }

      if (lookup) {
        try {
          lookup = JSON.parse(lookup);

          if (loaded && !lookup.reload) {
            return {};
          }
          if (loaded && vm.reloadedElements[name]) {
            return {};
          }
          return {
            name: name,
            lookup: lookup,
            selected: selected,
            loaded: loaded,
            preSelected: preSelected,
            formTableName,
            formTableIndex,
          };
        } catch (e) {
          console.log(e);
          return {};
        }
      } else {
        return {};
      }
    }

    function addSelectedValue (_this, config) {
      const {name, options, selected, type, loaded, lookupType, lookupWorkspace} = config ||
      {};
      let selectedItem = '';
      if (selected && options) {
        for (let i = 0; i < options.length; i++) {
          if (options[i].id === selected || options[i].text === selected) {
            selectedItem = options[i];
          }
        }
      }

      if (selectedItem) {
        if (type === 'select') {
          $(_this).find('option').each(function () {
            if ($(this).text() === '') {
              $(this).remove();
            }
          });
        }
        $timeout(() => {
          if (vm.formData[name] !== selectedItem.id) {
            $scope.preventParamChange[name] = true;
          }
          if (type === 'radio') {
            vm.formData[name] = selectedItem.id;
          }
          if (type === 'select') {
            $(_this).val(selectedItem.id).change();
          }

          const identifier = $(_this).attr('data-identifier');
          if (!identifier) {
            vm.selectedItemsAndOptions[name] = selectedItem;
          }

          vm.summaryCalculation('formData');
          storeOnLoadItemsAndOptions(name, selectedItem.key, {type: lookupType, workspace: lookupWorkspace}, _this);
        }, 0);
      } else {
        if (loaded) {
          $(_this).removeAttr('data-selected');
          vm.formData[name] = null;
          removeOnLoadItemsAndOptions(name);
        }
      }
    }

    function defaultLookupResult (result) {
      const value = '{item.key}';
      const label = '{item.name}';
      if (!result) {
        return {
          value: value,
          label: label,
        };
      }
      if (result) {
        if (!result.value) {
          result.value = value;
        }
        if (!result.label) {
          result.label = label;
        }
      }
      return result;
    }

    function replaceCurlies (query, obj) {
      if (query && utils.isString(query)) {
        const temp = [];
        query = query.split('&');
        for (let i = 0; i < query.length; i++) {
          const result = itemMapping.replaceCurlies(query[i], obj, {
            allowEmpty: true,
            singleCurlies: true,
            curliesFirst: true,
          });
          if (result) {
            temp.push(result);
          }
        }
        if (temp.length > 0) {
          query = temp.join('&');
        } else {
          query = '';
        }
      } else if (query && utils.isArray(query)) {
        const temp = [];
        for (let i = 0; i < query.length; i++) {
          const result = itemMapping.replaceCurlies(query[i], obj, {
            allowEmpty: true,
            singleCurlies: true,
            curliesFirst: true,
          });
          if (result) {
            temp.push(result);
          }
        }
        return temp;
      }
      return query;
    }

    function select2elementTemplateFormat (data) {
      if (data.loading || !data.id) return data.text;
      let description = '';
      if (data.description) {
        description = '<span class="option-description">' + data.description +
          '</span>';
      }
      return '<div class="single-option ' + (data.class ? data.class : '') +
        '"><span class="option-title">' + data.text + '</span>' + description +
        '</div>';
    }

    function getSelectedElements () {
      return utils.objectMarge(vm.formData, vm.selectedItems);
    }

    function onLoadItems (_this, lookup, name, init) {
      const type = lookup.type;
      const deferred = $q.defer();
      const data = convertStringToNumbers(utils.objectMarge(vm.formData || {}, vm.selectedItemsAndOptions || {}));
      data.element = getSelectedElements();

      lookup.query = replaceCurlies(lookup.query, data);
      const params = (lookup.query) ? utils.queryStringToJSON(lookup.query) : {};
      if (!params.term) {
        params.term = '*';
      }
      if (lookup.term) {
        params.term = lookup.term;
      }

      params.term = itemMapping.replaceCurlies(params.term, data, {
        allowEmpty: true,
        singleCurlies: true,
        curliesFirst: true,
      });

      if (lookup.sort) {
        params.sort = lookup.sort;
      }
      if (params.sort) {
        params.sort = itemsSort(params.sort);
      }
      if (!params.sort) {
        params.sort = 'name.lower,asc';
      }
      if (lookup.pagesize) {
        params.pagesize = lookup.pagesize;
      }
      if (!params.pagesize) {
        params.pagesize = '50';
      }
      //used by user type
      if (lookup.roles) {
        if (utils.isArray(lookup.roles)) {
          params.roles = lookup.roles.join(',');
        } else {
          params.roles = lookup.roles;
        }
      }
      let request;

      if (type === 'item') {
        request = itemsData.items(vm, lookup.workspace, params);
      } else if (type === 'user') {
        request = userService.getMyUsers(params);
      }

      request.success((result) => {
        const options = [];
        vm.loadedItems[name] = result.records;
        for (let i = 0; i < result.records.length; i++) {
          const data = itemMapping.mapData(
            cloneObject(defaultLookupResult(lookup.result)),
            {item: result.records[i]}, {
              singleCurlies: true,
              allowEmpty: true,
              curliesFirst: true,
            });

          options.push(utils.objectMarge(result.records[i], {
            id: data.value,
            text: data.label,
            class: data.class,
            description: data.description,
            key: result.records[i].key,
            type: type === 'item' ? 'items' : type,
            workspace: lookup.workspace,
          }));
        }

        const resultData = {
          options: options,
          name: name,
          lookup: lookup,
          this: _this
        };

        deferred.resolve(resultData);

        if (init) {
          select2elementInit(resultData);
        }
      }).error((error) => {
        errorService.save(error).success(() => {
          window.location.href = config.errorPage;
        });
      });

      return deferred.promise;
    }

    function onLoadOptions (_this, lookup, name, init) {
      const deferred = $q.defer();

      const params = {
        pagesize: (lookup.pagesize) ? lookup.pagesize : 50,
      };

      if (lookup.sort) {
        const sortValue = lookup.sort.split(',');
        params.sort = sortValue[0];
        if (sortValue[1]) {
          params.sortby = sortValue[1];
        }
      } else {
        params.sort = 'name';
        params.sortby = 'asc';
      }

      const data = convertStringToNumbers(utils.objectMarge(vm.formData || {}, vm.selectedItemsAndOptions || {}));
      data.element = getSelectedElements();

      lookup.tag = replaceCurlies(lookup.tag, data);

      if (lookup.term) {
        params.term = itemMapping.replaceCurlies(lookup.term, data, {
          allowEmpty: true,
          singleCurlies: true,
          curliesFirst: true,
        });
      }

      optionsService.get(params, lookup.tag.join(',')).success((result) => {
        vm.loadedItems[name] = result.records;
        const options = getOptionsData(lookup, result);
        const resultData = {
          options: options,
          name: name,
          lookup: lookup,
          this: _this
        };

        deferred.resolve(resultData);

        if (init) {
          select2elementInit(resultData);
        }
      }).error((error) => {
        errorService.save(error).success(() => {
          window.location.href = config.errorPage;
        });
      });

      return deferred.promise;
    }

    function addPreSelected (options, preSelected) {
      if (preSelected && options) {
        let found = false;
        for (let i = 0; i < options.length; i++) {
          if (options[i].id === preSelected.value) {
            found = true;
          }
        }
        if (!found) {
          options.push({
            id: preSelected.value,
            text: preSelected.label,
          });
        }
      }
      return options;
    }

    function addSelectedValues (_this, options, selected, name) {
      if (selected && options) {
        const found = [];
        for (let i = 0; i < options.length; i++) {
          for (let j = 0; j < selected.length; j++) {
            if (options[i].id === selected[j]) {
              found.push(selected[j]);
            }
          }
        }
        if (found.length) {
          $(_this).val(found).trigger('change.select2');
          const selected = $(_this).select2('data');
          if (selected) {
            storeSelectedItem(selectElementValue(selected, !$(_this).data('select2').options.options.multiple), name, _this);
          }
        }
      }
    }

    function select2elementInit (result) {
      const _this = result.this;
      const {lookup, name, selected, loaded, preSelected, formTableName, formTableIndex} = getElementConfig(_this);
      const data = utils.isArray(vm.formData[name]) ? vm.formData[name] : [vm.formData[name]];

      if (!lookup) return;

      $(_this).attr('data-loaded', true);
      result.options = addPreSelected(result.options, preSelected);

      const config = angular.extend(
        {},
        {
          data: result.options,
          allowClear: true,
          placeholder: ' ',
          dropdownCssClass: (lookup.search) ? '' : 'hide-search',
          templateResult: lookup.type === 'option' ? optionsTemplateFormat : select2elementTemplateFormat,
          escapeMarkup: function (m) {
            return m;
          },
          language: select2Utils.language(),
        },
        getCustomSelectConfig(_this),
      );

      const select2Init = $(_this).data('select2');

      if (select2Init)
      {
        $(_this).select2().empty();
        $(_this).select2('destroy');
        $(_this).select2(config);
        $(_this).val(data).trigger('change.select2');
      } else {
        $(_this).select2(config);
      }

      let selectedValues = null;

      if (formTableName) {
        if (vm.multipleItems[formTableName] && vm.multipleItems[formTableName][formTableIndex]) {
          const tableElementValue = vm.multipleItems[formTableName][formTableIndex][name];
          if (tableElementValue) {
            selectedValues = utils.isArray(tableElementValue) && tableElementValue.length ? tableElementValue : [tableElementValue];
          }
        }
      } else {
        if (vm.formData[name]) {
          selectedValues = utils.isArray(vm.formData[name]) && vm.formData[name].length ? vm.formData[name] : [vm.formData[name]];
        }
      }

      if (selectedValues) {
        addSelectedValues(_this, result.options, selectedValues, name);
      }

      //on change if select does not have value show error
      $(_this).on('change', function (e) {
        selectOnChange(_this, e);
      });
      //on tab if select does not have value show error
      selectOnFocusOut(_this);

      if (!select2Init){
        addSelectedValue(_this, {
          name,
          options: result.options,
          selected,
          loaded,
          type: 'select',
        });
      }
    }

    function select2element(options) {
      const {changedFields, initializeElements, skipElements} = options || {};
      const promises = [];

      $('.select2element').each(function() {
        const _this = this;
        const {lookup, name} = getElementConfig(this);
        let loadElement = true;

        if (skipElements && skipElements[name]) {
          return;
        }

        if (!initializeElements && changedFields && changedFields.hasOwnProperty(name)) {
          loadElement = false;
        }

        //initialize only elements that are in the object
        if (initializeElements && !(name in initializeElements)) {
          loadElement = false;
        }

        if (lookup && !lookup.reload && loadElement) {
          $(_this).attr('data-onload-element', true);

          if (lookup.type === 'item' || lookup.type === 'user') {
            promises.push(onLoadItems(_this, lookup, name, true));
          } else if (lookup.type === 'option') {
            promises.push(onLoadOptions(_this, lookup, name, true));
          }
        }
      });

      $q.all(promises).then(() => {
        $('.select2element').each(function () {
          const _this = this;
          const {lookup, name} = getElementConfig(this);
          let loadElement = true;

          if (!initializeElements && changedFields && changedFields.hasOwnProperty(name)) {
            loadElement = false;
          }

          //initialize only elements that are in the object
          if (initializeElements && !(name in initializeElements)) {
            loadElement = false;
          }

          if (lookup && lookup.reload && loadElement) {
            $timeout(() => {
              $(_this).attr('data-onload-element', true);

              if (lookup.type === 'item' || lookup.type === 'user') {
                onLoadItems(_this, lookup, name).then((result) => {
                  select2elementInit(result);
                });
              } else if (lookup.type === 'option') {
                onLoadOptions(_this, lookup, name).then((result) => {
                  select2elementInit(result);
                });
              }
            }, 20);
          }
        });
      });
    }

    function itemsSort (sort) {
      const fields = {
        key: 'key',
        name: 'name.lower',
        status: 'status.lower',
      };
      if (!sort) return sort;
      let temp = sort.split(',');
      const sortType = temp[1] ? temp[1] : 'asc';
      for (const key in fields) {
        if (fields.hasOwnProperty(key)) {
          if (key === temp[0] || key === temp) {
            return `${fields[key]},${sortType}`;
          }
        }
      }
      return sort;
    }

    function getOndemandQuery (_this, term) {
      let lookup = $(_this).attr('data-lookup');
      if (lookup) {
        try {
          lookup = JSON.parse(lookup);
          if (!lookup.query) {
            lookup.query = 'term={searchstring}';
          }
          const obj = utils.queryStringToJSON(lookup.query);
          if (lookup.pagesize) {
            obj.pagesize = lookup.pagesize;
          }
          if (!obj.pagesize) {
            obj.pagesize = 50;
          }
          if (lookup.sort) {
            obj.sort = lookup.sort;
          }
          if (obj.sort) {
            obj.sort = itemsSort(obj.sort);
          }
          if (!obj.sort) {
            obj.sort = 'name.lower,asc';
          }
          if (!obj.term) {
            obj.term = '*';
          }
          if (lookup.term) {
            obj.term = lookup.term;
          }
          //used by user type
          if (lookup.roles) {
            if (utils.isArray(lookup.roles)) {
              obj.roles = lookup.roles.join(',');
            } else {
              obj.roles = lookup.roles;
            }
          }

          lookup.query = utils.createUriFromObject(obj);

          const data = convertStringToNumbers(utils.objectMarge(vm.formData || {}, vm.selectedItemsAndOptions || {}));
          data.searchstring = term;

          return itemMapping.replaceCurlies(lookup.query, data,
            {
              singleCurlies: true,
              allowEmpty: true,
              curliesFirst: true,
            });
        } catch (e) {
          console.log(e);
        }
      }
      return '';
    }

    function onDemandTemplate (items, lookup) {
      const data = [];
      if (items && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          utils.safeApply(vm, () => {
            const item = itemMapping.itemMapping(items[i]);
            const constomField = itemMapping.mapData(
              defaultLookupResult(lookup.result), {item: items[i]}, {
                singleCurlies: true,
                allowEmpty: true,
                curliesFirst: true,
              });
            item.mapping.customClass = (constomField.class)
              ? constomField.class
              : '';
            item.mapping.customName = constomField.label;
            item.mapping.customDescription = (constomField.description)
              ? constomField.description
              : '';
            item.id = (constomField.value) ? constomField.value : items[i].key;
            item.text = (item.mapping.customName)
              ? item.mapping.customName
              : item.mapping.title;
            data.push(utils.objectMarge(items[i], item));
          });
        }
      }
      return data;
    }

    function getOndemandApiUrl (lookup) {
      let url = config.apiBaseUrl + '/my/items/' + lookup.workspace;
      if (lookup.type === 'user') {
        url = config.apiBaseUrl + '/my/users';
      }
      return url;
    }

    function getOndemandOptons (lookup, name) {
      const url = getOndemandApiUrl(lookup, name);
      const type = lookup.type;

      return {
        tags: false,
        multiple: true,
        // tokenSeparators: [','],
        minimumInputLength: 2,
        ajax: {
          url: url,
          dataType: 'json',
          headers: {
            'Authorization': Cookies.get('Auth'),
            'Content-Type': 'application/json',
          },
          type: 'GET',
          data: function (params) {
            return getOndemandQuery(this, params.term, type);
          },
          processResults: function (data) {
            if (type === 'user') {
              data.records.map((user) => {
                user.title = user.name;
              });
            }
            vm.loadedItems[name] = data.records;
            return {
              results: onDemandTemplate(data.records, lookup, type),
            };
          },
        },
        escapeMarkup: function (markup) {
          return markup;
        },
        templateResult: formateItem,
        language: select2Utils.language(),
      };
    }

    function multipleselect2element (options) {
      const {changedFields, skipElements, skipAlreadyLoaded} = options || {};
      function filterSelected(data, selected) {
        if (!data.length) {
          return [];
        }
        if (selected) {
          for (let i = 0; i < selected.length; i++) {
            let found = false;
            for (let j = 0; j < data.length; j++) {
              if (data[j].id === selected[i]) {
                found = true;
              }
            }
            if (!found) {
              selected.splice(i, 1);
            }
          }
        }
        return selected;
      }

      $('.multipleselect2element').each(function () {
        const _this = this;
        const {lookup, name, loaded, formTableName} = getElementConfig(this);
        const skipRecreatingSelectElement = loaded && (skipAlreadyLoaded || formTableName);

        if (changedFields && changedFields.hasOwnProperty(name)) {
          return;
        }
        if (skipElements && skipElements[name]) {
          return;
        }

        if (lookup) {
          if (lookup.type === 'item' || lookup.type === 'user') {
            $(_this).attr('data-loaded', true);
            vm.excludeOnLoadElements[name] = true;
            //data: [{id: 'test-company01', text: 'Test'}],
            const options = angular.extend(
              {},
              getOndemandOptons(lookup, name),
              getCustomSelectConfig(this),
            );

            let select;

            if (!skipRecreatingSelectElement) {
              select = $(this).select2(options);
            }

            //load selected item data
            if (vm.formData[name]) {
              const data = utils.isArray(vm.formData[name]) ? vm.formData[name] : [vm.formData[name]];
              const promises = [];
              for (let i = 0; i < data.length; i++) {
                if (isValidValue(data[i])) {
                  const params = {term: `key:"${data[i]}"`};
                  if (lookup.type === 'item') {
                    promises.push(itemsData.items(vm, lookup.workspace, params));
                  } else if (lookup.type === 'user') {
                    promises.push(userService.getMyUsers(params));
                  }
                }
              }

              if (promises.length) {
                $q.all(promises).then((result) => {
                  const records = [];
                  for (let i = 0; i < result.length; i++) {
                    if (result[i].data.records.length) {
                      records.push(result[i].data.records[0]);
                    }
                  }
                  if (lookup.type === 'user') {
                    records.map((user) => {
                      user.title = user.name;
                    });
                  }
                  vm.loadedItems[name] = records;

                  if (select) {
                    select.select2('destroy');
                  }

                  if (records.length) {
                    const identifier = $(_this).attr('data-identifier');
                    if (!identifier) {
                      vm.selectedItemsAndOptions[name] = records;
                    }
                    vm.summaryCalculation('formData');
                  }

                  options.data = onDemandTemplate(records, lookup);
                  const selected = filterSelected(options.data, data);

                  $(this).select2(options);
                  $(this).val(selected).trigger('change.select2');

                  vm.formData[name] = selected.join(',');
                  updateOnLoadMultiSelectedItems(_this, lookup, name);
                }).catch((error) => {
                  errorService.save(error).success(() => {
                    window.location.href = config.errorPage;
                  });
                });
              }
            }

            //on change if select does not have value show error
            $(_this).on('change', function (e) {
              const _self = $(this);
              $timeout(() => {
                const selection = _self.data('select2').$selection;
                $(selection).find('.select2-selection__choice').each(function () {
                  $(this).attr('title', stripString($(this).attr('title')));
                });

                updateOnLoadMultiSelectedItems(_self, lookup, name);
              }, 0);

              selectOnChange(this, e);
            });

            //on tab if select does not have value show error
            selectOnFocusOut(this);
          }
        }
      });
    }

    function updateOnLoadMultiSelectedItems (_this, lookup, name) {
      const selected = $(_this).select2('data');
      if (selected) {
        const items = [];
        for (let i = 0; i < selected.length; i++) {
          if (selected[i].mapping) {
            items.push(selected[i].mapping.key);
          }
        }

        if (items && items.length > 0 && vm.loadedItems[name]) {
          const identifier = $(_this).attr('data-identifier');
          if (!identifier) {
            for (let i = 0; i < vm.loadedItems[name].length; i++) {
              if (vm.loadedItems[name][i].key === items[0]) {
                vm.selectedItemsAndOptions[name] = vm.loadedItems[name][i];
                break;
              }
            }
          }
        } else {
          delete vm.selectedItemsAndOptions[name];
        }

        vm.summaryCalculation('formData');
        storeOnLoadItemsAndOptions(name, items, {
          workspace: lookup.workspace,
          type: (lookup.type === 'item') ? 'ondemand' : lookup.type,
        }, _this);
      }
    }

    function onLoadRadioElement (options) {
      const { changedFields, skipElements } = options || {};
      $('.radio-element-content').each(function () {
        const _this = this;
        const {lookup, name, selected, loaded} = getElementConfig(this);

        if (changedFields && changedFields.hasOwnProperty(name)) {
          return false;
        }
        if (skipElements && skipElements[name]) {
          return;
        }

        if (lookup) {
          if (lookup.type === 'item') {
            //vm.excludeOnLoadElements[name] = true;
            onLoadItems(_this, lookup, name).then((result) => {
              $(_this).attr('data-loaded', true);
              vm.onLoadItemsData[name] = result.options;
              addSelectedValue(_this, {
                name,
                options: result.options,
                selected,
                loaded,
                type: 'radio',
                lookupType: 'items',
                lookupWorkspace: lookup.workspace,
              });
            });
          } else if (lookup.type === 'option') {
            //vm.excludeOnLoadElements[name] = true;
            onLoadOptions(_this, lookup, name).then((result) => {
              $(_this).attr('data-loaded', true);
              vm.onLoadItemsData[name] = result.options;
              addSelectedValue(_this, {
                name,
                options: result.options,
                selected,
                loaded,
                type: 'radio',
                lookupType: 'options',
              });
            });
          }
        }
      });
    }

    //load hidden lookup
    hiddenLookup();

    function hiddenLookup () {
      $('.hidden-lookup').each(function () {
        const {lookup, name} = getElementConfig(this);

        if (lookup) {
          if (lookup.type === 'item') {
            lookup.type = 'items';
            storeOnLoadItemsAndOptions(name, lookup.value, lookup, this);
          } else if (lookup.type === 'option') {
            lookup.type = 'options';
            storeOnLoadItemsAndOptions(name, lookup.value, lookup, this);
          }
        }
      });
    }

    function loadElements (options) {
      const { reloaded } = options || {};
      //single select2 elements
      singleselect2();
      //multitag select2 elements
      multitagselect2();
      //default select 2
      defaultsingleselect2();

      //check if item exists element
      checkifitemexistselement();

      //options simple select
      optionsSimpleSelect();
      //options search select
      optionsSearchSelect();

      //date picker element
      datetimepicker();

      select2element(options);
      multipleselect2element(options);
      onLoadRadioElement(options);

      initTextInputValidation();

      fileUploadOptions();

      const checkbox = $('.toggle-form-checkbox');
      const checkboxHandler = function (_this, init) {
        const identifier = $(_this).attr('data-identifier');
        const index = $(_this).attr('data-index');
        let trueValue = $(_this).attr('ng-true-value');
        let falseValue = $(_this).attr('ng-false-value');
        const name = $(_this).attr('data-name');
        const dataValue = $(_this).attr('data-value');
        const dataReadonly = $(_this).attr('data-el-readonly');

        if (trueValue) {
          trueValue = trueValue.replace(/'/g, '');
        }
        if (falseValue) {
          falseValue = falseValue.replace(/'/g, '');
        }

        if (init) {
          if (vm.formData[name] === true &&
            (trueValue === true || trueValue === 'true')) {
            $(_this).prop('checked', true);
          } else if (vm.formData[name] === trueValue) {
            $(_this).prop('checked', true);
          }
        }

        let value = ($(_this).is(':checked')) ? trueValue : falseValue;
        if (value) value = value.replace(/'/g, '');
        if (value === 'true') value = true;
        if (value === 'false') value = false;

        if (init && index && identifier && dataValue) {
          if (dataValue === trueValue) {
            value = dataValue;
            $(_this).prop('checked', true);
          }
        }

        if (init && dataReadonly === 'true') {
          $(_this).attr('disabled', true);
        }

        utils.safeApply(vm, () => {
          if (identifier && index && vm.multipleItems[identifier] && vm.multipleItems[identifier][index]) {
            if (vm.multipleItems[identifier][index][name]) {
              if (vm.multipleItems[identifier][index][name].hasOwnProperty('value')) {
                vm.multipleItems[identifier][index][name].value = String(value);
              } else {
                vm.multipleItems[identifier][index][name] = String(value);
              }
            } else {
              let addValue = false;

              angular.forEach(vm.multipleItems[identifier], (item) => {
                if (item[name] && item[name].value) {
                  addValue = true;
                }
              });

              if (addValue) {
                vm.multipleItems[identifier][index][name] = {
                  value: String(value)
                };
              } else {
                vm.multipleItems[identifier][index][name] = String(value);
              }
            }

          } else {
            vm.formData[name] = String(value);
          }
        });
      };

      checkbox.on('change', function () {
        checkboxHandler(this, false);
      });
      checkbox.each(function () {
        checkboxHandler(this, true);
      });

      $('.select2-search__field').attr('aria-label', function() {
        return $(this).closest('.form-group').children('label').text();
      });
    }

    function fileUploadOptions() {
      var localesList = $('#currentLocale').val();

      if (localesList) {
        try {
          localesList = JSON.parse(localesList);
        } catch (e) {
          localesList = {};
        }
      }

      var fileinputOptions = {};
      if (localesList && localesList.app && localesList.app.fileupload) {
        var fileuploadLocale = localesList.app.fileupload;

        if (fileuploadLocale.msgloading) {
          fileinputOptions.msgLoading = fileuploadLocale.msgloading;
        }
        if (fileuploadLocale.msgselected) {
          fileinputOptions.msgSelected = fileuploadLocale.msgselected;
        }
        if (fileuploadLocale.filesingle) {
          fileinputOptions.fileSingle = fileuploadLocale.filesingle;
        }
        if (fileuploadLocale.fileplural) {
          fileinputOptions.filePlural = fileuploadLocale.fileplural;
        }
        if (fileuploadLocale.remove) {
          fileinputOptions.removeLabel = fileuploadLocale.remove;
        }
        if (fileuploadLocale.browse) {
          fileinputOptions.browseLabel = fileuploadLocale.browse;
        }
      }

      fileinputOptions.overwriteInitial = false;
      fileinputOptions.showCancel = false;
      fileinputOptions.showUpload = false;
      fileinputOptions.showCaption = true;
      fileinputOptions.browseIcon = '<i class="fa fa-folder-open" aria-hidden="true"></i>';
      fileinputOptions.removeIcon = '<i class="fa fa-trash-o" aria-hidden="true"></i>';
      fileinputOptions.previewFileIcon = '';

      var upload = $('#upload-files').fileinput(fileinputOptions);

      var maxAttachmentSize = $('#max-size').val();
      var alertMsg = $('#alert-msg').val();

      var errorMsg = $("#error-msg");

      upload.on('filebatchselected', function(event, files) {
        if (!maxAttachmentSize) return;
        var totalSize = 0;

        for (var i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }

        errorMsg.text('').css({"display": "none"});

        if (totalSize > maxAttachmentSize) {
          if (alertMsg) {
            errorMsg.text(alertMsg + ' ' + bytesToSize(maxAttachmentSize)).css({"display": "block"});
            setTimeout(function() {
              errorMsg.text('').css({"display": "none"});
            }, 6000)
          }

          upload.fileinput('clear').fileinput('refresh');
        }
      });

      function bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      }
    }

    getItemTemplate.loadConfig().then(() => {
      templatesLoaded = true;

      if (preInitializeElements) {
        loadElements({ changedFields: false, reloaded: false, initializeElements: preInitializeElements });
      }

      //load form elements
      loadElements({ skipElements: preInitializeElements });

      if (preInitializeElements) {
        preInitializeElements = null;
      }

      $timeout(() => {
        const form = $('form');
        form.validator('destroy');
        form.validator({
          custom: {
            'item-exists': function ($el) {
              return parseInt($($el).attr('data-item-exists'));
            },
          },
        });
      }, 0);

      barcodeService.init({
        decodingText: locales.getLocaleByKey('decoding'),
        mainContent: '#barcode-main-content',
        outputResultTo: '#barcode-main-content .barcode-input',
        trigger: {
          from: '#barcode-main-content .barcode-icon',
          to: '#barcode-reader__picture__input',
        },
      });
    });

    vm.executeAgentTask = (options) => {
      let {tag, vars, command, fields, identifier} = options || {};
      const values = {};
      let error = false;

      if (!identifier) {
        console.log('Task identifier is is missing');
        return false;
      }

      if (fields) {
        const notFound = [];
        for (let i = 0; i < fields.length; i++) {
          const el = $('[name=' + fields[i] + ']');
          if (el && el.length > 0) {
            const val = el.val();
            if (!val) {
              el.trigger('change');
              error = true;
            } else {
              values[fields[i]] = val;
            }
          } else {
            notFound.push(fields[i]);
          }
        }

        if (notFound.length > 0) {
          vm[identifier] = {
            result: {
              error: true,
              message: locales.getLocaleByKey('missing_field',
                {field: notFound[0]}),
            },
          };
          return false;
        }
        if (error) {
          return false;
        }
      }

      const payload = {};
      const params = {
        async: false,
      };

      command = itemMapping.replaceCurlies(command, values,
        {singleCurlies: true, allowEmpty: true});
      if (vars) {
        vars = itemMapping.replaceCurlies(vars, values,
          {singleCurlies: true, allowEmpty: true});
        payload.vars = vars.split(',');
      }
      if (tag) {
        params.tag = itemMapping.replaceCurlies(tag, values,
          {singleCurlies: true, allowEmpty: true});
      }

      if (!params.tag) {
        error = locales.getLocaleByKey('tag_is_required_field');
      }
      if (!command) {
        error = locales.getLocaleByKey('command_is_required_field');
      }

      if (error) {
        return vm[identifier] = {
          result: {
            error: true,
            message: error,
          },
        };
      }

      vm[identifier] = {
        loading: true,
      };

      taskService.run(command, params, payload).success((res) => {
        const result = {};
        if (res.result) {
          if (res.result.statuscode === 200) {
            try {
              const data = JSON.parse(res.result.response);
              for (const key in data) {
                if (data.hasOwnProperty(key)) {
                  const el = $('[name=' + key + ']');
                  if (el && el.length > 0) {
                    const type = el.attr('type');
                    if (type && type === 'checkbox') {
                      if (utils.isBoolean(data[key].value)) {
                        el.prop('checked', data[key].value);
                      }
                    } else {
                      if (data[key].hasOwnProperty('placeholder')) {
                        el.attr('placeholder', data[key].placeholder);
                      }
                      if (data[key].hasOwnProperty('value')) {
                        el.val(data[key].value);
                      }
                    }

                    if (data[key].hasOwnProperty('required')) {
                      el.attr('required', data[key].required);
                    }
                    if (data[key].hasOwnProperty('class')) {
                      el.addClass(data[key].class);
                    }

                    el.closest('.form-group').removeClass('hidden');
                    el.trigger('change');
                  }
                }
              }
            } catch (e) {
              result.message = res.result.response;
            }
          } else {
            result.error = true;
            result.message = res.result.statusmessage;
          }
        }

        vm[identifier] = {
          loading: false,
          result: result,
        };
      }).error((error) => {
        vm[identifier] = {
          result: {
            error: true,
            message: error.error.message,
          },
        };
      });
    };

    function prepareMultipleItemsData (data) {
      const temp = [];
      data.map((obj) => {
        const { trackBy, _trackBy, ...item } = obj;
        const tempItem = {};
        delete tempItem.trackBy;
        delete tempItem._trackBy;
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            if (item[key] && item[key].value) {
              tempItem[key] = item[key].value;
            } else {
              tempItem[key] = item[key];
            }
          }
        }
        temp.push(tempItem);
      });
      return temp;
    }

    vm.addNewItem = (identifier) => {
      vm.multipleItems[identifier].push({trackBy: new Date().getTime()});
      $timeout(() => {
        loadElements({ changedFields: {}, reloaded: true, skipAlreadyLoaded: true });

        $timeout(() => {
          $('form').validator('update');
          vm.summaryCalculation('itemTable');
        }, 15);
      }, 0);
    };

    vm.removeItem = (identifier, index) => {
      const tableElementData = vm.multipleItems[identifier][index];
      // Remove selected items and options
      if (tableElementData && utils.isObject(tableElementData)) {
        for (const type in vm.onLoadSelectedItemsKey) {
          for (const name in tableElementData) {
            if (vm.onLoadSelectedItemsKey[type][name] && Array.isArray(vm.onLoadSelectedItemsKey[type][name])) {
              vm.onLoadSelectedItemsKey[type][name].forEach((el, i) => {
                const trackBy = el._trackBy * 1;
                if (trackBy === tableElementData.trackBy) {
                  vm.onLoadSelectedItemsKey[type][name].splice(i, 1);
                }
              });
            }
          }
        }
      }

      vm.multipleItems[identifier].splice(index, 1);
      vm[identifier + 'Data'] = JSON.stringify(prepareMultipleItemsData(vm.multipleItems[identifier]));
      $timeout(() => {
        $('form').validator('update');
        vm.summaryCalculation('itemTable');
      }, 15);

      updateOnloadItemsInput();
    };

    vm.copyItemRow = (identifier, index) => {
      const items = [];
      const copy = cloneObject(vm.multipleItems[identifier][index]);
      copy.trackBy = new Date().getTime();

      angular.forEach(vm.multipleItems[identifier], (item, i) => {
        items.push(item);
        if (i === index) {
          items.push(copy);
        }
      });

      vm.multipleItems[identifier] = items;

      $timeout(() => {
        loadElements({changedFields: {}, reloaded: true, skipAlreadyLoaded: true});

        $timeout(() => {
          $('form').validator('update');
          vm.summaryCalculation('itemTable');
        }, 15);
      }, 0);

      vm[identifier + 'Data'] = JSON.stringify(prepareMultipleItemsData(vm.multipleItems[identifier]));
    };

    vm.updateItemValue = (identifier) => {
      vm[identifier + 'Data'] = JSON.stringify(prepareMultipleItemsData(vm.multipleItems[identifier]));
    };

    function addUniqueId (array) {
      if (array) {
        for (let i = 0; i < array.length; i++) {
          array[i].trackBy = new Date().getTime() + i;
        }
      }
      return array;
    }

    vm.initItems = (identifier, data) => {
      if (data) {
        vm.multipleItems[identifier] = addUniqueId(data);
      } else {
        vm.multipleItems[identifier] = [{trackBy: new Date().getTime()}];
      }

      storeElementTableData(identifier);

      $scope.$watch('multipleItems', function () {
        storeElementTableData(identifier);
      }, true);
    };

    function storeElementTableData (identifier) {
      const element = $('.elements-table-' + identifier);
      let dataRequired = (element.length > 0) ? element.attr(
        'data-required-elements') : false;
      const items = prepareMultipleItemsData(vm.multipleItems[identifier]);

      if (dataRequired) {
        const temp = [];
        dataRequired = JSON.parse(dataRequired);

        for (let i = 0; i < items.length; i++) {
          let add = 0;

          for (let j = 0; j < dataRequired.length; j++) {
            const val = (items[i][dataRequired[j].name] &&
              items[i][dataRequired[j].name].value)
              ? items[i][dataRequired[j].name].value
              : items[i][dataRequired[j].name];

            if (isnum(val) && val > 0) {
              add += 1;
            } else if (utils.isArray(val) && val.length > 0) {
              add += 1;
            } else if (!isnum(val) && utils.isString(val)) {
              if (dataRequired[j].hasOwnProperty('value') &&
                dataRequired[j].value === val) {
                add += 1;
              } else if (
                !dataRequired[j].hasOwnProperty('value') &&
                val !== '' &&
                val !== ' ' &&
                val !== null &&
                val !== 'undefined' &&
                val !== undefined
              ) {
                add += 1;
              }
            }
          }

          if (add === dataRequired.length) {
            temp.push(items[i]);
          }
        }

        vm[identifier + 'Data'] = JSON.stringify(temp);
      } else {
        vm[identifier + 'Data'] = JSON.stringify(items);
      }

      vm.summaryCalculation('itemTable');
    }

    function showValidationMessage (
      _this, config, result, term, existingValue) {
      const formGroup = $(_this).closest('.form-group');

      function showSuccess () {
        formGroup.removeClass(`validation-error success`).addClass('success');
        formGroup.find('.validate-item-exist-message').html('<i class="fa fa-check-circle"></i>');
        formGroup.find('.validate-item-exist-input').removeAttr('required');
      }

      function showError () {
        formGroup.addClass(`validation-error error`).removeClass('success');
        formGroup.find('.validate-item-exist-message').html('<i class="fa fa-exclamation-triangle"></i>');
        formGroup.find('.validate-item-exist-input').prop('required', true);
      }

      function showDefault () {
        formGroup.removeClass(`validation-error success error`);
        formGroup.find('.validate-item-exist-input').removeAttr('required');
      }

      if (existingValue === term) {
        showSuccess();
        return;
      }

      if (term && result) {
        if (result.meta.totalresults > 0) {
          showError();
        } else {
          showSuccess();
        }
      } else {
        if (!term || term === '') {
          showDefault();
        }
      }
    }

    function validateTextInputs(_this, term) {
      try {
        let validateConfig = $(_this).attr('data-checkduplicate');
        let existingValue = $(_this).attr('data-value');
        const name = $(_this).attr('data-name');

        if (vm.checkDuplicateInProgress[name]) return;

        if (validateConfig) {
          validateConfig = JSON.parse(validateConfig);

          let request;

          if (validateConfig.type === 'item' && validateConfig.workspace) {
            let params = {
              metaonly: true,
            };
            if (validateConfig.filter) {
              params.filter = validateConfig.filter;
            }

            if (validateConfig.field) {
              if (validateConfig.field.indexOf('attribute.') !== -1) {
                params.term = `${validateConfig.field}.lower:"${term}"`;
              } else if (validateConfig.field === 'key') {
                params.term = `key:"${term}"`;
              } else if (validateConfig.field === 'name') {
                params.term = `name.lower:"${term}"`;
              }
            } else {
              params.term = `name.lower:"${term}"`;
            }

            if (!params.term) {
              params.term = '*';
            }

            request = itemsData.items(vm, validateConfig.workspace, params);
          }

          if (request) {
            vm.checkDuplicateInProgress[name] = true;
            request.success((result) => {
              showValidationMessage(_this, validateConfig, result, term, existingValue);
              vm.checkDuplicateInProgress[name] = false;
            }).error((error) => {
              vm.checkDuplicateInProgress[name] = false;
              errorService.save(error).success(() => {
                window.location.href = config.errorPage;
              });
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    function initTextInputValidation() {
      const validateTextInputsElement = $('.validate-text-inputs-value');

      validateTextInputsElement.each(function() {
        const _this = this;
        $timeout(() => {
          const term = $(_this).val();
          if (term && term !== '') {
            validateTextInputs(_this, term);
          }
        }, 100);
      });

      validateTextInputsElement.on('change paste keyup', function() {
        try {
          let validateConfig = $(this).attr('data-checkduplicate');
          if (validateConfig) {
            validateConfig = JSON.parse(validateConfig);
            showValidationMessage(this, validateConfig, false, $(this).val());
          }
        } catch (e) {
          console.log(e);
        }
      });

      validateTextInputsElement.typeWatch({
        allowSubmit: false,
        captureLength: 1,
        wait: 400,
        callback: function(term) {
          validateTextInputs(this, term);
        },
      });
    }

    const simpleTextFormatted = $('.simple-text-formatted');

    simpleTextFormatted.each(function () {
      const format = $(this).attr('data-format');
      const formatLocale = $(this).attr('data-format-locale');
      const value = $(this).text();
      if (format && value && value !== '') {
        $(this).text(numeralFormat(value, format, formatLocale));
      }
    });

    function convertStringToNumbers(data) {
      if (!utils.isObject(data)) return data;
      const object = cloneObject(data);
      for (const key in object) {
        if (utils.isString(object[key]) && isnum(object[key])) {
          object[key] = Number(object[key]);
        }
        if (utils.isObject(object[key])) {
          object[key] = convertStringToNumbers(object[key]);
        }
      }
      return object;
    }

    function fixCalculation (string) {
      if (string) {
        const temp = [];
        const arr = string.split('+');
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]) {
            const v = arr[i].trim();
            if (v !== '' && v !== ' ') {
              temp.push(v);
            }
          }
        }
        return temp.join('+');
      }
      return string;
    }

    vm.summaryCalculation = (type) => {
      if (summaryCalculationInProgress) return;
      summaryCalculationInProgress = true;

      const queryParams = $location.search();

      $timeout(() => {
        const imageElement = $('.form-element-image');
        imageElement.each(function () {
          const identifier = $(this).attr('data-identifier');
          const index = $(this).attr('data-index');
          const name = $(this).attr('data-name');
          const src = $(this).attr('data-src');

          if (src.indexOf('{') !== -1 && src.indexOf('}') !== -1) {
            if (identifier && index && vm.multipleItems[identifier] &&
              vm.multipleItems[identifier][index] &&
              vm.multipleItems[identifier][index][name]) {
              const value = (vm.multipleItems[identifier][index][name].value)
                ? vm.multipleItems[identifier][index][name].value
                : vm.multipleItems[identifier][index][name];
              const imageUrl = itemMapping.replaceCurlies(src, {src: value}, {
                singleCurlies: true,
                allowEmpty: true,
              });
              $(this).attr('src', imageUrl);

            } else {
              const imageUrl = itemMapping.replaceCurlies(src,
                vm.selectedItemsAndOptions, {
                  singleCurlies: true,
                  allowEmpty: true,
                });
              $(this).attr('src', imageUrl);
            }
          }
        });

        const element = $('.summary-calculation');
        element.each(function () {
          const formGroup = $(this).closest('.form-group');
          const calculation = $(this).attr('data-calculation');
          const name = $(this).attr('data-name');
          const format = $(this).attr('data-format');
          const itemTable = $(this).attr('data-item-table');
          const formatLocale = $(this).attr('data-format-locale');

          if (itemTable) {
            let total = 0;
            let items = [];

            try {
              items = (vm[itemTable + 'Data']) ? JSON.parse(
                vm[itemTable + 'Data']) : [];
            } catch (e) {
              items = [];
            }

            for (let i = 0; i < items.length; i++) {
              const data = convertStringToNumbers(items[i]);
              const temp = itemMapping.replaceCurlies(calculation, data, {
                singleCurlies: true,
                allowEmpty: true,
                defaultValue: 0,
                valueType: 'number',
              });
              const calculationResult = itemMapping.replaceCurlies(`{${temp}}`,
                data, {
                  singleCurlies: true,
                  allowEmpty: true,
                });

              total += Number(calculationResult);
            }

            if (!total) {
              total = 0;
            }

            let resultValue = total;
            if (format) {
              resultValue = numeralFormat(total, format, formatLocale);
            }

            utils.safeApply(vm, () => {
              vm.preventParamChange[name] = true;
              vm.formData[name] = total;
              formGroup.find('.summary-calculation-value').text(resultValue);
            });
          } else {
            const data = convertStringToNumbers(utils.objectMarge(vm.formData || {}, vm.selectedItemsAndOptions || {}));

            const temp = itemMapping.replaceCurlies(calculation, data, {
              singleCurlies: true,
              allowEmpty: true,
              defaultValue: 0,
              valueType: 'number',
            });
            let calculationResult = itemMapping.replaceCurlies(`{${temp}}`,
              data, {
                singleCurlies: true,
                allowEmpty: true,
              });

            if (!calculationResult) {
              calculationResult = 0;
            }

            let resultValue = calculationResult;
            if (format) {
              resultValue = numeralFormat(resultValue, format, formatLocale);
            }

            utils.safeApply(vm, () => {
              vm.preventParamChange[name] = true;
              vm.formData[name] = calculationResult;
              formGroup.find('.summary-calculation-value').text(resultValue);
            });
          }
        });

        $timeout(() => {
          $('.element-dynamic-value').each(function () {
            parseDynamicValue(this);
          });

          $('.element-dynamic-pattern').each(function () {
            parseDynamicPattern(this);
          });

          $timeout(() => {
            // fix dynamic value after is visible on DOM
            const formGroup = $('.form-group');
            formGroup.each(function () {
              const ngIf = $(this).attr('ng-if');
              const elementDynamicValue = $(this).find('.element-dynamic-value');
              const elementDynamicPattern = $(this).find('.element-dynamic-pattern');

              if (ngIf && elementDynamicValue && elementDynamicValue.length > 0) {
                elementDynamicValue.each(function () {
                  parseDynamicValue(this);
                });
              }

              if (ngIf && elementDynamicPattern && elementDynamicPattern.length > 0) {
                elementDynamicPattern.each(function () {
                  parseDynamicPattern(this);
                });
              }
            });
          }, 30);
        }, 60);

        function parseDynamicPattern(_this) {
          const pattern = $(_this).attr('data-pattern');

          if (pattern && pattern.indexOf('{') !== -1 && pattern.indexOf('}') !== -1) {
            const data = {};
            for (const key in vm.selectedItemsAndOptions) {
              if (vm.selectedItemsAndOptions.hasOwnProperty(key)) {
                data[key] = utils.cloneItem(vm.selectedItemsAndOptions[key]);
              }
            }
            for (const key in vm.formData) {
              if (vm.formData.hasOwnProperty(key)) {
                if (!data[key]) {
                  data[key] = vm.formData[key];
                }
              }
            }

            const value = itemMapping.replaceCurlies(pattern, data, {
              singleCurlies: true,
              allowEmpty: true,
            });

            $(_this).attr('pattern', value);
          }
        }

        function injectTableElementData (data, identifier, rowIndex) {
          if (identifier && rowIndex && vm.multipleItems[identifier] && vm.multipleItems[identifier][rowIndex]) {
            const selectRow = vm.multipleItems[identifier][rowIndex];

            for (const key in selectRow) {
              if (selectRow.hasOwnProperty(key)) {
                data[key] = cloneObject(selectRow[key]);

                const id = identifier + '_' + key + '_' + rowIndex;
                const selectElement = $("select[data-table-el-id="+id+"]");

                if (selectElement) {
                  if ($(selectElement).data('select2')) {
                    const selectedData = $(selectElement).select2('data');
                    if (selectedData && selectedData.length) {
                      data[key] = getSelectedFields(selectedData[0]);
                    }
                  }
                }
              }
            }
          }

          return data;
        }

        function bindTableElementValue (identifier, name, rowIndex, value) {
          utils.safeApply(vm, () => {
            if (vm.multipleItems[identifier] && vm.multipleItems[identifier][rowIndex]) {
              if (name in vm.multipleItems[identifier][rowIndex]) {
                if (utils.isObject(vm.multipleItems[identifier][rowIndex][name]) && 'value' in  vm.multipleItems[identifier][rowIndex][name]) {
                  vm.multipleItems[identifier][rowIndex][name].value = value;
                } else {
                  vm.multipleItems[identifier][rowIndex][name] = value;
                }
              } else {
                vm.multipleItems[identifier][rowIndex][name] = value;
              }
            }
          });
        }
        
        // parse element dynamic value
        function parseDynamicValue(_this) {
          const customValue = $(_this).attr('data-value');
          const name = $(_this).attr('data-name');
          const format = $(_this).attr('data-format');
          const formatLocale = $(_this).attr('data-format-locale');
          
          const identifier = $(_this).attr('data-identifier');
          const rowIndex = $(_this).attr('data-index');
          
          if (customValue && customValue.indexOf('{') !== -1 && customValue.indexOf('}') !== -1) {
            const data = injectTableElementData({}, identifier, rowIndex);

            for (const key in vm.selectedItemsAndOptions) {
              if (vm.selectedItemsAndOptions.hasOwnProperty(key)) {
                data[key] = utils.cloneItem(vm.selectedItemsAndOptions[key]);
              }
            }
            for (const key in vm.formData) {
              if (vm.formData.hasOwnProperty(key)) {
                if (!data[key]) {
                  data[key] = vm.formData[key];
                }
              }
            }

            let value = itemMapping.replaceCurlies(customValue, data, {
              singleCurlies: true,
              allowEmpty: true
            });

            if (name) {
              if (value.indexOf('+') !== -1) {
                let temp = itemMapping.replaceCurlies(
                  `{${fixCalculation(value)}}`, data, {
                    singleCurlies: true,
                    allowEmpty: true,
                  });
                if (temp) {
                  value = temp;
                }
                if (temp === '{}') {
                  value = '';
                }
              }

              if (format && value && value !== '') {
                value = numeralFormat(value, format, formatLocale);
              }
              utils.safeApply(vm, () => {
                //if value is empty and form element is set as param use parameter value
                if (!value && value !== 0 &&
                  queryParams.hasOwnProperty(name)) {
                  value = queryParams[name];
                }

                vm.preventParamChange[name] = true;

                if (identifier && rowIndex) {
                  bindTableElementValue(identifier, name, rowIndex, value);
                } else {
                  vm.formData[name] = value;
                }
              });
            } else {
              if ($(_this).hasClass('simple-text')) {
                if (format && value && value !== '') {
                  value = numeralFormat(value, format, formatLocale);
                }
                $(_this).html(markdownConverter.showdown().makeHtml(value));
              }
            }
          }
        }

        $('.table-items-container .simple-text-formatted').each(function () {
          const format = $(this).attr('data-format');
          const formatLocale = $(this).attr('data-format-locale');
          const value = $(this).text();

          if (format && value && value !== '') {
            $(this).text(numeralFormat(value, format, formatLocale));
          }
        });

        summaryCalculationInProgress = false;
      }, 30);
    };
  }
})();

(function() {
  angular
    .module('onify')
    .controller('headerController', headerController);

  headerController.$inject = ['$scope', '$q', '$cookies', 'config', 'locales', 'workspacesService', 'userService'];
  function headerController($scope, $q, $cookies, config, locales, workspacesService, userService) {
    let vm = $scope;
    //update user geo location
    if ($cookies.get('getusergeolocation')) {
      navigator.geolocation.getCurrentPosition(function (position) {
        userService.saveSettings({geolocation: `${position.coords.latitude},${position.coords.longitude}`}).success(() => {
          $cookies.remove('getusergeolocation');
        });
      });
    }

    vm.openUserSettingsModal = function() {
      const defaultLanguage = $(config.domElements.defaultLanguage).val();
      vm.disableSave = false;
      vm.workspaces = [];

      $q.all([
        locales.getLocalesList(),
        workspacesService.getWorkspaces(),
        userService.getUserSettings()
      ]).then((results) => {
        vm.availableLanguages = results[0].data;
        vm.workspaces = results[1].data;
        const userSettings = results[2].data;

        if (!userSettings.settings) {
          if (userSettings.lastworkspace) {
            vm.settings = {locale: defaultLanguage, defaultpage: {type: "lastworkspace"}};
          } else {
            vm.settings = {locale: defaultLanguage, defaultpage: {type: "allworkspaces"}};
          }
        } else {
          vm.settings = userSettings.settings;

          let localeExist = false;
          //change locale to default language if does not exist
          vm.availableLanguages.map((locale) => {
            if (locale.key === vm.settings.locale) {
              localeExist = true;
            }
          });

          if (!localeExist) {
            vm.settings.locale = defaultLanguage;
          }

          if (!vm.settings.defaultpage) {
            if (userSettings.lastworkspace) {
              vm.settings.defaultpage = {type: "lastworkspace"};
            } else {
              vm.settings.defaultpage = {type: "allworkspaces"};
            }
          }
        }
        vm.username = userSettings.name;
        vm.lastworkspace = userSettings.lastworkspace;

        vm.userLocale = vm.settings.locale;

        angular.element('#userSettingsModal').modal('show');
      }).catch((err) => {
        console.log(err);
      });
    };

    vm.SaveUserSettings = function() {
      const settings = {
        settings: vm.settings,
        lastworkspace: vm.lastworkspace
      };

      if (settings.settings.defaultpage.type === 'lastworkspace' || settings.settings.defaultpage.type === 'allworkspaces') {
        delete settings.settings.defaultpage.value;
      } else {
        if (!settings.settings.defaultpage.value) {
          return;
        }
      }

      vm.disableSave = true;
      userService.saveSettings(settings).success(() => {
        vm.CancelUserSettings();
      }).error((error) => {
        vm.showError = true;
        vm.error = {
          message: error.error.message
        };
      });
    };

    vm.updateDefaultpageValue = function() {
      vm.settings.defaultpage.value = null;
    };

    vm.CancelUserSettings = function() {
      angular.element('#userSettingsModal').modal('hide');
    };
  }
})();

(function() {
  angular
    .module('onify')
    .controller('mainController', mainController);

  mainController.$inject = ['$scope', '$uibModal', 'config', 'locales', 'bulletinService', 'audit'];

  function mainController($scope, $uibModal, config, locales, bulletinService, audit) {
    let vm = $scope;

    vm.createShortcut = function() {
      $uibModal.open({
        templateUrl: 'shortcuts-modal.html',
        controller: 'shortcutsModalController',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          data: function() {
            return false;
          },
          modalAction: function() {
            return 'new';
          }
        }
      });
    };

    vm.closeBulletin = function(key) {
      bulletinService.aknowledge(key)
        .success(function(result) {
          if (result.statusCode) {
            if (result.statusCode === 200) {
              $("#alert_" + key).remove()
            }
          }
        })
        .error(function(error) {
          alert("Whoops, Something wrong");
        });
    };

    vm.addShortcutAudit = (name, key, placement) => {
      const data = {
        title: name,
        name: 'Click shortcut',
        tag: [
          'shortcut'
        ]
      };

      if (placement) {
        data.tag.push(placement);
      }
      audit.add(data);
    };

    vm.openGuide = (link, target, title, stepTitle, stepId) => {
      if (title && stepTitle) {
        const auditData = {
          title: title,
          name: 'Click step in guide',
          tag: [
            'guide',
            'step',
            'click'
          ],
          data: [{
            name: 'guide',
            value: stepTitle
          }]
        };

        if (stepId && stepId !== 'undefined') {
          auditData.data.push({
            name: 'step',
            value: stepId
          });
        }

        audit.add(auditData);
      }

      if (target === '_blank') {
        window.open(link, target);
        return;
      }
      if (target === '_top') {
        top.location.href = link;
        return;
      }

      window.location.href = link;
    };
  }
})();

(function() {
  angular
    .module('onify')
    .controller('commitMessageModalController', ['$scope', '$uibModalInstance', 'locales', 'onConfirm', 'onCancel', commitMessageModalController]);

  function commitMessageModalController($scope, $uibModalInstance, locales, onConfirm, onCancel) {
    $scope.savetext = locales.getLocaleByKey('save');
    $scope.canceltext = locales.getLocaleByKey('cancel');
    $scope.modalTitle = locales.getLocaleByKey('resources_add_commit_message');

    $scope.cancel = function() {
      onCancel();
      $uibModalInstance.close();
    };

    $scope.save = function() {
      onConfirm($scope.message);
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

(function() {
  angular
    .module('onify')
    .controller('shortcutsModalController', [
      '$scope',
      '$rootScope',
      '$q',
      '$location',
      '$timeout',
      '$window',
      'config',
      'utils',
      'locales',
      'userService',
      'errorService',
      'select2Utils',
      'workspacesService',
      'mediaService',
      'shortcutsService',
      '$uibModalInstance',
      'data',
      'modalAction',
      shortcutsModalController]);

  function shortcutsModalController($scope,
                                    $rootScope,
                                    $q,
                                    $location,
                                    $timeout,
                                    $window,
                                    config,
                                    utils,
                                    locales,
                                    userService,
                                    errorService,
                                    select2Utils,
                                    workspacesService,
                                    mediaService,
                                    shortcutsService,
                                    $uibModalInstance,
                                    data,
                                    modalAction) {

    $scope.modalAction = modalAction;

    $scope.updatetext = locales.getLocaleByKey('update');
    $scope.savetext = locales.getLocaleByKey('save');
    $scope.canceltext = locales.getLocaleByKey('cancel');
    $scope.modalTitle = locales.getLocaleByKey('create_new_shortcut');

    if ($scope.modalAction === 'edit') {
      $scope.modalTitle = locales.getLocaleByKey('edit_shortcut');
    }

    $scope.linktext = locales.getLocaleByKey('link');
    $scope.nametext = locales.getLocaleByKey('shortcuts_name');
    $scope.descriptiontext = locales.getLocaleByKey('shortcuts_description');
    $scope.icontext = locales.getLocaleByKey('icon');
    $scope.workspacetext = locales.getLocaleByKey('shortcuts_workspace');
    $scope.placementtext = locales.getLocaleByKey('shortcuts_placement');
    $scope.roletext = locales.getLocaleByKey('shortcuts_role');
    $scope.sharedinfotext = locales.getLocaleByKey('share_this_shortcut');
    $scope.sharedtext = locales.getLocaleByKey('shared');
    $scope.ordertext = locales.getLocaleByKey('order');

    $scope.placementworkspacetext = locales.getLocaleByKey('shortcuts_placement_workspace');
    $scope.placementmenutext = locales.getLocaleByKey('shortcuts_placement_menu');
    $scope.changesyoumademaynotbesaved = locales.getLocaleByKey('changes_you_made_may_not_be_saved');

    $scope.showLoading = true;
    $scope.disableSubmit = false;
    $scope.preventWatch = true;
    let showWarningModal = false;

    $window.onbeforeunload = function() {
      if (showWarningModal) {
        return true;
      }
    };

    $scope.$watch("shortcut", function(newData, oldData) {
      if ($scope.preventWatch) return false;
      for (let key in newData) {
        if (newData.hasOwnProperty(key)) {
          if (oldData[key] !== newData[key] && newData[key] !== 'undefined') {
            showWarningModal = true;
          }
        }
      }
    }, true);

    function loadElements() {
      const workspace = $('.shortcuts-modal-main .select-workspace');
      const role = $('.shortcuts-modal-main .select-role');
      const icon = $('.shortcuts-modal-main .select-icon');

      workspace.select2({
        tags: false,
        multiple: true,
        tokenSeparators: [','],
        placeholder: locales.getLocaleByKey('select_workspace'),
        language: select2Utils.language()
      }).on("change", (e) => {
        utils.safeApply($scope, () => {
          $scope.shortcut.workspace = $(e.currentTarget).val();
        });
      });

      role.select2({
        tags: false,
        multiple: true,
        tokenSeparators: [','],
        placeholder: locales.getLocaleByKey('select_role'),
        language: select2Utils.language()
      }).on("change", (e) => {
        utils.safeApply($scope, () => {
          $scope.shortcut.role = $(e.currentTarget).val();
        });
      });

      icon.select2({
        tags: false,
        multiple: false,
        tokenSeparators: [','],
        placeholder: locales.getLocaleByKey('select_icon'),
        language: select2Utils.language(),
        templateResult: function(data) {
          if (data.loading) return data.text;
          return "<img width='20' height='20' src=" + data.id + ">" + "<span>" + data.text + "</span>";
        },
        escapeMarkup: function(markup) {
          return markup;
        }
      }).on("change", (e) => {
        utils.safeApply($scope, () => {
          $scope.shortcut.icon = $(e.currentTarget).val();
        });
      });

      if ($scope.modalAction === 'edit') {
        $timeout(() => {
          if (data.icon) {
            icon.val(data.icon).trigger('change');
          }
          if (data.workspace) {
            workspace.val(data.workspace).trigger('change');
          }
          if (data.role) {
            role.val(data.role).trigger('change');
          }
          $scope.preventWatch = false;
        }, 100);
      } else {
        $scope.preventWatch = false;
      }

      $scope.showLoading = false;
    }

    if ($scope.modalAction === 'edit') {
      $scope.shortcut = utils.clone(data);

      if ($scope.shortcut.placement) {
        $scope.shortcut.placement.map(function(placement) {
          if (placement === 'workspace') {
            $scope.shortcut.placementWorkspace = true;
          }
          if (placement === 'menu') {
            $scope.shortcut.placementMenu = true;
          }
        });
      }
    } else {
      $scope.shortcut = {
        link: $location.$$absUrl,
        order: 100
      };
    }

    $q.all([
      workspacesService.getWorkspaces(),
      mediaService.getIcons()
    ]).then((results) => {
      $scope.workspaces = results[0].data;
      $scope.icons = results[1].data;

      $scope.$watch(() => {
        return userService.watchChanges();
      }, (user) => {
        if (user) {
          $scope.roles = user.role;
          loadElements();
        }
      });
    }).catch((error) => {
      errorService.save(error).success(() => {
        window.location.href = config.errorPage;
      });
    });

    function formatShortcutData(shortcut) {
      const fields = {
        icon: true,
        link: true,
        name: true,
        placement: true,
        role: true,
        shared: true,
        workspace: true,
        description: true,
        order: true
      };
      const placement = [];

      if (shortcut.placementWorkspace) {
        placement.push('workspace');
        delete shortcut.placementWorkspace;
      }

      if (shortcut.placementMenu) {
        placement.push('menu');
        delete shortcut.placementMenu;
      }

      if (placement.length > 0) {
        shortcut.placement = placement;
      }

      for (const key in shortcut) {
        if (shortcut.hasOwnProperty(key)) {
          if (!fields[key]) {
            delete shortcut[key];
          } else {
            if (utils.isArray(shortcut[key]) && shortcut[key].length === 0) {
              delete shortcut[key];
            } else if(utils.isString(shortcut[key]) && shortcut[key] === ''){
              delete shortcut[key];
            }
          }
        }
      }

      if (utils.useNewApi()) {
        shortcut.title = shortcut.name;
      }

      return shortcut;
    }

    $scope.save = function() {
      $scope.showLoading = true;
      $scope.disableSubmit = true;

      const shortcut = formatShortcutData(utils.clone($scope.shortcut));
      if (!shortcut.hasOwnProperty('shared')) {
        shortcut.shared = false;
      }

      shortcutsService.create(shortcut).success((result) => {
        $scope.showLoading = false;
        $scope.disableSubmit = false;
        showWarningModal = false;
        $rootScope.$broadcast('on_shortcut_create', result);
        $uibModalInstance.close();
      }).error((error) => {
        if (error.statusCode === 403) {
          $scope.showLoading = false;
          $scope.disableSubmit = false;
          $scope.showError = true;
          $scope.error = {
            message: locales.getLocaleByKey('shortcut_exit')
          };
        } else {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        }
      });
    };

    $scope.update = function() {
      $scope.showLoading = true;
      $scope.disableSubmit = true;

      const shortcut = formatShortcutData(utils.clone($scope.shortcut));

      shortcutsService.update(shortcut, data.key).success((result) => {
        $scope.showLoading = false;
        $scope.disableSubmit = false;
        showWarningModal = false;
        $rootScope.$broadcast('on_shortcut_update', result);
        $uibModalInstance.close();
      }).error((error) => {
        if (error.statusCode === 403) {
          $scope.showLoading = false;
          $scope.disableSubmit = false;
          $scope.showError = true;
          $scope.error = {
            message: locales.getLocaleByKey('shortcut_exit')
          };
        } else {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        }
      });
    };

    $scope.cancel = function() {
      if (showWarningModal && !confirm($scope.changesyoumademaynotbesaved)) {
        return false;
      }
      showWarningModal = false;
      $uibModalInstance.dismiss('cancel');
    };

    $scope.placementMenuChanged = function(placementMenu) {
      if (!placementMenu) {
        $('.shortcuts-modal-main .select-workspace').val('').trigger('change');
      }
    };

    $scope.sharedChanged = function(shared) {
      if (!shared) {
        $('.shortcuts-modal-main .select-role').val('').trigger('change');
      }
    };
  }
})();

(function() {

  angular
    .module('onify')
    .directive('compileHtml', compileHtml);

  compileHtml.$inject = ['$compile', '$templateRequest', 'config', 'markdownConverter'];
  function compileHtml($compile, $templateRequest, config, markdownConverter) {
    function removeParagraphTag(string) {
      const matches = [];
      string.replace(/<p>(.*?)<\/p>/, function() {
        matches.push(arguments[1]);
      });
      return (matches.length > 0) ? matches.join('') : string;
    }

    return {
      restrict: 'A',
      replace: true,
      link: function(scope, ele, attrs) {
        scope.$watch(attrs.compileHtml, function(html) {
          if (html.indexOf('.html') === -1) {
            ele.html(removeParagraphTag(markdownConverter.showdown().makeHtml(html)));
            $compile(ele.contents())(scope);
          } else {
            let path = html;
            if (attrs.templatePath) {
              if (attrs.templatePath == 'widget') {
                path = config.widgetsTemplatesPath + path
              }
            }
            //render custom html
            $templateRequest(path).then((html) => {
              ele.html(html);
              $compile(ele.contents())(scope);
            });
          }
        });
      }
    };
  }

})();

(function() {

  angular
    .module('onify')
    .directive('customHtml', customHtml);

  function customHtml() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(attrs.customHtml, function(html) {
          element.html(html);
        });
      }
    }
  }

})();
(function() {

  angular
    .module('onify')
    .directive('customOnChange', customOnChange);

  function customOnChange() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.customOnChange);
        element.on('change', onChangeHandler);
        element.on('$destroy', function() {
          element.off();
        });
      }
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('dynamicDirective', dynamicDirective);

  dynamicDirective.$inject = ['$compile'];
  function dynamicDirective($compile) {
    return {
      restrict: 'A',
      replace: false,
      terminal: true,
      priority: 1000,
      link:function(scope, element, attrs){
        element.attr(scope.$eval(attrs.dynamicDirective), "");//add dynamic directive
        element.removeAttr("dynamic-directive"); //remove the attribute to avoid indefinite loop
        element.removeAttr("data-dynamic-directive");
        $compile(element)(scope);
      }
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('ngEnter', ngEnter);

  function ngEnter() {
    return function(scope, element, attrs) {
      element.bind("keydown keypress", function(event) {
        if(event.which === 13) {
          scope.$apply(function(){
            scope.$eval(attrs.ngEnter, {'event': event});
          });

          event.preventDefault();
        }
      });
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('ngRightClick', ngRightClick);

  ngRightClick.$inject = ['$parse'];
  function ngRightClick($parse) {
    return function(scope, element, attrs) {
      const fn = $parse(attrs.ngRightClick);
      element.bind('contextmenu', function(event) {
        scope.$apply(function() {
          event.preventDefault();
          fn(scope, {$event:event});
        });
      });
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('onErrorSrc', onErrorSrc);

  function onErrorSrc() {
    return {
      link: function(scope, element, attrs) {
        element.bind('error', function() {
          if (attrs.src != attrs.onErrorSrc) {
            attrs.$set('src', attrs.onErrorSrc);
          }
        });
      }
    }
  }

})();
(function() {

  angular
    .module('onify')
    .directive('stringToNumber', stringToNumber);

  function stringToNumber() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(value) {
          return '' + value;
        });
        ngModel.$formatters.push(function(value) {
          return parseFloat(value, 10);
        });
      }
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('validInputElement', validInputElement);

  function validInputElement() {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {

        ctrl.$setValidity('noMatch', true);

        attrs.$observe('validInputElement', function (newVal) {
          if (newVal === 'true') {
            ctrl.$setValidity('noMatch', true);
          } else {
            ctrl.$setValidity('noMatch', false);
          }
        });
      }
    }
  }

})();
(function() {
  angular
    .module('onify')
    .service('auditUtils', auditUtils);

  auditUtils.$inject = ['$timeout', 'config', 'utils'];

  function auditUtils($timeout, config, utils) {
    function prepareResult(vm, service, result) {
      vm.requestSend = false;

      if (vm.params && result.meta.nexturl) {
        vm.params.startfrom = utils.getParameterByName("startfrom", result.meta.nexturl);
        vm.params.pagesize = result.meta.pagesize;
      }

      let excludedata;
      if (vm.excludedata) {
        try {
          excludedata = {};
          const temp = JSON.parse(vm.excludedata);
          for (let i = 0; i < temp.length; i++) {
            excludedata[temp[i]] = temp[i];
          }
        } catch (e) {
          console.log(e);
        }
      }

      //append data
      angular.forEach(result.records, (item) => {
        if (item.data && excludedata) {
          item.data = item.data.filter((d) => !(excludedata[d.name]));
        }
        if (item.data) {
          for (let i = 0; i < item.data.length; i++) {
            try {
              item.data[i].value = JSON.parse(item.data[i].value);
            } catch (e) {}
          }
        }
        vm.auditItems.push(item);
      });

      //check if we have more items to load
      if (result.records.length === result.meta.pagesize && result.meta.nexturl) {
        vm.showLoading = true;
        infiniteScrolling(vm, service);
      } else {
        //hide load more button if we don't have more data
        vm.showLoading = false;
        vm.disableScrolling = true;
      }
    }

    function infiniteScrolling(vm, service) {
      const loadMore = $(config.domElements.loadMoreId);

      if (loadMore.length) {
        loadMore.on('inview', (event, visible) => {
          if (visible === true) {
            //prevent multiple request in the same time
            if (vm.requestSend) {
              return;
            }

            loadMore.off('inview');

            service.getAdminAudit(vm.params).success((result) => {
              prepareResult(vm, service, result)
            }).error(() => {
              vm.showLoading = false;
            });
          }
        });
      }
    }

    return {
      prepareResult: prepareResult,
      infiniteScrolling: infiniteScrolling
    };
  }
})();
(function() {
  angular
    .module('onify')
    .factory('itemsUtils', itemsUtils);

  itemsUtils.$inject = ['$timeout', '$q', '$templateRequest', 'utils', 'itemMapping', 'config', 'queryStringService', 'widgets', 'getItemTemplate', 'itemSelection', 'locales'];

  function itemsUtils($timeout, $q, $templateRequest, utils, itemMapping, config, queryStringService, widgets, getItemTemplate, itemSelection, locales) {
    let selectionWidgets;
    const views = {
      TABLE: 'table',
      CARDS: 'cards'
    };

    function getTableViewTemplateFromItems(items) {
      if (items) {
        let tpl = false;

        for (let i = 0; i < items.length; i++) {
          if (items[i].hasOwnProperty('type')) {
            if (tpl === false) {
              tpl = items[i].type;
            } else {
              if (items[i].type !== tpl) {
                return config.defaultTableItemTempalte;
              }
            }
          } else {
            return config.defaultTableItemTempalte;
          }
        }

        return tpl;
      }
      return config.defaultTableItemTempalte;
    }

    function loadDefaultTableViewTemplate(vm) {
      const deferred = $q.defer();

      const viewConfig = customItemView();
      if (viewConfig) {
        loadTableViewTemplates(viewConfig).then((tableTemplates) => {
          if (tableTemplates) {
            vm.customItemView = viewConfig;
            vm.customItemView.templates = tableTemplates;
            deferred.resolve(true);
          } else {
            deferred.resolve(true);
          }
        });
      } else {
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    function changeTableViewTemplate(vm, items) {
      const deferred = $q.defer();

      if (vm.activeView === views.TABLE && vm.customItemView) {
        const customTemplate = getTableViewTemplateFromItems(items);
        if (customTemplate !== vm.customItemView.config.templateKey) {
          const viewConfig = customItemView(customTemplate);
          if (viewConfig) {
            loadTableViewTemplates(viewConfig).then((tableTemplates) => {
              if (tableTemplates) {
                vm.customItemView = viewConfig;
                vm.customItemView.templates = tableTemplates;
                deferred.resolve(true);
              } else {
                deferred.resolve(true);
              }
            });
          } else {
            deferred.resolve(true);
          }
        } else {
          deferred.resolve(true);
        }
      } else {
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    function changeResultView(vm, view) {
      vm.activeView = view;
      vm.items = [];

      changeTableViewTemplate(vm, vm.tempItems).then(() => {
        angular.forEach(vm.tempItems, (item) => {
          const tempItem = utils.clone(item);

          if (vm.activeView && vm.activeView === views.TABLE) {
            vm.items.push(tableView(vm, tempItem));
          } else {
            vm.items.push(listView(tempItem));
          }
        });
      });
    }

    function changeView(vm, itemsData, view) {
      $(config.domElements.loadMoreId).off('inview');

      if (view === views.TABLE && vm.customItemView) {
        changeResultView(vm, view);
      } else {
        changeResultView(vm, view);
      }

      $timeout(() => {
        if (vm.showLoadMore) {
          infiniteScrolling(vm, itemsData);
        }
      }, 0);
    }

    function loadTableViewTemplates(viewConfig) {
      const deferred = $q.defer();
      const version = '?v=' + new Date().getTime();
      const templates = {};

      $q.all([
        $templateRequest(config.templatesPath + '/table/' + viewConfig.config.tableHeader + '.html' + version),
        $templateRequest(config.templatesPath + '/table/' + viewConfig.config.tableRow + '.html' + version),
      ]).then((results) => {
        templates.header = results[0];
        templates.row = results[1];
        $templateRequest(config.templatesPath + '/table/' + viewConfig.config.tableFooter + '.html' + version, true).then((tableFooter) => {
          templates.footer = tableFooter;
          deferred.resolve(templates);
        }).catch(() => {
          deferred.resolve(templates);
        });
      });

      return deferred.promise;
    }

    function customItemView(template) {
      const viewConfig = getItemTemplate.template(template, views.TABLE);
      if (viewConfig) {
        return {
          view: views.TABLE,
          config: viewConfig,
          header: itemMapping.parseFields(utils.clone(viewConfig.columns))
        };
      }

      return false;
    }

    function listView(item) {
      return itemMapping.itemMapping(item, selectionWidgets);
    }

    function tableView(vm, item) {
      const columns = utils.clone(vm.customItemView.config.columns);
      const result = itemMapping.tableMapping({columns: columns, key: item.key}, item, selectionWidgets);
      result.item = item;
      return result;
    }

    function prepareResult(vm, itemsData, result) {
      vm.requestSend = false;
      vm.showLoadMore = false;

      if (!selectionWidgets) {
        selectionWidgets = widgets.checkActiveWidgets(['selected', 'actions']);
      }

      if (vm.params && result.meta.nexturl) {
        vm.params.startfrom = utils.getParameterByName("startfrom", result.meta.nexturl);
        vm.params.pagesize = result.meta.pagesize;
      }

      //append data
      angular.forEach(result.records, (item) => {
        if (vm.itemsKeys[item.key]) return;
        vm.itemsKeys[item.key] = true;
        item.workspace = vm.workspaceSlug;
        const tempItem = utils.clone(item);
        vm.tempItems.push(tempItem);

        if (vm.activeView && vm.activeView === views.TABLE) {
          vm.items.push(tableView(vm, tempItem));
        } else {
          vm.items.push(listView(tempItem));
        }

        itemSelection.updateSelectedItemsFromCart(tempItem);
      });

      //save items loaded count
      itemsData.addItemsLoaded(vm.items.length);

      //check if we have more items to load
      if (result.records.length === result.meta.pagesize && result.meta.nexturl) {
        infiniteScrolling(vm, itemsData);
      }
    }

    function getPagination(vm, itemsData) {
      vm.requestSend = true;

      itemsData.items(vm, vm.workspaceSlug, vm.params)
        .success(function(result) {
          const customTemplate = getTableViewTemplateFromItems(result.records);
          if (vm.activeView === views.TABLE && vm.customItemView && customTemplate !== vm.customItemView.config.templateKey) {
            loadDefaultTableViewTemplate(vm).then(() => {
              changeResultView(vm, views.TABLE);
              prepareResult(vm, itemsData, result);
            });
          } else {
            prepareResult(vm, itemsData, result);
          }
        })
        .error(function(error) {
          vm.showLoadMore = false;
          vm.showError = true;
          vm.noResultsFound = true;
        });
    }

    function infiniteScrolling(vm, itemsData) {
      vm.showLoadMore = true;
      const loadMore = $(config.domElements.loadMoreId);

      if (loadMore.length) {
        $timeout(() => {
          if (($(document).height() - 70) < $(window).height() && !vm.requestSend) {
            getPagination(vm, itemsData);
          }
        }, 600);

        $(document).on('inview', config.domElements.loadMoreId, function(event, visible) {
          if (visible === true) {
            //prevent multiple request in the same time
            if (vm.requestSend) {
              return;
            }

            $(config.domElements.loadMoreId).off('inview');
            getPagination(vm, itemsData);
          }
        });
      }
    }

    function groupActions(actions) {
      if (actions) {
        const group = {};
        const actionsList = [];
        let index = 0;

        for (let i = 0; i < actions.length; i++) {
          if (actions[i].name) {
            const paths = actions[i].name.split('.');
            if (paths.length > 1) {
              const action = utils.clone(actions[i]);
              action.name = paths[1];

              if (!group.hasOwnProperty(paths[0])) {
                group[paths[0]] = index;
                index += 1;
                actionsList.push({name: paths[0], group: true, actions: [action]});
              } else {
                actionsList[group[paths[0]]].actions.push(action);
              }
            } else {
              actionsList.push(actions[i]);
              index += 1;
            }
          } else {
            actionsList.push(actions[i]);
            index += 1;
          }
        }

        return actionsList;
      }
      return actions;
    }

    function prepareAction(actions, key) {
      return groupActions((actions && utils.isArray(actions) && actions.length) ? actions : false);
    }

    function translateFilterValue(value) {
      if (String(value) === 'true') {
        value = locales.getLocaleByKey('yes');
      }
      if (String(value) === 'false') {
        value = locales.getLocaleByKey('no');
      }
      return value;
    }

    function prepareFilter(filters, type, allowHidden) {
      let obj = [];

      if (filters && type) {
        if (utils.isObject(filters)) {
          for (let key in filters) {
            if (filters.hasOwnProperty(key)) {
              if (key && (key.substring(0, 1) !== '_' || allowHidden) && filters[key] !== null) {
                const secureFilter = key.substring(0, 1) === '$';
                const filterName = (secureFilter) ? key.replace('$', '') : key;

                if (utils.isArray(filters[key])) {
                  let arr = [];

                  for (let l = 0; l < filters[key].length; l++) {
                    arr.push({
                      filter: type + "." + key + ":" + filters[key][l],
                      value: translateFilterValue(filters[key][l]),
                      remove: queryStringService.checkFilter(type + "." + key + ":" + filters[key][l]),
                      secure: secureFilter
                    })
                  }

                  obj.push({
                    name: filterName,
                    arrayFilters: arr
                  })
                } else {
                  obj.push({
                    filter: type + "." + key + ":" + filters[key],
                    name: filterName,
                    value: translateFilterValue(filters[key]),
                    remove: queryStringService.checkFilter(type + "." + key + ":" + filters[key]),
                    secure: secureFilter
                  })
                }
              }
            }
          }
        } else if (utils.isArray(filters)) {
          for (let i = 0; i < filters.length; i++) {
            if (filters[i] && (filters[i].substring(0, 1) !== '_' || allowHidden)) {
              obj.push({
                filter: type + ":" + filters[i],
                name: filters[i],
                value: translateFilterValue(filters[i]),
                remove: queryStringService.checkFilter(type + ":" + filters[i])
              });
            }
          }
        } else if (utils.isString(filters)) {
          obj = {
            filter: type + ":" + filters,
            name: type,
            value: translateFilterValue(filters),
            remove: queryStringService.checkFilter(type + ":" + filters)
          };
        }
      }

      return obj;
    }

    function checkBulkSupport(actions) {
      let support = false;

      if (!selectionWidgets) {
        return support;
      }

      if (actions && utils.isArray(actions)) {
        for (let i = 0; i < actions.length; i++) {
          if (actions[i].bulksupported) {
            support = true;
            break;
          }
        }
      }

      return support;
    }

    return {
      prepareResult: prepareResult,
      infiniteScrolling: infiniteScrolling,
      prepareAction: prepareAction,
      prepareFilter: prepareFilter,
      checkBulkSupport: checkBulkSupport,
      customItemView: customItemView,
      loadTableViewTemplates: loadTableViewTemplates,
      changeView: changeView,
      changeTableViewTemplate: changeTableViewTemplate,
      groupActions: groupActions
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('manageUtils', manageUtils);

  manageUtils.$inject = ['$timeout', '$window', '$q', 'config', 'utils', 'itemMapping', 'locales', 'resourcesService'];

  function manageUtils($timeout, $window, $q, config, utils, itemMapping, locales, resourcesService) {
    let _tempItemsList = [];
    const constants = {
      CUSTOM_OBJECT: 'custom-object',
      CUSTOM: 'custom',
      INPUT: 'input',
      DYNAMIC_OBJECT: 'dynamic-object'
    };

    function getListEndpoint(sectionConfig, locale) {
      const url = sectionConfig.data.endpoints.list.fullUri;
      return itemMapping.replaceCurlies(url, {locale: locale}, {singleCurlies: true});
    }

    function getCreateNewEndpoint(sectionConfig, locale) {
      if (sectionConfig && sectionConfig.data && sectionConfig.data.endpoints.create && sectionConfig.data.endpoints.create.active) {
        const url = sectionConfig.data.endpoints.create.fullUri;
        return itemMapping.replaceCurlies(url, {locale: locale}, {singleCurlies: true});
      }
      return false;
    }

    function isActiveEndpoint(modelsConfigurations, endpoint, method) {
      return (
        modelsConfigurations &&
        modelsConfigurations.data &&
        modelsConfigurations.data.endpoints[endpoint] &&
        modelsConfigurations.data.endpoints[endpoint].endpoints &&
        modelsConfigurations.data.endpoints[endpoint].endpoints[method] &&
        modelsConfigurations.data.endpoints[endpoint].endpoints[method].active);
    }

    function getSingleItemEndpoint(sectionConfig, locale, itemId) {
      if (sectionConfig && sectionConfig.data && sectionConfig.data.endpoints.item) {
        const url = sectionConfig.data.endpoints.item.fullUri;
        return itemMapping.replaceCurlies(url, {
          locale: locale,
          [sectionConfig.data.keyField]: itemId
        }, {singleCurlies: true});
      }
      return false;
    }

    function getItemEndpoint(option) {
      const {section, item, type, locale, itemId} = option;
      const url = section.data.endpoints[type].fullUri;

      return {
        id: section.data.keyField,
        value: item[section.data.keyField] || itemId,
        uri: itemMapping.replaceCurlies(url, {
          locale: locale,
          [section.data.keyField]: item[section.data.keyField] || itemId
        }, {singleCurlies: true, allowEmpty: true})
      };
    }

    function getMeta(obj, field) {
      if (!obj) return '';
      if (obj['x-meta'] && obj['x-meta'].hasOwnProperty(field)) {
        return obj['x-meta'][field];
      }
      return '';
    }

    function prepareTableFieldsFromResultItems(result) {
      const fields = {};
      const itemKeys = [];

      result.map((item) => {
        for (const field in item) {
          if (item.hasOwnProperty(field)) {
            if (!fields[field]) {
              fields[field] = true;
              let type = 'string';
              let elementType = 'string';
              if (utils.isArray(item[field])) {
                type = 'array';
              }
              if (utils.isObject(item[field])) {
                type = 'object';
              }
              if (type === 'array' && utils.isObject(item[field][0])) {
                elementType = 'object';
              }
              if (type === 'array' && utils.isString(item[field][0])) {
                elementType = 'tag';
              }

              itemKeys.push({
                key: field,
                value: field,
                sort: false,
                elementType: elementType,
                type: type
              });
            }
          }
        }
      });
      return itemKeys;
    }

    function prepareTableFields(section, result) {
      const itemKeys = [];
      const model = utils.clone(section.model);

      if (!model) {
        return prepareTableFieldsFromResultItems(result);
      }

      const customModel = getMeta(model, 'admin-model');
      if (customModel && customModel.properties) {
        for (const key in customModel.properties) {
          if (customModel.properties.hasOwnProperty(key)) {
            model.properties[key] = customModel.properties[key];
          }
        }
      }

      for (const key in model.properties) {
        if (model.properties.hasOwnProperty(key)) {
          const field = {
            key: key,
            value: key,
            sort: false,
            elementType: getFieldType(model.properties[key]),
            type: model.properties[key].type,
            format: model.properties[key].format,
          };

          if (model.properties[key].description) {
            field.description = model.properties[key].description;
          }

          const sort = getMeta(model.properties[key], 'admin-sort');
          if (sort !== '') {
            if (sort === true) {
              field.sort = key;
            } else {
              field.sort = sort;
            }
          }

          const sortOrder = getMeta(model.properties[key], 'admin-sort-order');
          if (sortOrder) {
            field.sortOrder = sortOrder;
          }

          const showField = getMeta(model.properties[key], 'admin-list-show-field');
          if (showField) {
            field.showField = showField;
            field.type = 'string';
            field.elementType = 'string';
          }

          if (field.elementType === 'count') {
            field.type = 'string';
          }

          const maxChars = getMeta(model.properties[key], 'admin-max-chars');
          if (maxChars !== '') {
            field.maxChars = maxChars;
          }

          const list = getMeta(model.properties[key], 'admin-list');
          const hidden = getMeta(model.properties[key], 'admin-hidden');

          if (list === true) {
            itemKeys.push(field);
          } else {
            if (hidden === '' || hidden === false) {
              if (list === '' || list !== false) {
                itemKeys.push(field);
              }
            }
          }
        }
      }

      return itemKeys;
    }

    function isRequiredField(arr, key) {
      if (!arr) return false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === key) {
          return true;
        }
      }
      return false;
    }

    function getLinkedData(configuration, linked, options) {
      const {models} = options || {};
      let linkedData = {
        key: linked
      };
      let dynamicLinked;

      function getLinked(obj, key, endpoint) {
        if (!endpoint.endpoints || !endpoint.model) return obj;

        obj.key = key;
        obj.keyField = endpoint.keyField;
        obj.fullUri = endpoint.endpoints.list.fullUri;

        for (const field in endpoint.model.properties) {
          if (endpoint.model.properties.hasOwnProperty(field)) {
            if (field === 'title') {
              const sort = getMeta(endpoint.model.properties[field], 'admin-sort');
              if (sort !== '') {
                if (sort === true) {
                  obj.sort = field;
                } else {
                  obj.sort = sort;
                }
              }
              obj.name = '{title}';
            } else if (field === 'name') {
              const sort = getMeta(endpoint.model.properties[field], 'admin-sort');
              if (sort !== '') {
                if (sort === true) {
                  obj.sort = field;
                } else {
                  obj.sort = sort;
                }
              }
              obj.name = '{name}';
            }
            if (field === 'description') {
              obj.description = '{description}';
            }
          }
        }
        return obj;
      }

      //we need to check for dynamic linked endpoints
      if (linked.indexOf('/') !== -1) {
        const paths = linked.split('/');

        if (paths.length === 2 && configuration.data && configuration.data.endpoints && configuration.data.endpoints[paths[0]]) {
          if (paths[1].indexOf('{') !== -1 && paths[1].indexOf('}') !== -1) {
            const subPath = paths[1].replace('}', '').replace('{', '');
            linkedData.dynamicKey = linked;
            linkedData.subPath = subPath;

            if (models) {
              for (const key in models) {
                if (models.hasOwnProperty(key)) {
                  if (subPath === key && models[key].enum) {
                    for (let i = 0; i < models[key].enum.length; i++) {
                      if (configuration.data.endpoints[paths[0]][models[key].enum[i]]) {
                        if (!dynamicLinked) dynamicLinked = {};
                        dynamicLinked[models[key].enum[i]] = getLinked({}, models[key].enum[i], configuration.data.endpoints[paths[0]][models[key].enum[i]]);
                      }
                    }
                  }
                }
              }
            }
          } else {
            if (configuration.data && configuration.data.endpoints && configuration.data.endpoints[paths[0]][paths[1]]) {
              linkedData = getLinked(linkedData, linked, configuration.data.endpoints[paths[0]][paths[1]]);
            }
          }
        }

        if (dynamicLinked) {
          linkedData.dynamic = dynamicLinked;
        }

        return linkedData;
      }

      for (const endpoint in configuration.data.endpoints) {
        if (configuration.data.endpoints.hasOwnProperty(endpoint)) {
          if (linked === endpoint) {
            linkedData = getLinked(linkedData, linked, configuration.data.endpoints[endpoint]);
            break;
          }
        }
      }

      return linkedData;
    }

    function updateFiledRequired(field) {
      if (field.id && !field.required && field.items && field.items.length > 0) {
        const onElementsChange = [];
        field.items.map((item) => {
          if (!item.hasOwnProperty('default')) {
            onElementsChange.push(item.id);
          }
        });
        field.items.map((item) => {
          if (item.required) {
            item.onElementsChange = onElementsChange;
          }
        });
      }
    }

    function translateEnum(field, enumArray) {
      const translation = getMeta(field, 'admin-translation');
      const result = [];
      if (translation) {
        enumArray.map((value) => {
          const localeKey = value;
          const name = locales.getLocaleByKey(localeKey);
          result.push({
            key: value,
            name: (name && name !== localeKey) ? name : value
          });
        });
        return result;
      }
      return enumArray;
    }

    function getItemModel(configuration, sectionConfig, options) {
      const section = utils.clone(sectionConfig.data);
      const model = section.model;
      const customModel = prepareItemModel(configuration, section, model, {}, options);
      return customModel.items;
    }

    function prepareItemModel(configuration, section, model, customModel, options, isArray) {
      const {modalAction} = options;
      const items = [];

      for (const key in model.properties) {
        if (model.properties.hasOwnProperty(key)) {

          const field = {
            id: utils.uniqueId(),
            key: key,
            elementType: getFieldType(model.properties[key]),
            type: model.properties[key].type,
            required: isRequiredField(model.required, key),
            defaultRequiredState: isRequiredField(model.required, key)
          };

          if (model.properties[key].hasOwnProperty('minimum')) {
            field.minimum = model.properties[key].minimum;
          }
          if (model.properties[key].hasOwnProperty('maximum')) {
            field.maximum = model.properties[key].maximum;
          }

          const sort = getMeta(model.properties[key], 'admin-sort');
          if (sort !== '') {
            if (sort === true) {
              field.sort = key;
            } else {
              field.sort = sort;
            }
          }

          const sortOrder = getMeta(model.properties[key], 'admin-sort-order');
          if (sortOrder) {
            field.sortOrder = sortOrder;
          }

          const defaultSort = getMeta(model.properties[key], 'default-sort');
          if (defaultSort !== '') {
            field.defaultSort = true;
          }

          const viewOnly = getMeta(model.properties[key], 'admin-view-only');
          if (viewOnly !== '') {
            field.viewOnly = true;
            if (modalAction && modalAction === 'create') {
              continue;
            }
          }

          const hideItems = getMeta(model.properties[key], 'admin-hide-items');
          if (hideItems) {
            field.hideItems = true;
          }

          const adminModel = getMeta(model.properties[key], 'admin-model');
          if (adminModel) {
            model.properties[key].properties = {
              [constants.CUSTOM_OBJECT]: adminModel
            };
            field.elementType = constants.CUSTOM;
            if (key === 'meta') {
              field.hideItems = true;
            }
          }

          const onUpdate = getMeta(model.properties[key], 'admin-on-update');
          if (modalAction && modalAction === 'update' && onUpdate) {
            if (onUpdate.hasOwnProperty('required')) {
              field.required = onUpdate.required;
              field.defaultRequiredState = onUpdate.required;
            }
            if (onUpdate.hasOwnProperty('readonly')) {
              field.readonly = onUpdate.readonly;
              field.defaultReadonlydState = onUpdate.readonly;
            }
          }

          const onCreate = getMeta(model.properties[key], 'admin-on-create');
          if (modalAction && modalAction === 'create' && onCreate) {
            if (onCreate.required) {
              field.required = onCreate.required;
              field.defaultRequiredState = onCreate.required;
            }
            if (onCreate.readonly) {
              field.readonly = onCreate.readonly;
              field.defaultReadonlydState = onCreate.readonly;
            }
            if (onCreate.hidden) {
              continue;
            }
          }

          const adminRequired = getMeta(model.properties[key], 'admin-required');
          if (adminRequired !== '') {
            field.required = adminRequired;
            field.defaultRequiredState = adminRequired;
          }

          if (key === 'id' && !field.required) {
            //field.objectId = true;
          }

          if (model.properties[key].description) {
            field.description = model.properties[key].description;
          }

          if (model.properties[key].pattern) {
            field.pattern = model.properties[key].pattern;
          }

          if (model.properties[key].hasOwnProperty('default')) {
            if (modalAction && modalAction === 'create') {
              field.default = model.properties[key].default;
              field.value = model.properties[key].default;
            }
          }

          const adminDefault = getMeta(model.properties[key], 'admin-default');
          if (adminDefault !== '' && modalAction && modalAction === 'create') {
            field.default = adminDefault;
            field.value = adminDefault;
          }

          const linked = getMeta(model.properties[key], 'admin-linked');
          if (linked) {
            field.linked = getLinkedData(configuration, linked, {models: model.properties});
            field.disabled = !(hasAccessToEndpoint(configuration, linked, {models: model.properties}));
          }

          const linkedResource = getMeta(model.properties[key], 'admin-resource');
          if (linkedResource) {
            field.linked = {
              type: 'resource',
              key: linkedResource
            };
          }

          if (model.properties[key].format) {
            field.format = model.properties[key].format;
          }

          if (model.properties[key].onchange) {
            field.onchange = true;
          }

          if (model.properties[key].enum) {
            field.enum = translateEnum(model.properties[key], model.properties[key].enum);
          } else if (
            model.properties[key].type === 'array' &&
            model.properties[key].items &&
            model.properties[key].items.type === 'string' &&
            model.properties[key].items.enum) {
            field.enum = translateEnum(model.properties[key], model.properties[key].items.enum);
          }

          const format = getMeta(model.properties[key], 'admin-format');
          if (field.elementType === 'date' && format) {
            field.format = format;
          }

          const visible = getMeta(model.properties[key], 'admin-visible');
          if (visible === false) {
            field.isVisible = false;
          }

          let hidden = getMeta(model.properties[key], 'admin-hidden');
          if (modalAction && modalAction === 'update' && onUpdate && onUpdate.hasOwnProperty('hidden')) {
            hidden = onUpdate.hidden;
          }
          if (hidden === '' || hidden === false) {
            if (section.keyField && section.keyField === key) {
              field.isKey = true;
            }

            const readonly = getMeta(model.properties[key], 'admin-readonly');
            if (readonly === true) {
              field.readonly = true;
              field.defaultReadonlydState = true;
            }

            const when = getMeta(model.properties[key], 'admin-when');
            if (when) {
              if (when.field && model.properties[when.field]) {
                let isOptional = false;
                let subField;
                model.properties[when.field].onchange = true;
                if (when.then && when.then.when && model.properties[when.then.when.field]) {
                  model.properties[when.then.when.field].onchange = true;
                  subField = when.then.when.field;
                }
                items.map((obj) => {
                  if (obj.key === when.field) {
                    obj.onchange = true;
                    isOptional = true;
                  }
                  if (subField && obj.key === subField) {
                    obj.onchange = true;
                    isOptional = true;
                  }
                });
                if (isOptional) {
                  field.required = false;
                }
              }
              field.when = when;
            }

            if (model.properties[key].items && model.properties[key].items.type !== 'string') {
              prepareItemModel(configuration, section, model.properties[key].items, field, options, true);
            } else if (model.properties[key].properties) {
              prepareItemModel(configuration, section, model.properties[key], field, options);
            }

            items.push(field);
          }
        }
      }

      if (isArray) {
        customModel.model = updateModelFieldsIds(utils.clone(items), false, true);

        if (customModel.required) {
          customModel.items = [items];
        } else {
          customModel.items = [];
        }
      } else {
        if (customModel.hideItems && utils.isArray(items) && items.length > 0) {
          customModel.model = updateModelFieldsIds(utils.clone(items), false, true);
        }
        if (modalAction === 'create' && customModel.hideItems && utils.isArray(items) && items.length > 0) {
          customModel.items = [];
        } else {
          customModel.items = items;
        }
      }

      updateFiledRequired(customModel);

      return customModel;
    }

    function getFieldType(obj) {
      if (obj.type === 'number') {
        if (obj.enum) {
          if (obj.enum && obj.enum.length === 2 &&
            ((obj.enum[0] === 0 || obj.enum[0] === 1) && (obj.enum[1] === 0 || obj.enum[1] === 1)) ||
            ((obj.enum[0] === false || obj.enum[0] === true) && (obj.enum[1] === false || obj.enum[1] === true))) {
            return 'checkbox';
          }
        }

        return obj.type;
      } else if (obj.type === 'boolean') {
        return 'checkbox';
      } else if (obj.type === 'array') {
        if (obj.items) {
          const type = getMeta(obj, 'admin-type');
          if (type) {
            return type;
          }
          if (obj.items.type === 'string') {
            return 'tag';
          }
          if (obj.items.type === 'object') {
            return 'object';
          }

          return obj.type;
        } else {
          return obj.type;
        }
      } else if (obj.type === 'string') {
        const type = getMeta(obj, 'admin-type');
        if (type) {
          return type;
        }

        if (obj.format && obj.format === 'date') {
          return 'date';
        }

        return obj.type;
      } else if (obj.type === 'object') {
        const type = getMeta(obj, 'admin-type');
        if (type) {
          return type;
        }

        return obj.type;
      } else {
        return obj.type;
      }
    }

    function prepareResult(vm, manageService, result, reset) {
      vm.requestSend = false;

      if (vm.params && result.meta.nexturl) {
        vm.params.startfrom = utils.getParameterByName('startfrom', result.meta.nexturl);
        vm.params.pagesize = result.meta.pagesize;
      }

      if (reset) {
        _tempItemsList = [];
      }

      //append data
      angular.forEach(result.records, (item) => {
        prepareItemIds(item);
        const tempItem = utils.clone(item);
        vm.itemsList.push(prepareItem(vm, tempItem));
        _tempItemsList.push(item);
      });

      //check if we have more items to load
      if (result.records.length === result.meta.pagesize && result.meta.nexturl) {
        vm.showLoadMore = true;
        infiniteScrolling(vm, manageService);
      } else {
        //hide load more button if we don't have items
        vm.showLoadMore = false;
      }
    }

    function prepareItemIds(item) {
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          if (utils.isArray(item[key])) {
            if (utils.isObject(item[key][0])) {
              updateObjectId(item[key]);
            }
          }
        }
      }
    }

    //update array of objects ids
    function updateObjectId(arr) {
      if (arr && utils.isArray(arr)) {
        for (let i = 0; i < arr.length; i++) {
          if (!arr[i].id) {
            arr[i].id = guId();
          }
        }
      }
    }

    //find object inside array of objects by id
    function findFieldByObjectId(arr, id) {
      if (arr && id && utils.isArray(arr)) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === id) {
            return arr[i];
          }
        }
      }
      return false;
    }

    function getOriginalItem(id, value) {
      for (let i = 0; i < _tempItemsList.length; i++) {
        if (_tempItemsList[i][id] === value) {
          return utils.clone(_tempItemsList[i]);
        }
      }
      return false;
    }

    //marge edited item with old value stored in session
    function patchObject(sectionConfig, data, item) {
      const model = sectionConfig.data.model.properties;
      let tempItem = {};

      for (let i = 0; i < _tempItemsList.length; i++) {
        if (_tempItemsList[i][data.id] === data.value) {
          tempItem = utils.clone(_tempItemsList[i]);
        }
      }

      return patchObjectFields(model, tempItem, item, data.id);
    }

    function patchObjectFields(model, tempItem, item, itemKey) {
      for (const key in tempItem) {
        if (tempItem.hasOwnProperty(key)) {
          if (model.hasOwnProperty(key)) {
            if (item.hasOwnProperty(key)) {
              let subModel = {};

              if (model[key]) {
                if (model[key].items) {
                  subModel = model[key].items.properties;
                } else if (model[key].properties) {
                  subModel = model[key].properties;
                }
              }

              if (utils.isObject(item[key])) {
                patchObjectFields(subModel, tempItem[key], item[key], itemKey);
              } else if (utils.isArray(item[key]) && utils.isObject(item[key][0])) {
                for (let i = 0; i < item[key].length; i++) {
                  const newItem = item[key][i];
                  const newTempItem = findFieldByObjectId(tempItem[key], newItem.id);
                  if (newTempItem) {
                    patchObjectFields(subModel, newTempItem, newItem, itemKey);
                  }
                }
              }
            } else {
              const hidden = getMeta(model[key], 'admin-hidden');
              if (itemKey !== key && hidden === true) {
                item[key] = tempItem[key];
              }
            }
          }
        }
      }

      return item;
    }

    function isOnScreen(elem) {
      // if the element doesn't exist, abort
      if (elem.length === 0) {
        return;
      }
      var _window = $(window);
      var viewport_top = _window.scrollTop();
      var viewport_height = _window.height();
      var viewport_bottom = viewport_top + viewport_height;
      var $elem = $(elem);
      var top = $elem.offset().top;
      var height = $elem.height();
      var bottom = top + height;

      return (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom);
    }

    function infiniteScrolling(vm, manageService) {
      const loadMore = $(config.domElements.loadMoreId);

      if (loadMore.length) {
        loadMore.on('inview', (event, visible) => {
          if (visible === true) {
            //prevent multiple request in the same time
            if (vm.requestSend) {
              return;
            }

            $(config.domElements.loadMoreId).off('inview');

            manageService.getItems(vm, vm.itemsListEndpoint, vm.params).success(function(result) {
              if (vm.configuration.processPage) {
                result.records = result.records.map((record) => {
                  record.flow = record.bpmn;
                  return record;
                });
              }
              if (vm.activeTab === 'workflows') {
                result.records = result.records.map((record) => {
                  record.schedule = record.scheduled && record.scheduled.timer;
                  record.nextRunAt = record.scheduled && record.scheduled.nextRunAt;
                  return record;
                });
              }
              prepareResult(vm, manageService, result);
            }).error(() => {
              vm.showLoading = false;
            });
          }
        });
      }

      //check if load more element is visible on screen
      //load more data if is visible
      $timeout(function() {
        if (!vm.requestSend && isOnScreen($(config.domElements.loadMoreId))) {
          manageService.getItems(vm, vm.itemsListEndpoint, vm.params).success(function(result) {
            prepareResult(vm, manageService, result);
          }).error(() => {
            vm.showLoading = false;
          });
        }
      }, 200);
    }

    function prepareResourceResult(tree, field, list) {
      list = list || [];

      const lastChar = field.linked.key[field.linked.key.length - 1];
      const path = field.linked.key.substring(0, field.linked.key.length - 1);

      for (let i = 0; i < tree.length; i++) {
        if (tree[i].type === 'file') {
          let value = tree[i].path;

          if (value.indexOf('public/') !== -1) {
            if (!utils.useNewApi()) {
              value = '/' + value.replace('public/', '');
            }
            if (value.charAt(0) !== '/') {
              value = '/' + value;
            }
          } else if ((value.indexOf(field.linked.key + '/') !== -1)) {
            const split = value.split(path + '/');
            if (split[1]) {
              const extension = split[1].split('.').pop();
              value = split[1].replace('.' + extension, '');
            }
          } else {
            if (lastChar === 's' && (value.indexOf(path + '/') !== -1)) {
              const split = value.split(path + '/');
              if (split[1]) {
                const extension = split[1].split('.').pop();
                value = split[1].replace('.' + extension, '');
              }
            }
          }

          list.push({
            extension: tree[i].extension,
            //name: tree[i].name,
            name: (value.charAt(0) === '/') ? value.slice(1) : value,
            key: tree[i].key ? tree[i].key : value,
            path: tree[i].path
          });
        } else if (tree[i].type === 'directory' && tree[i].children) {
          prepareResourceResult(tree[i].children, field, list);
        }
      }

      return list;
    }

    function removeObjectOnlyWithDefaultValuesField(values, items) {
      if (values && items && items.length > 0) {
        let totalValues = 0;
        let totalDefault = 0;
        let totalDefaultChanged = 0;
        for (const key in values) {
          totalValues += 1;
          if (values.hasOwnProperty(key)) {
            for (let i = 0; i < items.length; i++) {
              if (items[i].key === key && items[i].hasOwnProperty('default')) {
                totalDefault += 1;
                if (items[i].default !== values[key]) {
                  totalDefaultChanged += 1;
                }
              }
            }
          }
        }
        if (totalDefaultChanged === 0 && totalDefault > 0 && items.length > totalDefault && totalValues === totalDefault) {
          return false;
        }
      }

      return values;
    }

    function getLinkedResource(field) {
      const deferred = $q.defer();
      resourcesService.getTree({directory: field.linked.key, fallback: true}).success((result) => {
        deferred.resolve({
          key: getLinkedKey(field.linked),
          data: prepareResourceResult(result, field)
        });
      }).error((err) => {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getLinkedSection(manageService, itemLocale, field) {
      const deferred = $q.defer();
      let url = field.linked.fullUri;
      url = itemMapping.replaceCurlies(url, {locale: itemLocale}, {singleCurlies: true});

      if (!url) {
        deferred.resolve({
          key: getLinkedKey(field.linked),
          data: []
        });
      } else {
        const params = {pagesize: 2000};
        if (field.linked.sort) {
          params.sort = field.linked.sort + ',asc';
        }
        manageService.getItems({}, url, params).success(function(result) {
          const response = [];
          angular.forEach(result.records, (item) => {
            const data = {
              key: item[field.linked.keyField],
              linkedTo: field.linked.key
            };
            if (field.linked.name) {
              data.name = itemMapping.replaceCurlies(field.linked.name, item, {singleCurlies: true});
            }
            if (field.linked.description) {
              data.description = itemMapping.replaceCurlies(field.linked.description, item, {singleCurlies: true});
            }
            if (data.key) {
              if (!data.name) {
                data.name = data.key;
              }
              response.push(data);
            }
          });
          deferred.resolve({
            key: getLinkedKey(field.linked),
            data: response
          });
        }).error((err) => {
          deferred.reject(err);
        });
      }

      return deferred.promise;
    }

    function validateNullObjctFields(obj) {
      if (obj && utils.isObject(obj)) {
        let nullValue = 0;
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (obj[key] === null || obj[key] === '' || obj[key] === ' ') {
              nullValue += 1;
            }
          }
        }
        if (Object.keys(obj).length === nullValue) return null;
      }
      return obj;
    }

    function getItemObject(itemModel, itemData, uploadedFiles, type) {
      const data = {};
      for (let i = 0; i < itemModel.length; i++) {
        let key = itemModel[i].key;
        let value = (itemData.hasOwnProperty(itemModel[i].id)) ? itemData[itemModel[i].id] : '';

        if (itemModel[i].elementType && itemModel[i].elementType === 'checkbox') {
          if (itemModel[i].type !== 'boolean') {
            value = (value === true) ? 1 : 0;
          }
        }

        if (itemModel[i].elementType && itemModel[i].elementType === 'file') {
          if (uploadedFiles[itemModel[i].id]) {
            value = uploadedFiles[itemModel[i].id];
          }
        }

        if (itemModel[i].viewOnly) {
          continue;
        }

        if (type === 'replace' && itemData.hasOwnProperty(itemModel[i].id) && itemData[itemModel[i].id] === '') {
          value = null;
        }
        if (utils.isArray(value) && value.length === 0) {
          if (type === 'replace') {
            value = null;
          } else {
            value = '';
          }
        }

        if (itemModel[i].items && itemModel[i].elementType !== 'json') {
          if (itemModel[i].type === 'array') {
            const arrData = [];
            for (let j = 0; j < itemModel[i].items.length; j++) {
              const tempValue = getItemObject(itemModel[i].items[j], itemData, uploadedFiles);
              if (tempValue) {
                arrData.push(tempValue);
              }
            }
            if (arrData.length > 0) {
              data[key] = arrData;
            }
          } else {
            let tempValue = getItemObject(itemModel[i].items, itemData, uploadedFiles);

            if (itemModel[i].required === false) {
              tempValue = removeObjectOnlyWithDefaultValuesField(tempValue, itemModel[i].items);
            }

            if (tempValue && type === 'replace') {
              tempValue = validateNullObjctFields(tempValue);
            }

            if (tempValue || tempValue === null) {
              if (key === constants.CUSTOM_OBJECT) {
                if (value) {
                  data[value] = tempValue;
                }
              } else {
                data[key] = tempValue;
              }
            }
          }
        } else {
          if (value !== '' || (utils.isArray(value) && value.length > 0)) {
            if (itemModel[i].elementType === constants.DYNAMIC_OBJECT) {
              const customValue = (itemData.hasOwnProperty(itemModel[i].id + '-value')) ? itemData[itemModel[i].id + '-value'] : '';
              if (customValue !== '') {
                data[value] = customValue;
              }
            } else {
              data[key] = value;
            }
          }
        }
      }

      return (utils.objectLength(data) > 0) ? data : '';
    }

    function updateModelFieldsIds(fields, itemData, reset) {
      for (let i = 0; i < fields.length; i++) {
        if (!fields[i].id || reset) {
          fields[i].id = utils.uniqueId();
        }

        if (itemData && fields[i].key === 'id' && !itemData[fields[i].id]) {
          //itemData[fields[i].id] = guId();
        }

        if (fields[i].items) {
          if (fields[i].type === 'array') {
            for (let j = 0; j < fields[i].items.length; j++) {
              updateModelFieldsIds(fields[i].items[j], itemData, reset);
            }
          } else {
            updateModelFieldsIds(fields[i].items, itemData, reset);
          }
        }
      }

      return fields;
    }

    function getValueType(value) {
      if (utils.isObject(value)) {
        return 'object';
      } else if (utils.isArray(value)) {
        if (value.length > 0) {
          if (utils.isObject(value[0])) {
            return 'array';
          } else {
            return 'tag';
          }
        }
        return '';
      } else {
        return 'string';
      }
    }

    function prepareItem(vm, item, options) {
      for (const key in item) {
        if (key === 'x-meta') {
          continue;
        }
        if (item.hasOwnProperty(key)) {
          const type = getValueType(item[key]);
          if (type === 'array') {
            item[key] = prepareArrayOfObjects(vm, item[key], key, options);
          } else if (type === 'object') {
            item[key] = prepareObjectValue(vm, item[key], key, options);
          }
        }
      }

      return item;
    }

    function getCustomPath(vm, path, value) {
      const fieldsProperties = vm.fieldsProperties;
      const customPath = path + '.' + constants.CUSTOM_OBJECT;
      const type = getValueType(value);
      if (value && fieldsProperties[customPath] && type === 'object') {
        for (const key in value) {
          if (value.hasOwnProperty(key)) {
            const customSubPath = customPath + '.' + key;
            if (fieldsProperties[customSubPath]) {
              return customPath;
            }
          }
        }
      }
      return false;
    }

    function prepareObjectValue(vm, value, path, options) {
      const {modalAction} = options || {};
      const temp = [];
      const fieldsProperties = vm.fieldsProperties;
      if (fieldsProperties[path] && fieldsProperties[path].model) {
        const type = getMeta(fieldsProperties[path].model, 'admin-type');
        if (type === 'json') {
          return value;
        }
      }

      for (const key in value) {
        if (value.hasOwnProperty(key)) {
          let hide = false;
          let subPath = path + '.' + key;
          const field = {
            key: key,
            type: getValueType(value[key])
          };

          if (!fieldsProperties[subPath]) {
            const customPath = getCustomPath(vm, path, value[key]);
            if (customPath && fieldsProperties[customPath]) {
              subPath = customPath;
            }
          }

          const customPath = path + '.' + constants.CUSTOM_OBJECT;
          if (fieldsProperties[customPath]) {
            const elementType = getFieldType(fieldsProperties[customPath].model);
            if (elementType === constants.DYNAMIC_OBJECT && fieldsProperties[customPath].model.type === 'string') {
              field.elementType = elementType;
            }
          }

          if (fieldsProperties[subPath]) {
            field.elementType = getFieldType(fieldsProperties[subPath].model);

            let list = getMeta(fieldsProperties[subPath].model, 'admin-list');
            const hidden = getMeta(fieldsProperties[subPath].model, 'admin-hidden');

            if (hidden === true || (list === false && modalAction !== 'update')) {
              hide = true;
            }
          }

          if (!hide) {
            if (field.type === 'object') {
              if (field.elementType === 'json') {
                field.value = value[key];
              } else {
                field.items = prepareObjectValue(vm, value[key], subPath);
              }
            } else {
              field.value = value[key];
            }

            temp.push(field);
          }
        }
      }

      return temp;
    }

    function prepareArrayOfObjects(vm, value, path) {
      if (value) {
        const arr = [];
        for (let i = 0; i < value.length; i++) {
          arr.push(prepareObjectValue(vm, value[i], path));
        }
        return arr;
      } else {
        return [];
      }
    }

    function getActionButtons(section, itemsViewRaw) {
      const actions = {};
      let show = false;

      if (section.data.endpoints.delete && section.data.endpoints.delete.active) {
        actions.delete = true;
        show = true;
      }
      if (section.data.endpoints.replace && section.data.endpoints.replace.active) {
        actions.update = true;
        show = true;
      }
      if (itemsViewRaw) {
        actions.view = true;
        show = true;
      }

      return (show) ? actions : show;
    }

    function isDynamicObject(items) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].elementType && items[i].elementType === constants.DYNAMIC_OBJECT) {
          return true;
        }
      }
      return false;
    }

    function assignDynamicObjectValue(model, item, itemData) {
      const tempModel = model.items[0];
      model.items = [];
      for (let i = 0; i < item.items.length; i++) {
        const itemsModel = utils.clone(tempModel);
        itemsModel.id = utils.uniqueId();
        itemData[itemsModel.id] = item.items[i].key;
        itemData[itemsModel.id + '-value'] = item.items[i].value;
        model.items.push(itemsModel);
      }
    }

    function prepareToUpdateItem(itemModel, item, itemData) {
      for (let i = 0; i < itemModel.length; i++) {
        const itemField = item[itemModel[i].key];

        if (!itemField) {
          continue;
        }

        if (itemModel[i].type === 'array' && itemModel[i].elementType === 'object') {
          const modelField = itemModel[i];

          itemModel[i].items = [];

          if (itemField) {
            const total = (itemField.length - modelField.items.length);

            if (total > 0) {
              for (let j = 0; j < total; j++) {
                const subModel = utils.clone(modelField.model);
                updateModelFieldsIds(subModel, itemData, true);
                modelField.items.push(subModel);
              }
            }

            for (let j = 0; j < modelField.items.length; j++) {
              assignValue(modelField.items[j], itemField[j], itemData);
            }
          } else {
            modelField.items = [];
          }
        } else if (itemModel[i].type === 'object') {
          if (itemModel[i].elementType === 'json') {
            itemData[itemModel[i].id] = itemField;
          } else if (itemModel[i].elementType === constants.CUSTOM) {
            if (isDynamicObject(itemField)) {
              assignDynamicObjectValue(itemModel[i], {
                items: itemField
              }, itemData);
            } else {
              assignValue(itemModel[i], {
                items: itemField
              }, itemData);
            }
          } else {
            if (itemModel[i].items) {
              assignValue(itemModel[i].items, itemField, itemData);
            }
          }
        } else {
          if (itemModel[i].linked && itemModel[i].linked.type === 'resource') {
            itemData[itemModel[i].id] = assignResourceValue(itemModel[i], item[itemModel[i].key]);
          } else {
            if (itemModel[i].linked && item[itemModel[i].key] && itemModel[i].enum && itemModel[i].enum.length === 0) {
              itemModel[i] = setDefaultLinkedValue(itemModel[i], item[itemModel[i].key]);
            }
            itemData[itemModel[i].id] = item[itemModel[i].key];
            if (itemModel[i].type === 'string' && itemModel[i].elementType === 'password') {
              itemData[itemModel[i].id + '-retype'] = item[itemModel[i].key];
            }
          }
        }
      }

      return itemModel;
    }

    function setDefaultLinkedValue(model, values) {
      if (values && model.enum) {
        values = (utils.isArray(values)) ? values : [values];
        for (let i = 0; i < values.length; i++) {
          model.enum.push({
            linkedTo: model.linked.key,
            key: values[i],
            name: values[i]
          });
        }
      }
      return model;
    }

    function assignCustomObjectValue(model, item, itemData) {
      const tempModel = model.items[0];
      model.items = [];

      for (let i = 0; i < item.items.length; i++) {
        const itemsModel = utils.clone(tempModel);
        itemsModel.id = utils.uniqueId();
        itemData[itemsModel.id] = item.items[i].key;
        updateModelFieldsIds(itemsModel.items, itemData, true);
        assignValue(itemsModel.items, item.items[i].items, itemData);
        model.items.push(itemsModel);
      }
    }

    function assignResourceValue(field, value) {
      return value;
    }

    function assignValue(model, item, itemData) {
      updateFiledRequired(model);

      if (utils.isObject(model) && model.type === 'object' && model.elementType === constants.CUSTOM) {
        if (item && item.items && model.items[0].key === constants.CUSTOM_OBJECT) {
          assignCustomObjectValue(model, item, itemData);
        }
        return;
      }

      if (utils.isArray(model)) {
        for (let i = 0; i < model.length; i++) {
          assignValue(model[i], findElementByKey(item, model[i].key), itemData);
        }
      } else if (utils.isObject(model)) {
        if (item) {
          if (model.type === 'integer') {
            itemData[model.id] = parseInt(item.value);
          } else if (model.type === 'number') {
            itemData[model.id] = Number(item.value);
          } else if (model.type === 'boolean') {
            itemData[model.id] = item.value;
          } else if (model.type === 'string' && model.elementType === 'password') {
            itemData[model.id] = item.value;
            itemData[model.id + '-retype'] = item.value;
          } else if (model.type === 'string') {
            if (model.linked && model.linked.type === 'resource') {
              itemData[model.id] = assignResourceValue(model, item.value);
            } else {
              if (model.linked && model.linked.dynamic) {
                model.enum = [item.value];
              }
              itemData[model.id] = item.value;
            }
          } else if (model.type === 'array' && model.elementType === 'tag') {
            itemData[model.id] = item.value;
          } else if ((model.type === 'object' || model.type === 'array') && model.elementType === 'json') {
            itemData[model.id] = item.value;
          } else {
            if (model.items) {
              assignValue(model.items, item.items, itemData)
            }
          }
        }
      }
    }

    function findElementByKey(array, key) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          return array[i];
        }
      }
    }

    function getFieldsProperties(section) {
      const obj = {};
      const model = utils.clone(section.model);

      if (!model) {
        return obj;
      }

      return prepareFieldsProperties(obj, model);
    }

    function prepareFieldsProperties(obj, model, path) {
      for (const key in model.properties) {
        if (model.properties.hasOwnProperty(key)) {
          const subPath = (path) ? path + '.' + key : key;

          obj[subPath] = {
            model: model.properties[key]
          };

          const adminModel = getMeta(model.properties[key], 'admin-model');
          if (adminModel) {
            model.properties[key].properties = {
              [constants.CUSTOM_OBJECT]: adminModel
            };
          }

          if (model.properties[key].items) {
            if (model.properties[key].items.type !== 'string') {
              prepareFieldsProperties(obj, model.properties[key].items, subPath);
            }
          } else if (model.properties[key].properties) {
            prepareFieldsProperties(obj, model.properties[key], subPath);
          }
        }
      }
      return obj;
    }

    function getDefaultLocale(sectionConfig) {
      if (sectionConfig.locale) {
        return sectionConfig.locale
      }
      return false;
    }

    function guId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return s4();
    }

    function getTabs(configuration) {
      const tabs = [];
      for (const endpoint in configuration.data.endpoints) {
        if (configuration.data.endpoints.hasOwnProperty(endpoint)) {
          if (configuration.data.endpoints[endpoint].endpoints) {
            if (!configuration.data.endpoints[endpoint].hidden) {
              tabs.push({
                key: endpoint,
                name: configuration.data.endpoints[endpoint].name
              });
            }
          } else {
            const tab = {
              key: endpoint,
              name: configuration.data.endpoints[endpoint].name,
              submenu: []
            };

            for (const subEndpoint in configuration.data.endpoints[endpoint]) {
              if (configuration.data.endpoints[endpoint].hasOwnProperty(subEndpoint)) {
                if (!configuration.data.endpoints[endpoint][subEndpoint].hidden && subEndpoint !== 'name') {
                  tab.submenu.push({
                    parent: endpoint,
                    key: subEndpoint,
                    name: configuration.data.endpoints[endpoint][subEndpoint].name,
                    isSubmenu: true
                  });
                }
              }
            }

            tabs.push(tab);
          }
        }
      }

      return tabs;
    }

    function getLinkedKey(linked) {
      let key = linked.key;
      if (linked.type) {
        key += linked.type;
      }
      return key;
    }

    function hasAccessToEndpoint(configuration, endpoint, options) {
      const {models} = options || {};
      //we need to check for dynamic linked endpoints
      if (endpoint.indexOf('/') !== -1) {
        const paths = endpoint.split('/');

        if (paths.length === 2 && configuration.data && configuration.data.endpoints && configuration.data.endpoints[paths[0]]) {
          if (paths[1].indexOf('{') !== -1 && paths[1].indexOf('}') !== -1) {
            const subPath = paths[1].replace('}', '').replace('{', '');
            if (models) {
              for (const key in models) {
                if (models.hasOwnProperty(key)) {
                  if (subPath === key && models[key].enum) {

                    //check if has access in all possible endpoints
                    for (let i = 0; i < models[key].enum.length; i++) {
                      if (!configuration.data.endpoints[paths[0]][models[key].enum[i]]) {
                        return false;
                      }
                    }

                    return true;
                  }
                }
              }
            }
          } else {
            return !!(configuration.data && configuration.data.endpoints && configuration.data.endpoints[paths[0]][paths[1]])
          }
        }
      }

      return !!(endpoint && configuration.data && configuration.data.endpoints && configuration.data.endpoints[endpoint]);
    }

    function storeItem(item) {
      _tempItemsList.push(item);
    }

    return {
      prepareTableFields,
      getItemModel,
      prepareResult,
      infiniteScrolling,
      getListEndpoint,
      getCreateNewEndpoint,
      getItemObject,
      updateModelFieldsIds,
      getValueType,
      getActionButtons,
      getItemEndpoint,
      prepareToUpdateItem,
      prepareItem,
      getFieldsProperties,
      getDefaultLocale,
      guId,
      patchObject,
      getTabs,
      getSingleItemEndpoint,
      prepareItemIds,
      getLinkedSection,
      getLinkedResource,
      getOriginalItem,
      getLinkedKey,
      storeItem,
      updateFiledRequired,
      hasAccessToEndpoint,
      isActiveEndpoint,
      getLinkedData
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('pagination', pagination);

  pagination.$inject = ['utils'];
  function pagination(utils) {
    const create = function(options) {
      let fullUrl = location.href;
      const pageParamter = 'startfrom';
      const sizeParamter = 'pagesize';
      const total = Number(options.totalresults);
      const maxPost = options.pagesize;
      let current = (fullUrl.indexOf(pageParamter) !== -1) ? ((Number(utils.getParamByName(pageParamter, fullUrl)) + maxPost) / maxPost) : 1;
      const maxPages = 10;
      const startOffsetOn = 6;

      let link = (fullUrl.indexOf(pageParamter) !== -1) ? utils.removeParam(pageParamter, fullUrl) : fullUrl;
      if (fullUrl.indexOf(pageParamter) !== -1) {
        link = utils.removeParam(pageParamter, fullUrl);
        link = utils.removeParam(sizeParamter, link);
      }

      let sep = (link.indexOf('?') !== -1) ? ((link.indexOf('=') !== -1) ? '&' : '') : '?';
      sep += sizeParamter + '=' + maxPost;

      const obj = {
        next: false,
        prev: false,
        pages: false
      };

      if (total > maxPost) {
        const totalPages = (total > (parseInt(total / maxPost) * maxPost)) ? parseInt(total / maxPost) + 1 : parseInt(total / maxPost);
        const nextStartFrom = (((current + 1) * maxPost) - maxPost);
        const prevStartFrom = (((current - 1) * maxPost) - maxPost);

        const next = {
          link: link + sep + pageParamter + '=' + nextStartFrom,
          params: {
            startfrom: nextStartFrom,
            pagesize: maxPost
          }
        };
        const prev = {
          link: link + sep + pageParamter + '=' + prevStartFrom,
          params: {
            startfrom: prevStartFrom,
            pagesize: maxPost
          }
        };

        if (current == 1) {
          obj.next = next;
        } else if (current == totalPages) {
          obj.prev = prev;
        } else {
          obj.next = next;
          obj.prev = prev;
        }

        const activePages = (totalPages >= maxPages) ? maxPages : totalPages;
        const offset = (current > startOffsetOn && totalPages > maxPages) ? current - startOffsetOn : 0;
        const stopOffset = ((offset + activePages) > totalPages);
        obj.pages = [];

        for (let i = 1; i <= activePages; i++) {
          const page = (stopOffset) ? (totalPages - activePages) + i : (offset) + i;
          const pageStartFrom = ((page * maxPost) - maxPost);

          obj.pages.push({
            link: link + sep + pageParamter + '=' + pageStartFrom,
            active: (page == current),
            number: page,
            params: {
              startfrom: pageStartFrom,
              pagesize: maxPost
            }
          })
        }
      }

      return obj;
    };

    return {
      create: create
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('processesUtils', processesUtils);

  processesUtils.$inject = ['$timeout', 'config', 'utils'];

  function processesUtils ($timeout, config, utils) {
    const statusIcon = {
      running: 'fa-play',
      completed: 'fa-check',
      paused: 'fa-pause',
      error: 'fa-times',
      stopped: 'fa-stop'
    };

    function updateProcessesItem(process) {
      process = setProcessStatusClass(process);
      process = setProcessStatusIcon(process);
      process = updateProcessStates(process);

      return process;
    }

    function getProcessStatePosition(process) {
      if (processCompleted(process)) {
        return {index: false};
      }
      let index = -1;
      let stateError = false;

      process.state.sort((a, b) => {
        return a.order - b.order;
      });
      for (let i = 0; i < process.state.length; i++) {
        if (process.state[i].result) {
          index = i;
          if (process.state[i].result.error === true) {
            stateError = true;
          }
        }
      }
      if (process.processStatus === 'running' && index === -1) {
        return {index: false};
      }

      return {index, stateError};
    }

    function processCompleted(process) {
      let completed = true;

      if (process.processStatus === 'completed') {
        for (let i = 0; i < process.state.length; i++) {
          if (!process.state[i].result && process.state[i].required) {
            completed = false;
          } else if (process.state[i].result && process.state[i].required && process.state[i].result.error === true) {
            completed = false;
          }
        }
      } else {
        completed = false;
      }

      return completed;
    }

    function updateProcessStates(process) {
      const states = [];
      const processStates = process.state.filter((state) => state.hide !== true);

      processStates.sort((a, b) => {
        return a.order - b.order;
      });

      const {index} = getProcessStatePosition(process);

      const startState = {
        customClass: 'x-small x-start',
        completed: !processCompleted(process) && index === false
      };
      const endState = {
        customClass: 'x-small x-end',
        completed: processCompleted(process),
        status: (processCompleted(process) && process.status.statusmessage) ? process.status : false
      };

      if (index === -1) {
        startState.status = (process.status.statusmessage) ? process.status : false;
        startState.currentPosition = true;
      }

      states.push(startState);
      for (let i = 0; i < processStates.length; i++) {
        const state = processStates[i];
        const percentage = (100 / (processStates.length + 1)) * (i + 1);
        state.leftStyle = 'calc(' + percentage + '% - 13px)';
        states.push(state);
      }

      states.push(endState);

      process.state = states;
      return process;
    }

    function setProcessStatusIcon(process) {
      process.processStatusIcon = statusIcon[process.processStatus];
      return process;
    }

    function setProcessStatusClass(process) {
      let status = process.status.name.toLowerCase();

      if (status === 'stopped') {
        let stoppedWithError = false;
        for (let i = 0; i < process.state.length; i++) {
          if (process.state[i].required && process.state[i].result && process.state[i].result.error) {
            stoppedWithError = true;
          }
        }

        if (stoppedWithError || process.status.statuscode !== 200) {
          status = 'error';
        }
      }

      process.processStatus = status;
      return process;
    }

    function fixTooltipPosition() {
      $('.process-tooltip').each(function() {
        const width = $(this).outerWidth();
        if (width > 380) {
          $(this).addClass('remove-nowrap');
        }
        $(this).css({'margin-left': '-' + ((width / 2) - 2) + 'px'});
      });
    }

    function prepareResult(vm, service, result) {
      vm.requestSend = false;
      vm.showLoading = false;

      if (vm.params && result.meta.nexturl) {
        vm.params.startfrom = utils.getParameterByName('startfrom', result.meta.nexturl);
        vm.params.pagesize = result.meta.pagesize;
      }

      //append data
      angular.forEach(result.records, (item) => {
        vm.processesItems.push(updateProcessesItem(item));
      });

      $timeout(() => {
        fixTooltipPosition();
      }, 0);

      //check if we have more items to load
      if (result.records.length === result.meta.pagesize && result.meta.nexturl) {
        infiniteScrolling(vm, service);
      }
    }

    function getPagination(vm, service) {
      vm.requestSend = true;

      service.get(vm, vm.params).success(function(result) {
        prepareResult(vm, service, result);
      }).error(function() {
        vm.showLoading = false;
      });
    }

    function infiniteScrolling(vm, service) {
      vm.showLoading = true;
      const loadMore = $(config.domElements.loadMoreId);

      if (loadMore.length) {
        $timeout(() => {
          if (($(document).height() - 70) < $(window).height() && !vm.requestSend) {
            getPagination(vm, service);
          }
        }, 600);

        loadMore.on('inview', (event, visible) => {
          if (visible === true) {
            //prevent multiple request in the same time
            if (vm.requestSend) {
              return;
            }

            loadMore.off('inview');

            getPagination(vm, service);
          }
        });
      }
    }

    return {
      prepareResult: prepareResult,
      infiniteScrolling: infiniteScrolling,
      updateProcessesItem: updateProcessesItem,
      fixTooltipPosition: fixTooltipPosition
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('queryStringUtils', queryStringUtils);

  queryStringUtils.$inject = ['config', 'utils'];
  function queryStringUtils(config, utils) {
    let workspaceOperator = false;
    let defaultWorkspaceOperator = 'OR';

    function removeCustomQuerySting(params) {
      //remove custom params from QueryString
      if (config.excludeCustomParams) {
        for (let key in params) {
          if (params.hasOwnProperty(key)) {
            if (config.excludeCustomParams.indexOf(key) !== -1) {
              delete params[key];
            }
          }
        }
      }

      return params;
    }

    function escapedString(string) {
      const specialChar = [':', '!', '[', ']', '(', ')', '{', '}', '"', '^'];
      let tempString = '';
      let i = string.length;
      let returnString = true;

      while (i--) {
        if (i === string.length - 1) {
          if (specialChar.indexOf(string[i]) !== -1) {
            tempString = '\\\\' + string[i];
            returnString = false;
          }
        } else {
          if (specialChar.indexOf(string[i]) !== -1) {
            tempString = '\\\\' + string[i] + tempString;
          } else {
            tempString = string[i] + tempString;
          }
        }
      }

      return (returnString) ? string : tempString;
    }

    function getWorkspaceOperator(operator) {
      if (operator) {
        return operator;
      }
      if (!workspaceOperator) {
        const workspace = $(config.domElements.currentWorkspaceId);
        if (workspace.length) {
          if (workspace.attr("operator")) {
            workspaceOperator = workspace.attr("operator");
          }
        }
      }

      return (workspaceOperator) ? workspaceOperator : defaultWorkspaceOperator;
    }

    const prepareTerm = function(params, operator) {
      let queryParam = utils.clone(params);
      const wildcard = '*';

      queryParam.term = escapedString(queryParam.term);

      if (queryParam.term !== wildcard) {
        if (queryParam.term.indexOf(':') === -1 && queryParam.term.indexOf('!') === -1) {
          queryParam.term = queryParam.term.replace(/-/g, ' ');
          if ((queryParam.term.match(new RegExp(" ", "g")) || []).length) {
            const termArray = queryParam.term.split(' ');
            const term = termArray.filter(v => v !== '');
            for (let i = 0; i < term.length; i++) {
              term[i] = escapedString(term[i]);
              term[i] += wildcard
            }

            if (term.length > 1) {
              queryParam.term = term.join(' ' + getWorkspaceOperator(operator) + ' ');
            } else {
              term[0] = term[0].substring(0, term[0].length - 1);
              queryParam.term = term[0] + '* OR ' + term[0];
            }

          } else {
            queryParam.term += wildcard + ' OR ' + queryParam.term;
          }
        }
      }

      return removeCustomQuerySting(queryParam);
    };

    return {
      prepareTerm: prepareTerm,
      removeCustomQuerySting: removeCustomQuerySting
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('resourcesUtils', resourcesUtils);

  function resourcesUtils() {

    function getFileNameFormPath(path) {
      const arrPath = removeEmptyValue(path.split('/'));
      return arrPath[arrPath.length - 1];
    }

    function getFileExtensionFormName(item, name) {
      if (item.type === 'directory') return '';
      const arr = removeEmptyValue(name.split('.'));
      return '.' + arr[arr.length - 1];
    }

    function getParentFromPath(path) {
      if (!path) return path;
      const newPath = [];
      const arrPath = removeEmptyValue(path.split('/'));
      if (arrPath.length === 1) return path;
      for (let i = 0; i < arrPath.length; i++) {
        if (i !== (arrPath.length - 1)) {
          newPath.push(arrPath[i]);
        }
      }
      return newPath.join('/');
    }

    function removeEmptyValue(arr) {
      const temp = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[1] !== '') {
          temp.push(arr[i]);
        }
      }
      return temp;
    }

    function getNewItemPath(item) {
      const name = getFileNameFormPath(item.path);
      const extension = getFileExtensionFormName(item, name);
      const parent = getParentFromPath(item.path);
      return parent + '/' + item.newPath + extension;
    }

    function changeChildPath(tree, newPath, oldPath) {
      for (let i = 0; i < tree.length; i++) {
        tree[i].path = newPath + tree[i].path.substring(oldPath.length);
        if (tree[i].children) {
          changeChildPath(tree[i].children, newPath, oldPath);
        }
      }
    }

    function removePreviewsSelected(tree) {
      angular.forEach(tree, (node) => {
        if (node.selected) {
          node.selected = false;
        }
        if (node.open && node.children) {
          removePreviewsSelected(node.children);
        }
        return node;
      });
    }

    function removePreviewsActive(tree) {
      angular.forEach(tree, (node) => {
        if (node.active) {
          node.active = false;
        }
        if (node.open && node.children) {
          removePreviewsActive(node.children);
        }
        return node;
      });
    }

    function closeChildren(tree) {
      angular.forEach(tree, (node) => {
        if (node.open && node.children) {
          node.open = false;
          removePreviewsActive(node.children);
        }
        return node;
      });
    }

    function getItemByPath(tree, path) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].path === path) {
          return tree[i];
        } else {
          if (tree[i].open && tree[i].children) {
            const found = getItemByPath(tree[i].children, path);
            if (found) return found;
          }
        }
      }
    }

    function getItemByPathDipped(tree, path, options) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].path === path) {
          return tree[i];
        } else {
          if (isSubDir(tree[i].path, path)) {
            if (options && options.openSubDir) {
              tree[i].open = true;
            }
            const found = getItemByPathDipped(tree[i].children, path, options);
            if (found) return found;
          }
        }
      }
    }

    function getItemById(tree, id) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].id === id) {
          return tree[i];
        } else {
          if (tree[i].children) {
            const found = getItemById(tree[i].children, id);
            if (found) return found;
          }
        }
      }
    }

    function removeItemById(tree, id) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].id === id) {
          tree.splice(i, 1);
        } else {
          if (tree[i].children) {
            const found = removeItemById(tree[i].children, id);
            if (found) return found;
          }
        }
      }
    }

    function checkItemName(tree, item, name) {
      const dir = (item.path === '/') ? tree : getItemById(tree, item.id);

      if (dir && dir.children) {
        for (let i = 0; i < dir.children.length; i++) {
          if (dir.children[i].name === name) {
            return true;
          }
        }
      }

      return false;
    }

    function renameItem(tree, selected, newPath) {
      const name = getFileNameFormPath(newPath);
      const item = getItemByPath(tree, selected.path);

      if (selected.type === 'directory') {
        if (item.children) {
          changeChildPath(item.children, newPath, item.path);
        }
      }

      item.name = name;
      item.path = newPath;
    }

    function sort(tree) {
      tree.sort(function(a, b) {
        const o1 = a.type;
        const o2 = b.type;
        const p1 = a.name;
        const p2 = b.name;

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      });
    }

    function getFormsList(tree, path) {
      const list = [];
      const parent = path.split('/');
      const dir = getItemByPath(tree, parent[0]);

      if (dir && dir.children) {
        getChildren(dir.children);
      }

      function getChildren(arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type === 'file') {
            list.push({
              path: arr[i].path,
              name: arr[i].name
            });
          } else {
            if (arr[i].children) {
              getChildren(arr[i].children);
            }
          }
        }
      }

      return list;
    }

    function isSubDir(dirPath, path) {
      return (dirPath && path.substring(0, dirPath.length) === dirPath);
    }

    function selectItemByPath(tree, path, options) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].path === path) {
          tree[i].open = options.open;
          tree[i].active = true;
        } else if (isSubDir(tree[i].path, path)) {
          tree[i].open = true;
          if (tree[i].children) {
            selectItemByPath(tree[i].children, path, options);
          }
        } else {
          tree[i].open = false;
          tree[i].active = false;
        }
      }
    }

    return {
      sort: sort,
      removeEmptyValue: removeEmptyValue,
      getFileNameFormPath: getFileNameFormPath,
      getFileExtensionFormName: getFileExtensionFormName,
      getParentFromPath: getParentFromPath,
      getNewItemPath: getNewItemPath,
      changeChildPath: changeChildPath,
      removePreviewsActive: removePreviewsActive,
      closeChildren: closeChildren,
      getItemByPath: getItemByPath,
      getItemById: getItemById,
      removeItemById: removeItemById,
      checkItemName: checkItemName,
      renameItem: renameItem,
      removePreviewsSelected: removePreviewsSelected,
      getFormsList: getFormsList,
      selectItemByPath: selectItemByPath,
      getItemByPathDipped: getItemByPathDipped
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('select2Utils', select2Utils);

  select2Utils.$inject = ['locales'];
  function select2Utils(locales) {
    const language = function() {
      return {
        maximumSelected: function(args) {
          const maximumSelected = locales.getLocaleByKey('form_autocomplete_maximum_selected');
          let message = maximumSelected.replace(/{{maxSelect}}/g, args.maximum).replace(/{maxSelect}/g, args.maximum);
          if (args.maximum != 1) {
            message += 's';
          }
          return message;
        },
        inputTooShort: function(args) {
          const inputTooShort = locales.getLocaleByKey('form_autocomplete_input_to_short');
          return inputTooShort.replace(/{{chars}}/g, args.minimum - args.input.length).replace(/{chars}/g, args.minimum - args.input.length);
        },
        errorLoading: function() {
          return locales.getLocaleByKey('form_autocomplete_error_loading');
        },
        loadingMore: function() {
          return locales.getLocaleByKey('form_autocomplete_loading_more');
        },
        noResults: function() {
          return locales.getLocaleByKey('form_autocomplete_noresults');
        },
        searching: function() {
          return locales.getLocaleByKey('form_autocomplete_searching');
        }
      }
    };

    return {
      language: language
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('shortcutsUtils', shortcutsUtils);

  shortcutsUtils.$inject = ['$location', '$timeout', 'config', 'utils', 'queryStringService'];
  function shortcutsUtils($location, $timeout, config, utils, queryStringService) {
    function prepareResult(vm, service, result) {
      vm.requestSend = false;

      if (vm.params && result.meta.nexturl) {
        vm.params.startfrom = utils.getParameterByName("startfrom", result.meta.nexturl);
        vm.params.pagesize = result.meta.pagesize;
      }

      //append data
      angular.forEach(result.records, (item) => {
        if (utils.useNewApi()) {
          item.name = item.title;
        }
        prepareTags(vm, item);
        vm.shortcutsItems.push(item);
      });

      $timeout(changeShortcutHeight, 0);

      //check if we have more data to load
      if (result.records.length == result.meta.pagesize && !vm.disableScrolling && result.meta.nexturl) {
        vm.showLoading = true;
        infiniteScrolling(vm, service);
      } else {
        //hide load more button
        vm.showLoading = false;
        vm.disableScrolling = true;
      }
    }

    function changeShortcutHeight() {
      let maxHight = false;
      const shortcutsElements = $('.shortcuts-list .shortcuts .item-block');
      shortcutsElements.attr('style', '');

      shortcutsElements.each(function() {
        const hight = $(this).outerHeight();
        if (maxHight) {
          if (hight > maxHight) {
            maxHight = hight;
          }
        } else {
          maxHight = hight;
        }
      });

      shortcutsElements.css({
        height: maxHight + 'px'
      });
    }

    function prepareWorkspaces(vm, item) {
      const params = queryStringService.getQueryString();
      const workspaces = [];

      if (item.workspace) {
        for (let i = 0; i < item.workspace.length; i++) {
          if (vm.userWorkspaces[item.workspace[i]]) {
            workspaces.push({
              name: vm.userWorkspaces[item.workspace[i]],
              key: item.workspace[i],
              remove: !!(params.workspace && params.workspace === item.workspace[i])
            });
          } else {
            workspaces.push({
              name: item.workspace[i],
              key: item.workspace[i],
              remove: !!(params.workspace && params.workspace === item.workspace[i])
            });
          }
        }
      }

      item.workspace = workspaces;
    }

    function prepareTags(vm, item) {
      const tags = [];

      if (item.tag) {
        for (let i = 0; i < item.tag.length; i++) {
          tags.push({
            key: item.tag[i],
            remove: !!checkTagOnParams(item.tag[i])
          });
        }
      }

      item.tag = tags;
    }

    function checkTagOnParams(tag) {
      const queryParams = $location.search();
      const activeTags = (queryParams.tag) ? (utils.isArray(queryParams.tag)) ? queryParams.tag : [queryParams.tag] : false;

      if (activeTags) {
        for (let i = 0; i < activeTags.length; i++) {
          if (activeTags[i] == tag) {
            return true;
          }
        }
      }

      return false;
    }

    function infiniteScrolling(vm, service) {
      const loadMore = $(config.domElements.loadMoreId);

      if (loadMore.length) {
        loadMore.on('inview', (event, visible) => {
          if (visible == true) {
            //prevent multiple request in the same time
            if (vm.requestSend) {
              return;
            }

            loadMore.off('inview');

            service.get(vm, vm.params).success((result) => {
              prepareResult(vm, service, result)
            }).error(() => {
              vm.showLoading = false;
            });
          }
        });
      }
    }

    return {
      prepareResult: prepareResult,
      infiniteScrolling: infiniteScrolling,
      changeShortcutHeight: changeShortcutHeight
    };
  }
})();

(function() {
  angular
    .module('onify')
    .factory('utils', utils);

  utils.$inject = ['$http', '$q', '$window', 'config'];

  function utils($http, $q, $window, config) {
    return {
      getParameterByName: function(name, url) {
        if (!url) url = window.location.href;

        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      },
      prepareQueryString: function(queryString) {
        let obj = {};
        //prepare query
        if (queryString.indexOf('?') !== -1) {
          let query = queryString.split('?');

          if (query[1]) {
            query = query[1].split('&');

            query.map(function(item) {
              if (item.indexOf('__proto__') === -1) {
                const sp = item.split('=');

                if (sp[0] === "filter") {
                  if (obj[sp[0]]) {
                    obj[sp[0]].push(decodeURIComponent(sp[1]))
                  } else {
                    obj[sp[0]] = [decodeURIComponent(sp[1])]
                  }
                } else {
                  obj[sp[0]] = decodeURIComponent(sp[1]);
                }
              }
            });

            return obj;
          }
        }

        return false;
      },
      isObject: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
      },
      isArray: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      },
      isString: function(obj) {
        return Object.prototype.toString.call(obj) === '[object String]';
      },
      isBoolean: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Boolean]';
      },
      isNumber: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Number]';
      },
      isFile: function(obj) {
        return Object.prototype.toString.call(obj) === '[object File]';
      },
      isFunction: function(obj) {
        return Object.prototype.toString.call(obj) === '[object Function]';
      },
      arrayConcat: function(arr1, arr2) {
        let arr = [];

        for (let i = 0; i < arr1.length; i++) {
          arr.push(arr1[i])
        }

        for (let j = 0; j < arr2.length; j++) {
          if (arr1.indexOf(arr2[j]) === -1) arr.push(arr2[j])
        }

        return arr;
      },
      anyMatchInArray: function(array, toCheck, allowEmpty) {
        let found = false;

        if (toCheck && this.isString(toCheck)) {
          toCheck = [toCheck];
        }

        if (array && array.length) {
          if (toCheck && toCheck.length) {
            for (let j = 0; j < toCheck.length; j++) {
              if (array.indexOf(toCheck[j]) !== -1) {
                found = true;
                break;
              }
            }
          }
        } else {
          return (allowEmpty);
        }

        return found;
      },
      replaceLineBreaks: function(string) {
        if (string) return string.replace(/(?:\r\n|\r|\n)/g, '<br />');
        return string;
      },
      capitalizeFirstLetter: function(string) {
        if (string) return string.charAt(0).toUpperCase() + string.slice(1);
        return string;
      },
      urlExists: function(url) {
        var deferred = $q.defer();

        $http.head(url)
          .success(() => {
            deferred.resolve(true);
          })
          .error(() => {
            deferred.reject(false);
          });

        return deferred.promise;
      },
      getParamByName: function(name, url) {
        if (!url) {
          url = window.location.href;
        }

        if (url.indexOf('?') !== -1 && name) {
          const param = [];
          url = url.split('?');

          if (url[1]) {
            const parameters = url[1].split('&');
            if (parameters.length) {
              for (let i = 0; i < parameters.length; i++) {
                const paramName = parameters[i].split('=');
                if (paramName && paramName[0] === name) {
                  param.push(paramName[1]);
                }
              }

              if (param.length) {
                return (param.length === 1) ? param[0] : param;
              }
            }
          }
        }

        return false;
      },
      removeParam: function(key, sourceURL) {
        let rtn = sourceURL.split("?")[0],
          param,
          params_arr = [],
          queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
          params_arr = queryString.split("&");
          for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
              params_arr.splice(i, 1);
            }
          }
          rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
      },
      safeApply: function(vm, fn) {
        const phase = vm.$root.$$phase;
        if (phase == '$apply' || phase == '$digest') {
          if (fn && (typeof(fn) === 'function')) {
            fn();
          }
        } else {
          vm.$apply(fn);
        }
      },
      clone: function(obj) {
        var copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
          copy = new Date();
          copy.setTime(obj.getTime());
          return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
          copy = [];
          for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = this.clone(obj[i]);
          }
          return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
          copy = {};
          for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
          }
          return copy;
        }
      },
      cloneItem: function(obj) {
        var copy = {};

        if (null == obj || !this.isObject(obj)) return obj;

        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            if (this.isObject(obj[attr])) {
              copy[attr] = this.cloneItem(obj[attr]);
            } else {
              copy[attr] = obj[attr];
            }
          }
        }

        return copy;
      },
      order: function(object, field) {
        object.sort((a, b) => {
          if (!a[field] || !b[field]) return 0;
          return parseFloat((a[field]) ? a[field] : 0) - parseFloat((b[field]) ? b[field] : 0);
        });
        return object;
      },
      removeDuplicatedObjects: function(arr, field) {
        const tempArr = [];
        const tempFields = {};

        for (let i = 0; i < arr.length; i++) {
          if (!tempFields[arr[i][field]]) {
            tempArr.push(arr[i]);
            tempFields[arr[i][field]] = true;
          }
        }

        return tempArr;
      },
      onResizeEnd: function(cb) {
        let rtime;
        let timeout = false;
        let delta = 200;
        $($window).resize(function() {
          rtime = new Date();
          if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
          }
        });

        function resizeend() {
          if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
          } else {
            timeout = false;
            if (cb) cb();
          }
        }
      },
      parseJson: function(object) {
        try {
          return JSON.parse(object);
        } catch (e) {
          console.log(e);
          return false;
        }
      },
      uniqueId: function() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
          s4() + '-' + s4() + s4() + s4();
      },
      arrayContainsField: function(arr, key) {
        if (arr && key) {
          let exist = false;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i] === key) {
              exist = true;
              break;
            }
          }
          return exist;
        }

        return false;
      },
      checkUserCanAccess: function(destination, source) {
        if (!source || source.length === 0) {
          return true;
        }

        for (let i = 0; i < source.length; i++) {
          if (this.arrayContainsField(destination, source[i])) {
            return true;
          }
        }
      },
      getEscapedString: function(query) {
        return query
          .replace(/[\*\+\-=~><\"\?^\${}\(\)\:\!\/[\]\\\s]/g, '\\\\$&') // replace single character special characters
          .replace(/\|\|/g, '\\\\||') // replace ||
          .replace(/\&\&/g, '\\\\&&') // replace &&
          .replace(/AND/g, '\\\\A\\\\N\\\\D') // replace AND
          .replace(/OR/g, '\\\\O\\\\R') // replace OR
          .replace(/NOT/g, '\\\\N\\\\O\\\\T'); // replace NOT
      },
      autoChangePlaceholder: function() {
        const attr = 'data-auto-change-placeholder';
        $('input[' + attr + ']').each(function() {
          const _this = $(this);
          let placeHolder = _this.attr(attr);
          if (placeHolder) {
            try {
              placeHolder = JSON.parse(placeHolder);
              if (Array.isArray(placeHolder) && placeHolder.length > 0) {
                let n = 0;
                const loopLength = placeHolder.length;
                setInterval(function() {
                  if (n < loopLength) {
                    const newPlaceholder = placeHolder[n];
                    n++;
                    _this.attr('placeholder', newPlaceholder);
                  } else {
                    _this.attr('placeholder', placeHolder[0]);
                    n = 0;
                  }
                }, 5000);
              }
            } catch (e) {
              console.log(e);
            }
          }
        });
      },
      slugify: function(str) {
        if (!str) return str;
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
        const to = 'aaaaeeeeiiiioooouuuunc------';
        for (let i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes

        return str;
      },
      slugifyObjectField: function(object, option) {
        let id = '';
        let from = ['title', 'name'];
        if (option && option.from) {
          from = option.from;
        }
        for (let i = 0; i < from.length; i++) {
          if (object[from[i]]) {
            const tempId = this.slugify(object[from[i]]);
            if (tempId) {
              id = tempId;
              break;
            }
          }
        }
        if (option && option.id && !object[option.id]) {
          object[option.id] = id;
        }
        return id;
      },
      imageExtensions: function() {
        return ['.png', '.jpg', '.jpeg', '.png', '.gif', '.svg'];
      },
      objectLength: function(object) {
        if (!object || !this.isObject(object)) return 0;
        let length = 0;
        for (const key in object) {
          if (object.hasOwnProperty(key)) {
            length += 1;
          }
        }
        return length;
      },
      createUriFromObject: function(object, encode, excluded) {
        let uri = [];
        for (const key in object) {
          if (object.hasOwnProperty(key)) {
            if (excluded && excluded[key]) continue;

            if (this.isArray(object[key])) {
              for (let i = 0; i < object[key].length; i++) {
                if (object[key][i] !== '' && object[key][i] !== null && object[key][i] !== 'null') {
                  if (encode) {
                    uri.push(`${key}=${encodeURIComponent(object[key][i])}`);
                  } else {
                    uri.push(`${key}=${object[key][i]}`);
                  }
                }
              }
            } else {
              if (object[key] !== 'undefined' &&
                object[key] !== undefined &&
                object[key] !== '' &&
                object[key] !== null &&
                object[key] !== 'null') {
                if (encode) {
                  uri.push(`${key}=${encodeURIComponent(object[key])}`);
                } else {
                  uri.push(`${key}=${object[key]}`);
                }
              }
            }
          }
        }
        return uri.join('&');
      },
      queryStringToJSON: function(locationSearch) {
        const _this = this;
        const result = {};
        if (!locationSearch) return result;
        const pairs = (locationSearch.indexOf('?') !== -1) ? locationSearch.slice(1).split('&') : locationSearch.split('&');
        pairs.forEach((pair) => {
          pair = pair.split('=');
          if (result.hasOwnProperty(pair[0]) && _this.isArray(result[pair[0]])) {
            result[pair[0]].push(decodeURIComponent(pair[1] || ''));
          } else if (result.hasOwnProperty(pair[0])) {
            result[pair[0]] = [result[pair[0]], decodeURIComponent(pair[1] || '')]
          } else {
            result[pair[0]] = decodeURIComponent(pair[1] || '');
          }
        });
        return JSON.parse(JSON.stringify(result));
      },
      objectMarge: function(obj, obj1) {
        const temp = {};
        if (obj) {
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              temp[key] = obj[key];
            }
          }
        }
        if (obj1) {
          for (const key in obj1) {
            if (obj1.hasOwnProperty(key)) {
              temp[key] = obj1[key];
            }
          }
        }
        return temp;
      },
      useNewApi: function() {
        return (config.apiBaseUrl && config.apiBaseUrl.indexOf('/api/v2') !== -1);
      },
      isFormDataPayload: function(obj) {
        if (obj) {
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              if (this.isFile(obj[key])) {
                return true;
              }
            }
          }
        }
        return false;
      }
    };
  }
})();

/* globals moment */
(function() {
  angular
    .module('onify')
    .filter('dateFormat', dateFormat);

  function dateFormat() {
    return function localTimestamp(value, format) {
      if (!value) return value;
      return moment(value).format(format || 'YYYY-MM-DD HH:mm:ss');
    };
  }
})();

(function() {
  angular
    .module('onify')
    .filter('htmlize', htmlize);

  htmlize.$inject = ['$sce', 'utils'];
  function htmlize($sce, utils) {
    return function(string) {
      return $sce.trustAsHtml(utils.replaceLineBreaks(string));
    }
  }
})();

(function() {
  angular
    .module('onify')
    .filter('prepareAction', prepareAction)
    .filter('prepareFilter', prepareFilter)
    .filter('uppercaseField', uppercaseField)
    .filter('checkBulkSupport', checkBulkSupport)
    .filter('prepareDescription', prepareDescription)
    .filter('toFixed', toFixed)
    .filter('trustSrc', trustSrc)
    .filter('getField', getField)
    .filter('getarrayfilter_query', getarrayfilter_query)
    .filter('getarrayfilter_url', getarrayfilter_url)
    .filter('getDate', getDate);

  //filter can be used to prepare item actions
  prepareAction.$inject = ['itemsUtils'];

  function prepareAction(itemsUtils) {
    return function(actions, key) {
      return (actions && key) ? itemsUtils.prepareAction(actions, key) : false;
    }
  }

  //filter can be used to prepare item filters
  prepareFilter.$inject = ['itemsUtils', 'utils'];

  function prepareFilter(itemsUtils, utils) {
    return function(filters, type, allowHidden, filterAsObject) {
      if (filters && utils.isString(filters) && type && type.indexOf('attribute.') !== -1) {
        const result = itemsUtils.prepareFilter({
          [type.substring(10)]: filters
        }, 'attribute', allowHidden);
        return (filterAsObject && result[0]) ? result[0] : result;
      }
      return (filters && type) ? itemsUtils.prepareFilter(filters, type, allowHidden) : false;
    }
  }

  //filter can be used to uppercase string
  function uppercaseField() {
    return function(string) {
      return (string) ? string.toUpperCase() : false;
    }
  }

  //filter can be used to check if item has Bulk Support
  checkBulkSupport.$inject = ['itemsUtils'];

  function checkBulkSupport(itemsUtils) {
    return function(actions) {
      return (actions) ? itemsUtils.checkBulkSupport(actions) : false;
    }
  }

  //filter can be used to check if item has Bulk Support
  prepareDescription.$inject = ['$sce', 'utils'];

  function prepareDescription($sce, utils) {
    return function(description) {
      if (description && utils.isString(description)) {
        return $sce.trustAsHtml(utils.replaceLineBreaks(description));
      }
      return '';
    }
  }

  //filter can be used to parse float with two decimal places
  function toFixed() {
    return function(number) {
      return (number) ? parseFloat(number).toFixed(2) : false;
    }
  }

  trustSrc.$inject = ['$sce'];

  function trustSrc($sce) {
    return function(url) {
      return (url) ? $sce.trustAsResourceUrl(url) : false;
    }
  }

  function getField() {
    return function(field) {
      return field;
    }
  }

  function getarrayfilter_query() {
    return function(arr, key) {
      const filter = [];
      if (arr) {
        arr.map((value) => {
          filter.push(key + ':' + value);
        });
      }
      return filter;
    }
  }

  function getarrayfilter_url() {
    return function(arr, key) {
      const filter = [];
      arr.map((value) => {
        filter.push('filter=' + key + ':' + value);
      });
      return filter.join('&');
    }
  }

  function getDate() {
    return function(date, type, days) {
      let tempDate;
      if (date === 'now') {
        tempDate = moment();
      } else {
        tempDate = moment(date);
      }
      if (type && type === 'daysago' && days) {
        tempDate = tempDate.subtract(parseInt(days), "days");
      }
      if (!tempDate) {
        tempDate = moment();
      }
      return tempDate.format('YYYY-MM-DD');
    }
  }
})();

(function() {
  angular
    .module('onify')
    .filter('formatNumber', number)
    .filter('number', stringToNumber);

  function number() {
    return function(value, toFixed) {
      if (!value) return value;
      if (!toFixed) toFixed = 0;
      value = Number(value);
      value = value.toFixed(toFixed);
      if (value <= 999) {
        return value;
      }
      return numeral(value).format('0.0a');
    }
  }

  function stringToNumber() {
    return function(value) {
      if (!value) return value;
      return Number(value);
    }
  }
})();

(function() {
  angular
    .module('onify')
    .filter('percentage', percentage);

  function percentage() {
    return function(value, toFixed) {
      if (!value) return value;
      if (!toFixed) toFixed = 0;
      value = Number(value);
      return value.toFixed(toFixed) + '%';
    }
  }
})();

(function() {
  angular
    .module('onify')
    .filter('slugify', slugify);

  slugify.$inject = ['utils'];
  function slugify(utils) {
    return function(string) {
      if (!string) return string;
      return utils.slugify(string);
    }
  }
})();

(function() {
  angular
    .module('onify')
    .filter('translate', translate);
  angular
    .module('onify')
    .filter('t', translate);

  translate.$inject = ['locales'];
  function translate(locales) {
    return function(input) {
      const stringKey = 'strings.' + input;
      const defaultKey = 'default.' + input;
      // Check if string exist
      const string = locales.getLocaleByKey(stringKey);
      if (stringKey !== string) {
        return string;
      }
      // Check if default exist
      const defaultTranslation = locales.getLocaleByKey(defaultKey);
      if (defaultKey !== defaultTranslation) {
        return defaultTranslation;
      }
      // Return old translation
      // Important for app translations
      return locales.getLocaleByKey(input);
    }
  }
})();

(function () {
  'use strict';
  angular.module('onify')
    .service('markdownConverter', markdownConverter)
    .directive('htmlMarkdown', htmlMarkdown);

  function markdownConverter () {
    var opts = {};
    return {
      config: function (newOpts) {
        opts = newOpts;
      },
      showdown: function () {
        return new showdown.Converter(opts);
      }
    };
  }

  htmlMarkdown.$inject = ['$sanitize', 'markdownConverter'];
  function htmlMarkdown ($sanitize, markdownConverter) {
    return {
      restrict: 'AE',
      link: function (scope, element, attrs) {
        if (attrs.htmlMarkdown) {
          scope.$watch(attrs.htmlMarkdown, function (newVal) {
            var html = newVal ? $sanitize(markdownConverter.showdown().makeHtml(newVal)) : '';
            element.html(html);
          });
        } else {
          var html = $sanitize(markdownConverter.showdown().makeHtml(element.text()));
          element.html(html);
        }
      }
    };
  }

})();

(function () {
  'use strict';
  angular.module('onify')
    .factory('ValidationServices', ValidationServices)
    .factory('CharBasedTruncation', CharBasedTruncation)
    .factory('WordBasedTruncation', WordBasedTruncation)
    .directive('ngTextTruncate', ngTextTruncate);

  function ValidationServices(){
    return {
      failIfWrongThreshouldConfig: function (firstThreshould, secondThreshould) {
        if ((!firstThreshould && !secondThreshould) || (firstThreshould && secondThreshould)) {
          throw 'You must specify one, and only one, type of threshould (chars or words)';
        }
      }
    };
  }

  CharBasedTruncation.$inject = ['$compile'];
  function CharBasedTruncation ($compile) {
    return {
      truncationApplies: function ($scope, threshould) {
        return $scope.text.length > threshould;
      },

      applyTruncation: function (threshould, $scope, $element) {
        if ($scope.useToggling) {
          var el = angular.element('<span>' +
            $scope.text.substr(0, threshould) +
            '<span ng-show=\'!open\'>...</span>' +
            '<span class=\'btn-link ngTruncateToggleText\' ' +
            'ng-click=\'toggleShow()\'' +
            'ng-show=\'!open\'>' +
            ' ' + ($scope.customMoreLabel ? $scope.customMoreLabel : 'More') +
            '</span>' +
            '<span ng-show=\'open\'>' +
            $scope.text.substring(threshould) +
            '<span class=\'btn-link ngTruncateToggleText\'' +
            'ng-click=\'toggleShow()\' ' +
            'ng-show=\'open\'>' +
            ' ' + ($scope.customLessLabel ? $scope.customLessLabel : 'Less') +
            '</span>' +
            '</span>' +
            '</span>');
          $compile(el)($scope);
          $element.append(el);

        } else {
          $element.append($scope.text.substr(0, threshould) + '...');

        }
      }
    };
  }

  WordBasedTruncation.$inject = ['$compile'];
  function WordBasedTruncation ($compile) {
    return {
      truncationApplies: function ($scope, threshould) {
        return $scope.text.split(' ').length > threshould;
      },

      applyTruncation: function (threshould, $scope, $element) {
        var splitText = $scope.text.split(' ');
        if ($scope.useToggling) {
          var el = angular.element('<span>' +
            splitText.slice(0, threshould).join(' ') + ' ' +
            '<span ng-show=\'!open && customMoreLabel\'>...</span>' +
            '<span class=\'btn-link ngTruncateToggleText\' ' +
            'ng-show=\'!open && !customMoreLabel\'' +
            'ng-click=\'toggleShow()\'' +
            '>...</span>' +
            '<span class=\'btn-link ngTruncateToggleText\' ' +
            'ng-click=\'toggleShow()\'' +
            'ng-show=\'!open && customMoreLabel\'>' +
            ' ' + ($scope.customMoreLabel) +
            '</span>' +
            '<span ng-show=\'open\'>' +
            splitText.slice(threshould, splitText.length).join(' ') +
            '<span class=\'btn-link ngTruncateToggleText\'' +
            'ng-click=\'toggleShow()\' ' +
            'ng-show=\'open && customLessLabel\'>' +
            ' ' + ($scope.customLessLabel) +
            '</span>' +
            '</span>' +
            '</span>');
          $compile(el)($scope);
          $element.append(el);

        } else {
          $element.append(splitText.slice(0, threshould).join(' ') + '...');
        }
      }
    };
  }

  ngTextTruncate.$inject = ['$compile', '$sanitize', 'ValidationServices', 'CharBasedTruncation', 'WordBasedTruncation', 'markdownConverter'];
  function ngTextTruncate ($compile, $sanitize, ValidationServices, CharBasedTruncation, WordBasedTruncation, markdownConverter) {
    return {
      restrict: 'A',
      scope: {
        text: '=ngTextTruncate',
        charsThreshould: '@ngTtCharsThreshold',
        wordsThreshould: '@ngTtWordsThreshold',
        customMoreLabel: '@ngTtMoreLabel',
        customLessLabel: '@ngTtLessLabel'
      },
      controller: function ($scope, $element, $attrs) {
        $scope.toggleShow = function () {
          $scope.open = !$scope.open;
        };

        $scope.useToggling = $attrs.ngTtNoToggling === undefined;
      },
      link: function ($scope, $element, $attrs) {
        $scope.open = false;
        if ($scope.text) {
          $scope.text = markdownConverter.showdown().makeHtml($scope.text.replace(/(\r\n|\n|\r)/gm," ").replace(/\s+/g," "));
        }

        ValidationServices.failIfWrongThreshouldConfig($scope.charsThreshould, $scope.wordsThreshould);

        var CHARS_THRESHOLD = parseInt($scope.charsThreshould);
        var WORDS_THRESHOLD = parseInt($scope.wordsThreshould);

        $scope.$watch('text', function () {
          $element.empty();

          if (CHARS_THRESHOLD) {
            if ($scope.text && CharBasedTruncation.truncationApplies($scope, CHARS_THRESHOLD)) {
              CharBasedTruncation.applyTruncation(CHARS_THRESHOLD, $scope, $element);

            } else {
              $element.append($scope.text);
            }

          } else {

            if ($scope.text && WordBasedTruncation.truncationApplies($scope, WORDS_THRESHOLD)) {
              WordBasedTruncation.applyTruncation(WORDS_THRESHOLD, $scope, $element);

            } else {
              $element.append($scope.text);
            }

          }
        });
      }
    };
  }
})();

(function () {
  angular
    .module('onify')
    .service('audit', audit);

  audit.$inject = ['$http', 'config'];
  function audit($http, config) {
    const add = function(obj) {
      $http({
        method: 'POST',
        url: config.apiBaseUrl + '/my/audit',
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: obj
      }).success((result) => {
        //console.log(result)
      }).error((error) => {
        console.log(error)
      });

      return true;
    };

    const getMyAudit = function(params) {
      return $http.get(config.apiBaseUrl + '/my/audit', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getAdminAudit = function(params) {
      return $http.get(config.apiBaseUrl + '/admin/audit', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      add,
      getMyAudit,
      getAdminAudit
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('barcodeService', barcodeService);

  barcodeService.$inject = ['$q', 'utils'];
  function barcodeService($q, utils) {
    const quaggaFormats = [
      {
        format: "code_128_reader",
        config: {}
      },
      {
        format: "ean_reader",
        config: {
          supplements: [
            'ean_5_reader', 'ean_2_reader'
          ]
        }
      },
      {
        format: "ean_8_reader",
        config: {}
      },
      {
        format: "code_39_reader",
        config: {}
      },
      {
        format: "code_39_vin_reader",
        config: {}
      },
      {
        format: "codabar_reader",
        config: {}
      },
      {
        format: "upc_reader",
        config: {}
      },
      {
        format: "upc_e_reader",
        config: {}
      },
      {
        format: "i2of5_reader",
        config: {}
      },
      {
        format: "2of5_reader",
        config: {}
      },
      {
        format: "code_93_reader",
        config: {}
      }
    ];
    const defaults = {
      viewResult: true
    };
    const quaggaConfig = {
      inputStream: {
        size: 1200,
        singleChannel: false
      },
      locator: {
        patchSize: "small",
        halfSample: true
      },
      decoder: {
        readers: quaggaFormats,
        multiple: true
      },
      locate: true,
      src: null
    };

    function prepareFormat(string) {
      return string.replace(/[^a-z0-9]/gi, ' ').toUpperCase();
    }

    function removeDuplicated(codes) {
      const temp = {};
      const arr = [];
      for (let i = 0; i < codes.length; i++) {
        for (let j = 0; j < codes[i].length; j++) {
          if (!temp[codes[i][j].code]) {
            temp[codes[i][j].code] = codes[i][j].format;
            arr.push(codes[i][j]);
          }
        }
      }

      return arr;
    }

    const quaggaDecode = function(imgEl) {
      const deferred = $q.defer();
      const options = utils.clone(quaggaConfig);
      options.src = imgEl.src;

      Quagga.decodeSingle(options, function(result) {
        const formated = [];

        if (result) {
          for (let i = 0; i < result.length; i++) {
            if (result[i].codeResult) {
              formated.push({
                code: result[i].codeResult.code,
                format: prepareFormat(result[i].codeResult.format)
              })
            }
          }
        }

        options.locator.patchSize = 'large';
        Quagga.decodeSingle(options, function(largeResult) {
          if (largeResult) {
            for (let i = 0; i < largeResult.length; i++) {
              if (largeResult[i].codeResult) {
                formated.push({
                  code: largeResult[i].codeResult.code,
                  format: prepareFormat(largeResult[i].codeResult.format)
                })
              }
            }
          }
          deferred.resolve(formated);
        });
      });

      return deferred.promise;
    };

    const jobDecode = function(imgEl) {
      const deferred = $q.defer();

      BarcodeReader.DecodeImage(imgEl, function(result) {
        const formated = [];

        if (result) {
          for (let i = 0; i < result.length; i++) {
            formated.push({
              code: result[i].Value,
              format: prepareFormat(result[i].Format)
            })
          }
        }

        deferred.resolve(formated);
      });

      return deferred.promise;
    };

    const init = (options) => {
      const settings = angular.extend({}, defaults, options);

      const $userCanvasEl = $(settings.canvasTo);
      const $userInputEl = $(settings.inputTo);
      const $userResultEl = $(settings.outputTo);
      const $userImgEl = $(settings.imageTo);
      const $userOutputResultTo = $(settings.outputResultTo);

      const $loadingEl = $('<span id="barcode-reader__loading">' + settings.decodingText + '</span>');
      const $canvasEl = ($userCanvasEl.length > 0) ? $userCanvasEl : $('<canvas id="barcode-reader__picture"></canvas>');
      const $inputEl = ($userInputEl.length > 0) ? $userInputEl : $('<input id="barcode-reader__picture__input" type="file" accept="image/*;capture=camera" />');
      const $resultEl = ($userResultEl.length > 0) ? $userResultEl : $('<div id="barcode-reader__result"></div>');
      const $imgEl = ($userImgEl.length > 0) ? $userImgEl : $('<img id="barcode-reader__image" />');

      const canvasEl = $canvasEl[0];
      const imgEl = $imgEl[0];
      const ctx = canvasEl.getContext("2d");

      if (settings.mainContent) {
        const $mainEl = $(options.mainContent);
        if ($mainEl.length > 0) {

          BarcodeReader.Init();

          if (options.trigger && options.trigger.from && options.trigger.to) {
            $(options.trigger.from).on('click', function() {
              $(options.trigger.to).trigger('click');
            });
          }

          function getDecodedResult(imgEl) {
            $q.all([
              quaggaDecode(imgEl),
              jobDecode(imgEl)
            ]).then((results) => {
              const codes = removeDuplicated(results);
              updateContent(codes)
            }).catch((err) => {
              console.log(err);
            });
          }

          function updateContent(result) {
            const tempArray = [];

            if (result.length > 0) {
              if (settings.viewResult && result.length > 1) {
                result.forEach(function(resultItem, index) {
                  if (index === 0) {
                    tempArray.push('<label><input checked="checked" class="barcode-reader-result-input" name="barcode-reader-result" type="radio" value="' + resultItem.code + '"> ' + resultItem.format + ' : ' + resultItem.code + '</label>');
                  } else {
                    tempArray.push('<label><input class="barcode-reader-result-input" name="barcode-reader-result" type="radio" value="' + resultItem.code + '"> ' + resultItem.format + ' : ' + resultItem.code + '</label>');
                  }
                });
                $resultEl.empty().append(tempArray);
                $('.barcode-reader-result-input').on('click', function() {
                  $userOutputResultTo.val($(this).val());
                });
              } else {
                $resultEl.empty();
              }

              if ($userOutputResultTo.length > 0) {
                $userOutputResultTo.addClass('found').removeClass('failed').val(result[0].code);
              }
            } else {
              $resultEl.empty();
              $userOutputResultTo.removeClass('found').addClass('failed').val('');
            }

            $loadingEl.hide();
          }

          BarcodeReader.PostOrientation = true;

          BarcodeReader.OrientationCallback = function(result) {
            $canvasEl.css('width', result.width);
            $canvasEl.css('height', result.height);
            $canvasEl.width = 640;
            $canvasEl.height = 360;
            const data = ctx.getImageData(0, 0, $canvasEl.width, $canvasEl.height);
            for (let i = 0; i < data.data.length; i++) {
              data.data[i] = result.data[i];
            }
            ctx.putImageData(data, 0, 0);
          };

          BarcodeReader.SetLocalizationCallback(function(result) {
            ctx.beginPath();
            ctx.lineWIdth = "2";
            ctx.strokeStyle = "red";

            for (let i = 0; i < result.length; i++) {
              ctx.rect(result[i].x, result[i].y, result[i].width, result[i].height);
            }
            ctx.stroke();
          });

          if ($inputEl.length !== 0 && $imgEl.length !== 0) {
            $inputEl.on('change', function(event) {
              const files = event.target.files;
              if (files && files.length > 0) {
                let file = files[0];

                try {
                  const URL = window.URL || window.webkitURL;
                  imgEl.onload = function() {
                    $resultEl.html('');
                    getDecodedResult(imgEl);
                  };
                  imgEl.src = URL.createObjectURL(file);
                } catch (e) {
                  try {
                    const fileReader = new FileReader();
                    fileReader.onload = function(event) {
                      imgEl.onload = function() {
                        $resultEl.html('');
                        getDecodedResult(imgEl);
                      };
                      imgEl.src = event.target.result;
                    };
                    fileReader.readAsDataURL(file);
                  } catch (e) {
                    console.log("Neither createObjectURL or FileReader are supported");
                  }
                }

                $canvasEl.addClass('show');
                $imgEl.addClass('show');
                $loadingEl.show();
              }
            });
          }

          // create the dom elements needed
          $mainEl.append([$loadingEl, $resultEl, $canvasEl, $inputEl, $imgEl]);
        }
      }
    };

    return {
      init: init
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('bulletinService', bulletinService);

  bulletinService.$inject = ['$http', 'config'];
  function bulletinService($http, config) {

    const aknowledge = function(key) {
      return $http({
        method: 'POST',
        url: config.apiBaseUrl + '/my/bulletins/aknowledge/' + key,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const get = function(key) {
      return $http({
        method: 'GET',
        url: config.apiBaseUrl + '/my/bulletins/' + key,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      aknowledge: aknowledge,
      get: get
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('errorService', errorService);

  errorService.$inject = ['$http'];
  function errorService($http) {
    const save = function(obj) {
      let error = {};

      if (obj.stack) {
        error.stack = obj.stack;

        for(let key in obj){
          if(obj.hasOwnProperty(key)){
            if(key !== 'stack'){
              error[key] = obj[key];
            }
          }
        }
      } else {
        error = obj;
      }

      return $http({
        method: 'POST',
        url: '/error',
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: {
          error: JSON.stringify(error)
        }
      });
    };

    return {
      save: save
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('eventsService', eventsService);

  eventsService.$inject = ['$http', 'config', 'queryStringUtils'];
  function eventsService($http, config) {

    const getEvents = function(workspace, key, params) {
      return $http.get(config.apiBaseUrl + `/my/items/${workspace}/${key}/events`, {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      getEvents
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('getItemTemplate', getItemTemplate);

  getItemTemplate.$inject = ['$q', '$templateRequest', '$location', 'config', 'utils', 'userService', 'queryStringService'];
  function getItemTemplate($q, $templateRequest, $location, config, utils, userService, queryStringService) {
    let triggerTemplatesLoaded;
    let itemTemplates = {};
    let tableItemTemplates = {};
    const defaultItemTemplate = {
      'color': '#4a90e2',
      'role': [],
      'order': 100,
      'showActions': 1,
      'workspace': [],
      'mapping': {
        'title': '{{item.name}}',
        'key': '{{item.key}}',
        'action': 'item.action | prepareAction : item.key',
        'tag': 'item.tag | prepareFilter : \'tag\'',
        'image': '{{item.icon}}',
        'subtitle1': '{{item.description}}',
        'status': 'item.status ? "item.status | prepareFilter : \'status\'" : \'\'',
        'bulkSupport': 'item.cost.cart ? "true" : "item.action | checkBulkSupport"',
        'subtitle2': 'item.owner | prepareFilter : \'owner\'',
        'attachment': 'item.attachment | getField',
        'information': [{
          'type': 'filter',
          'name': 'Attribute',
          'value': 'item.attribute | prepareFilter : \'attribute\''
        }
        ]
      }
    };
    const defaultTableTemplate = {
      'role': [],
      'order': 100,
      'workspace': [],
      'tableHeader': '_default/header',
      'tableRow': '_default/row',
      'tableFooter': '_default/footer',
      'columns': [
        {
          'name': '',
          'template': 'bulksupport',
          'type': 'bulksupport',
          'value': 'item.cost.cart ? "true" : "item.action | checkBulkSupport"'
        },
        {
          'name': '',
          'template': 'image',
          'type': 'image',
          'value': '{{item.icon}}'
        },
        {
          'name': '<%name%>',
          'value': '{{item.name}}'
        },
        {
          'name': '<%owner%>',
          'template': 'link',
          'type': 'link',
          'link': '/workspace/{{item.workspace}}/search?term={{item.owner}}',
          'value': '{{item.owner}}',
          'target': '_blank'
        },
        {
          'name': '<%status%>',
          'template': 'status',
          'type': 'status',
          'value': 'item.status ? "item.status | prepareFilter : \'status\'" : \'\'',
          'class': '{{item.status | slugify}}'
        },
        {
          'name': '<%tags%>',
          'template': 'tags',
          'type': 'tag',
          'value': 'item.tag | prepareFilter : \'tag\''
        },
        {
          'name': '<%actions%>',
          'template': 'actions',
          'type': 'action',
          'value': 'item.action | prepareAction : item.key'
        }
      ]
    };

    function getTemplates(name, view) {
      if (!name) return false;
      let tpl = null;

      if (view && view === 'table') {
        tpl = utils.clone(tableItemTemplates);
      } else {
        tpl = utils.clone(itemTemplates);
      }

      const ext = '.jade';

      //remove .jade from template name
      if (name.indexOf(ext) != -1) {
        name = name.replace(ext, '');
      }

      if (tpl[name]) {
        return orderTemplates(tpl[name]);
      }

      return false;
    }

    function orderTemplates(templates) {
      templates.sort((a, b) => {
        return parseFloat((a.order) ? a.order : 0) - parseFloat((b.order) ? b.order : 0);
      });

      return templates;
    }

    function getTemplatesByWorkspace(templates) {
      const workspace = queryStringService.getWorkspace();
      let tpl = [];

      for (let i = 0; i < templates.length; i++) {
        //allow empty workspace or undefined
        if (!templates[i].workspace || (templates[i].workspace && !templates[i].workspace.length)) {
          tpl.push(templates[i]);
        } else {
          //check if workspace match with template role
          if (utils.anyMatchInArray(templates[i].workspace, workspace, true)) {
            tpl.push(templates[i]);
          }
        }
      }

      return tpl;
    }

    function getTemplatesByUserRole(templates) {
      const role = userService.getSettings('role');
      let tpl = [];

      for (let i = 0; i < templates.length; i++) {
        //allow empty role or undefined
        if (!templates[i].role || (templates[i].role && !templates[i].role.length)) {
          tpl.push(templates[i]);
        } else {
          //check if user role match with template role
          if (role && role.length && utils.anyMatchInArray(templates[i].role, role, true)) {
            tpl.push(templates[i]);
          }
        }
      }

      return tpl
    }

    function prepareTemplates(templates) {
      const userRoleTemplates = getTemplatesByUserRole(templates);
      if (userRoleTemplates) {
        const workspaceRoleTemplates = getTemplatesByWorkspace(userRoleTemplates);
        if (workspaceRoleTemplates) {
          return workspaceRoleTemplates;
        }
      }

      return [];
    }

    const template = function(templateName, view) {
      let params = $location.search();
      let customTemplateName = (params.template) ? params.template : null;
      let defaultTemplateName = (view && view === 'table') ? config.defaultTableItemTempalte : config.defaultItemTempalte;

      //if template parameter is set check that first
      if (customTemplateName) {
        const customTemplates = getTemplates(customTemplateName, view);
        if (customTemplates) {
          const templates = prepareTemplates(customTemplates);
          if (templates && templates.length > 0) {
            templates[0].templateKey = customTemplateName;
            return templates[0];
          }
        }
      }

      //check item template
      if (templateName) {
        const requiredTemplates = getTemplates(templateName, view);
        if (requiredTemplates) {
          const templates = prepareTemplates(requiredTemplates);
          if (templates && templates.length > 0) {
            templates[0].templateKey = templateName;
            return templates[0];
          }
        }
      }

      //load default template
      const defaultTemplates = getTemplates(defaultTemplateName, view);
      if (defaultTemplates) {
        const templates = prepareTemplates(defaultTemplates);
        if (templates && templates.length > 0) {
          templates[0].templateKey = defaultTemplateName;
          return templates[0];
        }
      }

      if (view && view === 'table') {
        return {...defaultTableTemplate, templateKey: 'defaultTableTemplate'};
      }

      return {...defaultItemTemplate, templateKey: 'defaultItemTemplate'};
    };

    const loadConfig = function(customFile) {
      const file = (customFile) ? customFile : 'itemTemplates.json';
      const tableViewConfig = 'tableTemplates.json';
      const deferred = $q.defer();
      const version = '?v=' + new Date().getTime();

      $templateRequest(config.configDirPath + file + version).then((itemTpl) => {
        itemTemplates = JSON.parse(itemTpl);

        $templateRequest(config.configDirPath + tableViewConfig + version, true).then((tableTpl) => {
          tableItemTemplates = JSON.parse(tableTpl);
          deferred.resolve(true);
        }).catch(() => {
          deferred.resolve(true);
        });
      }).catch((err) => {
        console.log(err);
      });

      return deferred.promise;
    };

    const waitTemplates = () => {
      return triggerTemplatesLoaded;
    };

    const templatesLoaded = () => {
      triggerTemplatesLoaded = 1;
    };

    const getLoadedStatus = (type) => {
      if (type === 'table') {
        return Object.keys(tableItemTemplates).length;
      }

      return false;
    };

    return {
      templatesLoaded: templatesLoaded,
      waitTemplates: waitTemplates,
      loadConfig: loadConfig,
      template: template,
      getLoadedStatus: getLoadedStatus
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('itemDashboardService', itemDashboardService);

  itemDashboardService.$inject = ['$compile', '$q', '$templateRequest', '$timeout', '$location', '$http', 'config', 'locales', 'utils', 'itemsData', 'itemMapping', 'errorService', 'audit', 'eventsService'];

  function itemDashboardService($compile, $q, $templateRequest, $timeout, $location, $http, config, locales, utils, itemsData, itemMapping, errorService, audit, eventsService) {

    function getScope() {
      return angular.element(document.getElementById('items-dashboard-page')).scope();
    }

    function showError(id, error) {
      const err = {
        title: utils.isObject(error.error) ? error.error.title : ((error.title) ? error.title : error.error),
        message: (error.message) ? error.message : (utils.isObject(error.error) ? error.error.message : '')
      };

      let message = '';
      if (err.title) {
        message = err.title;
      }
      if (err.message) {
        message = err.message;
      }

      appendElementData(id, `<span class="element-error">${message}</span>`);
    }

    function showElementLoading(elements) {
      $timeout(() => {
        $('.grid-stack-item').each(function() {
          const id = $(this).attr('id');
          const el = `#${id} .grid-stack-item-content`;
          if (elements[id]) {
            $(el).html('<div class="loading"><i class="fa fa-spinner fa-spin"></i></div>');
          } else {
            $(el).html(`<span class="no-data-available">${locales.getLocaleByKey('no_data_available')}</span>`);
          }
        });
      }, 0);
    }

    function prepareElements(template) {
      const {workspace, item} = $location.search();
      const {elements} = template;

      if (workspace && item) {
        itemsData.getItem(workspace, item).success((items) => {
          const itemObject = items[0];
          itemObject.workspace = workspace;

          //update dashboard title
          changeDashboardTitle(template, itemObject);

          for (const id in elements) {
            if (elements.hasOwnProperty(id)) {
              loadElementsConfig(id, elements[id], template, itemObject);
            }
          }
        }).error((error) => {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        });
      } else {
        //update dashboard title
        changeDashboardTitle(template);

        for (const id in elements) {
          if (elements.hasOwnProperty(id)) {
            loadElementsConfig(id, elements[id], template);
          }
        }
      }
    }

    function changeDashboardTitle(template, item) {
      let title;
      if (template.title) {
        const data = {
          user: template.userData
        };
        title = template.title;

        if (item) {
          data.item = item;
        }

        title = itemMapping.parseFields(title, data);

        if (title) {
          $('.main-navbar-left .maintitle').text(title).show();
          $(document).prop('title', title);
        } else {
          $('.main-navbar-left .maintitle').show();
        }
      } else {
        $('.main-navbar-left .maintitle').show();
      }
    }

    function loadElementsConfig(id, elementConfig, template, itemObject) {
      if (elementConfig) {
        try {
          elementConfig = elementConfig.replace(/\[~/g, "{{").replace(/~]/g, "}}");
          parseElements(id, JSON.parse(elementConfig), template, itemObject);
        } catch (e) {
          showError(id, e);
        }
      } else {
        showError(id, {title: locales.getLocaleByKey('dashboard_element_not_found', {name: element})});
      }
    }

    function parseElements(id, elementConfig, template, itemObject) {
      const param = $location.search();
      let workspace = param.workspace;
      let item = param.item;

      if (elementConfig.source && (elementConfig.source.item || elementConfig.source.items || elementConfig.source.events)) {
        //get item and workspace form config
        if (!workspace && !item && elementConfig.source.item) {
          item = itemMapping.parseFields(elementConfig.source.item, {
            config: {
              api: {
                url: config.apiBaseUrl
              }
            },
            user: template.userData
          }, {allowEmpty: true});

          if (!isUrlApi(item)) {
            //workspace in config is required
            if (!elementConfig.source.workspace) {
              return showError(id, {title: locales.getLocaleByKey('missing_workspace_config')});
            }
            workspace = elementConfig.source.workspace;
          }
        }

        if (itemObject) {
          prepareElementDataField(id, elementConfig, template, itemObject).then((customData) => {
            prepareItemData(id, elementConfig, template, itemObject, customData).then((data) => {
              parseElementWidget(id, data);
            });
          });
        } else {
          if (isUrlApi(item) || (workspace && item)) {
            let promises = null;
            if (isUrlApi(item)) {
              promises = urlApiData(item);
            } else {
              promises = itemsData.getItem(workspace, item);
            }

            promises.success((items) => {
              itemObject = items[0];
              itemObject.workspace = workspace;

              prepareElementDataField(id, elementConfig, template, itemObject).then((customData) => {
                prepareItemData(id, elementConfig, template, itemObject, customData).then((data) => {
                  parseElementWidget(id, data);
                });
              });
            }).error((error) => {
              if (error.statusCode === 404) {
                showError(id, {title: locales.getLocaleByKey('item_not_found', {key: item})});
              } else {
                showError(id, error);
              }
            });
          } else {
            prepareElementDataField(id, elementConfig, template, itemObject).then((customData) => {
              prepareItemData(id, elementConfig, template, itemObject, customData).then((data) => {
                parseElementWidget(id, data);
              });
            });
          }
        }
      } else {
        if (elementConfig.source) {
          if (elementConfig.source.audit) {
            getAuditItems(id, elementConfig, template, itemObject).then((data) => {
              parseElementWidget(id, data);
            });
          }
        } else {
          const tempConfig = utils.clone(elementConfig);

          prepareElementDataField(id, tempConfig, template, itemObject).then((customData) => {
            let data = itemMapping.parseFields(tempConfig, utils.objectMarge(customData, {
              config: {
                api: {
                  url: config.apiBaseUrl
                }
              },
              item: itemObject,
              user: template.userData
            }), {allowEmpty: true});
            data.tags = widgetTags(id, elementConfig, template);
            parseElementWidget(id, data);
          });
        }
      }
    }

    function getAuditItems(id, elementConfig, template, itemObject) {
      const deferred = $q.defer();
      const tempConfig = utils.clone(elementConfig);

      let data = itemMapping.parseFields(tempConfig, {
        config: {
          api: {
            url: config.apiBaseUrl
          }
        },
        item: itemObject,
        user: template.userData
      }, {allowEmpty: true});

      const params = data.source.audit;
      delete params.admin;

      data.tags = widgetTags(id, elementConfig, template);

      if (elementConfig.source.audit.admin) {
        audit.getAdminAudit(params).success((result) => {
          data.config.meta = result.meta;
          if (result.records.length === 0) {
            customWidgetTags(data, 'noresults');
          } else {
            customWidgetTags(data, 'hasresults');
          }
          deferred.resolve(data);
        }).error((error) => {
          showError(id, error);
        });
      } else {
        audit.getMyAudit(params).success((result) => {
          data.config.meta = result.meta;
          if (result.records.length === 0) {
            customWidgetTags(data, 'noresults');
          } else {
            customWidgetTags(data, 'hasresults');
          }
          deferred.resolve(data);
        }).error((error) => {
          showError(id, error);
        });
      }

      return deferred.promise;
    }

    function missingVariableError(variable) {
      throw new Error(locales.getLocaleByKey('dashboard_missing_variable', {variable}));
    }

    function prepareItemData(id, elementConfig, template, item, customData) {
      if (!customData) customData = {};
      const deferred = $q.defer();

      if (elementConfig.source) {
        if (elementConfig.source.item) {
          const tempConfig = utils.clone(elementConfig);
          let data = itemMapping.parseFields(tempConfig, {
            config: {
              api: {
                url: config.apiBaseUrl
              }
            },
            item: item,
            user: template.userData
          }, {exclude: ['config'], allowEmpty: true});

          if (elementConfig.source.item && !data.source.item) {
            missingVariableError(elementConfig.source.item);
          }

          loadCustomElementItem(id, data, item).then((customItem) => {
            data = itemMapping.parseFields(data, utils.objectMarge(customData, {
              config: {
                api: {
                  url: config.apiBaseUrl
                }
              },
              result: {
                item: customItem
              },
              item: item,
              user: template.userData
            }), {allowEmpty: true});
            prepareCustomWidget(data, template);
            //add custom tags (class) to widgets
            data.tags = widgetTags(id, elementConfig, template);
            deferred.resolve(data);
          });
        } else if (elementConfig.source.items) {
          const tempConfig = utils.clone(elementConfig);
          let fields = tempConfig.config.fields;
          let items = tempConfig.source.items;
          delete tempConfig.config.fields;
          delete tempConfig.source.items;

          if (utils.isString(items)) {
            items = itemMapping.parseFields(items, {
              config: {
                api: {
                  url: config.apiBaseUrl
                }
              },
              item: item,
              user: template.userData
            }, {allowEmpty: true});
          } else {
            prepareItemsParams(template, items, item);
          }

          const data = itemMapping.parseFields(tempConfig, utils.objectMarge(customData, {
            item: item,
            user: template.userData
          }), {allowEmpty: true});

          getItemsList(id, items).then((itemsData) => {
            data.config.meta = itemsData.meta;
            //add custom tags (class) to widgets
            data.tags = widgetTags(id, elementConfig, template);
            if (itemsData.records.length === 0) {
              customWidgetTags(data, 'noresults');
              data.config.fields = false;
              deferred.resolve(data);
            } else {
              customWidgetTags(data, 'hasresults');

              if (itemsData.records) {
                const fieldsData = [];
                for (let i = 0; i < itemsData.records.length; i++) {
                  const tempfields = utils.clone(fields);
                  const tempData = itemMapping.parseFields({fields: tempfields}, {
                    result: {
                      item: itemsData.records[i]
                    },
                    item: item,
                    user: template.userData
                  }, {allowEmpty: true});
                  if (tempData.fields) {
                    fieldsData.push(tempData.fields);
                  }
                }

                data.config.fields = fieldsData;

                data.config.tableThead = [];

                if (data.config.fields.length > 0) {
                  for (let i = 0; i < data.config.fields[0].length; i++) {
                    data.config.tableThead.push(data.config.fields[0][i].name);
                  }
                }
              }

              if (data.config.showmore) {
                if (data.config.showmore && data.config.showmore.text) {
                  data.config.showmore.text = data.config.showmore.text.replace(new RegExp('{x}', 'gi'), itemsData.meta.totalresults);
                }
              }

              deferred.resolve(data);
            }
          });
        } else if (elementConfig.source.events) {
          const tempConfig = utils.clone(elementConfig);
          let fields = tempConfig.config.fields;
          let lookup = tempConfig.source.events;
          delete tempConfig.config.fields;
          delete tempConfig.source.events;

          prepareItemsParams(template, lookup, item);

          const data = itemMapping.parseFields(tempConfig, utils.objectMarge(customData, {
            item: item,
            user: template.userData
          }), {allowEmpty: true});

          getEventsList(id, lookup).then((eventsData) => {
            data.config.meta = eventsData.meta;
            //add custom tags (class) to widgets
            data.tags = widgetTags(id, elementConfig, template);
            if (eventsData.records.length === 0) {
              customWidgetTags(data, 'noresults');
              data.config.fields = false;
              deferred.resolve(data);
            } else {
              customWidgetTags(data, 'hasresults');

              if (eventsData.records) {
                const fieldsData = [];
                for (let i = 0; i < eventsData.records.length; i++) {
                  const tempfields = utils.clone(fields);
                  const tempData = itemMapping.parseFields({fields: tempfields}, {
                    event: eventsData.records[i],
                    item: item,
                    user: template.userData
                  }, {allowEmpty: true});
                  if (tempData.fields) {
                    fieldsData.push(tempData.fields);
                  }
                }

                data.config.fields = fieldsData;
              }

              deferred.resolve(data);
            }
          });
        }
      } else {
        const tempConfig = utils.clone(elementConfig);
        const data = itemMapping.parseFields(tempConfig, utils.objectMarge(customData, {
          config: {
            api: {
              url: config.apiBaseUrl
            }
          },
          user: template.userData
        }), {allowEmpty: true});
        //add custom tags (class) to widgets
        data.tags = widgetTags(id, elementConfig, template);
        deferred.resolve(data);
      }

      return deferred.promise;
    }

    function getEventsParams(lookup) {
      const params = (lookup.query) ? utils.queryStringToJSON(lookup.query) : {};

      if (params.term) {
        params.query = params.term;
        delete params.term;
      }

      if (lookup.term) {
        params.query = lookup.term;
      }
      if (lookup.sort) {
        params.sort = lookup.sort;
      }
      if (lookup.level) {
        params.level = lookup.level;
      }
      if (lookup.tag) {
        params.tag = lookup.tag;
      }
      if (lookup.category) {
        params.category = lookup.category;
      }
      if (lookup.startfrom) {
        params.startfrom = lookup.startfrom;
      }
      if (lookup.pagesize) {
        params.pagesize = lookup.pagesize;
      }

      return params;
    }

    function getEventsList(id, params) {
      const vm = getScope();
      const deferred = $q.defer();

      eventsService.getEvents(params.workspace, params.item, getEventsParams(params)).success((result) => {
        vm.requestSend = false;
        deferred.resolve(result);
      }).error((error) => {
        showError(id, error);
      });

      return deferred.promise;
    }

    function prepareCustomWidget(data, template) {
      if (data.widget === 'actions') {
        if (data.config.custom) {
          for (let i = 0; i < data.config.custom.length; i++) {
            if (utils.checkUserCanAccess(template.userData.role, data.config.custom[i].role)) {
              data.config.actions.push(data.config.custom[i]);
            }
          }
          delete data.config.custom;
        }

        if (data.config.exclude) {
          for (let i = 0; i < data.config.actions.length; i++) {
            if (data.config.actions[i].id && utils.arrayContainsField(data.config.exclude, data.config.actions[i].id)) {
              data.config.actions.splice(i, 1);
            }
          }
        }

        if (data.config.actions) {
          data.config.actions = utils.order(data.config.actions, 'order');
        }
      }
    }

    function isUrlApi(url) {
      return (url && utils.isString(url) && url.indexOf(config.apiBaseUrl) !== -1);
    }

    function prepareElementDataField(id, elementConfig, template, itemObject) {
      const deferred = $q.defer();
      const response = {};

      if (elementConfig.data && utils.isObject(elementConfig.data)) {
        const promises = [];
        const fields = [];

        elementConfig.data = itemMapping.parseFields(elementConfig.data, {
          item: itemObject,
          user: template.userData
        }, {allowEmpty: true});

        for (const filed in elementConfig.data) {
          if (elementConfig.data.hasOwnProperty(filed)) {
            promises.push(getItemsList(id, elementConfig.data[filed]));
            fields.push(filed);
          }
        }

        if (promises.length > 0) {
          $q.all(promises).then((results) => {
            for (let i = 0; i < results.length; i++) {
              response[fields[i]] = results[i].meta;
            }
            deferred.resolve(response);
          }).catch((error) => {
            showError(id, error);
          });
        } else {
          deferred.resolve(response);
        }
      } else {
        deferred.resolve(response);
      }
      return deferred.promise;
    }

    function urlApiData(url) {
      return $http.get(url, {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    }

    /**
     * Load different item if item form params has different key from config item
     * @param id
     * @param data
     * @param item
     */
    function loadCustomElementItem(id, data, item) {
      const {workspace} = $location.search();
      const deferred = $q.defer();
      if (data.source.item === item.key) {
        deferred.resolve(item);
      } else {
        let promises = null;

        if (isUrlApi(data.source.item)) {
          promises = urlApiData(data.source.item);
        } else {
          promises = itemsData.getItem(workspace, data.source.item);
        }

        promises.success((resultItem) => {
          resultItem = resultItem[0];
          deferred.resolve(resultItem);
        }).error((error) => {
          if (error.statusCode === 404) {
            showError(id, {title: locales.getLocaleByKey('item_not_found', {key: data.source.item})});
          } else {
            showError(id, error);
          }
        });
      }
      return deferred.promise;
    }

    function widgetTags(id, elementConfig, template) {
      return `${id} ${elementConfig.widget} ${template.grid}`;
    }

    function customWidgetTags(data, tag) {
      if (data.tags) {
        data.tags = `${data.tags} ${tag}`;
      } else {
        data.tags = tag;
      }
    }

    function itemsSort(sort) {
      const fields = {
        key: 'key',
        name: 'name.lower',
        status: 'status.lower'
      };
      if (!sort) return sort;
      let temp = sort.split(',');
      const sortType = temp[1] ? temp[1] : 'asc';
      for (const key in fields) {
        if (fields.hasOwnProperty(key)) {
          if (key === temp[0] || key === temp) {
            return `${fields[key]},${sortType}`;
          }
        }
      }
      return sort;
    }

    function getItemsParams(lookup) {
      const params = (lookup.query) ? utils.queryStringToJSON(lookup.query) : {};
      if (!params.term) {
        params.term = '*';
      }
      if (lookup.term) {
        params.term = lookup.term;
      }
      if (lookup.sort) {
        params.sort = lookup.sort;
      }
      if (params.sort) {
        params.sort = itemsSort(params.sort);
      }
      if (!params.sort) {
        params.sort = 'name.lower,asc';
      }
      if (lookup.filter) {
        params.filter = lookup.filter;
      }
      if (lookup.pagesize) {
        params.pagesize = lookup.pagesize;
      }
      return params;
    }

    function getItemsList(id, params) {
      const vm = getScope();
      const deferred = $q.defer();
      let promises = null;

      if (isUrlApi(params)) {
        promises = urlApiData(params);
      } else {
        const workspace = params.workspace;
        promises = itemsData.items(vm, workspace, getItemsParams(params));
      }

      promises.success((itemsData) => {
        vm.requestSend = false;
        deferred.resolve(itemsData);
      }).error((error) => {
        showError(id, error);
      });

      return deferred.promise;
    }

    function prepareItemsParams(template, items, item) {
      for (const key in items) {
        if (items.hasOwnProperty(key)) {
          if (utils.isObject(items[key])) {
            prepareItemsParams(template, items[key], item)
          } else if (utils.isArray(items[key])) {
            for (let i = 0; i < items[key].length; i++) {
              const field = itemMapping.parseFields(items[key][i], {item: item, user: template.userData}, {allowEmpty: true});
              if (field) {
                items[key][i] = field;
              } else {
                missingVariableError(items[key][i]);
              }
            }
          } else {
            const field = itemMapping.parseFields(items[key], {item: item, user: template.userData}, {allowEmpty: true});
            if (field) {
              items[key] = field;
            } else {
              missingVariableError(items[key]);
            }
          }
        }
      }
    }

    function parseElementWidget(id, data) {
      const widgetPath = `${config.dashboardWidgetPath}/${data.widget}.html?v=${config.version}`;

      $templateRequest(widgetPath, true).then((widget) => {
        const vm = getScope();
        vm.widget[id] = {
          config: { ...data, id },
          template: widget,
          id: id
        };
        const template = $compile(`<div class="dynamic-element-content" dashboard-dynamic-element data="widget.${id}"></div>`)(vm);
        appendElementData(id, template);
      }).catch(() => {
        appendElementData(id, `<span class="element-error">${locales.getLocaleByKey('widget_not_found', {name: data.widget})}</span>`);
      });
    }

    function appendElementData(id, content) {
      $timeout(() => {
        const el = `.grid-stack #${id} .grid-stack-item-content`;
        $(el).html(content);
      }, 0);
    }

    return {
      showElementLoading,
      prepareElements
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('itemMapping', itemMapping);

  itemMapping.$inject = ['$parse', '$location', 'getItemTemplate', 'utils', 'itemSelection', 'locales'];

  function itemMapping($parse, $location, getItemTemplate, utils, itemSelection, locales) {
    function defaultItemIcon() {
      return $("#defaultItemIcon").attr("value");
    }

    function isTranslationFilter(str) {
      if (!str) return false;
      try {
        const split = str.split(' ');
        const filter = split[0].trim();
        const locale = split[1].trim();
        if (filter && locale && (filter === 'translate' || filter === 't')) {
          return `${locale} | ${filter}`;
        }
      } catch (e) {
        return false;
      }
    }

    //check for curly brackets inside mapping fields
    function getWordsBetweenCurlies(str, options) {
      let results = [], re = /{{([^}}]+)}}/g, text;

      if (options && options.singleCurlies) {
        re = /{([^}]+)}/g;
      }

      while (text = re.exec(str)) {
        results.push(text[1]);
      }
      return results;
    }

    //translate all mapping fields
    function translateFileds(str) {
      let resultString = str, re = /<%([^%>]+)%>/g, text;

      while (text = re.exec(str)) {
        var translation = locales.getLocaleByKey(text[1].trim());

        if (translation != text[1].trim()) {
          resultString = resultString.replace("<%" + text[1] + "%>", translation);
        }
      }

      return resultString;
    }

    //replace all curly brackets founded inside mapping fields
    //if are multiple curly brackets will replace all of them in any case one of them doesn't exist will return false
    function replaceCurlies(string, item, options) {
      const checkCurlie = getWordsBetweenCurlies(string, options);

      if (checkCurlie.length) {
        for (let j = 0; j < checkCurlie.length; j++) {
          const translationFilter = isTranslationFilter(checkCurlie[j]);
          let field = $parse(translationFilter ? translationFilter : checkCurlie[j])(item);

          if (options && options.encode && field) {
            field = field.replace(/&/g, '%26');
          }

          if (field || (options && options.allowEmpty)) {
            if (field && utils.isString(field) && options && options.valueType && options.valueType === 'number') {
              field = Number(field);
            }
            if (checkCurlie.length === 1 && utils.isObject(field)) {
              string = field;
            } else {
              if (!field && (options && options.allowEmpty)) {
                if (options.hasOwnProperty('defaultValue')) {
                  field = options.defaultValue;
                } else {
                  field = ''
                }
              }
              if (options && options.singleCurlies) {
                string = string.replace("{" + checkCurlie[j] + "}", field);
              } else {
                string = string.replace("{{" + checkCurlie[j] + "}}", field);
              }
            }
          } else {
            string = false;
            break;
          }
        }
      }

      return string;
    }

    function checkForTernaryOperator(mappingField, item, options) {
      if (options && options.curliesFirst) {
        return mappingField;
      }

      if (mappingField.indexOf('?') != -1) {
        const split = mappingField.split('?');
        if (split[0].indexOf('/') != -1) {
          return mappingField;
        }

        mappingField = $parse(mappingField)(item);
      }
      return mappingField;
    }

    function parseFields(obj, data, options) {
      if (utils.isString(obj)) {
        if (obj === '') {
          return obj;
        } else {
          return prepareMapping(obj, data, options);
        }
      } else if (utils.isArray(obj)) {
        const tempArray = [];
        for (let i = 0; i < obj.length; i++) {
          const parsedField = parseFields(obj[i], data, options);
          if (parsedField) {
            tempArray.push(parsedField);
          }
        }
        return tempArray;
      } else if (utils.isObject(obj)) {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (options && options.exclude) {
              if (!utils.arrayContainsField(options.exclude, key)) {
                obj[key] = parseFields(obj[key], data, options);
              }
            } else {
              obj[key] = parseFields(obj[key], data, options);
            }
          }
        }
        return obj;
      } else {
        return obj;
      }
    }

    function prepareMapping(mappingField, item, options) {
      let result = false;
      let multipleOptions = [];
      let filterOperator = false;

      if (!utils.isString(mappingField)) {
        return mappingField;
      }
      //translate all fields before check for Ternary Operator inside mapping fields
      mappingField = checkForTernaryOperator(translateFileds(mappingField), item, options);

      //check for multiple Operator inside mapping fields
      if (mappingField.indexOf("||") != -1) {
        multipleOptions = mappingField.split("||");
      } else {
        //check for filter operator
        if (mappingField.indexOf("|") != -1) {
          filterOperator = true;
        } else {
          multipleOptions = [mappingField]
        }
      }

      if (filterOperator) {
        let filter = '';
        if (mappingField.indexOf("{{") !== -1) {
          filter = replaceCurlies(mappingField, item, options);
        } else {
          filter = $parse(mappingField)(item);
        }
        if (filter) {
          result = filter;
        }
      } else {
        //will return the first filed which exits
        for (let i = 0; i < multipleOptions.length; i++) {
          const preparedString = replaceCurlies(multipleOptions[i].trim(), item, options);

          if (preparedString) {
            result = preparedString;
            break;
          }
        }
      }

      return result;
    }

    const mapData = function(mapping, item, options) {
      let obj = {};

      for (let key in mapping) {
        if (mapping.hasOwnProperty(key)) {
          let mappingField = mapping[key];

          if (utils.isString(mappingField)) {
            if (mappingField === '') {
              obj[key] = mappingField;
            } else {
              const resField = prepareMapping(mappingField, item, options);
              if (resField) obj[key] = resField;
            }
          } else if (utils.isBoolean(mappingField)) {
            obj[key] = mappingField;
          } else if (utils.isNumber(mappingField)) {
            obj[key] = mappingField;
          } else if (utils.isArray(mappingField)) {
            const arrayMapping = prepareMappingFields(mappingField, item, options);
            if (arrayMapping.length) {
              obj[key] = arrayMapping;
            }
          } else if (utils.isObject(mappingField) && mappingField.name) {
            mappingField.name = prepareMapping(mappingField.name, item);

            if (mappingField.fields && utils.isArray(mappingField.fields)) {
              const arrayFields = prepareMappingFields(mappingField.fields, item, options);
              if (arrayFields.length) {
                arrayFields.map((field) => {
                  if (field.name && field.name.substring(0, 1) === '_') {
                    field.name = field.name.substr(1);
                  }
                });
                mappingField.fields = arrayFields;
                obj[key] = mappingField;
              }
            }
          } else if (utils.isObject(mappingField)) {
            for (const subKey in mappingField) {
              if (mappingField.hasOwnProperty(subKey)) {
                const subField = prepareMapping(mappingField[subKey], item, options);
                if (subField) {
                  if (!obj[key]) {
                    obj[key] = {}
                  }
                  obj[key][subKey] = subField;
                }
              }
            }
          }
        }
      }

      return obj;
    };

    function prepareMappingFields(mappingField, item, options) {
      let arrayMapping = [];
      const optionalFields = { tooltip: true, value_details: true };

      for (let j = 0; j < mappingField.length; j++) {
        const fieldValue = mappingField[j].value;
        let addField = true;

        for (let value in mappingField[j]) {
          if (mappingField[j].hasOwnProperty(value)) {
            if (value != 'type') {
              const customOptions = {};
              if (value === 'link') {
                customOptions.encode = true;
              }

              const fieldData = prepareMapping(mappingField[j][value], item, customOptions);

              if ((fieldData && utils.isString(fieldData)) || (utils.isArray(fieldData) && fieldData.length > 0)) {
                if (mappingField[j].type === 'filter' && utils.isString(fieldData) && value === 'value') {
                  const singleFilter = getSingleFilter(item, mappingField[j], fieldData);
                  if (singleFilter) {
                    mappingField[j][value] = singleFilter;
                  } else {
                    addField = false;
                  }
                } else {
                  mappingField[j][value] = fieldData;
                }
              } else {
                if ((options && options.allowEmpty) || optionalFields[value]) {
                  mappingField[j][value] = fieldData;
                } else {
                  addField = false;
                }
              }
            }
          }
        }

        if (mappingField[j].type && mappingField[j].type == 'attribute') {
          if (mappingField[j].value.length > 160) {
            mappingField[j].subValue = mappingField[j].value.substring(0, 160) + '...';
          }
          if (mappingField[j].type && mappingField[j].type == 'attribute' && !mappingField[j].name) {
            const name = getAttributeKey(fieldValue);
            if (name) {
              mappingField[j].name = name;
            } else {
              addField = false;
            }
          }
        }

        if (addField) {
          arrayMapping.push(mappingField[j]);
        }
      }

      return arrayMapping;
    }

    function getAttributeKey(fieldValue) {
      const val = getWordsBetweenCurlies(fieldValue);
      if (val && val.length > 0) {
        if (val[0].indexOf('[') !== -1) {
          const matches = val[0].match(/\[(.*?)\]/);
          if (matches) {
            return matches[1].replace(/'/g, '').replace(/"/g, '');
          }
        } else {
          const split = val[0].split('.');
          if (split.length >= 3) {
            return split[2];
          }
        }
      }
      return false;
    }

    function getSingleFilter(item, obj, value) {
      const name = getAttributeKey(obj.value);
      if (name) {
        let parseValue = '';
        let parseObject = {
          attribute: {}
        };

        if (obj.value.indexOf('attribute') !== -1) {
          parseValue = "attribute | prepareFilter : 'attribute' : 'true'";
          const arrayValue = value.split(',');
          parseObject.attribute[name] = arrayValue.length > 1 ? arrayValue : value;
        }

        const filter = $parse(parseValue)(parseObject);
        if (filter && filter.length > 0) {
          if (obj.name) {
            const filterName = prepareMapping(obj.name, item);
            if (filterName) {
              filter[0].name = filterName;
            }
          }

          return filter;
        }
      }

      return false;
    }

    const itemMapping = function(item, selectionWidgets) {
      //get the right template for the item or use default
      let template = getItemTemplate.template(item.type);

      //map the item data depends on user role and template
      template.mapping = mapData(template.mapping, {item: item});
      if (!template.mapping.image) {
        template.mapping.image = defaultItemIcon();
      }

      //add item to selection list
      if (template.mapping && template.mapping.bulkSupport && selectionWidgets) {
        itemSelection.addItems(item, template.mapping);
      }
      if (template.color) {
        template.color = parseFields(template.color, {item}, {allowEmpty: true});
      }
      template.type = item.type;
      return template;
    };

    const tableMapping = function(config, item, selectionWidgets) {
      config = mapData(config, {item: item}, {allowEmpty: true});

      //add item icon usd by selection widget
      if (item.icon) {
        config.image = item.icon;
      } else {
        config.image = defaultItemIcon();
      }

      if (config.columns) {
        for (let i = 0; i < config.columns.length; i++) {
          if (config.columns[i].type === 'bulksupport' && config.columns[i].value && selectionWidgets) {
            itemSelection.addItems(item, config);
          }
        }
      }

      return config;
    };

    return {
      itemMapping: itemMapping,
      tableMapping: tableMapping,
      mapData: mapData,
      replaceCurlies: replaceCurlies,
      parseFields: parseFields
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('itemSelection', itemSelection);

  itemSelection.$inject = ['utils', '$cookies', '$rootScope'];

  function itemSelection(utils, $cookies, $rootScope) {
    let selectionChanged = false;
    let allItems = [];
    let activeSelection = [];
    let activeActions = [];
    let showSelectAll = false;
    let totalLoadedSelection = 0;
    const cartPrefix = 'CART';
    const itemCartPrefix = 'CART__';

    function getCart() {
      let itemsInCart = {};
      if ($cookies.get(cartPrefix)) {
        try {
          const cart = JSON.parse($cookies.get(cartPrefix));
          if (utils.isObject(cart)) {
            itemsInCart = {...cart};
          }
        } catch (e) {
          console.log(e);
        }
      }
      // Cookies have size limit of 4096 bytes
      // We are storing items separately to make sure this limit is not reached
      try {
        const allCookies = $cookies.getAll();
        if (allCookies && utils.isObject(allCookies)) {
          for (const cookie_key in allCookies) {
            if (cookie_key.indexOf(itemCartPrefix) !== -1) {
              const item = JSON.parse(allCookies[cookie_key]);
              if (utils.isObject(item)) {
                itemsInCart[item.key] = item;
              }
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
      return itemsInCart;
    }

    function addToCart(item) {
      // Cookies have size limit of 4096 bytes
      // We are storing items separately to make sure this limit is not reached
      if (item.cost && item.cost.cart) {
        $cookies.put(`${itemCartPrefix}${item.key}`, JSON.stringify({
          key: item.key,
          name: item.name,
          image: item.image,
          action: item.action
        }));
      }
    }

    function removeFromCart(id) {
      const cart = getCart();
      delete cart[id];
      $cookies.put(cartPrefix, JSON.stringify(cart));
      $cookies.remove(`${itemCartPrefix}${id}`);
    }

    function clearCart() {
      $cookies.remove(cartPrefix);

      const allCookies = $cookies.getAll();
      if (allCookies && utils.isObject(allCookies)) {
        for (const cookie_key in allCookies) {
          if (cookie_key.indexOf(itemCartPrefix) !== -1) {
            $cookies.remove(cookie_key);
          }
        }
      }
    }

    function isInCart(id) {
      const cart = getCart();
      return !!(cart && cart[id]);
    }

    const updateSelectedItemsFromCart = (item) => {
      if (item && item.key && isInCart(item.key)) {
        select(item.key);
      }
    };

    const clear = function() {
      allItems = [];
      totalLoadedSelection = 0;
      activeSelection = [];
      activeActions = [];
      showSelectAll = false;
      //trigger changes
      selectionChanged = new Date();
    };

    const clearItems = function() {
      allItems = [];
    };

    function getItemById(id) {
      for (let i = 0; i < allItems.length; i++) {
        if (allItems[i].key === id) {
          return allItems[i];
        }
      }
    }

    function removeItemById(id) {
      for (let i = 0; i < activeSelection.length; i++) {
        if (activeSelection[i].key === id) {
          activeSelection.splice(i, 1);
        }
      }
    }

    //change item checkbox value used for selection
    function selectionItemScopeAction(key, action) {
      let itemScope = angular.element(document.getElementById('item-selection-' + key)).scope();

      if (itemScope && itemScope.$parent) {
        itemScope.$parent.actionActive = action;
      }
    }

    function prepareActions() {
      const actions = [];
      const actionsUrl = [];
      activeActions = [];

      for (let i = 0; i < activeSelection.length; i++) {
        const check = !!actions.length;

        if (activeSelection[i].action && utils.isArray(activeSelection[i].action)) {
          for (let j = 0; j < activeSelection[i].action.length; j++) {
            const actionObj = {
              name: activeSelection[i].action[j].name,
              description: activeSelection[i].action[j].description,
              url: activeSelection[i].action[j].url,
              urlPath: activeSelection[i].action[j].urlPath,
              params: activeSelection[i].action[j].params
            };

            if (check) {
              let actionFound = false;
              const currentActionURL = document.createElement('a');
              const commonActionURL = document.createElement('a');

              for (let l = 0; l < actions.length; l++) {
                if (activeSelection[i].action[j].name === actions[l].name) {
                  currentActionURL.href = activeSelection[i].action[j].url;
                  commonActionURL.href = actions[l].url;

                  if (currentActionURL.host === commonActionURL.host
                    && currentActionURL.pathname === commonActionURL.pathname
                    && currentActionURL.port === commonActionURL.port) {
                    const index = actionsUrl.indexOf(activeSelection[i].action[j].urlPath);

                    if (index === -1) {
                      actions.push(actionObj);
                      actionsUrl.push(activeSelection[i].action[j].urlPath);
                    } else {
                      actions[index].params = utils.arrayConcat(actions[index].params, activeSelection[i].action[j].params);
                    }

                    actionFound = true;
                    break;
                  }
                }
              }

              if (!actionFound) {
                break;
              }
            } else {
              actions.push(actionObj);
              actionsUrl.push(activeSelection[i].action[j].urlPath);
            }
          }
        }
      }

      function checkIfExistInAllItems(actionName) {
        return activeSelection.every((item) => {
          if (item.action && Array.isArray(item.action) && item.action.length > 0) {
            return item.action.find((a) => a.name === actionName);
          }
          return true;
        });
      }

      if (actions.length) {
        for (let k = 0; k < actions.length; k++) {
          const existInAllItems = checkIfExistInAllItems(actions[k].name);
          if (existInAllItems) {
            activeActions.push({
              name: actions[k].name,
              description: actions[k].description,
              url: (actions[k].params) ? actions[k].urlPath + '?' + actions[k].params.join('&') : actions[k].url
            });
          }
        }
      }
    }

    function prepareActionsUrl(obj) {
      let allActions = [];

      //put only action with bulksupported
      if (obj.action && utils.isArray(obj.action)) {
        for (let j = 0; j < obj.action.length; j++) {
          if (obj.action[j].bulksupported) {
            if (obj.action[j].url.indexOf('?')) {
              let urlPath = obj.action[j].url.split('?');

              //split the url paramters
              let params = [urlPath[1]];
              if (urlPath[1].indexOf('&')) {
                params = urlPath[1].split('&');
              }

              obj.action[j].urlPath = urlPath[0];
              obj.action[j].params = params;
            }

            allActions.push(obj.action[j]);
            showSelectAll = true;
          }
        }

        if (allActions.length) obj.action = allActions;
      }
    }

    function isUnique(items, obj) {
      let addItem = true;
      for (let i = 0; i < items.length; i++) {
        if (items[i].key === obj.key) {
          addItem = false;
          break;
        }
      }

      return addItem;
    }

    //store item
    const addItems = (obj, mapping) => {
      if (obj && utils.isObject(obj)) {
        if (isUnique(allItems, obj)) {
          prepareActionsUrl(obj);

          allItems.push({
            key: obj.key,
            name: obj.name,
            action: obj.action,
            image: mapping.image,
            cost: obj.cost
          });

          totalLoadedSelection = allItems.length;
        }
      }
    };

    //select all item
    const selectAll = () => {
      if (allItems.length) {
        for (let i = 0; i < allItems.length; i++) {
          if (isUnique(activeSelection, allItems[i])) {
            activeSelection.push(allItems[i]);
            addToCart(allItems[i]);
          }
          //make item checkbox checked
          selectionItemScopeAction(allItems[i].key, true)
        }

        prepareActions();
        //trigger changes
        selectionChanged = new Date();
      }
    };

    //deselect all item
    const deselectAll = (removeSelectionScope) => {
      if (removeSelectionScope) {
        for (let i = 0; i < activeSelection.length; i++) {
          selectionItemScopeAction(activeSelection[i].key, false)
        }
      }

      clearCart();
      activeSelection = [];
      activeActions = [];
      //trigger changes
      selectionChanged = new Date();
    };

    //deselect single item
    const deselect = (key, removeSelectionScope) => {
      //change Selection checkbox value to unchecked
      if (removeSelectionScope) {
        selectionItemScopeAction(key, false);
      }

      removeFromCart(key);
      removeItemById(key);
      prepareActions();
      //trigger changes
      selectionChanged = new Date();
    };

    //select single item
    const select = (key) => {
      let item = getItemById(key);

      if (item && isUnique(activeSelection, item)) {
        activeSelection.push(item);
        prepareActions();
        addToCart(item);
        //trigger changes
        selectionChanged = new Date();
      }
    };

    const isSelected = (id) => {
      for (let i = 0; i < activeSelection.length; i++) {
        if (activeSelection[i].key === id) {
          return true;
        }
      }

      return false;
    };

    const getNames = () => {
      return activeSelection;
    };

    const getActiveActions = () => {
      return activeActions;
    };

    const getTotalLoadedSelection = () => {
      return allItems.length;
    };

    const showSelectAllButton = () => {
      return showSelectAll;
    };

    const watchChanges = () => {
      return selectionChanged;
    };

    function storeSelectedFromCart() {
      const cart = getCart();
      if (cart) {
        for (const key in cart) {
          if (cart.hasOwnProperty(key)) {
            if (!isSelected(key)) {
              activeSelection.push(cart[key]);
            }
          }
        }

        prepareActions();
        //trigger changes
        selectionChanged = new Date();
      }
    }

    $rootScope.$on('widgets_loaded', () => {
      //restore selected items from cart
      storeSelectedFromCart();
    });

    return {
      watchChanges: watchChanges,
      selectAll: selectAll,
      deselectAll: deselectAll,
      deselect: deselect,
      select: select,
      addItems: addItems,
      getNames: getNames,
      getActiveActions: getActiveActions,
      getTotalLoadedSelection: getTotalLoadedSelection,
      showSelectAllButton: showSelectAllButton,
      clear: clear,
      clearItems: clearItems,
      isSelected: isSelected,
      updateSelectedItemsFromCart: updateSelectedItemsFromCart,
      clearCart: clearCart
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('itemsData', itemsData);

  itemsData.$inject = ['$http', 'config', 'queryStringUtils', 'utils'];
  function itemsData($http, config, queryStringUtils, utils) {
    const escapeParams = ['view', 'template', 'embed', 'size', 'export', 'bulletin'];
    let total = 0;
    let itemsLoaded = 0;

    //get total items count
    const totalResults = function() {
      return total;
    };

    //store total items count
    const addTotalResults = function(value) {
      total = value;
    };

    const getItemsLoaded = function() {
      return itemsLoaded;
    };

    //store items loaded
    const addItemsLoaded = function(value) {
      itemsLoaded = value;
    };

    const filterParams = function(params) {
      const obj = {};

      if (utils.isObject(params)) {
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            let exclude = false;
            for (let i = 0; i < escapeParams.length; i++) {
              if (escapeParams[i] === key) {
                exclude = true;
                break;
              }
              if (key.substring(0, 2) === '__') {
                exclude = true;
                break;
              }
            }

            if (!exclude) {
              obj[key] = params[key];
            }
          }
        }
      }

      return obj;
    };

    const items = function(vm, workspace, params) {
      vm.requestSend = true;
      params = filterParams(params);

      return $http.get(config.apiBaseUrl + '/my/items/' + workspace, {
        params: queryStringUtils.removeCustomQuerySting(params),
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getItem = function(workspace, key) {
      return $http.get(config.apiBaseUrl + `/my/items/${workspace}/${key}`, {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const exportItems = function(workspace, params) {
      const exportParam = params.export;
      params = filterParams(params);
      params.export = exportParam;
      return $http.get(`/workspace/${workspace}/export`, {
        params: queryStringUtils.removeCustomQuerySting(params),
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      items: items,
      getItem: getItem,
      totalResults: totalResults,
      getItemsLoaded: getItemsLoaded,
      addItemsLoaded: addItemsLoaded,
      addTotalResults: addTotalResults,
      filterParams: filterParams,
      exportItems: exportItems
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('locales', locales);

  locales.$inject = ['$parse', '$http', 'utils', 'config'];
  function locales($parse, $http, utils, config) {
    //store locale
    const localesElement = $(config.domElements.localeId);
    let locales = {};

    if (localesElement && localesElement.length > 0) {
      const localesData = localesElement.val();
      if (localesData && utils.isString(localesData) && localesData !== 'undefined') {
        locales = JSON.parse(localesData);
      }
    }

    //store translation
    const addLocale = (obj) => {
      if (obj && utils.isString(obj) && obj !== "undefined") {
        locales = JSON.parse(obj);
      }
    };

    const getLocale = () => {
      return locales;
    };

    //translate variables by using angular filters
    const getLocaleByKey = (prop, data) => {
      try {
        let translate = $parse(prop)(locales);
        if ((translate && utils.isString(translate))) {
          if (data) {
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                translate = translate.replace(new RegExp('{{' + key + '}}', 'gi'), data[key]);
              }
            }
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                translate = translate.replace(new RegExp('{' + key + '}', 'gi'), data[key]);
              }
            }

            return translate;
          } else {
            return translate;
          }
        } else {
          return prop;
        }
      } catch (e) {
        return prop;
      }
    };

    const getLocaleObjectByKey = (prop) => {
      try {
        let translate = $parse(prop)(locales);
        if ((translate && utils.isObject(translate))) {
          return translate;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    };

    const getLocalesList = () => {
      const url = (config.apiBaseUrl.indexOf('api/v2') > 0) ? config.apiBaseUrl + '/my/locales' : config.apiBaseUrl + '/my/locale';
      return $http.get(url, {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      addLocale: addLocale,
      getLocale: getLocale,
      getLocaleByKey: getLocaleByKey,
      getLocalesList: getLocalesList,
      getLocaleObjectByKey: getLocaleObjectByKey
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('mediaService', mediaService);

  mediaService.$inject = ['$http'];
  function mediaService($http) {
    const getIcons = () => {
      return $http.get('/icons/list', {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };
    
    return {
      getIcons: getIcons
    };
  }
})();
(function () {
  angular
    .module('onify')
    .service('optionsService', optionsService);

  optionsService.$inject = ['$http', 'config'];
  function optionsService($http, config) {
    const get = function(params, tags) {
      return $http.get(`${config.apiBaseUrl}/my/options/tags/${tags}`, {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      get
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('processesService', processesService);

  processesService.$inject = ['$http', 'config'];
  function processesService($http, config) {

    const get = function(vm, params) {
      return $http.get(config.apiBaseUrl + '/my/processes', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getById = function(id) {
      return $http.get(config.apiBaseUrl + '/my/processes/' + id, {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getProcessesOutput = function(id) {
      return $http.get(config.apiBaseUrl + '/my/processes/' + id + '/output', {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      get: get,
      getById: getById,
      getProcessesOutput: getProcessesOutput
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('queryStringService', queryStringService);

  queryStringService.$inject = ['$window', '$location', 'utils', 'locales'];

  function queryStringService($window, $location, utils, locales) {
    let queryString = {};
    let excludeParams = [];
    let filters = [];
    let preparedFilters = [];
    let worksapce = false;
    let queryStringChanged = false;

    //function to change url parameters depends on filters
    const pushState = () => {
      const origin = window.location.origin;
      const currentUrl = window.location.href.split("?");
      let url = currentUrl[0];
      const params = [];

      for (const prop in queryString) {
        if (queryString.hasOwnProperty(prop)) {
          if (utils.isArray(queryString[prop])) {
            for (let i = 0; i < queryString[prop].length; i++) {
              if (excludeParams.indexOf(prop) === -1) {
                params.push(prop + '=' + encodeURIComponent(queryString[prop][i]));
              }
            }
          } else {
            if (excludeParams.indexOf(prop) === -1) {
              params.push(prop + '=' + encodeURIComponent(queryString[prop]));
            }
          }
        }
      }

      if (params.length) {
        url += '?' + params.join('&');
      }

      $location.url(url.replace(origin, ''));
      $location.replace();
      //change url parameters
      $window.history.pushState({path: url}, "", url);
    };

    const addQueryString = (obj) => {
      if (obj && utils.isObject(obj)) {
        queryString = obj;
        //prepare filters
        filters = [];
        preparedFilters = [];

        if (utils.isObject(obj) && obj.filter && utils.isArray(obj.filter)) {
          prepareFilter(obj.filter);
        }
      }
    };

    const excludeQueryParams = (params) => {
      if (params) {
        excludeParams = params;
      }
    };

    const updateQueryString = (obj, reloadData) => {
      if (obj && utils.isObject(obj)) {
        if (queryString) {
          for (const property in obj) {
            if (obj.hasOwnProperty(property)) {
              queryString[property] = obj[property];
            }
          }

          if (reloadData) {
            queryString.startfrom = (Number(queryString.startfrom) - Number(queryString.pagesize));
            if (queryString.startfrom < 0 || isNaN(queryString.startfrom)) {
              queryString.startfrom = 0;
            }
            //trigger changes
            triggerChanges();
          }
        } else {
          queryString = obj;
        }

        //change url parameter without reloading
        pushState();
      }
    };

    const getQueryString = () => {
      return queryString;
    };

    const prepareFilter = (obj, addToQueryString) => {
      angular.forEach(obj, (item) => {
        if (filters.indexOf(item) === -1) {
          filters.push(item);
          //prepare filters
          const arrFilter = item.trim().split(":");
          const arrValue = [];
          const attr = [];

          for (var i = 0; i < arrFilter.length; i++) {
            if (i === 0) {
              attr.push(arrFilter[i]);
            } else {
              arrValue.push(arrFilter[i]);
            }
          }

          attr.push(arrValue.join(':'));

          let value = (item.indexOf("!") !== -1) ? '!' + attr[1] : attr[1];

          if (value.indexOf('attribute.') !== -1) {
            value = value.replace('attribute.', '');
          } else if (item.indexOf('status.') !== -1) {
            value = value.split('.')[0];
          }

          if (value === 'true') {
            value = locales.getLocaleByKey('yes');
          }
          if (value === 'false') {
            value = locales.getLocaleByKey('no');
          }

          preparedFilters.push({
            filter: item,
            key: attr[0],
            value: value.toUpperCase(),
            tooltip: attr[0].replace('attribute.', '') + ' = ' + value
          });

          //Do not add filter on queryString object in case is not needed
          if (addToQueryString) {
            if (queryString.filter) {
              queryString.filter.push(item);
            } else {
              queryString.filter = [item]
            }
          }
        }
      });
    };

    const getFilters = () => {
      return preparedFilters;
    };

    const addFilter = (obj) => {
      if (obj) {
        if (utils.isObject(obj) && obj.filter) {
          prepareFilter(obj.filter, true);
        } else if (utils.isArray(obj)) {
          prepareFilter(obj, true);
        } else if (utils.isString(obj)) {
          prepareFilter([obj], true);
        }

        if (queryString.startfrom) queryString.startfrom = 0;
        //trigger changes
        triggerChanges();

        //change url parameter without reloading
        pushState();
      }
    };

    const addTerm = (term, fieldKey) => {
      if (term) {
        if (fieldKey) {
          queryString[fieldKey] = term;
        } else {
          queryString.term = term;
        }
        queryString.startfrom = 0;
        //trigger changes
        triggerChanges();

        //change url parameter without reloading
        pushState();
      }
    };

    const indexOfFilter = (filter) => {
      if (filter) {
        for (let i = 0; i < filters.length; i++) {
          if (filters[i].toLowerCase() === filter.toLowerCase()) {
            return i
          }
        }
      }

      return -1;
    };

    const removeFilter = (filter) => {
      if (filter) {
        const index = indexOfFilter(filter);

        if (index !== -1) {
          filters.splice(index, 1);
          preparedFilters.splice(index, 1);
          queryString.filter.splice(index, 1);

          if (queryString.startfrom) queryString.startfrom = 0;
          //trigger changes
          triggerChanges();

          //change url parameter without reloading
          pushState();
        }
      }
    };

    const addWorkspace = (workspaceSlug) => {
      if (workspaceSlug) worksapce = workspaceSlug;
    };

    const getWorkspace = () => {
      return worksapce;
    };

    const watchChanges = () => {
      return queryStringChanged;
    };

    //trigger changes
    const triggerChanges = () => {
      queryStringChanged = new Date().getTime();
    };

    const checkFilter = (filter) => {
      return (indexOfFilter(filter) !== -1);
    };

    return {
      addQueryString: addQueryString,
      updateQueryString: updateQueryString,
      excludeQueryParams: excludeQueryParams,
      getQueryString: getQueryString,
      getFilters: getFilters,
      addFilter: addFilter,
      addTerm: addTerm,
      removeFilter: removeFilter,
      watchChanges: watchChanges,
      checkFilter: checkFilter,
      addWorkspace: addWorkspace,
      getWorkspace: getWorkspace,
      triggerChanges: triggerChanges
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('shortcutsService', shortcutsService);

  shortcutsService.$inject = ['$http', 'config'];
  function shortcutsService($http, config) {
    const get = function(vm, params) {
      vm.requestSend = true;
      return $http.get(config.apiBaseUrl + '/my/shortcuts', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const create = function(shortcut) {
      return $http({
        method: 'POST',
        url: config.apiBaseUrl + '/my/shortcuts',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: shortcut
      });
    };

    const update = function(shortcut, key) {
      return $http({
        method: 'PUT',
        url: config.apiBaseUrl + '/my/shortcuts/' + key,
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: shortcut
      });
    };

    const remove = function(key) {
      return $http({
        method: 'DELETE',
        url: config.apiBaseUrl + '/my/shortcuts/' + key,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      get,
      create,
      update,
      remove
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('tagCloudService', tagCloudService);

  tagCloudService.$inject = ['$http', 'config', 'queryStringService', 'queryStringUtils', 'itemsUtils', 'widgets'];
  function tagCloudService($http, config, queryStringService, queryStringUtils, itemsUtils, widgets) {
    let tagCloud = [];
    let tagCloudChanged = false;
    const tagCloudParams = ['filter', 'term', 'size'];
    const widgetName = 'tag-cloud';

    function get(workspace, params) {
      return $http.get(config.apiBaseUrl + '/my/workspaces/' + workspace + '/tagcloud', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    }

    function prepareParams(params) {
      const obj = {};
      for (let param in params) {
        if (params.hasOwnProperty(param)) {
          if (tagCloudParams.indexOf(param) !== -1) {
            obj[param] = params[param];
          }
        }
      }

      return obj;
    }

    function prepareTags(result) {
      const tags = [];
      for (let tag in result) {
        if (result.hasOwnProperty(tag)) {
          tags.push(tag);
        }
      }

      if (tags.length) {
        tagCloud = itemsUtils.prepareFilter(tags, 'tag');
        for (let tag in tagCloud) {
          if (tagCloud.hasOwnProperty(tag)) {
            tagCloud[tag].value += ' (' + result[tagCloud[tag].value] + ')';
          }
        }

        triggerChanges();
      }
    }

    const loadTagCloud = () => {
      if (!widgets.checkActiveWidgets([widgetName])) {
        return false;
      }

      tagCloud = [];
      const tagCloudWidget = widgets.getWidgetByName(widgetName);
      const workspace = queryStringService.getWorkspace();
      const params = queryStringUtils.removeCustomQuerySting(queryStringService.getQueryString());

      if (tagCloudWidget && tagCloudWidget.params) {
        const widgetParmas = tagCloudWidget.params.split('&');
        for (let i = 0; i < widgetParmas.length; i++) {
          const singleParm = widgetParmas[i].split('=');
          params[singleParm[0]] = singleParm[1];
        }
      }

      triggerChanges();

      get(workspace, prepareParams(params)).success((result) => {
        prepareTags(result);
      }).error((error) => {
        //console.log(error)
      });
    };

    const watchChanges = () => {
      return tagCloudChanged;
    };

    //trigger changes
    function triggerChanges() {
      tagCloudChanged = new Date().getTime();
      widgets.updateWidget(tagCloud.length, widgetName);
    }

    const getTagCloud = () => {
      return tagCloud;
    };

    return {
      getTagCloud: getTagCloud,
      loadTagCloud: loadTagCloud,
      watchChanges: watchChanges,
      triggerChanges: triggerChanges
    };
  }
})();

(function () {
  angular
    .module('onify')
    .service('taskService', taskService);

  taskService.$inject = ['$http', 'config'];
  function taskService($http, config) {
    const run = function(command, params, payload) {
      return $http({
        method: 'POST',
        url: config.apiBaseUrl + '/my/agent/task/' + command,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: payload,
        params: params
      });
    };

    const getTaskResult = function(taskId) {
      return $http({
        method: 'get',
        url: `${config.apiBaseUrl}/my/agent/task/${taskId}/result`,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getTaskLogs = function(taskId) {
      return $http({
        method: 'get',
        url: `${config.apiBaseUrl}/my/agent/task/${taskId}/log`,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      run,
      getTaskResult,
      getTaskLogs
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('userService', userService);

  userService.$inject = ['$http', 'config'];
  function userService($http, config) {
    let userSettings = false;

    //get user settings
    const getSettings = (type) => {
      if (type == 'settings' && userSettings[type]) {
        return userSettings[type];
      } else if (type == 'role' && userSettings[type]) {
        return userSettings[type];
      }

      return userSettings;
    };

    //store user settings
    const loadUserSettings = () => {
      getUserSettings()
        .success((settings) => {
          userSettings = settings;
        })
        .error(function(e) {
          console.log(e);
        });
    };

    const getUserSettings = () => {
      return $http.get(config.apiBaseUrl + '/my/settings', {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const saveSettings = function(settings) {
      return $http({
        method: 'POST',
        url: config.apiBaseUrl + '/my/settings',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: settings
      });
    };

    const getMyUsers = function(params) {
      return $http({
        method: 'get',
        url: config.apiBaseUrl + '/my/users',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        params: params
      });
    };

    const watchChanges = () => {
      return userSettings;
    };

    return {
      getUserSettings: getUserSettings,
      loadUserSettings: loadUserSettings,
      getSettings: getSettings,
      saveSettings: saveSettings,
      watchChanges: watchChanges,
      getMyUsers: getMyUsers
    };
  }
})();
(function() {
  angular
    .module('onify')
    .service('widgets', widgetsService);

  widgetsService.$inject = ['$rootScope', '$q', '$location', '$templateRequest', 'config', 'utils', 'locales', 'itemSelection', 'queryStringService', 'itemsData', 'userService'];
  function widgetsService($rootScope, $q, $location, $templateRequest, config, utils, locales, itemSelection, queryStringService, itemsData, userService) {
    const watchActiveWidgets = {};
    const activeSidebars = {};
    let _sidebarsConfig = {};
    let _widgetsConfig = [];
    let widgetsFromQueryParams = {};

    //reactive variable for meta widget
    $rootScope.$watch(() => {
      return itemsData.totalResults();
    }, () => {
      changeWidget(itemsData.totalResults(), 'meta');
    });

    //reactive variable for filters widget
    $rootScope.$watch(() => {
      return queryStringService.watchChanges();
    }, () => {
      changeWidget(queryStringService.getFilters().length, 'filters');
    });

    //reactive variable for selected and actions widget
    $rootScope.$watch(() => {
      return itemSelection.watchChanges();
    }, () => {
      changeWidget(itemSelection.getNames().length, 'selected');
      changeWidget(itemSelection.getActiveActions().length, 'actions');
    });

    function widgetsByWorkspace(widget) {
      const worksapce = queryStringService.getWorkspace();
      if (!widget.workspace) return true;
      const widgetWorkspace = Array.isArray(widget.workspace) ? widget.workspace : [widget.workspace];
      return widgetWorkspace.indexOf(worksapce) !== -1;
    }

    function widgetsByRole(widget) {
      const role = userService.getSettings('role');
      if (!widget.role || !role || !Array.isArray(role)) return true;
      const widgetRole = Array.isArray(widget.role) ? widget.role : [widget.role];
      return utils.anyMatchInArray(widgetRole, role, true);
    }

    function disableActiveWidgetsFormQueryParams() {
      const params = $location.search();
      if (params && params.widgets) {
        const widgets = params.widgets.split(',');
        widgetsFromQueryParams = {};
        for (let i = 0; i < widgets.length; i++) {
          if (widgets[i].indexOf('!') !== -1) {
            widgetsFromQueryParams[widgets[i].replace('!', '')] = {active: false};
          } else {
            widgetsFromQueryParams[widgets[i].replace('!', '')] = {active: true};
          }
        }
      }
    }

    function isActiveWidget(widget) {
      let active = false;
      if (widgetsFromQueryParams[widget.widget] && widgetsFromQueryParams[widget.widget].active) {
        active = true;
      } else if (widget.active && !widgetsFromQueryParams[widget.widget]) {
        active = true;
      }

      return active;
    }

    //remove or add widget on sidebar if has data to show
    function changeWidget(total, widget) {
      for (const attr in watchActiveWidgets) {
        if (watchActiveWidgets.hasOwnProperty(attr)) {
          if (watchActiveWidgets[attr][widget]) {
            watchActiveWidgets[attr][widget].active = !(!total);
            activeSidebars[attr] = new Date().getTime();
          }
        }
      }
    }

    function translateWidget(widget) {
      //load title form locales
      if (widget.title) {
        if (widget.title.indexOf(' ') === -1) {
          widget.title = locales.getLocaleByKey(widget.title)
        }
      }
      //load help text form locales
      if (widget.help) {
        if (widget.help.indexOf(' ') === -1) {
          widget.help = locales.getLocaleByKey(widget.help)
        }
      }
      return widget;
    }

    //get available widgets for an sidebar
    function getSidebarWidgets(sidebarName) {
      const widgets = [];
      const sidebarsConfig = utils.clone(_sidebarsConfig);
      let sidebarOptions = sidebarsConfig[sidebarName];

      if (!sidebarOptions || !sidebarOptions.length) {
        return [];
      }

      sidebarOptions = utils.order(sidebarOptions, 'order');
      const widgetsConfig = utils.clone(_widgetsConfig);

      for (let i = 0; i < sidebarOptions.length; i++) {
        for (let j = 0; j < widgetsConfig.length; j++) {
          if (sidebarOptions[i].widget === widgetsConfig[j].name) {
            //translate widget fields
            widgetsConfig[j] = translateWidget(widgetsConfig[j]);

            if ((watchActiveWidgets[sidebarName][widgetsConfig[j].name] && watchActiveWidgets[sidebarName][widgetsConfig[j].name].active)) {
              widgets.push(widgetsConfig[j]);
            }
            break;
          }
        }
      }

      return utils.removeDuplicatedObjects(widgets, 'name');
    }

    const checkActiveWidgets = (widgets) => {
      if (!widgets || !widgets.length) {
        return 0;
      }
      const activeWigets = {};
      //update disabled widgets form query strings
      disableActiveWidgetsFormQueryParams();

      const sidebarsConfig = utils.clone(_sidebarsConfig);
      for (const sidebar in sidebarsConfig) {
        if (sidebarsConfig.hasOwnProperty(sidebar)) {
          for (let i = 0; i < sidebarsConfig[sidebar].length; i++) {
            if (widgets.indexOf(sidebarsConfig[sidebar][i].widget) !== -1) {
              if (isActiveWidget(sidebarsConfig[sidebar][i])) {
                activeWigets[sidebarsConfig[sidebar][i].widget] = true;
              }
            }
          }
        }
      }
      return Object.keys(activeWigets).length;
    };

    //set up all available sidebars and widgets
    const loadSidebarsAndWidgets = function() {
      //update disabled widgets form query strings
      disableActiveWidgetsFormQueryParams();

      const sidebarsConfig = utils.clone(_sidebarsConfig);
      const widgetsConfig = utils.clone(_widgetsConfig);

      //loop all sidebars names
      for (const sidebarName in sidebarsConfig) {
        if (sidebarsConfig.hasOwnProperty(sidebarName)) {
          //get all widgets on sidebar
          const sidebarOptions = sidebarsConfig[sidebarName];
          //loop all sidebar widgets
          for (let i = 0; i < sidebarOptions.length; i++) {
            //loop all widgets list
            for (let j = 0; j < widgetsConfig.length; j++) {
              if (sidebarOptions[i].widget === widgetsConfig[j].name) {
                if (!watchActiveWidgets[sidebarName]) {
                  watchActiveWidgets[sidebarName] = {};
                }

                if (isActiveWidget(sidebarOptions[i]) && widgetsByWorkspace(sidebarOptions[i]) && widgetsByRole(sidebarOptions[i])) {
                  watchActiveWidgets[sidebarName][sidebarOptions[i].widget] = {active: !widgetsConfig[j].watch};
                }
                break;
              }
            }
          }

          activeSidebars[sidebarName] = true;
        }
      }

      $rootScope.$broadcast('widgets_loaded', true);
    };

    const get = function(sidebarName) {
      return getSidebarWidgets(sidebarName);
    };

    const watchChanges = (sidebarName) => {
      return activeSidebars[sidebarName];
    };

    const loadConfigs = function() {
      const deferred = $q.defer();

      if (Object.keys(_sidebarsConfig).length && _widgetsConfig.length) {
        deferred.resolve(true);
        return deferred.promise;
      }
      const version = '?v=' + new Date().getTime();

      $q.all([
        $templateRequest(config.configDirPath + 'sidebars.json' + version),
        $templateRequest(config.configDirPath + 'widgets.json' + version)
      ]).then((results) => {
        _sidebarsConfig = JSON.parse(results[0]);
        _widgetsConfig = JSON.parse(results[1]);
        //set up widgets
        loadSidebarsAndWidgets();
        deferred.resolve(true);
      }).catch((err) => {
        console.log(err);
      });

      return deferred.promise;
    };

    const checkNavBarSupportOnMobile = (widgets) => {
      for (let i = 0; i < widgets.length; i++) {
        if (config.topNavWigets.indexOf(widgets[i].name) !== -1) {
          widgets[i].hideMobile = true;
        }
      }

      return widgets;
    };

    const updateWidget = function(value, widgetName) {
      changeWidget(value, widgetName);
    };

    const getWidgetByName = function(name) {
      for (let i = 0; i < _widgetsConfig.length; i++) {
        if (_widgetsConfig[i].name === name) {
          return _widgetsConfig[i];
        }
      }

      return false;
    };

    return {
      get: get,
      updateWidget: updateWidget,
      checkActiveWidgets: checkActiveWidgets,
      watchChanges: watchChanges,
      loadConfigs: loadConfigs,
      checkNavBarSupportOnMobile: checkNavBarSupportOnMobile,
      getWidgetByName: getWidgetByName
    };
  }
})();

(function() {
  angular
    .module('onify')
    .service('workspacesService', workspacesService);

  workspacesService.$inject = ['$http', 'config'];
  function workspacesService($http, config) {
    const getWorkspaces = () => {
      return $http.get(config.apiBaseUrl + '/my/workspaces', {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };
    
    return {
      getWorkspaces: getWorkspaces
    };
  }
})();
(function() {
  angular
    .module('onify')
    .controller('navbarresultsController', navbarresultsController);

  navbarresultsController.$inject = ['$window', '$scope', 'config', 'utils', 'locales', 'itemSelection', 'widgets'];
  function navbarresultsController($window, $scope, config, utils, locales, itemSelection, widgets) {
    let vm = $scope;
    vm.hideSelectionBar = false;
    vm.expandSelection = false;
    vm.activeSelection = 0;
    vm.activeActions = 0;
    //translations
    vm.filtersLabelLocale = locales.getLocaleByKey('filters');
    vm.filtersLabelHelpLocale = locales.getLocaleByKey('help_filters_label');

    angular.element($window).bind('resize', () => {
      changeSelectionBar();
    });

    vm.$watch(() => {
      return widgets.watchChanges('sidebarRight');
    }, () => {
      const activeWidgetsRight = widgets.get('sidebarRight');
      for (let i = 0; i < activeWidgetsRight.length; i++) {
        if(config.topNavWigets.indexOf(activeWidgetsRight[i].name) !== -1){
          vm['widget' + activeWidgetsRight[i].name] = true;
        }
      }

      changeSelectionBar();
    });

    function changeSelectionBar() {
      utils.safeApply(vm, () => {
        vm.hideSelectionBar = ($(document).outerWidth() < 700);
      });
    }

    vm.$watch(() => {
      return itemSelection.watchChanges();
    }, () => {
      if (!vm.widgetselected && !vm.widgetactions) {
        return;
      }

      const activeSelection = itemSelection.getNames().length;
      vm.activeSelection = itemSelection.getNames().length;
      vm.activeActions = itemSelection.getActiveActions().length;

      if (activeSelection) {
        if (activeSelection === 1) {
          vm.activeSelectionLabel = activeSelection + ' ' + locales.getLocaleByKey('object') + ' ' + locales.getLocaleByKey('selected');
          vm.showObjectLabel = locales.getLocaleByKey('showobject');
          vm.hideObjectLabel = locales.getLocaleByKey('hide_object');
        } else {
          vm.activeSelectionLabel = activeSelection + ' ' + locales.getLocaleByKey('objects') + ' ' + locales.getLocaleByKey('selected');
          vm.showObjectLabel = locales.getLocaleByKey('show') + ' ' + activeSelection + ' ' + locales.getLocaleByKey('objects');
          vm.hideObjectLabel = locales.getLocaleByKey('hide_all_objects');
        }
      }

      changeSelectionBar();
    });

    vm.removeSelection = (key) => {
      itemSelection.deselect(key, true);
    };

    vm.showHideAllObjects = () => {
      vm.expandSelection = !vm.expandSelection;
      changeSelectionBar();
    };
  }
})();
(function() {
  angular
    .module('onify')
    .controller('resultController', resultController);

  resultController.$inject = ['$window', '$location', '$scope', '$q', '$timeout', 'config', 'itemsData', 'utils', 'itemsUtils', 'queryStringService', 'locales', 'itemSelection', 'widgets', 'getItemTemplate', 'tagCloudService', 'userService', 'bulletinService'];

  function resultController($window, $location, $scope, $q, $timeout, config, itemsData, utils, itemsUtils, queryStringService, locales, itemSelection, widgets, getItemTemplate, tagCloudService, userService, bulletinService) {
    let vm = $scope;
    let pagesize = ($location.search().hasOwnProperty('pagesize')) ? $location.search().pagesize : config.workspaceResultsPageSize;
    vm.itemsKeys = {};
    vm.loadingText = locales.getLocaleByKey('loading');
    vm.noresultsfoundText = locales.getLocaleByKey('no_results_found');
    vm.closeText = locales.getLocaleByKey('close');
    //on controller init load items for current workspace
    const workspace = $(config.domElements.currentWorkspaceId);

    vm.resultPageBulletin = $('#resultPageBulletin').val();
    vm.allowedExport = workspace.attr("data-export");
    vm.workspaceSlug = workspace.attr("workspace");
    //prepare all filters from query string and store filters on queryStringService
    queryStringService.excludeQueryParams(['startfrom', 'pagesize', 'size', 'bulletin']);
    //store workspace
    queryStringService.addWorkspace(vm.workspaceSlug);

    $q.all([
      widgets.loadConfigs(),
      getItemTemplate.loadConfig()
    ]).then(() => {
      const params = $location.search();
      if (params['__message']) {
        vm.__message = params['__message'];
      }

      //download items
      if (params.export && vm.allowedExport === 'true') {
        const exportParam = params.export;
        const exportLinkParams = itemsData.filterParams(params);
        exportLinkParams.export = exportParam;
        const link = `/workspace/${vm.workspaceSlug}/export?${utils.createUriFromObject(exportLinkParams)}`;
        const anchor = angular.element('<a/>');
        anchor.attr({
          href: link,
          target: '_blank',
          download: vm.workspaceSlug
        })[0].click();
        anchor.remove();
      }

      vm.customItemView = itemsUtils.customItemView();
      if (vm.customItemView) {
        setActiveView(params);

        //load table view main templates
        return itemsUtils.loadTableViewTemplates(vm.customItemView);
      } else {
        return false;
      }
    }).then((tableTemplates) => {
      if (tableTemplates) {
        vm.customItemView.templates = tableTemplates;
      }

      queryStringService.addQueryString(utils.prepareQueryString(workspace.attr("query")));
      queryStringService.triggerChanges();

      vm.$watch(() => {
        return userService.watchChanges();
      }, (user) => {
        if (user) {
          vm.$watch(() => {
            return queryStringService.watchChanges();
          }, () => {
            getItems();
            //get tag cloud if widget is active
            tagCloudService.loadTagCloud();
          });
        }
      });
    });

    function setActiveView(params) {
      if (params.view && params.view === vm.customItemView.view) {
        vm.activeView = vm.customItemView.view;
      } else {
        vm.activeView = null;
      }
    }

    //search input
    const searchItemsInput = $(config.domElements.searchItemsInput);
    // Revert to a previously saved state
    $window.addEventListener('popstate', () => {
      let filtersObject = $location.search();

      if (filtersObject) {
        if (filtersObject.filter && utils.isString(filtersObject.filter)) {
          filtersObject.filter = [filtersObject.filter];
        }
        if (filtersObject.term) {
          searchItemsInput.val(filtersObject.term)
        }
      }

      setActiveView(filtersObject);

      queryStringService.addQueryString(filtersObject);
      queryStringService.triggerChanges();
      vm.$apply();
    });

    vm.$on('result_on_view_change', (event, view) => {
      utils.safeApply(vm, () => {
        if (vm.customItemView) {
          itemsUtils.changeView(vm, itemsData, view);
        }
      });
    });

    vm.$on('result_on_page_size_change', (event, pageSize) => {
      utils.safeApply(vm, () => {
        pagesize = pageSize;
        const params = queryStringService.getQueryString();
        params.pagesize = pageSize;
        queryStringService.updateQueryString(params, true);
      });
    });

    vm.$on('open_actions_modal_form', (event, option) => {
      vm.embedFormLoading = true;
      vm.modalHeader = option.data.title;
      vm.embedFormUrl = option.data.url;

      angular.element('#' + option.id).modal('show');

      if (!vm.iframeOnloadAction) {
        vm.iframeOnloadAction = true;
        $timeout(() => {
          $('#' + option.id + ' iframe').on("load", function() {
            utils.safeApply(vm, () => {
              vm.embedFormLoading = false;
            });
          });
        }, 200);
      } else {
        $('#' + option.id + ' iframe').attr('src', '').attr('src', vm.embedFormUrl);
      }
    });

    function getItems() {
      vm.params = queryStringService.getQueryString();
      vm.showLoadMore = true;
      vm.items = [];
      vm.tempItems = [];
      vm.itemsKeys = {};
      vm.showError = false;
      vm.errorDetails = false;
      vm.errorMessage = false;
      vm.noResultsFound = false;

      if (pagesize) {
        vm.params.pagesize = pagesize;
      }

      itemsData.items(vm, vm.workspaceSlug, vm.params)
        .success((result) => {
          vm.$watch(() => {
            return getItemTemplate.waitTemplates();
          }, () => {
            itemsUtils.changeTableViewTemplate(vm, result.records).then(() => {
              vm.items = [];
              vm.tempItems = [];
              vm.noResultsFound = false;
              itemSelection.clearItems();
              itemsUtils.prepareResult(vm, itemsData, result);
              itemsData.addTotalResults((result.records.length) ? result.meta.totalresults : 0);

              //check if we have more items to load
              if (vm.items.length < result.meta.pagesize) {
                if (!result.records.length) vm.noResultsFound = true;
              }
            });
          });
        })
        .error((error) => {
          vm.showLoadMore = false;
          vm.noResultsFound = true;
        });
    }

    vm.$watch(() => {
      return widgets.watchChanges('sidebarRight');
    }, () => {
      vm.isSidebarRightActive = widgets.get('sidebarRight').length > 0;
    });

    vm.$watch(() => {
      return widgets.watchChanges('sidebarLeft');
    }, () => {
      vm.isSidebarLeftActive = widgets.get('sidebarLeft').length > 0;
    });

    vm.$watch(() => {
      return widgets.watchChanges('sidebarTop');
    }, () => {
      vm.activeWidgetsSidebarTop = widgets.get('sidebarTop');
      vm.isActiveSidebarTop = vm.activeWidgetsSidebarTop.length;
      vm.metaWigetActive = false;
      for (let i = 0; i < vm.activeWidgetsSidebarTop.length; i++) {
        if (vm.activeWidgetsSidebarTop[i].name === 'meta') {
          vm.metaWigetActive = true;
        }
      }
    });

    searchItemsInput.typeWatch({
      allowSubmit: false,
      captureLength: 2,
      wait: 400,
      callback: function(value) {
        utils.safeApply(vm, () => {
          queryStringService.addTerm(value);
        });
      }
    });

    searchItemsInput.keyup(function(e) {
      if (e.keyCode === 13 || e.keyCode === 8) {
        // Clear timer
        clearTimeout(vm.timer);
        vm.timer = setTimeout(() => {
          const value = this.value.replace(/\s+/g, ' ');
          if (e.keyCode === 8 && value && value.length >= 2) return;
          utils.safeApply(vm, () => {
            if (!value || value === '' || value === ' ') {
              if (e.keyCode !== 8) {
                searchItemsInput.val('');
              }
              queryStringService.addTerm('*');
            } else {
              queryStringService.addTerm(value);
            }
          });
        }, 400);
      }
    });

    vm.removeMessage = function() {
      const params = queryStringService.getQueryString();
      delete params['__message'];
      queryStringService.updateQueryString(params);
      vm.__message = null;
    }
  }
})();

(function() {
  angular
    .module('onify')
    .controller('workspaceSearchController', workspaceSearchController);

  workspaceSearchController.$inject = ['$scope', '$timeout', '$location', 'config', 'itemsData', 'queryStringService', 'itemsUtils', 'locales', 'utils', 'getItemTemplate'];
  function workspaceSearchController($scope, $timeout, $location, config, itemsData, queryStringService, itemsUtils, locales, utils, getItemTemplate) {
    let vm = $scope;

    const workspace = $(config.domElements.currentWorkspaceId);
    vm.workspaceSlug = workspace.attr("workspace");
    //store workspace
    queryStringService.addWorkspace(vm.workspaceSlug);
    const searchItemsInput = $(config.domElements.searchItemsInput);

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.noresultsfoundText = locales.getLocaleByKey('no_results_found');
    vm.closeText = locales.getLocaleByKey('close');
    vm.itemsKeys = {};

    const resultsPageLink = '/workspace/' + vm.workspaceSlug + '/search?term=';

    const params = $location.search();

    if (params.hasOwnProperty('showall') && params.showall === '0') {
      vm.hideAllResults = true;
    }

    if (params.hasOwnProperty('selectitem') && params.selectitem === '0') {
      vm.preventEnter = true;
    }

    //load item templates
    getItemTemplate.loadConfig().then(() => {
    });

    searchItemsInput.val('');

    searchItemsInput.typeWatch({
      allowSubmit: false,
      captureLength: 2,
      wait: 400,
      callback: function(value) {
        vm.items = [];
        vm.tempItems = [];
        vm.showLoading = true;
        vm.openDropdown = true;
        vm.noResultsFound = false;
        vm.viewAllResults = false;
        vm.itemsKeys = {};
        searchItemsInput.addClass('active');

        itemsData.items(vm, vm.workspaceSlug, {term: value, pagesize: config.autocompletePagesize})
          .success((result) => {
            vm.$watch(() => {
              return getItemTemplate.waitTemplates();
            }, () => {
              vm.showLoading = false;
              vm.noResultsFound = false;

              itemsUtils.prepareResult(vm, itemsData, result, 'search');

              if (result.meta.totalresults > result.records.length && result.records.length && !vm.hideAllResults) {
                vm.viewAllResults = locales.getLocaleByKey('show_all_results', {x: result.meta.totalresults});
                vm.viewMoreLink = resultsPageLink + searchItemsInput.val();
              }

              if (!result.records.length) {
                vm.noResultsFound = true;
              }
            });
          })
          .error((error) => {
            vm.showLoading = false;
            vm.noResultsFound = true;
          });
      }
    });

    searchItemsInput.keypress(function(e) {
      if (e.keyCode === 13) {
        if (vm.preventEnter) {
          return;
        }
        e.preventDefault();
        const selected = $('.dropdown-search-result .item-result.selected');
        if (selected.length > 0) {
          const link = selected.find('.autocomplete-title a');
          if (link.length > 0) {
            location.href = link.attr('href');
          } else {
            selected.find('.autocomplete-title').trigger('click');
          }
        } else {
          const value = this.value.replace(/\s+/g, ' ');
          if (!value || value === '') {
            this.value = '*';
            location.href = resultsPageLink + '*';
          } else {
            location.href = resultsPageLink + value;
          }
        }
      }
    });

    function closeSearchDropdown() {
      if (searchItemsInput.hasClass('active')) {
        searchItemsInput.removeClass('active').blur();
        utils.safeApply(vm, () => {
          vm.openDropdown = false;
        });
      }
    }

    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        closeSearchDropdown();
      }
    });

    searchItemsInput.on('click', function() {
      utils.safeApply(vm, () => {
        if (vm.items && vm.items.length) {
          searchItemsInput.addClass('active');
          vm.openDropdown = true;
        }
      });
    });

    function selectItems(which) {
      if (!vm.openDropdown) return;
      const selected = $('.dropdown-search-result .item-result.selected');
      const items = $('.dropdown-search-result .item-result');
      items.removeClass('selected');

      if (which === 38) {
        if (selected.length > 0) {
          if (selected.is(':first-child')) {
            items.last().addClass('selected');
          } else {
            selected.prev().addClass('selected');
          }
        } else {
          items.last().addClass('selected');
        }
      } else if (which === 40) {
        if (selected.length > 0) {
          if (selected.next().hasClass('item-result')) {
            selected.next().addClass('selected');
          } else {
            items.first().addClass('selected');
          }
        } else {
          items.first().addClass('selected');
        }
      }
    }

    $(document).on('click', function(e) {
      if (!($(e.target).closest('.workspace-search-container').length)) {
        closeSearchDropdown();
      }
    });

    $(document).keydown(function(e) {
      if (e.which === 38 || e.which === 40) {
        selectItems(e.which);
        e.preventDefault();
      }
    });

    vm.$on('open_actions_modal_form', (event, option) => {
      vm.embedFormLoading = true;
      vm.modalHeader = option.data.title;
      vm.embedFormUrl = option.data.url;

      angular.element('#' + option.id).modal('show');

      if (!vm.iframeOnloadAction) {
        vm.iframeOnloadAction = true;
        $timeout(() => {
          $('#' + option.id + ' iframe').on("load", function() {
            utils.safeApply(vm, () => {
              vm.embedFormLoading = false;
            });
          });
        }, 200);
      } else {
        $('#' + option.id + ' iframe').attr('src', '').attr('src', vm.embedFormUrl);
      }
    });

    //Auto scrolling help text
    utils.autoChangePlaceholder();
  }
})();

(function() {

  angular
    .module('onify')
    .controller('dashboardController', dashboardController);

  dashboardController.$inject = ['$scope', '$location', 'locales', 'queryStringService', 'itemDashboardService', 'userService'];

  function dashboardController($scope, $location, locales, queryStringService, itemDashboardService, userService) {
    let vm = $scope;
    vm.widget = {};

    vm.noDataAvailable = locales.getLocaleByKey('no_data_available');

    let params = $location.search();
    if (params.workspace) {
      //store workspace
      queryStringService.addWorkspace(params.workspace);
    }
    let template = {
      elements: {}
    };

    vm.refresh = function(dashboard) {
      if (dashboard.refreshinterval) {
        const interval = dashboard.refreshinterval * 1;
        if (interval && interval > 0) {
          setInterval(function () {
            document.location.reload();
          }, interval * 1000);
        }
      }
    };

    let dashboardConfig = $('#items-dashboard-page').attr('data-dashboard');
    try {
      dashboardConfig = JSON.parse(dashboardConfig);
      if (dashboardConfig && dashboardConfig.template) {
        template.grid = dashboardConfig.template;
      }

      vm.refresh(dashboardConfig);
    } catch (err) {
      console.log(err);
    }

    const grid = $('.grid-stack').gridstack({
      cellHeight: 40,
      verticalMargin: 0
    }).data('gridstack');
    grid.enableMove(false, true);
    grid.enableResize(false, true);

    $('.grid-stack .grid-stack-item').each(function() {
      const id = $(this).attr('id');
      const config = $(this).attr('data-element-config');
      if (config) {
        template.elements[id] = config;
      }
    });

    vm.$watch(() => {
      return userService.watchChanges();
    }, (user) => {
      if (user) {
        template.userData = user;
        //show loading icons
        itemDashboardService.showElementLoading(template.elements);
        //parse elements templates and corresponding widgets
        itemDashboardService.prepareElements(template);
      }
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('itemsDashboard', itemsDashboard);

  itemsDashboard.$inject = ['config'];
  function itemsDashboard(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/dashboard/dashboard.template.html?v=' + config.version,
      controller: "dashboardController"
    };
  }

})();
(function () {

  angular
    .module('onify')
    .directive('dashboardDynamicElement', dashboardDynamicElement);

  dashboardDynamicElement.$inject = ['$compile', '$parse', '$timeout', 'utils', 'locales'];

  function dashboardDynamicElement($compile, $parse, $timeout, utils, locales) {
    return {
      restrict: 'A',
      replace: false,
      terminal: true,
      priority: 1000,
      scope: {
        data: '=',
      },
      link: function(scope, element) {
        const defaultWidgetLayout = {
          expandable: false,
          collapsed: false,
        };
        scope.noDataAvailable = locales.getLocaleByKey('no_data_available');
        scope.showless = locales.getLocaleByKey('show_less');
        scope.showmore = locales.getLocaleByKey('show_more');
        scope.widget = {...scope.data.config, layout: {...defaultWidgetLayout, ...scope.data.config.layout}};

        $timeout(() => {
          if (scope.widget.layout.expandable && scope.widget.layout.collapsed) {
            toggleExpand(scope.widget);
          }
        }, 100);

        function toggleExpand(widget) {
          const grid = $('.grid-stack').data('gridstack');
          const gsi = $(`#${widget.id}`);
          grid.resize(gsi, widget.layout.width * 1, widget.collapsed ? (widget.layout.height * 2) + 1 : 1);
          widget.collapsed = !widget.collapsed;
        }

        scope.toggleExpand = toggleExpand;

        scope.fieldValue = (fields, name, returnObj) => {
          if (fields && utils.isArray(fields)) {
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name === name) {
                if (returnObj) {
                  return fields[i];
                }
                return fields[i].value;
              }
            }
          }
          return '';
        };

        scope.isColor = (string) => {
          if (!string) return false;
          return (string.indexOf('#') !== -1);
        };

        scope.getCustomStyle = (expression, value, isColor) => {
          if (utils.isObject(value)) {
            //let field = $parse(checkCurlie[j])(item);
            for (const key in value) {
              if (value.hasOwnProperty(key)) {
                if ($parse(expression + ' ' + value[key])({})) {
                  if (isColor) {
                    return scope.isColor(key);
                  }
                  return key;
                }
              }
            }
          } else {
            if (isColor) {
              return scope.isColor(value);
            }
            return value;
          }
          return true;
        };

        scope.formUrl = (path, form, params) => {
          let formPath = path + '/' + form;
          if (params) {
            formPath += '?' + params;
          }
          return formPath;
        };
        const template = $compile(scope.data.template)(scope);
        $(element).html(template);
      }
    };
  }

})();

(function() {

  angular
    .module('onify')
    .directive('defaultWidgetContent', defaultWidgetContent);

  defaultWidgetContent.$inject = ['config'];
  function defaultWidgetContent(config) {
    return {
      restrict: 'EA',
      transclude: true,
      replace: true,
      templateUrl: 'app/common/directives/dashboard/default.widget.content.html?v=' + config.version
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('errorContentController', errorContentController);

  errorContentController.$inject = ['$scope'];
  function errorContentController($scope) {
    let vm = $scope;
  }

})();
(function() {

  angular
    .module('onify')
    .directive('errorContent', errorContent);

  function errorContent() {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        error: '=error'
      },
      templateUrl: 'app/common/directives/error/error.template.html',
      controller: "errorContentController"
    };
  }

})();
(function() {
  angular
    .module('onify')
    .directive('compileCustomTemplates', compileCustomTemplates);

  compileCustomTemplates.$inject = ['$compile', '$parse', 'utils'];
  function compileCustomTemplates($compile, $parse, utils) {
    return {
      restrict: 'AE',
      transclude: false,
      scope: {
        templatePath: '=templatePath',
        data: '=',
        items: '='
      },
      link: function($scope, $element) {
        const templatePath = $scope.templatePath;
        if (templatePath) {
          const templateHtml = $parse(templatePath)($scope.data);
          if (templateHtml) {
            const template = angular.element(templateHtml);
            $element.append(template);
            // And let Angular $compile it
            $compile(template)($scope);
          }
        }
      }
    };
  }
})();
(function () {
  angular
    .module('onify')
    .controller('itemsController', itemsController);

  itemsController.$inject = ['$timeout', '$scope', '$rootScope', '$location', 'config', 'utils', 'queryStringService', 'itemSelection', 'audit', 'locales'];

  function itemsController ($timeout, $scope, $rootScope, $location, config, utils, queryStringService, itemSelection, audit, locales) {
    let vm = $scope;

    vm.workspaceSlug = queryStringService.getWorkspace();
    vm.informationText = locales.getLocaleByKey('information');
    vm.descriptionText = locales.getLocaleByKey('description');
    vm.showmoreText = locales.getLocaleByKey('show_more');
    vm.showlessText = locales.getLocaleByKey('show_less');
    vm.scoreText = locales.getLocaleByKey('score');
    vm.attachmentText = locales.getLocaleByKey('attachments');
    vm.chooseactionText = locales.getLocaleByKey('select_ction');
    vm.iconText = locales.getLocaleByKey('icon');
    vm.selectItemText = locales.getLocaleByKey('select_item');
    vm.addText = locales.getLocaleByKey('add');
    vm.removeText = locales.getLocaleByKey('remove');

    vm.isNewBulkSupport = vm.item && vm.item.mapping && utils.isObject(vm.item.mapping.bulkSupport) && 'enable' in vm.item.mapping.bulkSupport;
    vm.isOldBulkSupport = vm.item && vm.item.mapping && 'bulkSupport' in vm.item.mapping && !utils.isObject(vm.item.mapping.bulkSupport);

    vm.$watch(() => {
      return itemSelection.watchChanges();
    }, () => {
      vm.actionActive = itemSelection.isSelected(vm.item && vm.item.mapping && vm.item.mapping.key);
    });

    if (vm.item) {
      vm.actionActive = itemSelection.isSelected(vm.item.mapping.key);
    } else if (vm.itemKey) {
      vm.actionActive = itemSelection.isSelected(vm.itemKey);
    }

    $timeout(() => {
      $('[rel~=tooltip]').tooltip();
    }, 10);

    vm.openDetails = (event) => {
      expandDetails($(event.currentTarget));
    };

    vm.isColor = (string) => {
      if (!string) return false;
      return (string.indexOf('#') !== -1);
    };

    vm.openDetailsFromName = (event, actions) => {
      const primaryAction = vm.getPrimaryAction(actions);
      if (primaryAction) {
        location.href = primaryAction.url;
        return;
      }
      expandDetails($(event.currentTarget).closest('.item-card-list').find('.toogle-btn'));
    };

    vm.isPrimaryAction = (actions) => {
      return vm.getPrimaryAction(actions);
    };

    const expandDetails = (elemnt) => {
      const isOpen = elemnt.attr('data-toggle-open');
      elemnt.closest('.item-card-list').find('.toogle-area').slideToggle();
      const CurVal = elemnt.text();
      elemnt.text(elemnt.attr('data-toggle-val'));
      elemnt.attr('data-toggle-val', CurVal);
      elemnt.attr('data-toggle-open', (isOpen === 'true') ? 'false' : 'true');
      let sort = 'fa-sort-asc';
      if (isOpen === 'true') {
        sort = 'fa-sort-desc';
      }
      elemnt.append('<i class="fa ' + sort + '"></i>');

      if (vm.item) {
        vm.item.isOpenDetails = !(isOpen === 'true');
      }
    };

    vm.itemAction = (event, key) => {
      event.stopPropagation();
      event.preventDefault();

      vm.actionActive = !(vm.actionActive);

      if (vm.actionActive) {
        itemSelection.select(key);
      } else {
        itemSelection.deselect(key);
      }
    };

    vm.addFilter = (obj) => {
      if (obj.secure) return;
      queryStringService.addFilter(obj.filter);
    };

    vm.removeFilter = (obj) => {
      if (obj.secure) return;
      queryStringService.removeFilter(obj.filter);
    };

    vm.addActionAudit = (obj, key) => {
      let dataItem = utils.getParamByName('item', obj.url);
      if (!dataItem) {
        dataItem = key;
      }
      const auditObj = {
        title: obj.name,
        name: 'Click item action',
        tag: [
          'action',
          'item'
        ],
        item: utils.isString(dataItem) ? [dataItem] : dataItem
      };
      if (obj.id) {
        auditObj.data = [];
        auditObj.data.push({
          name: 'id',
          value: obj.id
        });
      }
      audit.add(auditObj);
    };

    vm.onActionClick = (action, key, $event) => {
      if (action.target === '_modal') {
        $event.preventDefault();

        let url = action.url;
        if (action.url.indexOf('?') === -1) {
          url += '?embed=modal-embed-page-form';
        } else {
          url += '&embed=modal-embed-page-form';
        }

        $rootScope.$broadcast('open_actions_modal_form', {
          id: 'actionAsModal',
          data: {
            url: url,
            title: action.name
          }
        });
      }

      vm.addActionAudit(action, key);
    };

    vm.preventClick = ($event) => {
      $event.preventDefault();
    };

    vm.addAttachmentAudit = (attachment, key) => {
      audit.add({
        title: attachment.name,
        name: 'View attachment',
        tag: [
          'attachment',
          'item'
        ],
        item: [key]
      });
    };

    vm.getPrimaryAction = (actions) => {
      let primary = [];

      if (actions && actions.length) {
        for (let i = 0; i < actions.length; i++) {
          if (actions[i].primary) {
            primary.push(actions[i]);
          }
        }

        if (primary.length) {
          primary = utils.order(primary, 'order');
          return primary[0];
        }
      }

      return false;
    };

    vm.firstPrimaryActionClass = (actions, action) => {
      let primary = [];
      if (actions && actions.length) {
        for (let i = 0; i < actions.length; i++) {
          if (actions[i].group) {
            for (let j = 0; j < actions[i].actions.length; j++) {
              if (actions[i].actions[j].primary) {
                primary.push(actions[i].actions[j]);
              }
            }
          } else {
            if (actions[i].primary) {
              primary.push(actions[i]);
            }
          }
        }

        if (primary.length && primary[0].id === action.id) {
          return 'primary-action';
        }
      }
      return '';
    };

    vm.redirectFilters = (obj, actions) => {
      const primaryAction = vm.getPrimaryAction(actions);
      let term = $(config.domElements.searchItemsInput).val();
      if (!term) {
        term = '*';
      }
      if (primaryAction) {
        location.href = primaryAction.url;
        return;
      }
      location.href = '/workspace/' + vm.workspaceSlug + '/search?term=' + term + '&filter=' + encodeURIComponent(obj.filter);
    };

    vm.redirectTerm = (term, actions) => {
      const primaryAction = vm.getPrimaryAction(actions);
      if (primaryAction) {
        location.href = primaryAction.url;
        return;
      }
      location.href = '/workspace/' + vm.workspaceSlug + '/search?term=*&filter=key:' + encodeURIComponent(term);
    };

    vm.showMoreText = (event, attribute) => {
      const element = $(event.currentTarget);

      if (element.hasClass('fa-angle-down')) {
        element.parent().find('.custom-attribute-value').html(utils.replaceLineBreaks(attribute.value));
        element.removeClass('fa-angle-down').addClass('fa-angle-up');
      } else {
        element.parent().find('.custom-attribute-value').html(utils.replaceLineBreaks(attribute.subValue));
        element.removeClass('fa-angle-up').addClass('fa-angle-down');
      }
    };

    vm.getActionUrl = (url) => {
      const params = $location.search();

      if (params && params['__drilldown']) {
        const drilldown = utils.isString(params['__drilldown']) ? [params['__drilldown']] : params['__drilldown'];
        const u = url.split('?');
        const p = (u[1]) ? u[1].split('&') : [];
        for (let i = 0; i < drilldown.length; i++) {
          p.push(drilldown[i]);
        }

        return u[0] + '?' + p.join('&');
      }

      return url;
    };

    let stopClosing = false;
    $(document).on('hide.bs.dropdown', function () {
      if (stopClosing) {
        stopClosing = false;
        return false;
      }
    });

    $(document).on('show.bs.dropdown', function () {
      $('.dropdown-sub-menu').removeClass('open');
    });

    vm.onActionGroupClick = ($event) => {
      stopClosing = true;
      $($event.currentTarget).parent().find('.dropdown-sub-menu').toggleClass('open');
    };

    vm.encodeLink = (link) => {
      if (link.indexOf('?') !== -1) {
        const url = link.split('?');
        const arr = url[1].split('=');

        if (arr.length > 2) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].indexOf('&')) {
              const val = arr[i].split('&');
              const last = i === arr.length - 1;

              if (val.length > 2 && !last) {
                const string = val.splice(0, val.length - 1).join('&');
                link = link.replace(string, string.replace(/&/g, '%26'));
              }
              if (last) {
                link = link.replace(arr[i], arr[i].replace(/&/g, '%26'));
              }
            }
          }
        } else {
          link = link.replace(/&/g, '%26');
        }
      }
      return link;
    };
  }
})();

(function() {
  angular
    .module('onify')
    .directive('workspaceItem', items);

  items.$inject = ['$compile', '$location', 'itemHtmlTemplates', 'config'];
  function items($compile, $location, itemHtmlTemplates, config) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        item: '=itemData',
        templateType: '=templateType'
      },
      link: function($scope, $element) {
        const params = $location.search();

        let templateName = $scope.item.mapping.htmlTemplate;
        if (templateName) {
          templateName = templateName.replace('.html', '');
        }
        if ($scope.templateType && $scope.templateType === 'autocomplete') {
          if ($scope.item.mapping.autocompleteHtmlTemplate) {
            templateName = $scope.item.mapping.autocompleteHtmlTemplate;
          } else {
            templateName = config.defaultAutocompleteItemHtmlTempalte;
          }

          if (params.template){
            const customTemplate = itemHtmlTemplates.getCustomHtml('templates', params.template);
            if (customTemplate) {
              templateName = params.template;
            }
          }
        }

        const template = angular.element(itemHtmlTemplates.getHtml('templates', templateName, config.defaultItemHtmlTempalte));
        $element.append(template);
        // And let Angular $compile it
        $compile(template)($scope);
      },
      controller: "itemsController"
    };
  }
})();
(function () {
  angular
    .module('onify')
    .controller('itemsTableController', itemsTableController);

  itemsTableController.$inject = ['$timeout', '$scope', 'utils'];

  function itemsTableController ($timeout, $scope, utils) {
    let vm = $scope;

    vm.getPrimaryAction = (actions) => {
      let primary = [];

      if (actions && actions.length) {
        for (let i = 0; i < actions.length; i++) {
          if (actions[i].primary) {
            primary.push(actions[i]);
          }
        }

        if (primary.length) {
          primary = utils.order(primary, 'order');
          return primary[0];
        }
      }

      return false;
    };

    vm.isItemNameField = (obj, value) => {
      if (obj && obj.item && obj.item.name === value) {
        if (obj.item.action) {
          const primaryAction = vm.getPrimaryAction(obj.item.action);
          if (primaryAction) {
            return 'item-name primary-action';
          }
        }
        return 'item-name';
      }
      return '';
    };

    vm.redirectToPrimaryActionLink = (obj, value) => {
      if (obj && obj.item && obj.item.name === value) {
        if (obj.item.action) {
          const primaryAction = vm.getPrimaryAction(obj.item.action);
          if (primaryAction) {
            return primaryAction;
          }
        }
      }
      return false;
    };
  }
})();

(function() {
  angular
    .module('onify')
    .directive('partialsItemTemplates', partialsItemTemplates);

  partialsItemTemplates.$inject = ['$compile', 'itemHtmlTemplates', 'utils'];
  function partialsItemTemplates($compile, itemHtmlTemplates, utils) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        templateName: '=templateName',
        templateType: '=templateType',
        itemKey: '=itemKey',
        customData: '=',
        currentScope: '='
      },
      link: function($scope, $element) {
        let defaultTemplate = false;
        let templateName = $scope.templateName;
        const type = ($scope.templateType) ? $scope.templateType : 'partials';
        const $parent = $scope.$parent;
        const partialsTemplates = $parent.item.partialsTemplates;

        if ($parent.item && partialsTemplates && utils.isArray(partialsTemplates)) {
          for (let i = 0; i < partialsTemplates.length; i++) {
            const customTemplate = partialsTemplates[i].replace('.html', '');
            if (customTemplate.indexOf(templateName) !== -1) {
              defaultTemplate = templateName;
              templateName = customTemplate;
            }
          }
        }

        const template = angular.element(itemHtmlTemplates.getHtml(type, templateName, defaultTemplate));
        $element.append(template);
        // And let Angular $compile it
        if ($scope.currentScope) {
          $compile(template)($scope);
        } else {
          $compile(template)($parent);
        }
      },
      controller: "itemsController"
    };
  }
})();
(function() {

  angular
    .module('onify')
    .directive('confirmModal', confirmModal);

  confirmModal.$inject = ['config'];
  function confirmModal(config) {
    return {
      restrict: 'EA',
      transclude: false,
      replace: true,
      templateUrl: 'app/common/directives/modal/confirm.modal.template.html?v=' + config.version
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('modal', modal);

  modal.$inject = ['config'];
  function modal(config) {
    return {
      restrict: 'EA',
      transclude: true,
      replace: true,
      templateUrl: 'app/common/directives/modal/modal.template.html?v=' + config.version
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('shortcutsModal', shortcutsModal);

  shortcutsModal.$inject = ['config'];
  function shortcutsModal(config) {
    return {
      restrict: 'EA',
      transclude: false,
      replace: true,
      templateUrl: 'app/common/directives/modal/shortcuts.modal.template.html?v=' + config.version
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('snackbarNotificationController', snackbarNotificationController);

  snackbarNotificationController.$inject = ['$scope', '$timeout'];

  function snackbarNotificationController($scope, $timeout) {
    const defaultType = 'success';
    $scope.type = defaultType;
    $scope.message = null;

    $scope.$on('show_snackbar_notification', (event, {type, message}) => {
      $scope.type = type || defaultType;
      $scope.message = message;
      $timeout(() => {
        $scope.message = null;
      }, 6000);
    });

    $scope.remove = function() {
      $scope.message = null;
    };
  }

})();

(function() {

  angular
    .module('onify')
    .directive('snackbarNotification', snackbarNotification);

  snackbarNotification.$inject = ['config'];

  function snackbarNotification(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/notifications/template.html?v=' + config.version,
      controller: "snackbarNotificationController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .directive('pagination', pagination);

  function pagination() {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/pagination/pagination.template.html'
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('formProcessesController', formProcessesController);

  formProcessesController.$inject = ['$scope', '$interval', 'config', '$timeout', 'locales', 'processesService', 'processesUtils', 'errorService'];
  function formProcessesController($scope, $interval, config, $timeout, locales, processesService, processesUtils, errorService) {
    const vm = $scope;
    let previewResult = '';

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.norecordsfoundText = locales.getLocaleByKey('no_records_found');
    vm.runningText = locales.getLocaleByKey('running');
    vm.pausedText = locales.getLocaleByKey('paused');
    vm.stoppedText = locales.getLocaleByKey('stopped');
    vm.completedText = locales.getLocaleByKey('completed');
    vm.startedText = locales.getLocaleByKey('started');
    vm.processidText = locales.getLocaleByKey('process_id');

    vm.showLoading = false;
    vm.showNoDataLable = false;
    vm.processesItems = [];
    const defaultAutoRefresh = 1000;
    const autoRefresh = (vm.autorefresh && Number(vm.autorefresh) >= defaultAutoRefresh) ? Number(vm.autorefresh) : 1000;

    function getProcessById() {
      processesService.getById(vm.processid).success((result) => {
        const resultAsString = JSON.stringify(result);
        // Skip updating if previews result is equal
        if (previewResult === resultAsString) return;
        const process = processesUtils.updateProcessesItem(result);
        vm.processesItems = [];
        vm.processesItems.push(process);
        $timeout(() => {
          processesUtils.fixTooltipPosition();
        }, 0);
        previewResult = resultAsString;
      }).error((error) => {
        errorService.save(error).success(() => {
          window.location.href = config.errorPage;
        });
        if (vm.stopInterval) {
          $interval.cancel(vm.stopInterval);
        }
      });
    }

    if (vm.processid) {
      if (Number(vm.autorefresh) === 0) {
        getProcessById();
      } else {
        getProcessById();
        vm.stopInterval = $interval(getProcessById, autoRefresh);
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('formProcesses', formProcesses);

  formProcesses.$inject = ['config'];
  function formProcesses(config) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        processid: '=',
        autorefresh: '@',
      },
      templateUrl: 'app/common/directives/processes/processes.template.html?v=' + config.version,
      controller: "formProcessesController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('processesController', processesController);

  processesController.$inject = ['$scope', '$location', 'config', 'utils', 'locales', 'queryStringService', 'select2Utils', 'processesService', 'processesUtils', 'errorService'];
  function processesController($scope, $location, config, utils, locales, queryStringService, select2Utils, processesService, processesUtils, errorService) {
    let vm = $scope;

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.norecordsfoundText = locales.getLocaleByKey('no_records_found');
    vm.runningText = locales.getLocaleByKey('running');
    vm.pausedText = locales.getLocaleByKey('paused');
    vm.stoppedText = locales.getLocaleByKey('stopped');
    vm.completedText = locales.getLocaleByKey('completed');
    vm.startedText = locales.getLocaleByKey('started');
    vm.processidText = locales.getLocaleByKey('process_id');
    vm.statusMessageText = locales.getLocaleByKey('status_message');
    vm.chooseactionText = locales.getLocaleByKey('select_ction');

    vm.showLoading = true;
    vm.showNoDataLable = false;
    vm.processesItems = [];

    vm.sortFields = [{
      name: locales.getLocaleByKey('title'),
      key: 'title.lower',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('status'),
      key: 'status.name.lower',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('started_date'),
      key: 'startdate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('modified_date'),
      key: 'modifieddate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('relevance'),
      key: '_score',
      availableSorts: ['desc'],
      defaultSort: 'desc',
      default: true
    }];

    //prepare all filters from query string and store filters on queryStringService
    queryStringService.excludeQueryParams(['startfrom', 'pagesize']);
    const params = $location.search();
    params.pagesize = 12;
    queryStringService.addQueryString(params);

    vm.$watch(() => {
      return queryStringService.watchChanges();
    }, () => {
      getProcesses();
    });

    //load shortcut data
    function getProcesses() {
      vm.params = queryStringService.getQueryString();
      vm.showLoading = true;
      vm.processesItems = [];
      vm.showNoDataLable = false;
      vm.disableScrolling = false;

      processesService.get(vm, vm.params).success((result) => {
        vm.processesItems = [];

        processesUtils.prepareResult(vm, processesService, result);

        //check if we have more items to load
        if (vm.processesItems.length < result.meta.pagesize) {
          if (!result.records.length) {
            vm.showNoDataLable = true;
          }
        }
      }).error(() => {
        vm.showLoading = false;
        vm.showNoDataLable = true;
      });
    }

    const selectStatusElement = $(".processes-select-status");
    selectStatusElement.select2({
      placeholder: locales.getLocaleByKey('select_status'),
      allowClear: true,
      language: select2Utils.language()
    }).on("change", (e) => {
      const status = $(e.currentTarget).val();
      const params = queryStringService.getQueryString();
      params.startfrom = 0;

      if (status) {
        params.status = status;
      } else {
        delete params.status;
      }

      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });

    selectStatusElement.on('select2:unselecting', function() {
      setTimeout(() => {
        selectStatusElement.select2('close');
      }, 0);
    });

    //search input
    const searchInput = $('.search-processes');
    searchInput.typeWatch({
      allowSubmit: false,
      captureLength: 2,
      wait: 400,
      callback: function(value) {
        utils.safeApply(vm, () => {
          queryStringService.addTerm(value);
        });
      }
    });

    searchInput.keypress((e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
        let value = searchInput.val();

        utils.safeApply(vm, () => {
          if (!value || value == '') {
            searchInput.val('*');
            queryStringService.addTerm('*');
          } else {
            value = value.replace(/\s+/g, '');
            queryStringService.addTerm(value);
          }
        });
      }
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('processes', processes);

  processes.$inject = ['config'];
  function processes(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/processes/processes.template.html?v=' + config.version,
      controller: "processesController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('processesNavController', processesNavController);

  processesNavController.$inject = ['$scope', 'locales', 'processesService'];
  function processesNavController($scope, locales, processesService) {
    let vm = $scope;
    vm.totalProcesses = 0;
    vm.totalContinue = 0;
    vm.processesText = locales.getLocaleByKey('processes');
    vm.runningprocessesText = locales.getLocaleByKey('running_processes', {total: vm.totalContinue});
    vm.allprocessesText = locales.getLocaleByKey('all_processes');

    processesService.get(vm, {metaonly: true}).success((result) => {
      vm.totalProcesses = result.meta.totalresults;

      if (result.meta.totalresults > 0) {
        processesService.get(vm, {status: 'running', metaonly: true}).success((continueProcesses) => {
          vm.totalContinue = continueProcesses.meta.totalresults;
          vm.runningprocessesText = locales.getLocaleByKey('running_processes', {total: vm.totalContinue});
        }).error(function(error) {
          console.log(error)
        });
      }
    }).error(function(error) {
      console.log(error)
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('processesNav', processesNav);

  processesNav.$inject = ['config'];
  function processesNav(config) {
    return {
      restrict: 'AE',
      transclude: true,
      templateUrl: 'app/common/directives/processes-nav/processes.nav.template.html?v=' + config.version,
      controller: "processesNavController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('resultPageBulletinController', resultPageBulletinController);

  resultPageBulletinController.$inject = ['$scope', '$location', 'queryStringService'];
  function resultPageBulletinController($scope, $location, queryStringService) {
    const vm = $scope;

    if (vm.bulletin) {
      try {
        vm.bulletin = JSON.parse(vm.bulletin);
      } catch (e) {
        vm.bulletin = false;
      }
    }

    if (vm.bulletin) {
      if (vm.bulletin.action) {
        for (let i = 0; i < vm.bulletin.action.length; i++) {
          if (!vm.bulletin.action[i].description) {
            vm.bulletin.action[i].description = vm.bulletin.action[i].name;
          }
          if (!vm.bulletin.action[i].target) {
            vm.bulletin.action[i].target = '_self';
          }
        }
      }

      vm.closeBulletin = !(vm.bulletin.sticky === "1" || vm.bulletin.sticky === 1 || vm.bulletin.sticky === true);
      vm.bulletinClass = 'info';

      if (vm.bulletin.status.toUpperCase() === 'CRITICAL'){
        vm.bulletinClass = 'danger';
      } else if(vm.bulletin.status.toUpperCase() === 'WARNING'){
        vm.bulletinClass = 'warning';
      }
    }

    vm.close = function() {
      const params = queryStringService.getQueryString();
      delete params['bulletin'];
      queryStringService.updateQueryString(params);
      vm.bulletin = null;
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('resultPageBulletin', resultPageBulletin);

  resultPageBulletin.$inject = ['config'];
  function resultPageBulletin(config) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        bulletin: '=bulletin'
      },
      templateUrl: 'app/common/directives/result-page-bulletin/template.html?v=' + config.version,
      controller: "resultPageBulletinController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('shortcutsController', shortcutsController);

  shortcutsController.$inject = ['$window', '$scope', '$location', '$uibModal', 'config', 'utils', 'locales', 'shortcutsService', 'shortcutsUtils', 'queryStringService', 'select2Utils', 'userService', 'errorService'];
  function shortcutsController($window, $scope, $location, $uibModal, config, utils, locales, shortcutsService, shortcutsUtils, queryStringService, select2Utils, userService, errorService) {
    let vm = $scope;

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.norecordsfoundText = locales.getLocaleByKey('no_records_found');
    vm.showLoading = true;
    vm.showNoDataLable = false;
    vm.shortcutsItems = [];

    vm.sortFields = [{
      name: locales.getLocaleByKey('name'),
      key: 'name',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('modified_date'),
      key: 'modifieddate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('created_date'),
      key: 'createdate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('relevance'),
      key: '_score',
      availableSorts: ['desc'],
      defaultSort: 'desc',
      default: true
    }];

    //prepare all filters from query string and store filters on queryStringService
    queryStringService.excludeQueryParams(['startfrom', 'pagesize', 'placement']);
    const params = $location.search();
    params.pagesize = 12;
    //params.placement = 'shortcuts';
    queryStringService.addQueryString(params);

    //search input
    const searchInput = $('.search-shortcuts');
    // Revert to a previously saved state
    $window.addEventListener('popstate', () => {
      const params = $location.search();

      if (params && params.term) {
        searchInput.val(params.term)
      }

      queryStringService.addQueryString(params);
      queryStringService.triggerChanges();
      vm.$apply();
    });

    utils.onResizeEnd(() => {
      shortcutsUtils.changeShortcutHeight();
    });

    const workspacesElement = $(".shortcuts-select-workspace");
    getUserWorksapces();

    workspacesElement.select2({
      placeholder: locales.getLocaleByKey('select_workspace'),
      allowClear: true,
      language: select2Utils.language()
    }).on("change", (e) => {
      const workspace = $(e.currentTarget).val();
      const params = queryStringService.getQueryString();
      params.startfrom = 0;

      if (workspace) {
        params.workspace = workspace;
      } else {
        delete params.workspace;
      }

      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });

    const filterElement = $(".filter-shortcuts");
    filterElement.select2({
      placeholder: locales.getLocaleByKey('filter_shortcuts'),
      allowClear: true,
      language: select2Utils.language()
    }).on("change", (e) => {
      const filter = $(e.currentTarget).val();
      const params = queryStringService.getQueryString();
      params.startfrom = 0;

      if (filter) {
        params.filter = filter;
      } else {
        delete params.filter;
      }

      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });

    //const clearAllTags = $('.select2-selection__clear__all');
    // const multiselectTags = $(".shortcuts-select-tags");
    // multiselectTags.select2({
    //   placeholder: locales.getLocaleByKey('select_tags'),
    //   multiple: true,
    //   tokenSeparators: [','],
    //   language: select2Utils.language()
    // }).on("change", (e) => {
    //   const tags = $(e.currentTarget).val();
    //   const params = queryStringService.getQueryString();
    //   params.startfrom = 0;
    //
    //   if (tags && tags.length > 0) {
    //     params.tag = tags;
    //   } else {
    //     delete params.tag;
    //   }
    //
    //   utils.safeApply(vm, () => {
    //     queryStringService.updateQueryString(params, true);
    //   });
    //
    //   changeMultiselectTagsFields(50);
    // }).on("select2:open", function() {
    //   const searchField = multiselectTags.data("select2").dataAdapter.$search;
    //   const results = multiselectTags.data("select2").$results;
    //
    //   addClearicon(50);
    //
    //   $(searchField).on('keydown', function() {
    //     addClearicon();
    //   });
    //
    //   function addClearicon(timeout = 0) {
    //     setTimeout(function() {
    //       $(results).find('li').each(function() {
    //         const isSelected = $(this).attr('aria-selected');
    //         if (isSelected && isSelected === 'true') {
    //           $(this).append('<span class="select2-selection__clear_icon">×</span>')
    //         }
    //       });
    //     }, timeout);
    //   }
    // });

    function changeMultiselectTagsFields(timeout = 0) {
      const params = queryStringService.getQueryString();
      const searchField = multiselectTags.data("select2").dataAdapter.$search;
      let tags = (params.tag) ? (utils.isArray(params.tag)) ? params.tag : [params.tag] : false;

      if (tags) {
        setTimeout(() => {
          $(searchField).attr('placeholder', tags.join(', '));
        }, timeout);
        clearAllTags.show();
      } else {
        clearAllTags.hide();
      }
    }

    // clearAllTags.on("click", () => {
    //   multiselectTags.val(null).trigger("change");
    // });

    vm.$watch(() => {
      return userService.watchChanges();
    }, (user) => {
      if (user) {
        vm.user = user;
        vm.$watch(() => {
          return queryStringService.watchChanges();
        }, () => {
          getShortcuts();
        });
      }
    });

    function getUserWorksapces() {
      const workspaces = {};
      workspacesElement.find('option').each(function() {
        const key = $(this).attr('value');
        const name = $(this).text();
        if (name && key) {
          workspaces[key] = name;
        }
      });
      vm.userWorkspaces = workspaces;
    }

    //append tags form query parameters to tags input element
    // addTagsFromParams();
    // function addTagsFromParams() {
    //   const tagsParams = getTagsFromParams();
    //   if (tagsParams) {
    //     const tags = [];
    //     tagsParams.map((key) => {
    //       tags.push({key: key});
    //     });
    //     prepareTags(tags);
    //   }
    // }

    //append tags form result to tags input element
    function prepareTags(tags) {
      //save current config. options
      const options = multiselectTags.data('select2').options.options;
      const data = [];
      const tagsParams = getTagsFromParams();

      if (tags && tags.length > 0) {
        //delete all items of the native select element
        multiselectTags.html('');

        tags.map((tag) => {
          data.push({id: tag.key, text: tag.key});
          let selected = '';

          if (tagsParams) {
            for (let i = 0; i < tagsParams.length; i++) {
              if (tagsParams[i] === tag.key) {
                selected = 'selected';
              }
            }
          }

          multiselectTags.append('<option ' + selected + ' value=\"' + tag.key + '\">' + tag.key + '</option>');
        });

        //add new items
        options.data = tags;
        multiselectTags.select2(options);
        changeMultiselectTagsFields();
      }
    }

    function getTagsFromParams() {
      const queryParams = $location.search();
      return (queryParams.tag) ? (utils.isArray(queryParams.tag)) ? queryParams.tag : [queryParams.tag] : false;
    }

    //load shortcut data
    function getShortcuts() {
      vm.params = queryStringService.getQueryString();
      vm.showLoading = true;
      vm.shortcutsItems = [];
      vm.showNoDataLable = false;
      vm.disableScrolling = false;

      shortcutsService.get(vm, vm.params).success((result) => {
        vm.shortcutsItems = [];
        //prepareTags(result.tags);
        shortcutsUtils.prepareResult(vm, shortcutsService, result);

        //check if we have more items to load
        if (vm.shortcutsItems.length < result.meta.pagesize) {
          if (!result.records.length) {
            vm.showNoDataLable = true;
          }
        }
      }).error(() => {
        vm.showLoading = false;
        vm.showNoDataLable = true;
      });
    }

    searchInput.typeWatch({
      allowSubmit: false,
      captureLength: 2,
      wait: 400,
      callback: function(value) {
        utils.safeApply(vm, () => {
          queryStringService.addTerm(value);
        });
      }
    });

    searchInput.keypress((e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
        let value = searchInput.val();

        utils.safeApply(vm, () => {
          if (!value || value == '') {
            searchInput.val('*');
            queryStringService.addTerm('*');
          } else {
            value = value.replace(/\s+/g, '');
            queryStringService.addTerm(value);
          }
        });
      }
    });

    vm.onTagClick = (event, tag) => {
      event.preventDefault();
      let tags = getTagsFromParams();

      if (tag.remove) {
        for (let i = 0; i < tags.length; i++) {
          if (tags[i] == tag.key) {
            tags.splice(i, 1);
          }
        }
      } else {
        if (!tags) {
          tags = [tag.key];
        } else {
          tags.push(tag.key)
        }
      }

      multiselectTags.val(tags).trigger("change");
    };

    vm.onWorkspaceClick = (event, worksapce) => {
      event.preventDefault();
      workspacesElement.val((!worksapce.remove) ? worksapce.key : '').trigger("change");
    };

    vm.removeShortcut = (event, shortcut) => {
      event.preventDefault();

      $uibModal.open({
        templateUrl: 'confirm-modal.html',
        controller: 'confirmModalController',
        size: 'md',
        resolve: {
          onConfirm: function () {
            return function ()
            {
              shortcutsService.remove(shortcut.key).success(() => {
                const params = queryStringService.getQueryString();
                params.startfrom = 0;
                utils.safeApply(vm, () => {
                  queryStringService.updateQueryString(params, true);
                });
              }).error((error) => {
                errorService.save(error).success(() => {
                  window.location.href = config.errorPage;
                });
              });
            };
          }
        }
      });
    };

    vm.editShortcut = (event, shortcut) => {
      event.preventDefault();

      $uibModal.open({
        templateUrl: 'shortcuts-modal.html',
        controller: 'shortcutsModalController',
        backdrop  : 'static',
        keyboard  : false,
        size: 'md',
        resolve: {
          data: function () {
            return shortcut;
          },
          modalAction: function () {
            return 'edit';
          }
        }
      });
    };

    vm.$on('on_shortcut_create', () => {
      const params = queryStringService.getQueryString();
      params.startfrom = 0;
      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });

    vm.$on('on_shortcut_update', () => {
      const params = queryStringService.getQueryString();
      params.startfrom = 0;
      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('shortcuts', shortcuts);

  shortcuts.$inject = ['config'];
  function shortcuts(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/shortcuts/shortcuts.template.html?v=' + config.version,
      controller: "shortcutsController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('shortcutsBadgesController', shortcutsBadgesController);

  shortcutsBadgesController.$inject = ['$scope', '$http', 'itemMapping', 'config', 'userService'];

  function shortcutsBadgesController($scope, $http, itemMapping, config, userService) {
    let vm = $scope;
    vm.showBadge = false;

    vm.isColor = (string) => {
      if (!string) return false;
      return (string.indexOf('#') !== -1);
    };

    vm.formatNumber = (number) => {
      if (number <= 999) {
        return number;
      }
      return numeral(number).format('0.0a');
    };

    vm.$watch(() => {
      return userService.watchChanges();
    }, (user) => {
      if (user) {
        vm.badge = itemMapping.parseFields(vm.badge, {
          user: user,
          workspace: vm.workspace,
          config: {
            api: {
              url: config.apiBaseUrl
            }
          }
        }, {allowEmpty: true});

        if (vm.badge.url.indexOf('pagesize=') === -1) {
          vm.badge.url += '&pagesize=1';
        }

        $http.get(vm.badge.url, {
          async: true,
          cache: false,
          headers: {
            Authorization: Cookies.get('Auth')
          }
        }).success((result) => {
          vm.badge.totalresults = result.meta.totalresults;
          if (vm.badge.type === 'noresult') {
            vm.showBadge = (vm.badge.totalresults === 0);
          } else if (vm.badge.type === 'totalresults') {
            vm.showBadge = (vm.badge.totalresults > 0);
          } else {
            vm.showBadge = true;
          }
        }).error(function(error) {
          console.log(error)
        });
      }
    });
  }

})();
(function() {

  angular
    .module('onify')
    .directive('shortcutsBadges', shortcutsBadges);

  function shortcutsBadges() {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        workspace: '=workspace',
        badge: '=badge'
      },
      templateUrl: 'app/common/directives/shortcuts-badges/shortcuts.badges.template.html',
      controller: "shortcutsBadgesController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('shortcutsNavListController', shortcutsNavListController);

  shortcutsNavListController.$inject = ['$scope', '$timeout', 'shortcutsService', 'locales', 'utils'];
  function shortcutsNavListController($scope, $timeout, shortcutsService, locales, utils) {
    let vm = $scope;
    vm.showMoreShortcuts = false;
    vm.shortcuts = [];
    vm.noShortcutsfound = locales.getLocaleByKey('no_records_found');

    getShortcuts();
    function getShortcuts() {
      shortcutsService.get(vm, {placement: ['menu']}).success((result) => {

        if (utils.useNewApi()) {
          for (let i = 0; i < result.records.length; i++) {
            result.records[i].name = result.records[i].title;
          }
        }

        vm.shortcuts = result.records;

        if (vm.shortcuts.length < result.meta.totalresults) {
          vm.showMoreShortcuts = true;
        }

        if (vm.disablemenu === true) {
          if (vm.shortcuts.length === 0) {
            $('#shortcuts-nav-menu-main').hide();
          }

          $('.shortcuts-nav-menu-main-title .external-link').attr('href', 'javascript:void(0);');
        }


        $timeout(() => {
          $('[rel~=tooltip]').tooltip();
        }, 10);
      }).error(function(error) {
        console.log(error)
      });
    }

    vm.$on('on_shortcut_create', () => {
      getShortcuts();
    });

    vm.$on('on_shortcut_update', () => {
      getShortcuts();
    });

    // shortcutsService.get(vm, {placement: ['shortcuts']}).success((result) => {
    //   if (result.records.length === 0) {
    //     $('.shortcuts-nav-menu-main-title .external-link').attr('href', 'javascript:void(0);');
    //   }
    // });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('shortcutsNavList', shortcutsNavList);

  shortcutsNavList.$inject = ['config'];
  function shortcutsNavList(config) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        disablemenu: '='
      },
      templateUrl: 'app/common/directives/shortcuts-nav-list/shortcuts.nav.list.template.html?v=' + config.version,
      controller: "shortcutsNavListController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('sortButtonController', sortButtonController);

  sortButtonController.$inject = ['$scope', '$location', 'queryStringService', 'utils'];

  function sortButtonController($scope, $location, queryStringService, utils) {
    let vm = $scope;

    //check if sort is set on query params
    setDefaultSort();

    function setDefaultSort() {
      const filtersObject = $location.search();
      let sortOnParams = (filtersObject && filtersObject.sort) ? filtersObject.sort : false;
      const sortParam = (sortOnParams) ? sortOnParams.split(',') : false;
      const sort = (sortParam && sortParam[1] === 'asc') ? 'desc' : 'asc';
      if (!vm.sortFields) return;
      for (let i = 0; i < vm.sortFields.length; i++) {
        vm.sortFields[i].sort = vm.sortFields[i].defaultSort;
        if (sortParam) {
          if (sortParam[0] === vm.sortFields[i].key && vm.sortFields[i].availableSorts.indexOf(sortParam[1]) !== -1) {
            vm.sortFields[i].sort = (vm.sortFields[i].availableSorts.indexOf(sort) !== -1) ? sort : sortParam[1];
            vm.activeSort = utils.clone(vm.sortFields[i]);
            vm.activeSort.sort = sortParam[1];
          }
        } else {
          if (vm.sortFields[i].default) {
            vm.activeSort = vm.sortFields[i];
          }
        }
      }
    }

    vm.sortingSelection = (obj) => {
      const filtersObject = $location.search();
      let sortOnParams = (filtersObject && filtersObject.sort) ? filtersObject.sort : false;
      const sortParam = (sortOnParams) ? sortOnParams.split(',') : false;
      const sort = (sortParam && sortParam[1] === 'asc') ? 'desc' : 'asc';
      if (!vm.sortFields) return;
      for (let i = 0; i < vm.sortFields.length; i++) {
        vm.sortFields[i].sort = vm.sortFields[i].defaultSort;

        if (vm.activeSort && obj.key === vm.activeSort.key) {
          if (obj.key === vm.sortFields[i].key && vm.sortFields[i].availableSorts.indexOf(sort) !== -1) {
            vm.activeSort.sort = sort;
            vm.sortFields[i].sort = sortParam[1];
            queryStringService.updateQueryString({sort: obj.key + ',' + sort}, true);
          }
        } else {
          if (obj.key === vm.sortFields[i].key) {
            vm.activeSort = utils.clone(vm.sortFields[i]);
            const defaultSort = (vm.sortFields[i].defaultSort === 'asc') ? 'desc' : 'asc';
            vm.sortFields[i].sort = (vm.sortFields[i].availableSorts.indexOf(defaultSort) !== -1) ? defaultSort : vm.sortFields[i].defaultSort;
            queryStringService.updateQueryString({sort: obj.key + ',' + vm.sortFields[i].defaultSort}, true);
          }
        }
      }
    };

    vm.$on('sort_element_data', (event, data) => {
      if (data) {
        vm.sortFields = data;
        setDefaultSort();
      }
    });
  }

})();
(function() {

  angular
    .module('onify')
    .directive('sortButton', sortButton);

  sortButton.$inject = ['config'];
  function sortButton(config) {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        sortFields: '=sortFields'
      },
      templateUrl: 'app/common/directives/sort-button/sort-button.html?v=' + config.version,
      controller: "sortButtonController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('userSettingsModal', userSettingsModal);

  function userSettingsModal() {
    return {
      restrict: 'EA',
      transclude: true,
      replace: true,
      templateUrl: 'userSettingsModalTemplate.html'
    };
  }

})();
(function() {
  angular
    .module('onify')
    .service('manageService', manageService);

  manageService.$inject = ['$http', 'config'];
  function manageService($http, config) {
    const getItems = function(vm, uri, params) {
      vm.requestSend = true;

      return $http.get(config.apiBaseUrl + uri, {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const removeItem = function(vm, uri) {
      vm.requestSend = true;
      return $http.delete(config.apiBaseUrl + uri, {
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const create = function(vm, uri, item, isFormData) {
      if (vm) {
        vm.requestSend = true;
      }

      if (isFormData) {
        var formData = new FormData();

        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            formData.append(key, item[key]);
          }
        }

        return $http.post(config.apiBaseUrl + uri, formData, {
          transformRequest: angular.identity,
          headers: {
            'Authorization': Cookies.get('Auth'),
            'Content-Type': undefined
          }
        });
      }

      return $http({
        method: 'POST',
        url: config.apiBaseUrl + uri,
        headers: {
          Authorization: Cookies.get('Auth'),
          ['x-onify-admin-pages']: 'true',
        },
        data: item
      });
    };

    const update = function(vm, uri, item) {
      vm.requestSend = true;
      return $http({
        method: 'PUT',
        url: config.apiBaseUrl + uri,
        headers: {
          Authorization: Cookies.get('Auth'),
          ['x-onify-admin-pages']: 'true',
        },
        data: item
      });
    };

    const getItem = function(vm, uri) {
      return $http({
        method: 'GET',
        url: config.apiBaseUrl + uri,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getLocales = function(params) {
      const url = (config.apiBaseUrl.indexOf('api/v2') > 0) ? config.apiBaseUrl + '/admin/locales' : config.apiBaseUrl + '/admin/locale';
      return $http({
        params: params,
        method: 'GET',
        url: url,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const reloadSettings = function() {
      return $http({
        method: 'POST',
        url: '/admin/settings/reload',
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    return {
      getItems,
      getItem,
      removeItem,
      create,
      update,
      getLocales,
      reloadSettings
    };
  }
})();

(function () {
  angular
    .module('onify')
    .service('resourcesService', resourcesService);

  resourcesService.$inject = ['$http'];
  function resourcesService($http) {
    const getTree = function(params) {
      return $http.get('admin/resources/tree', {
        params: params,
        async: true,
        cache: false,
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const getInfo = function() {
      return $http({
        method: 'get',
        url: '/admin/resources/info',
        headers: {
          Authorization: Cookies.get('Auth')
        }
      });
    };

    const check = () => {
      return $http.get('/admin/resources/check', {
        async: true,
        cache: false
      });
    };

    const getFormParams = (data) => {
      return $http.put('/admin/resources/from/params', data, {
        withCredentials: false,
        transformRequest: angular.identity,
        headers: {
          'Authorization': Cookies.get('Auth'),
          'Content-Type': undefined
        },
        params: {
          data
        }
      });
    };

    const update = (params) => {
      return $http.get('/admin/resources/update', {
        params: params,
        async: true,
        cache: false
      });
    };

    const getContent = function(file) {
      return $http({
        method: 'get',
        url: '/admin/resources/content',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        params: {
          path: file.path,
          name: file.name
        }
      });
    };

    const deleteFile = function(options) {
      return $http({
        method: 'delete',
        url: '/admin/resources/content',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        params: options
      });
    };

    const deleteDirectory = function(options) {
      return $http({
        method: 'delete',
        url: '/admin/resources/directory',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        params: options
      });
    };

    const updateContent = function(data) {
      return $http.put('/admin/resources/content', data, {
        withCredentials: false,
        transformRequest: angular.identity,
        headers: {
          'Authorization': Cookies.get('Auth'),
          'Content-Type': undefined
        },
        params: {
          data
        }
      });
    };

    const createNewFile = function(data) {
      return $http.post('/admin/resources/content', data, {
        withCredentials: false,
        transformRequest: angular.identity,
        headers: {
          'Authorization': Cookies.get('Auth'),
          'Content-Type': undefined
        },
        params: {
          data
        }
      });
    };

    const newDirectory = function(data) {
      return $http({
        method: 'POST',
        url: '/admin/resources/directory',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: data
      });
    };

    const renameFile = function(data) {
      return $http({
        method: 'POST',
        url: '/admin/resources/rename',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: data
      });
    };

    const resetContent = function(data) {
      return $http({
        method: 'POST',
        url: '/admin/resources/reset',
        headers: {
          Authorization: Cookies.get('Auth')
        },
        data: data
      });
    };

    return {
      getTree: getTree,
      getInfo: getInfo,
      check: check,
      update: update,
      getContent: getContent,
      newDirectory: newDirectory,
      updateContent: updateContent,
      createNewFile: createNewFile,
      deleteFile: deleteFile,
      deleteDirectory: deleteDirectory,
      renameFile: renameFile,
      resetContent: resetContent,
      getFormParams: getFormParams
    };
  }
})();

(function() {

  angular
    .module('onify')
    .controller('activityLogController', activityLogController);

  activityLogController.$inject = ['$rootScope', '$scope', '$location', 'config', 'utils', 'locales', 'queryStringService', 'select2Utils', 'errorService', 'audit', 'auditUtils', 'itemMapping'];

  function activityLogController($rootScope, $scope, $location, config, utils, locales, queryStringService, select2Utils, errorService, audit, auditUtils, itemMapping) {
    let vm = $scope;

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.norecordsfoundText = locales.getLocaleByKey('no_records_found');
    vm.resultsText = locales.getLocaleByKey('results');
    vm.showmoreText = locales.getLocaleByKey('show_more');
    vm.showlessText = locales.getLocaleByKey('show_less');

    vm.showLoading = true;
    vm.showNoDataLable = false;
    vm.auditItems = [];

    vm.sortFields = [{
      name: locales.getLocaleByKey('title'),
      key: 'title.lower',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('name'),
      key: 'name.lower',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('created_date'),
      key: 'datetime',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'desc',
      default: true
    }, {
      name: locales.getLocaleByKey('relevance'),
      key: '_score',
      availableSorts: ['desc'],
      defaultSort: 'desc'
    }];

    $rootScope.$broadcast('sort_element_data', vm.sortFields);

    //prepare all filters from query string and store filters on queryStringService
    queryStringService.excludeQueryParams(['startfrom', 'pagesize', 'userInfo']);
    const params = $location.search();
    params.pagesize = 20;
    params.userInfo = true;
    params.sort = "datetime,desc";
    queryStringService.addQueryString(params);

    vm.$watch(() => {
      return queryStringService.watchChanges();
    }, () => {
      getAudits();
    });

    //load shortcut data
    function getAudits() {
      vm.params = queryStringService.getQueryString();
      vm.showLoading = true;
      vm.auditItems = [];
      vm.showNoDataLable = false;
      vm.disableScrolling = false;

      if (vm.params.tag && utils.isArray(vm.params.tag)) {
        vm.params.tag = vm.params.tag.join(',');
      }

      const params = utils.clone(vm.params);

      if (vm.logquery && utils.isString(vm.logquery)) {
        let term = (vm.params.query) ? vm.params.query : '*';
        if (vm.logquery.indexOf('{term}') !== -1) {
          const query = itemMapping.parseFields(vm.logquery, {term: term}, {
            singleCurlies: true
          });
          params.query = query;
        } else {
          params.query = vm.logquery + ' ' + term;
        }
      }

      if (vm.params.range) {
        const format = 'YYYY-MM-DD';
        const fromdate = moment().format(format);
        const startOfMonth = moment().startOf('month').format(format);
        const endOfMonth = moment().endOf('month').format(format);
        const startOfWeek = moment().startOf('week').add(1, 'days').format(format);
        const endOfWeek = moment().endOf('week').add(1, 'days').format(format);
        const startOfYear = moment().startOf('year').format(format);
        const endOfYear = moment().endOf('year').format(format);

        if (vm.params.range === 'today') {
          params.fromdate = fromdate;
          params.todate = fromdate;
        } else if (vm.params.range === 'week') {
          params.fromdate = startOfWeek;
          params.todate = endOfWeek;
        } else if (vm.params.range === 'month') {
          params.fromdate = startOfMonth;
          params.todate = endOfMonth;
        } else if (vm.params.range === 'year') {
          params.fromdate = startOfYear;
          params.todate = endOfYear;
        }
        delete params.range;
      }

      params.aggregations = true;
      vm.params = params;

      audit.getAdminAudit(params).success((result) => {
        vm.auditItems = [];

        auditUtils.prepareResult(vm, audit, result);

        vm.totalresults = result.meta.totalresults;
        if (result.aggregations && result.aggregations.tags) {
          prepareTags(result.aggregations.tags);
        }
        //check if we have more items to load
        if (vm.auditItems.length < result.meta.pagesize) {
          if (!result.records.length) {
            vm.showNoDataLable = true;
          }
        }
      }).error(() => {
        vm.showLoading = false;
        vm.showNoDataLable = true;
        vm.auditItems = [];

        // error.logger = true;
        // error.logLevel = 'debug';
        // errorService.save(error).success(() => {
        //
        // });
      });
    }

    const range = $(".audit-select-range");
    range.select2({
      placeholder: locales.getLocaleByKey('select_range'),
      allowClear: true,
      language: select2Utils.language()
    }).on("change", (e) => {
      const range = $(e.currentTarget).val();
      const params = queryStringService.getQueryString();
      params.startfrom = 0;

      if (range) {
        params.range = range;
      } else {
        delete params.range;
      }

      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });
    });

    range.on('select2:unselecting', function() {
      setTimeout(() => {
        range.select2('close');
      }, 0);
    });

    const clearAllTags = $('.select2-selection__clear__all');
    const multiselectTags = $(".audit-select-tags");
    multiselectTags.select2({
      placeholder: locales.getLocaleByKey('select_tags'),
      multiple: true,
      tokenSeparators: [','],
      language: select2Utils.language()
    }).on("change", (e) => {
      const tags = $(e.currentTarget).val();
      const params = queryStringService.getQueryString();
      params.startfrom = 0;

      if (tags && tags.length > 0) {
        params.tag = tags;
      } else {
        delete params.tag;
      }

      utils.safeApply(vm, () => {
        queryStringService.updateQueryString(params, true);
      });

      changeMultiselectTagsFields(50);
    }).on("select2:open", function() {
      const searchField = multiselectTags.data("select2").dataAdapter.$search;
      const results = multiselectTags.data("select2").$results;

      addClearicon(50);

      $(searchField).on('keydown', function() {
        addClearicon();
      });

      function addClearicon(timeout = 0) {
        setTimeout(function() {
          $(results).find('li').each(function() {
            const isSelected = $(this).attr('aria-selected');
            if (isSelected && isSelected === 'true') {
              $(this).append('<span class="select2-selection__clear_icon">×</span>')
            }
          });
        }, timeout);
      }
    });

    function changeMultiselectTagsFields(timeout = 0) {
      const params = queryStringService.getQueryString();
      const searchField = multiselectTags.data("select2").dataAdapter.$search;
      let tags = (params.tag) ? (utils.isArray(params.tag)) ? params.tag : [params.tag] : false;

      if (tags) {
        setTimeout(() => {
          $(searchField).attr('placeholder', tags.join(', '));
        }, timeout);
        clearAllTags.show();
      } else {
        clearAllTags.hide();
      }
    }

    clearAllTags.on("click", () => {
      multiselectTags.val(null).trigger("change");
    });

    //append tags form query parameters to tags input element
    addTagsFromParams();

    function addTagsFromParams() {
      const tagsParams = getTagsFromParams();
      if (tagsParams) {
        const tags = [];
        tagsParams.map((key) => {
          tags.push({key: key});
        });
        prepareTags(tags);
      }
    }

    //append tags form result to tags input element
    function prepareTags(tags) {
      //save current config. options
      const options = multiselectTags.data('select2').options.options;
      const data = [];
      const tagsParams = getTagsFromParams();

      if (tags && tags.length > 0) {
        //delete all items of the native select element
        multiselectTags.html('');

        tags.map((tag) => {
          data.push({id: tag.key, text: tag.key});
          let selected = '';
          if (tagsParams) {
            for (let i = 0; i < tagsParams.length; i++) {
              if (tagsParams[i] === tag.key) {
                selected = 'selected';
              }
            }
          }

          multiselectTags.append('<option ' + selected + ' value=\"' + tag.key + '\">' + tag.key + '</option>');
        });

        //add new items
        options.data = tags;
        multiselectTags.select2(options);
        changeMultiselectTagsFields();
      }
    }

    function getTagsFromParams() {
      const queryParams = $location.search();
      const tags = (queryParams.tag) ? (utils.isArray(queryParams.tag) ? queryParams.tag : queryParams.tag.split(',')) : false;
      if (tags && utils.isString(tags)) {
        return tags.split(',');
      }
      return tags;
    }

    //search input
    const searchInput = $('.search-audit');
    searchInput.typeWatch({
      allowSubmit: false,
      captureLength: 2,
      wait: 400,
      callback: function(value) {
        utils.safeApply(vm, () => {
          queryStringService.addTerm(value, 'query');
        });
      }
    });

    searchInput.keypress((e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        let value = searchInput.val();

        utils.safeApply(vm, () => {
          if (!value || value === '') {
            searchInput.val('*');
            queryStringService.addTerm('*', 'query');
          } else {
            value = value.replace(/\s+/g, '');
            queryStringService.addTerm(value, 'query');
          }
        });
      }
    });

    const expandDetails = (elemnt) => {
      const isOpen = elemnt.attr('data-toggle-open');
      elemnt.closest(".audit-item").find(".toogle-area").slideToggle();
      const CurVal = elemnt.text();
      elemnt.text(elemnt.attr("data-toggle-val"));
      elemnt.attr("data-toggle-val", CurVal);
      elemnt.attr("data-toggle-open", (isOpen === 'true') ? 'false' : 'true');
      let sort = 'fa-sort-asc';
      if (isOpen === 'true') {
        sort = 'fa-sort-desc';
      }
      elemnt.append('<i class="fa ' + sort + '"></i>');
    };

    vm.openDetails = (event) => {
      expandDetails($(event.currentTarget))
    };

    vm.isObject = (str) => {
      return utils.isObject(str) || utils.isArray(str);
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('activityLog', activityLog);

  activityLog.$inject = ['config'];
  function activityLog(config) {
    return {
      restrict: 'EA',
      scope: {
        logquery: '@',
        excludedata: '@'
      },
      transclude: false,
      templateUrl: 'app/common/directives/admin/audit/template.html?v=' + config.version,
      controller: "activityLogController"
    };
  }

})();
(function IIFE() {
  angular
    .module('onify')
    .controller('configurationItemsModalController', [
      '$scope',
      '$rootScope',
      '$q',
      '$window',
      '$location',
      '$timeout',
      '$uibModalInstance',
      'locales',
      'utils',
      'manageUtils',
      'manageService',
      'modelsConfigurations',
      'sectionConfig',
      'errorService',
      'model',
      'item',
      'modalAction',
      'itemLocale',
      'dialogOnConfirm',
      'dialogOnCancel',
      configurationItemsModalController]);

  function configurationItemsModalController ($scope,
                                              $rootScope,
                                              $q,
                                              $window,
                                              $location,
                                              $timeout,
                                              $uibModalInstance,
                                              locales,
                                              utils,
                                              manageUtils,
                                              manageService,
                                              modelsConfigurations,
                                              sectionConfig,
                                              errorService,
                                              model,
                                              item,
                                              modalAction,
                                              itemLocale,
                                              dialogOnConfirm,
                                              dialogOnCancel) {
    const vm = $scope;

    vm.modelsConfigurations = modelsConfigurations;
    vm.sectionConfig = sectionConfig;
    vm.modalAction = modalAction;
    vm.itemModel = model;
    vm.itemLocale = itemLocale;
    vm.item = item;
    vm.itemData = {};
    vm.activeEditors = {};
    vm.editorErrors = {};
    vm.modalMessages = [];
    vm.stringsLocaleDropDown = false;
    vm.uploadedFiles = {};

    vm.updatetext = locales.getLocaleByKey('save');
    vm.savetext = locales.getLocaleByKey('save');
    vm.canceltext = locales.getLocaleByKey('cancel');
    vm.addnewitemText = locales.getLocaleByKey('configuration_add_new_item');
    vm.removeitemText = locales.getLocaleByKey('configuration_remove_item');
    vm.retypeText = locales.getLocaleByKey('retype');
    vm.addnewText = locales.getLocaleByKey('add_new_item');
    vm.valueText = locales.getLocaleByKey('value');
    vm.addlocale = locales.getLocaleByKey('add_locale');
    vm.changesyoumademaynotbesaved = locales.getLocaleByKey('changes_you_made_may_not_be_saved');

    vm.modalTitle = locales.getLocaleByKey(vm.modalAction === 'update' ? 'update_item' : 'create_new_item');
    const settingsPage = ($location.$$url.indexOf('/admin/settings') !== -1);
    const readonlySystemSettingsFields = {
      category: true,
      role: true,
      tag: true,
      type: true,
      name: true,
      description: true,
      default: true
    };

    function changeFiledsForSystemSettingsModel() {
      if (!settingsPage || !item || !item.system) return false;
      // remove filed if is system settings
      const exclude = {meta: true};
      const tempModel = [];
      for (let i = 0; i < vm.itemModel.length; i++) {
        if (vm.itemModel[i].key === 'value' && item.type === 'object') {
          vm.itemModel[i].elementType = 'json';
        }
        if (readonlySystemSettingsFields[vm.itemModel[i].key]) {
          const field = utils.clone(vm.itemModel[i]);
          field.readonly = true;
          field.elementType = 'string';
          field.type = 'string';
          delete field.enum;
          tempModel.push(field);
        } else if (!exclude[vm.itemModel[i].key]) {
          if (vm.itemModel[i].key === 'value' && item.type === 'password') {
            vm.itemModel[i].elementType = 'password';
          }
          tempModel.push(vm.itemModel[i]);
        }

        if (vm.itemModel[i].key === 'value') {
          const defaultValue = utils.clone(vm.itemModel[i]);
          defaultValue.id = defaultValue.id + '1';
          defaultValue.readonly = true;
          defaultValue.elementType = 'string';
          defaultValue.type = 'string';
          defaultValue.key = 'default';
          vm.itemData[defaultValue.id] = item.default;
          tempModel.push(defaultValue);
        }

        if (vm.itemModel[i].key === 'value') {
          if (vm.item['x-meta'] && vm.item['x-meta']['admin-linked']) {
            vm.itemModel[i].linked = manageUtils.getLinkedData(modelsConfigurations, vm.item['x-meta']['admin-linked']);
            if (vm.item['x-meta'] && vm.item['x-meta']['admin-type']) {
              vm.itemModel[i].type = vm.item['x-meta']['admin-type'];
              if (vm.item['x-meta']['admin-type'] === 'array') {
                vm.itemModel[i].elementType = 'tag';
                if (vm.item.value && utils.isString(vm.item.value)) {
                  try {
                    vm.item.value = JSON.parse(vm.item.value)
                  } catch (e) {}
                }
              }
            }
          }

          if (item.type === 'boolean') {
            vm.itemModel[i].type = 'boolean';
            vm.itemModel[i].elementType = 'checkbox';
            item.value = item.value === 'true';
          }
        }
      }

      vm.itemModel = tempModel;
    }

    function settingsValueModelBasedOnType(onFiledChange) {
      if (!settingsPage || (item && item.system)) return false;
      let type = item && item.type;

      if (!onFiledChange && item && type) {
        if (type === 'number') {
          item.value = Number(item.value);
        } else if (type === 'boolean') {
          item.value = item.value === 'true';
        }
      }

      for (let i = 0; i < vm.itemModel.length; i++) {
        if (vm.itemModel[i].key === 'type') {

          if (onFiledChange) {
            type = vm.itemData[vm.itemModel[i].id];
          }
          vm.itemModel[i].onchange = true;
          break;
        }
      }

      const tempModel = [];

      for (let i = 0; i < vm.itemModel.length; i++) {
        const field = utils.clone(vm.itemModel[i]);

        if (field.key === 'value') {
          if (type === 'password') {
            field.type = 'string';
            field.elementType = 'password';
          } else if (type === 'object') {
            field.type = 'string';
            field.elementType = 'json';
          } else if (type === 'boolean') {
            field.type = 'boolean';
            field.elementType = 'checkbox';
          } else if (type === 'number') {
            field.type = 'number';
            field.elementType = null;
          } else {
            field.type = 'string';
            field.elementType = 'string';
          }
          // Reset element
          if (!type) {
            field.elementType = null;
          }
        }

        tempModel.push(field);
      }

      vm.itemModel = tempModel;

      if (onFiledChange) {
        if (type === 'object') {
          vm.activeEditors = {};
          loadEditor(vm);
        }
        if (item.type === 'boolean') {
          reloadCheckboxesDependencies(vm.itemModel);
        }
      }

    }

    function reloadSettingValueOnTypeChange(obj) {
      if (!obj || !obj.field || obj.field.key !== 'type') return false;
      settingsValueModelBasedOnType(true);
    }

    changeFiledsForSystemSettingsModel();
    settingsValueModelBasedOnType(false);

    vm.preventWatch = true;
    let showWarningModal = false;
    $window.onbeforeunload = function () {
      if (showWarningModal) {
        return true;
      }
    };

    vm.$watch('itemData', function (newData, oldData) {
      const changed = {};

      for (let key in newData) {
        if (newData.hasOwnProperty(key)) {
          if (oldData[key] !== newData[key] && newData[key] !== 'undefined') {
            if (vm.preventWatch !== true) {
              showWarningModal = true;
            }

            changed[key] = newData[key];
          }
        }
      }

      updateDynamicLinked(changed);
    }, true);

    vm.dynamicLinkedValue = {};

    function updateDynamicLinked (changed) {
      if (changed) {
        for (const id in changed) {
          if (changed.hasOwnProperty(id)) {
            if (vm.dynamicLinkedValue[changed[id]]) {
              const subPath = vm.dynamicLinkedValue[changed[id]];
              const obj = findElementById({}, vm.itemModel, id, true);

              if (obj && obj.parent) {
                for (let i = 0; i < obj.parent.length; i++) {
                  if (obj.parent[i].linked && obj.parent[i].linked.subPath && obj.parent[i].linked.subPath === subPath) {
                    if (obj.parent[i].linked.dynamicKey && obj.parent[i].linked.dynamic && obj.parent[i].linked.dynamic[changed[id]]) {
                      const key = obj.parent[i].linked.dynamicKey.split('/')[0];
                      const filed = utils.clone(obj.parent[i]);
                      const linked = utils.clone(obj.parent[i].linked.dynamic[changed[id]]);

                      linked.key = key + '/' + changed[id];
                      filed.linked = linked;

                      manageUtils.getLinkedSection(manageService, vm.itemLocale, filed).then((result) => {
                        $(filed.id).select2('destroy');
                        obj.parent[i].enum = result.data;
                        $timeout(() => {
                          loadCustomElements();
                        }, 10);
                        //vm.itemData[filed.id] = null;
                      }).catch((err) => {
                        if (err.title) {
                          err.message = err.title;
                        }
                        err.title = locales.getLocaleByKey('configuration_linked_error', {name: err.key});
                        showModalError(vm, err);
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    function saveDynamicLinked (obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key].linked && obj[key].linked.dynamic) {
            for (const value in obj[key].linked.dynamic) {
              if (obj[key].linked.dynamic.hasOwnProperty(value)) {
                vm.dynamicLinkedValue[value] = obj[key].linked.subPath;
              }
            }
          }
        }
      }
    }

    loadLocales();

    function loadLocales () {
      if (modelsConfigurations.data.endpoints.locales && $location.$$url.indexOf('/configuration/strings') !== -1) {
        angular.forEach(vm.itemModel, (obj) => {
          if (obj.key === 'translation') {
            if (vm.item) {
              if (vm.item.translation) {
                angular.forEach(obj.items, (field) => {
                  field.readonly = true;
                });
              } else {
                obj.model = utils.clone(obj.items);
                obj.items = [];
              }
            } else {
              obj.model = utils.clone(obj.items);
              obj.items = [];
            }
          } else {
            if (vm.item && vm.item.system) {
              obj.readonly = true;
              obj.elementType = 'string';
              obj.type = 'string';
              delete obj.enum;
            }
          }
        });

        manageService.getLocales({pagesize: 100}).success((result) => {
          vm.stringsLocaleDropDown = result.records;
          updateFields(getLikedField(vm.itemModel));
          loadSingleSelectLocale();
        }).error((error) => {
          errorService.save(error).success(() => {
            window.location.href = config.errorPage;
          });
        });
      } else {
        updateFields(getLikedField(vm.itemModel));
      }
    }

    function updateFields (linkedFields) {
      vm.loadingModalData = true;
      const linked = [];

      for (const key in linkedFields) {
        if (linkedFields.hasOwnProperty(key)) {
          if (linkedFields[key].linked.type && linkedFields[key].linked.type === 'resource') {
            linked.push(manageUtils.getLinkedResource(linkedFields[key]));
          } else {
            if (linkedFields[key].disabled) {
              if (linkedFields[key].defaultRequiredState) {
                vm.disabledForm = true;
                vm.modalMessages.push({
                  message: `Cannot create or update ${vm.sectionConfig.data.name}! You do not have access to ${utils.capitalizeFirstLetter(linkedFields[key].linked.key)} endpoints.`,
                  class: 'alert-danger'
                });
              } else {
                vm.modalMessages.push({
                  message: `Some fields cannot be added or updated! You do not have access to ${utils.capitalizeFirstLetter(linkedFields[key].linked.key)} endpoints.`,
                  class: 'alert-warning'
                });
              }
            }
            linked.push(manageUtils.getLinkedSection(manageService, vm.itemLocale, linkedFields[key]));
          }
        }
      }
      //update default values
      setDefaultValue(vm.itemModel);

      if (linked.length > 0) {
        $q.all(linked).then((results) => {
          for (let i = 0; i < results.length; i++) {
            if (linkedFields[results[i].key]) {
              linkedFields[results[i].key].data = results[i].data;
            }
          }

          setLinked(linkedFields, model);

          if (vm.item) {
            vm.itemModel = manageUtils.prepareToUpdateItem(vm.itemModel, vm.item, vm.itemData);
            updateDynamicLinked(vm.itemData);
          } else {
            manageUtils.updateModelFieldsIds(vm.itemModel, vm.itemData);
          }

          loadCustomElements(vm);
          vm.loadingModalData = false;
          $timeout(() => {
            vm.preventWatch = false;
          }, 100);
        }).catch((err) => {
          if (err.title) {
            err.message = err.title;
          }
          err.title = locales.getLocaleByKey('configuration_linked_error', {name: err.key});
          showModalError(vm, err);
          vm.loadingModalData = false;
        });
      } else {
        if (vm.item) {
          vm.itemModel = manageUtils.prepareToUpdateItem(vm.itemModel, vm.item, vm.itemData);
          updateDynamicLinked(vm.itemData);
        } else {
          manageUtils.updateModelFieldsIds(vm.itemModel, vm.itemData);
        }
        loadCustomElements(vm);
        vm.loadingModalData = false;
        $timeout(() => {
          vm.preventWatch = false;
        }, 100);
      }

      //open markdown links in new window
      $timeout(() => {
        const descriptions = document.getElementsByClassName('field-description');
        if (descriptions && descriptions.length > 0) {
          for (let i = 0; i < descriptions.length; i++) {
            const anchors = descriptions[i].getElementsByTagName('a');
            if (anchors && anchors.length > 0) {
              for (let j = 0; j < anchors.length; j++) {
                anchors[j].setAttribute('target', '_blank');
              }
            }
          }
        }
      }, 0);
    }

    function showModalError (vm, error, timeout) {
      vm.modalError = {
        title: utils.isObject(error.error) ? error.error.title : ((error.title) ? error.title : error.error),
        message: (error.message) ? error.message : (utils.isObject(error.error) ? error.error.message : '')
      };

      if (timeout) {
        $timeout(() => {
          vm.modalError = false;
        }, timeout);
      }
      vm.requestSend = false;
      vm.loadingModalData = false;
    }

    function setLinked (linkedFields, model) {
      for (let i = 0; i < model.length; i++) {
        if (model[i].linked) {
          let key = manageUtils.getLinkedKey(model[i].linked);
          if (linkedFields[key] && linkedFields[key].data) {
            model[i].enum = linkedFields[key].data;
          }
        }
        if (model[i].items && model[i].items.length > 0) {
          setLinked(linkedFields, model[i].items);
        } else if (utils.isArray(model[i]) && model[i].length > 0) {
          setLinked(linkedFields, model[i]);
        }
        if (model[i].model) {
          setLinked(linkedFields, model[i].model);
        }
      }
    }

    function setDefaultValue (model) {
      for (let i = 0; i < model.length; i++) {
        if (model[i].hasOwnProperty('default')) {
          vm.itemData[model[i].id] = model[i].default;
          if (model[i].type === 'boolean') {
            $timeout( () => {
              // fix default value for checkbox
              vm.onChange(model[i]);
            }, 500);
          }
        }
        if (model[i].items && model[i].items.length > 0) {
          setDefaultValue(model[i].items);
        } else if (utils.isArray(model[i]) && model[i].length > 0) {
          setDefaultValue(model[i]);
        }
      }
    }

    function getLikedField (model, linked) {
      linked = linked || {};
      for (let i = 0; i < model.length; i++) {
        if (model[i].linked) {
          let key = manageUtils.getLinkedKey(model[i].linked);
          linked[key] = utils.clone(model[i]);
        }
        if (model[i].items && model[i].items.length > 0) {
          linked = getLikedField(model[i].items, linked);
        } else if (utils.isArray(model[i]) && model[i].length > 0) {
          linked = getLikedField(model[i], linked);
        }
        if (model[i].model) {
          linked = getLikedField(model[i].model, linked);
        }
      }

      saveDynamicLinked(linked);
      return linked;
    }

    function findElementById (obj, itemModel, id, returnParent) {
      for (let i = 0; i < itemModel.length; i++) {
        if (itemModel[i].items) {
          findElementById(obj, itemModel[i].items, id, returnParent);
        } else if (utils.isArray(itemModel[i])) {
          findElementById(obj, itemModel[i], id, returnParent);
        } else {
          if (itemModel[i].id === id) {
            obj.field = itemModel[i];
            if (returnParent) {
              obj.parent = itemModel;
            }
            break;
          }
        }
      }

      return obj;
    }

    function validateWhenValue (when, value) {
      if (utils.isArray(value)) {
        if (utils.isArray(when)) {
          for (let i = 0; i < when.length; i++) {
            for (let j = 0; j < value.length; j++) {
              if (when[i] === value[j]) {
                return true;
              }
            }
          }
        } else {
          for (let i = 0; i < value.length; i++) {
            if (value[i] === when) {
              return true;
            }
          }
        }
      }

      if (utils.isArray(when)) {
        for (let i = 0; i < when.length; i++) {
          if (when[i] === value) {
            return true;
          }
        }
      } else {
        return (when === value);
      }
      return false;
    }

    function resetElement (field) {
      delete vm.itemData[field.id];
      if (field.elementType === 'json' || field.elementType === 'xml' || field.elementType === 'javascript') {
        if (vm.activeEditors[field.id]) {
          vm.activeEditors[field.id].setValue('');
        }
      }
      if (field.items) {
        field.items.map((i) => {
          resetElement(i);
        });
      }
    }

    function changeElementsVisibility (itemModel, id, value) {
      const obj = findElementById({}, itemModel, id, true);

      reloadSettingValueOnTypeChange(obj);

      if (obj.parent && obj.field) {
        for (let i = 0; i < obj.parent.length; i++) {
          if (obj.parent[i].when && obj.parent[i].when.field === obj.field.key) {

            if (obj.parent[i].when.then && obj.parent[i].when.then.only) {
              if (validateWhenValue(obj.parent[i].when.is, value)) {
                obj.parent[i].customEnum = obj.parent[i].when.then.only;
                if (vm.itemData[obj.parent[i].id] && obj.parent[i].customEnum.indexOf(vm.itemData[obj.parent[i].id]) === -1) {
                  vm.itemData[obj.parent[i].id] = '';
                  $('#' + obj.parent[i].id).val('').trigger('change.select2');
                }
              } else {
                delete obj.parent[i].customEnum
              }
            }

            if (obj.parent[i].when.then && obj.parent[i].when.then.when) {
              if (validateWhenValue(obj.parent[i].when.is, value)) {
                const subConditionValue = getElementValue(obj.parent, obj.parent[i].when.then.when.field);
                obj.parent[i] = updateElementsVisibility(obj.parent[i], {when: obj.parent[i].when.then.when}, subConditionValue);
              } else {
                obj.parent[i] = updateElementsVisibility(obj.parent[i], {when: obj.parent[i].when}, value);
              }
            } else {
              if (obj.parent[i].when.then && obj.parent[i].when.then.only) {
                continue;
              }
              obj.parent[i] = updateElementsVisibility(obj.parent[i], {when: obj.parent[i].when}, value);
            }
          } else if (obj.parent[i].when && obj.parent[i].when.then && obj.parent[i].when.then.when && obj.parent[i].when.then.when.field === obj.field.key) {
            if (isValidCondition(obj.parent, obj.parent[i].when.field, obj.parent[i].when.is)) {
              obj.parent[i] = updateElementsVisibility(obj.parent[i], {when: obj.parent[i].when.then.when}, value);
            }
          }
        }
      }
    }

    function isValidCondition (fields, key, value) {
      let firstWhenField;
      for (let j = 0; j < fields.length; j++) {
        if (fields[j].key === key) {
          firstWhenField = fields[j];
        }
      }
      if (firstWhenField) {
        let val = vm.itemData[firstWhenField.id];
        if (firstWhenField.type === 'boolean') {
          if (val === undefined || val === null) {
            val = false;
          }
        }
        if (validateWhenValue(value, val)) {
          return true;
        }
      }
      return false;
    }

    function getElementValue (fields, key) {
      let firstWhenField;
      for (let j = 0; j < fields.length; j++) {
        if (fields[j].key === key) {
          firstWhenField = fields[j];
        }
      }
      if (firstWhenField) {
        let val = vm.itemData[firstWhenField.id];
        if (firstWhenField.type === 'boolean') {
          if (val === undefined || val === null) {
            val = false;
          }
        }
        return val;
      }
      return false;
    }

    function updateElementsVisibility (field, conditions, value) {
      if (validateWhenValue(conditions.when.is, value)) {
        if (conditions.when.then.forbidden) {
          field.readonly = true;
          field.hidden = true;
          resetElement(field);
          delete field.required;
        } else {
          delete field.readonly;
          delete field.hidden;

          if (conditions.when.then.hasOwnProperty('required')) {
            field.required = conditions.when.then.required;
          }
        }
      } else {
        if (conditions.when.otherwise) {
          if (conditions.when.otherwise.hasOwnProperty('required')) {
            delete field.readonly;
            delete field.hidden;

            if (conditions.when.otherwise.required) {
              field.required = conditions.when.otherwise.required;
            } else {
              delete field.required;
            }
          } else if (conditions.when.otherwise.forbidden) {
            field.readonly = true;
            field.hidden = true;
            delete field.required;
            resetElement(field);
          }
        } else {
          delete field.readonly;
          delete field.hidden;
          delete field.required;
          resetElement(field);
        }
      }

      field = updateFieldItemsState(field);

      return field;
    }

    function updateFieldItemsState (field) {
      if (!field.hidden && field.items && field.items.length > 0) {
        for (let i = 0; i < field.items.length; i++) {
          if (field.required) {
            field.items[i].required = field.items[i].defaultRequiredState;
            if (field.items[i].required) {
              field.items[i].forceRequired = true;
            }
          } else {
            field.items[i].required = false;
            delete field.items[i].forceRequired;
          }
        }
      }

      return field;
    }

    function loadCustomElements() {
      $timeout(() => {
        loadSingleSelect(vm);
        loadMultipleSelect();
        loadDateTimePicker();
        loadEditor(vm);
        reloadCheckboxesDependencies(vm.itemModel);
      }, 100);
    }

    function reloadCheckboxesDependencies(model) {
      for (let i = 0; i < model.length; i++) {
        if (model[i].type === 'boolean') {
          vm.onChange(model[i]);
        }
        if (model[i].items && model[i].items.length > 0) {
          reloadCheckboxesDependencies(model[i].items);
        }
      }
    }

    function getResourceLink(path) {
      const baseUrl = 'admin/resources';
      const params = [];
      const directoryPath = path.split('/');
      const fileName = directoryPath.pop();
      params.push(`activedirectory=${directoryPath.join('/')}`);
      params.push('isdirectoryopen=true');
      params.push(`openfile=${path}`);
      return `${baseUrl}?${params.join('&')}`;
    }

    function resourceSelectTemplateFormat(data) {
      if (data.loading || !data.id) return data.text;

      const extension = (data.element.dataset.extension) ? data.element.dataset.extension.replace('.', '') : data.text.split('.').pop();
      const path = (data.element.dataset.path) ? data.element.dataset.path : '';
      const imageExtensions = utils.imageExtensions();
      let resureceLink = '';
      if (path) {
        resureceLink = ' <a target=\'_blank\' class=\'linked-page\' href=\'' + getResourceLink(path) + '\'>[' + locales.getLocaleByKey('view_resource') + ']<a/>';
      }
      let src = '/img/extension/ext.' + extension + '.svg';
      if (extension === 'pug' || extension === 'jade') {
        src = '/img/extension/ext.pug.png';
      } else if (imageExtensions.indexOf(extension) !== -1) {
        src = data.id;
      }

      return $('<img width=\'20\' height=\'20\' src=' + src + '><span> ' + data.text + '</span>' + resureceLink);
    }

    function linkedSelectTemplateFormat (state) {
      if (!state.id) return state.text;
      if (state.element.dataset.linkedTo) {
        const configUrl = '/admin/configuration/';
        const origin = $window.location.origin;
        const link = origin + configUrl + state.element.dataset.linkedTo + '/' + state.id;
        const showEdit = manageUtils.isActiveEndpoint(vm.modelsConfigurations, state.element.dataset.linkedTo, 'replace');

        if (showEdit) {
          return $('<span>' + state.text + ' </span> <a target=\'_blank\' class=\'linked-page\' href=\'' + link + '\'>[' + locales.getLocaleByKey('edit') + ']<a/>');
        } else {
          return $('<span>' + state.text + ' </span>');
        }
      }
      return state.text;
    }

    function onSelectEvent (e) {
      if (e.params && e.params.args && e.params.args.originalEvent) {
        const target = $(e.params.args.originalEvent.target);
        if (target && target.hasClass('linked-page')) {
          e.preventDefault();
        }
      }
    }

    function onOpenEvent () {
      $timeout(() => {
        $('.select2-results .select2-results__option--highlighted .linked-page').on('mouseup', function (e) {
          const link = $(e.currentTarget).attr('href');
          const open_link = window.open('', '_blank');
          open_link.location = link;
        });
      }, 200);
    }

    function loadSingleSelectLocale () {
      $timeout(() => {
        const selector = '.mange_drop_down_select_locale';

        $(selector).each(function () {
          const element = $(this).data('select2');
          if (!element) {
            $(this).select2().change(function () {
              const val = this.value;

              utils.safeApply(vm, () => {
                if (val && val !== '' && val !== ' ') {
                  angular.forEach(vm.itemModel, (obj) => {
                    if (obj.key === 'translation') {
                      let add = true;
                      if (obj.items) {
                        angular.forEach(obj.items, (item) => {
                          if (vm.itemData[item.id] === val) {
                            add = false;
                          }
                        });
                      }
                      if (add) {
                        const field = vm.addCustomField(obj);
                        if (field) {
                          field.readonly = true;
                          vm.itemData[field.id] = val;
                          $(this).val('').trigger('change');
                        }
                      } else {
                        $(this).val('').trigger('change');
                      }
                    }
                  });
                }
              });
            });
          }
        });
      }, 0);
    }

    function loadSingleSelect(vm) {
      $timeout(() => {
        const selector = '.mange_drop_down_select';

        $(selector).each(function () {
          const element = $(this).data('select2');

          if (!element) {
            const onchange = $(this).attr('data-onchange-event');
            const linkedResource = $(this).attr('data-linked-resource');

            if (linkedResource) {
              $(this).select2({
                templateResult: resourceSelectTemplateFormat,
                templateSelection: resourceSelectTemplateFormat,
                escapeMarkup: function escapeMarkup(m) {
                  return m;
                }
              }).on('select2:selecting', onSelectEvent).on('select2:open', onOpenEvent);
            } else {
              $(this).select2({
                templateResult: linkedSelectTemplateFormat,
                escapeMarkup: function escapeMarkup(m) {
                  return m;
                }
              }).on('select2:selecting', onSelectEvent).on('select2:open', onOpenEvent);
            }

            if (onchange && onchange === 'true') {
              $(this).change(function () {
                const val = this.value;
                const id = $(this).attr('id');

                utils.safeApply(vm, () => {
                  changeElementsVisibility(vm.itemModel, id, val);
                });
              });
            }
          }

          const value = $(this).attr('data-value');
          if (value) {
            $(this).val(value).trigger('change');
          } else {
            if (!($(this).val() !== '')) {
              $(this).val($(selector + '  option:first').val()).trigger('change');
            }
          }
        });
      }, 0);
    }

    function loadMultipleSelect () {
      $timeout(() => {
        const selector = '.mange_multiple_select';

        $(selector).each(function () {
          const element = $(this).data('select2');
          const value = $(this).attr('data-value');

          if (!element) {
            const onchange = $(this).attr('data-onchange-event');

            $(this).select2({
              templateResult: linkedSelectTemplateFormat,
              escapeMarkup: function (m) {
                return m;
              }
            }).on('select2:selecting', onSelectEvent);

            if (onchange && onchange === 'true') {
              $(this).change(function () {
                const id = $(this).attr('id');

                $timeout( ()=> {
                  const val = vm.itemData[id];

                  utils.safeApply(vm, () => {
                    changeElementsVisibility(vm.itemModel, id, val);
                  });
                }, 50);
              });
            }
          }

          if (value) {
            $(this).val(value.split(',')).trigger('change');
          }
        });
      }, 0);
    }

    function loadDateTimePicker () {
      const localesObj = locales.getLocale();

      $timeout(() => {
        const datePickerOptions = {
          icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-angle-up',
            down: 'fa fa-angle-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-circle',
            clear: 'fa fa-trash',
            close: 'fa fa-minus-circle'
          }
        };

        if (localesObj.app && localesObj.app.datetimepicker) {
          if (localesObj.app.datetimepicker.tooltips) {
            datePickerOptions.tooltips = localesObj.app.datetimepicker.tooltips;
          }
          if (localesObj.app.datetimepicker.locale) {
            moment.updateLocale('en', localesObj.app.datetimepicker.locale);
          }
        }
        const element = $('.datetimepicker');
        element.datetimepicker(datePickerOptions);
        element.on('dp.change', (e) => {
          $(e.currentTarget).trigger('change');
        });
      }, 0);
    }

    function loadEditor (vm) {
      $timeout(() => {
        const selector = '.editor-content';

        $(selector).each(function () {
          const id = $(this).attr('id');
          const mode = $(this).attr('data-mode');
          const valueType = $(this).attr('data-value-type');
          let defaultMode = 'ace/mode/json';
          let editorMode = 'ace/mode/json';
          if (mode === 'xml') {
            editorMode = 'ace/mode/xml';
          } else if (mode && mode !== '' && mode !== null) {
            editorMode = 'ace/mode/' + mode;
          }

          if (vm.activeEditors[id]) {
            return;
          }
          //init code editor
          const editor = ace.edit(id);
          editor.setTheme('ace/theme/iplastic');
          editor.getSession().setMode(editorMode);
          editor.$blockScrolling = Infinity;
          editor.setShowPrintMargin(false);

          if (vm.itemData[id]) {
            let value = vm.itemData[id];
            if (valueType && valueType === 'string' && editorMode === defaultMode) {
              try {
                value = JSON.parse(value);
              } catch (e) {
              }
            }
            if (editorMode === defaultMode) {
              editor.setValue(JSON.stringify(value, null, '\t'));
            } else {
              editor.setValue(value);
            }
          }

          editor.getSession().on('changeAnnotation', function () {
            const annot = editor.getSession().getAnnotations();
            utils.safeApply(vm, () => {
              vm.editorErrors[id] = false;
            });

            for (const key in annot) {
              if (annot.hasOwnProperty(key)) {
                if (annot[key].type === 'error') {
                  utils.safeApply(vm, () => {
                    vm.editorErrors[id] = true;
                  });
                  break;
                }
              }
            }
          });

          editor.getSession().on('change', function () {
            $timeout(() => {
              utils.safeApply(vm, () => {
                if (!vm.editorErrors[id]) {
                  if (editorMode === defaultMode) {
                    if (valueType && valueType === 'string') {
                      vm.itemData[id] = (editor.getValue()) ? editor.getValue().replace(/(\r\n\t|\n|\r\t|\t)/gm, '').replace(/\t/g, '') : editor.getValue();
                    } else {
                      try {
                        vm.itemData[id] = JSON.parse(editor.getValue());
                      } catch (e) {
                        vm.itemData[id] = editor.getValue();
                      }
                    }
                  } else {
                    vm.itemData[id] = editor.getValue();
                  }
                }
              });
            }, 600);
          });

          utils.safeApply(vm, () => {
            vm.activeEditors[id] = editor;
          });
        });
      }, 0);
    }

    function removeItemById (model, id, option) {
      const {removeLastItem} = option || {};
      for (let i = 0; i < model.length; i++) {
        if (model[i].id === id) {
          if (model.length > 1 || removeLastItem) {
            model.splice(i, 1);
          }
          return true;
        }
        if (model[i].items && model[i].items.length > 0) {
          removeItemById(model[i].items, id, option);
        } else if (utils.isArray(model[i]) && model[i].length > 0) {
          removeItemById(model[i], id, option);
        }
      }
      return false;
    }

    //add new array of objects fields
    vm.addNewField = function (singleItem) {
      //clone the object to make sure is not referenced
      const item = utils.clone(singleItem.model);
      //add unique id for each field
      manageUtils.updateModelFieldsIds(item, vm.itemData, true);
      singleItem.items.push(item);
      loadCustomElements();
    };

    //remove an object
    vm.removeSubField = function (singleItem, index) {
      if (singleItem.required && singleItem.items.length === 1) {
        showModalError(vm, {message: locales.getLocaleByKey('required_field', {name: singleItem.key})}, 6000);
      } else {
        singleItem.items.splice(index, 1);
      }
    };

    vm.updateDefaultValue = function (item, itemData) {
      manageUtils.updateFiledRequired(item);
      if (item && utils.isObject(item)) {
        if (item.value) {
          itemData[item.id] = item.value;
        }
        if (item.items) {
          vm.updateDefaultValue(item.items, itemData);
        }
      } else if (item && utils.isArray(item)) {
        for (let i = 0; i < item.length; i++) {
          vm.updateDefaultValue(item[i], itemData);
        }
      }
    };

    //add new custom object
    vm.addCustomField = function (singleItem) {
      if (singleItem.items && singleItem.items.length > 0 || singleItem.model) {
        const item = (singleItem.items && singleItem.items.length > 0) ? utils.clone(singleItem.items[0]) : utils.clone(singleItem.model[0]);
        item.id = utils.uniqueId();

        if (item.items) {
          //add unique id for each field
          item.items = manageUtils.updateModelFieldsIds(item.items, vm.itemData, true);
        }

        vm.updateDefaultValue(item, vm.itemData);

        singleItem.items.push(item);
        loadCustomElements();
        return item;
      }

      return false;
    };

    //remove an custom object
    vm.removeCustomField = function (singleItem, removeLastItem) {
      removeItemById(vm.itemModel, singleItem.id, {removeLastItem});
    };

    //convert string to number
    vm.numberFormat = function (value) {
      return parseInt(value);
    };

    //format array of value to string used by select2 package
    vm.arrayValueFormat = function (value) {
      if (utils.isArray(value)) {
        return value.join(',');
      } else {
        return value;
      }
    };

    vm.confirm = function (data, item) {
      showWarningModal = false;
      if (typeof dialogOnConfirm === 'function') {
        dialogOnConfirm.call(data, item);
      }
      $uibModalInstance.dismiss('cancel');
    };

    vm.cancel = function () {
      if (showWarningModal && !confirm(vm.changesyoumademaynotbesaved)) {
        return false;
      }
      showWarningModal = false;
      if (typeof dialogOnCancel === 'function') {
        dialogOnCancel.call(this);
      }
      $uibModalInstance.dismiss('cancel');
    };

    //update item after all required fields are set
    vm.updateItem = function () {
      vm.loadingModalData = true;
      let item = manageUtils.getItemObject(vm.itemModel, vm.itemData, vm.uploadedFiles, 'replace');

      const data = manageUtils.getItemEndpoint({
        section: vm.sectionConfig,
        item: vm.item,
        type: 'replace',
        locale: vm.itemLocale
      });

      item = manageUtils.patchObject(vm.sectionConfig, data, item);

      //remove item id/key/slug on update request
      for (let i = 0; i < vm.itemModel.length; i++) {
        if (vm.itemModel[i].isKey) {
          delete item[vm.itemModel[i].key];
          break;
        }
      }

      if (settingsPage && vm.item) {
        const valueType = item.type || vm.item.type;
        if (vm.item.system) {
          for (const key in readonlySystemSettingsFields) {
            if (readonlySystemSettingsFields.hasOwnProperty(key)) {
              delete item[key];
            }
          }
        }

        if (valueType === 'boolean') {
          item.value = (item.value === true || item.value === 'true') ? 'true' : 'false';
        }

        if (valueType === 'number') {
          item.value = String(item.value) || '';
        }
      }

      manageService.update(vm, data.uri, item).success((result) => {
        vm.confirm(data, result);
        vm.requestSend = false;
        vm.loadingModalData = false;

        if (settingsPage && vm.item && vm.item.system) {
          manageService.reloadSettings();
        }
      }).error(function (error) {
        showModalError(vm, error);
      });

    };

    //create new item after all fields are validated
    vm.saveItem = function () {
      vm.loadingModalData = true;

      const item = manageUtils.getItemObject(vm.itemModel, vm.itemData, vm.uploadedFiles);
      let itemId = utils.slugifyObjectField(item);

      for (let i = 0; i < vm.itemModel.length; i++) {
        if (vm.itemModel[i].isKey && item[vm.itemModel[i].key]) {
          itemId = item[vm.itemModel[i].key];
          break;
        }
      }

      if (settingsPage) {
        const valueType = item.type;
        if (valueType === 'boolean') {
          item.value = (item.value === true || item.value === 'true') ? 'true' : 'false';
        }

        if (valueType === 'number') {
          item.value = String(item.value) || '';
        }
      }

      const data = manageUtils.getItemEndpoint({
        section: vm.sectionConfig,
        item: item,
        type: 'item',
        locale: vm.itemLocale,
        itemId: itemId
      });

      if ($location.$$url.indexOf('/configuration/strings') !== -1 && !itemId) {
        const createEndpoint = manageUtils.getCreateNewEndpoint(vm.sectionConfig, vm.itemLocale);
        manageService.create(vm, createEndpoint, item).success((result) => {
          vm.requestSend = false;
          vm.loadingModalData = false;
          vm.confirm(data, result);
        }).error(function (err) {
          showModalError(vm, err);
        });
        return;
      }

      const isFormDataPayload = utils.isFormDataPayload(item);

      manageService.getItem(vm, data.uri).success(() => {
        showModalError(vm, {message: locales.getLocaleByKey('configuration_iteme_xist', {key: data.value})});
      }).error(function (error) {
        if (error && error.statusCode) {
          if (error.statusCode !== 404) {
            showModalError(vm, error);
          } else {
            const createEndpoint = manageUtils.getCreateNewEndpoint(vm.sectionConfig, vm.itemLocale);
            manageService.create(vm, createEndpoint, item, isFormDataPayload).success((result) => {
              vm.requestSend = false;
              vm.loadingModalData = false;
              vm.confirm(data, result);
            }).error(function (err) {
              showModalError(vm, err);
            });
          }
        } else {
          showModalError(vm, new Error(locales.getLocaleByKey('something_went_wrong')));
        }
      });
    };

    vm.setPattern = function(pattern) {
      if (!pattern) return pattern;
      if (pattern.charAt(0) === '/') pattern = pattern.substr(1);
      if (pattern.charAt(pattern.length - 1) === '/') pattern = pattern.substr(0, pattern.length - 1);
      return pattern;
    };

    vm.patternErrorMessage = function (field) {
      if (field.elementType === 'email') {
        return locales.getLocaleByKey('not_valid_email_address');
      } else {
        return locales.getLocaleByKey('format_error', {
          format: field.pattern
        });
      }
    };

    vm.customNgModel = function (id, custom) {
      return id + custom;
    };

    vm.customNgRequired = function (field) {
      let required = field.required;
      if (field.forceRequired) {
        return required;
      }
      if (field.onElementsChange && field.required) {
        required = false;
        field.onElementsChange.map((id) => {
          if (vm.itemData[id]) {
            required = true;
          }
        });
      }

      if (field.elementType === 'password') {
        vm.onPasswordChange(field);
      }

      return required;
    };

    vm.addNewTagValue = function (field) {
      const key = field.id + '-tag';
      if (vm.itemData[key]) {
        if (vm.itemData[field.id]) {
          vm.itemData[field.id].push(vm.itemData[key]);
        } else {
          vm.itemData[field.id] = [vm.itemData[key]];
        }
        delete vm.itemData[key];
      }
    };

    vm.removeTagValue = function (field, index) {
      if (vm.itemData[field.id]) {
        vm.itemData[field.id].splice(index, 1);
      }
    };

    vm.onChange = function (field) {
      if (field.onchange) {
        changeElementsVisibility(vm.itemModel, field.id, vm.itemData[field.id]);
      }
    };

    vm.onPasswordChange = function (field) {
      let required = vm.itemData[field.id] !== vm.itemData[field.id + '-retype'];
      if (!vm.itemData[field.id] && !vm.itemData[field.id + '-retype']) {
        required = false;
      }
      vm.itemData[field.id + '-required'] = required;
    };

    vm.onFileUpload = function (event) {
      if (event.target.files && event.target.files[0]) {
        utils.safeApply(vm, () => {
          vm.itemData[event.target.id] = { type: 'file' };
          vm.uploadedFiles[event.target.id] = event.target.files[0];
        });
      }
    };
  }
})();

(function () {
  angular
    .module('onify')
    .controller('viewItemsRawModalController', [
      '$scope',
      '$uibModalInstance',
      'locales',
      'item',
      'dialogOnCancel',
      configurationItemsModalController]);

  function configurationItemsModalController(
    $scope,
    $uibModalInstance,
    locales,
    item,
    dialogOnCancel,
  ) {
    $scope.errorMessage = locales.getLocaleByKey('something_went_wrong');

    try {
      $scope.rawItemStringify = item ? JSON.stringify(item, null, 4) : false;
      $scope.rawItem = item || false;
    } catch (e) {
      $scope.errorMessage = e.message;
    }

    $scope.cancel = function() {
      if (dialogOnCancel) {
        dialogOnCancel();
      }
      $uibModalInstance.close();
    };
  }
})();

(function () {

  angular
    .module('onify')
    .controller('manageController', manageController);

  manageController.$inject = ['$scope', '$timeout', '$window', '$location', '$uibModal', '$rootScope', 'utils', 'config', 'locales', 'manageUtils', 'manageService', 'errorService', 'queryStringService', 'resourcesService'];

  function manageController($scope, $timeout, $window, $location, $uibModal, $rootScope, utils, config, locales, manageUtils, manageService, errorService, queryStringService, resourcesService) {
    let vm = $scope;
    const params = $location.search();
    vm.configuration = utils.parseJson($('#configurationData').val());
    vm.configUrl = (vm.configuration.connectorPage) ? '/admin/connector/' : ((vm.configuration.settingsPage) ? '/admin/' : '/admin/configuration/');

    if (vm.configuration.itemsPage) {
      vm.configUrl = '/admin/';
      vm.itemsViewRaw = true;
    }

    if (vm.configuration.processPage) {
      vm.configUrl = '/admin/';
      vm.itemsViewRaw = true;
      vm.itemsViewRawKeyField = 'id';
      vm.isProcessPage = true;
    }

    vm.loadingText = locales.getLocaleByKey('loading');
    vm.norecordsfoundText = locales.getLocaleByKey('no_records_found');
    vm.searchPlaceholderText = locales.getLocaleByKey('search_for_items');
    vm.createNewText = locales.getLocaleByKey('create_new');
    vm.resultsText = locales.getLocaleByKey('results');

    vm.totalresults = 0;
    vm.hideTable = true;
    vm.showSection = false;
    vm.itemsList = [];
    vm.itemKeys = [];
    vm.activeSort = {};
    vm.searchValue = (params.term) ? params.term : '';
    vm.configTabs = manageUtils.getTabs(vm.configuration);
    vm.params = {
      query: (params.term) ? params.term : '*'
    };

    vm.newApi = (config.apiBaseUrl && config.apiBaseUrl.indexOf('/api/v2') !== -1);

    queryStringService.excludeQueryParams(['startfrom', 'pagesize', 'size']);

    function loadSectionConfigs() {
      vm.sectionDescription = vm.sectionConfig.data.description;
      vm.sectionTagline = vm.sectionConfig.data.tagline;
      vm.itemLocale = manageUtils.getDefaultLocale(vm.sectionConfig);
      vm.actionButtons = manageUtils.getActionButtons(vm.sectionConfig, vm.itemsViewRaw);
      vm.fieldsProperties = manageUtils.getFieldsProperties(vm.sectionConfig.data);

      showLocaleDropDown();
      loadItems(vm.itemLocale);
    }

    function showLocaleDropDown() {
      const sectionConfig = vm.sectionConfig;
      if (sectionConfig && sectionConfig.data && sectionConfig.data.endpoints.list) {
        const uri = sectionConfig.data.endpoints.list.fullUri;
        if (uri.indexOf('{locale}') !== -1 && manageUtils.hasAccessToEndpoint(vm.sectionConfig, 'locale')) {
          manageService.getLocales({pagesize: 100}).success((result) => {
            vm.localeDropDown = result.records;

            $timeout(() => {
              $('.manage-locales-drop-down').select2().change(function () {
                utils.safeApply(vm, () => {
                  vm.itemLocale = $(this).val();
                  loadItems(vm.itemLocale);
                });
              });
            }, 0);
          }).error((error) => {
            errorService.save(error).success(() => {
              window.location.href = config.errorPage;
            });
          });
        } else {
          vm.localeDropDown = false;
        }
      } else {
        vm.localeDropDown = false;
      }
    }

    function loadItems (locale) {
      vm.itemsListEndpoint = manageUtils.getListEndpoint(vm.sectionConfig, locale);
      vm.itemsCreateNewEndpoint = manageUtils.getCreateNewEndpoint(vm.sectionConfig, locale);
      getItemsList();
    }

    function setDefaultSort () {
      if (!vm.activeSort.key) {
        let found = false;
        const model = manageUtils.getItemModel(vm.configuration, vm.sectionConfig, {modalAction: 'update'});

        for (let i = 0; i < model.length; i++) {
          if (model[i].defaultSort) {
            vm.activeSort.key = model[i].key;
            vm.activeSort.sortClass = 'fa-sort-asc';
            vm.params.sort = model[i].sort ? model[i].sort : model[i].key || model[i].key;
            // Add default sort order
            if (vm.params.sort.indexOf(',') === -1) {
              if (model[i].sortOrder === 'desc') {
                vm.params.sort += ',desc';
                vm.activeSort.sortClass = 'fa-sort-desc';
              } else {
                vm.params.sort += ',asc';
              }
            }
            found = true;
          }
        }

        if (!found) {
          vm.activeSort = {};
          delete vm.params.sort;
        }
      }
    }

    vm.selectSection = function (section, init) {
      vm.itemsList = [];
      vm.itemKeys = [];
      vm.activeSort = {};

      vm.configTabs.map(function (tab) {
        if (section.isSubmenu) {
          tab.active = (tab.key === section.parent);

          if (tab.active) {
            vm.configSubTabs = tab.submenu;

            tab.submenu.map(function (sub) {
              sub.active = (sub.key === section.key);
              if (sub.active) {
                vm.activeTab = `${section.parent}/${section.key}`;
              }
            });
          }
        } else {
          tab.active = (tab.key === section.key);
          if (tab.active) {
            vm.activeTab = section.key;
          }

          if (tab.submenu) {
            tab.submenu.map(function (sub) {
              sub.active = false;
            });
          }
        }
      });

      if (section.submenu) {
        vm.configSubTabs = section.submenu;

        vm.showSection = false;
        $('.search-items').val('');
        changeUrlParams();
        return;
      } else if (!section.isSubmenu) {
        vm.configSubTabs = false;
      }

      if (section.isSubmenu) {
        vm.sectionConfig = {
          data: vm.configuration.data.endpoints[section.parent][section.key],
          locale: vm.configuration.locale
        };
      } else {
        vm.sectionConfig = {
          data: vm.configuration.data.endpoints[section.key],
          locale: vm.configuration.locale
        };
      }

      vm.showSection = true;

      if (!init) {
        vm.params.query = '*';
        vm.params.startfrom = 0;
      }
      $('.search-items').val('');
      loadSectionConfigs();
      changeUrlParams();
    };

    function changeUrlParams (remove) {
      const origin = $window.location.origin;
      const pathname = $window.location.pathname;
      let change = false;
      let url;

      if (vm.activeTab && pathname.indexOf(vm.activeTab) === -1 || vm.activeTab && remove) {
        url = origin + vm.configUrl + vm.activeTab;
        change = true;
        $location.url(url.replace(origin, ''));
        $location.replace();
      }

      if (vm.activeItemId && pathname.indexOf(vm.activeItemId) === -1 && !remove) {
        url = origin + vm.configUrl + vm.activeTab + '/' + vm.activeItemId;
        if (vm.isViewRaw) {
          url += '/view';
        }
        change = true;
      }

      if (change) {
        $window.history.pushState({path: url}, '', url);
      }
    }

    $window.addEventListener('popstate', () => {
      const activeSection = getActiveSection();
      openActiveSection(activeSection);
    });

    function getActiveSection (getItemKey) {
      const pathname = $window.location.pathname;
      if (pathname + '/' === vm.configUrl || pathname === vm.configUrl) return false;
      const paths = $window.location.pathname.replace(vm.configUrl, '').split('/');

      for (let i = 0; i < vm.configTabs.length; i++) {
        if (vm.configTabs[i].key === paths[0]) {
          if (vm.configTabs[i].submenu && paths[1]) {
            for (let j = 0; j < vm.configTabs[i].submenu.length; j++) {
              if (vm.configTabs[i].submenu[j].key === paths[1]) {
                if (getItemKey && paths[2]) {
                  return {item: paths[2]};
                }
                return vm.configTabs[i].submenu[j];
              }
            }
          }

          if (getItemKey && paths[1]) {
            return {item: paths[1]};
          }
          return vm.configTabs[i];
        }
      }

      return false;
    }

    openActiveSection();
    openActiveItem();

    function openActiveSection (selection) {
      const activeSection = getActiveSection();

      if (selection) {
        vm.selectSection(selection, true);
      } else if (activeSection) {
        vm.selectSection(activeSection, true);
      }
    }

    function openActiveItem () {
      const activeItem = getActiveSection(true);

      if (activeItem && activeItem.item) {
        const url = manageUtils.getSingleItemEndpoint(vm.sectionConfig, locale, activeItem.item);

        if (url && vm.sectionConfig.data.endpoints.replace && vm.sectionConfig.data.endpoints.replace.active) {
          manageService.getItem(vm, url).success(function (item) {
            const showViewItemModal = $window.location.pathname.indexOf('/view') !== -1 && vm.configuration.itemsPage;
            const tempItem = utils.clone(item);
            manageUtils.storeItem(item);
            if (showViewItemModal) {
              vm.viewRawItem(tempItem, true);
            } else {
              vm.updateItem(tempItem, true);
            }
          }).error((error) => {
            errorService.save(error).success(() => {
              window.location.href = config.errorPage;
            });
          });
        }
      }
    }

    vm.arrayOfStrings = function (arr) {
      if (!utils.isArray(arr)) return false;
      if (arr.length === 0) return false;
      return utils.isString(arr[0]);
    };

    vm.sortItems = function (field) {
      if (vm.requestSend) return;
      const asc = 'fa-sort-asc';
      const desc = 'fa-sort-desc';
      let sort = 'asc';

      if (vm.activeSort.key) {
        if (vm.activeSort.key === field.key) {
          if (vm.activeSort.sortClass === asc) {
            vm.activeSort.sortClass = desc;
            sort = 'desc';
          } else {
            vm.activeSort.sortClass = asc;
          }
        } else {
          vm.activeSort.key = field.key;
          vm.activeSort.sortClass = asc;
        }
      } else {
        vm.activeSort.key = field.key;
        vm.activeSort.sortClass = asc;
      }

      vm.params.sort = field.sort + ',' + sort;

      let params = utils.clone(vm.params);
      params.startfrom = 0;
      params.pagesize = vm.itemsList.length;
      vm.params = params;

      $(config.domElements.loadMoreId).off('inview');

      getItemsList();
    };

    function getItemsList () {
      vm.showNoData = false;
      vm.hideTable = true;
      vm.showLoadMore = true;
      vm.itemsList = [];

      setDefaultSort();

      manageService.getItems(vm, vm.itemsListEndpoint, vm.params).success((result) => {
        if (vm.configuration.processPage) {
          result.records = result.records.map((record) => {
            record.flow = record.bpmn;
            return record;
          });
        }
        if (vm.activeTab === 'workflows') {
          result.records = result.records.map((record) => {
            record.schedule = record.scheduled && record.scheduled.timer;
            record.nextRunAt = record.scheduled && record.scheduled.nextRunAt;
            return record;
          });
        }
        vm.itemKeys = manageUtils.prepareTableFields(vm.sectionConfig.data, result.records);
        manageUtils.prepareResult(vm, manageService, result, true);
        vm.hideTable = false;
        addTypeWatch();
        //check if we have more items to load

        vm.totalresults = result.meta.totalresults;

        if (vm.itemsList.length < result.meta.pagesize) {
          if (!result.records.length) {
            vm.showNoData = true;
            vm.hideTable = true;
          }
        }
      }).error(function () {
        addTypeWatch();
        vm.showLoadMore = false;
        vm.showNoData = true;
        vm.hideTable = true;
        vm.requestSend = false;
      });
    }

    function addTypeWatch () {
      //search input
      const searchInput = $('.search-items');
      searchInput.typeWatch({
        allowSubmit: false,
        captureLength: 1,
        wait: 400,
        callback: function (value) {
          if (vm.requestSend) return;
          vm.params.startfrom = 0;
          vm.params.query = value;
          utils.safeApply(vm, () => {
            queryStringService.addTerm(value);
          });
          getItemsList();
        }
      });

      searchInput.keypress((e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          if (vm.requestSend) return;
          let value = searchInput.val();
          value = (!value || value === '') ? value : value.replace(/\s+/g, ' ');
          if (!value || value === '') {
            searchInput.val('*');
            value = '*';
          }

          vm.params.startfrom = 0;
          vm.params.query = value;
          queryStringService.addTerm(value);
          getItemsList();
        }
      });
    }

    vm.viewRawItem = function(item, originalItem) {
      const key = vm.itemsViewRawKeyField || 'key';
      const itemObject = originalItem ? item : utils.clone(manageUtils.getOriginalItem(key, item[key]));

      vm.activeItemId = itemObject[key];
      vm.isViewRaw = true;

      const instance = $uibModal.open({
        templateUrl: 'app/common/directives/admin/manage/items.modal.view.raw.html?v=' + config.version,
        controller: 'viewItemsRawModalController',
        size: 'md',
        windowClass: 'configuration-view-item-raw-modal',
        resolve: {
          item: function() {
            if (vm.configuration.processPage) {
              delete itemObject.bpmn;
              delete itemObject.flow;
            }
            return itemObject;
          },
          dialogOnCancel: function() {
            return function() {
              vm.activeItemId = false;
              vm.isViewRaw = false;
              changeUrlParams(true);
            };
          }
        }
      });

      instance.result.then(() => {
      }, () => {
        vm.activeItemId = false;
        vm.isViewRaw = false;
        changeUrlParams(true);
      });

      changeUrlParams();
    };

    //open create new item modal
    vm.createNewItem = function (item) {
      const modalAction = 'create';
      const model = manageUtils.getItemModel(vm.configuration, vm.sectionConfig, {modalAction: (item) ? 'update' : modalAction});

      if (item) {
        let itemObject, key, keyValue;

        for (let i = 0; i < model.length; i++) {
          if (model[i].isKey) {
            key = model[i].key;
            keyValue = item[model[i].key];
          }
        }

        if (!key) {
          key = vm.sectionConfig.data.keyField;
          keyValue = item[key];
        }

        itemObject = utils.clone(manageUtils.getOriginalItem(key, keyValue));
        item = manageUtils.prepareItem(vm, itemObject, {modalAction: 'update'});

        //remove key or slug value
        for (let i = 0; i < model.length; i++) {
          if (model[i].isKey) {
            item[model[i].key] = '';
          }
        }
      }

      $uibModal.open({
        templateUrl: 'app/common/directives/admin/manage/items.modal.template.html?v=' + config.version,
        controller: 'configurationItemsModalController',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'configuration-modal',
        resolve: {
          modelsConfigurations: function () {
            return vm.configuration;
          },
          sectionConfig: function () {
            return vm.sectionConfig;
          },
          model: function () {
            return model;
          },
          item: function () {
            return item || false;
          },
          modalAction: function () {
            return modalAction;
          },
          itemLocale: function () {
            return vm.itemLocale;
          },
          dialogOnConfirm: function () {
            return function () {
              $timeout(() => {
                vm.params.startfrom = 0;
                getItemsList();
              }, 1000);
            };
          },
          dialogOnCancel: function () {
            return function () {
            };
          }
        }
      });
    };

    //open update items modal
    vm.updateItem = function (item, originalItem) {
      const modalAction = 'update';
      const model = manageUtils.getItemModel(vm.configuration, vm.sectionConfig, {modalAction: modalAction});
      let itemObject, key, keyValue;

      for (let i = 0; i < model.length; i++) {
        if (model[i].isKey) {
          model[i].readonly = true;
          key = model[i].key;
          keyValue = item[model[i].key];
        }
      }

      if (!key && !keyValue) {
        key = 'id';
        keyValue = item[key];
      }

      vm.activeItemId = keyValue;
      itemObject = (originalItem) ? item : manageUtils.getOriginalItem(key, keyValue);
      itemObject = manageUtils.prepareItem(vm, itemObject, {modalAction: modalAction});

      const instance = $uibModal.open({
        templateUrl: 'app/common/directives/admin/manage/items.modal.template.html?v=' + config.version,
        controller: 'configurationItemsModalController',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'configuration-modal',
        resolve: {
          modelsConfigurations: function () {
            return vm.configuration;
          },
          sectionConfig: function () {
            return vm.sectionConfig;
          },
          model: function () {
            return model;
          },
          item: function () {
            return itemObject;
          },
          modalAction: function () {
            return modalAction;
          },
          itemLocale: function () {
            return vm.itemLocale;
          },
          dialogOnConfirm: function () {
            return function () {
              vm.activeItemId = false;
              changeUrlParams(true);

              $timeout(() => {
                vm.params.startfrom = 0;
                getItemsList();
              }, 1000);
            };
          },
          dialogOnCancel: function () {
            return function () {
              vm.activeItemId = false;
              changeUrlParams(true);
            };
          }
        }
      });

      instance.result.then(() => {
      }, () => {
        vm.activeItemId = false;
        changeUrlParams(true);
      });

      changeUrlParams();
    };

    //clone any item form existing one also key is removed
    vm.cloneItem = function (item) {
      item = utils.clone(item);
      vm.createNewItem(item);
    };

    //delete any item by id
    vm.deleteItem = function (item) {
      if (vm.requestSend) return;
      $uibModal.open({
        templateUrl: 'confirm-modal.html',
        controller: 'confirmModalController',
        size: 'md',
        resolve: {
          onConfirm: function () {
            return function () {
              const data = manageUtils.getItemEndpoint({
                section: vm.sectionConfig,
                item: item,
                type: 'delete',
                locale: vm.itemLocale
              });

              manageService.removeItem(vm, data.uri).success(() => {
                $timeout(() => {
                  vm.requestSend = false;
                  vm.params.startfrom = 0;
                  getItemsList();
                }, 1000);
              }).error((error) => {
                vm.requestSend = false;
                errorService.save(error).success(() => {
                  window.location.href = config.errorPage;
                });
              });
            };
          }
        }
      });
    };

    //check for max characters
    vm.showMaxCharacters = function showMaxCharacters(field, value, item) {
      if (field.key === 'value' && item.type === 'password' && value) {
        return '********************';
      }
      if (value && field.maxChars && value.length > field.maxChars) {
        return value.substring(0, field.maxChars) + ' ...';
      }

      if (field.showField && Array.isArray(value) && value.length) {
        for (let i = 0; i < value.length; i++) {
          if (value[i].key === field.showField) {
            return value[i].value;
          }
        }
        return null;
      }

      if (field.elementType === 'count') {
        if (item[field.key] && Array.isArray(item[field.key])) {
          return item[field.key].length;
        }
        return 0;
      }

      return value;
    };

    vm.startProcess = function(workflow) {
      manageService.create(null, `/admin/processes/start/${workflow.key}`, {title: workflow.name}).success(() => {
        $rootScope.$broadcast('show_snackbar_notification', {
          message: locales.getLocaleByKey('process_started_successfully')
        });
      }).error((error) => {
        $rootScope.$broadcast('show_snackbar_notification', {
          type: 'error',
          message: error.message
        });
      });
    };

    vm.viewBpmn = function(object) {
      if (!object.bpmn && !object.bpmnresource) return;

      function openBPMNModal(item) {
        $uibModal.open({
          templateUrl: 'app/common/directives/admin/manage/view.bpmn.html?v=' + config.version,
          controller: 'viewBPMNModalController',
          size: 'lg',
          windowClass: 'view-bpmn-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            item: function() {
              return item;
            },
            dialogOnCancel: function() {
              return function() {};
            }
          }
        });
      }

      if (object.bpmnresource) {
        resourcesService.getContent({
          path: object.bpmnresource,
        }).success((result) => {
          openBPMNModal({...object, bpmn: result.content});
        }).error((error) => {
          $rootScope.$broadcast('show_snackbar_notification', {
            type: 'error',
            message: error.message || error.description
          });
        });
      } else {
        openBPMNModal(object);
      }
    };
  }
})();

(function() {

  angular
    .module('onify')
    .directive('managePage', managePage);

  managePage.$inject = ['config'];
  function managePage(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/admin/manage/manage.template.html?v=' + config.version,
      controller: "manageController"
    };
  }

})();
(function () {
  angular
    .module('onify')
    .controller('viewBPMNModalController', [
      '$scope',
      '$uibModalInstance',
      'locales',
      'item',
      'dialogOnCancel',
      viewBPMNModalController]);

  function viewBPMNModalController(
    $scope,
    $uibModalInstance,
    locales,
    item,
  ) {
    $scope.item = item;
    const viewer = new BpmnJS();

    viewer.importXML(item.bpmn).then(() => {
      viewer.attachTo('#bpmn-content');
    });

    $scope.cancel = function() {
      viewer.detach();
      $uibModalInstance.close();
    };
  }
})();

(function IIFE() {

  angular
    .module('onify')
    .controller('resourcesController', resourcesController);

  resourcesController.$inject = ['$scope', '$document', '$timeout', '$window', '$location', '$cookies', '$uibModal', 'utils', 'config', 'locales', 'resourcesService', 'resourcesUtils'];

  function resourcesController($scope, $document, $timeout, $window, $location, $cookies, $uibModal, utils, config, locales, resourcesService, resourcesUtils) {
    let vm = $scope;
    let activeEditorContent = false;
    let editorOpenFilePath;
    let showWarningModal = false;

    vm.editorMessage = false;
    vm.editorErrors = false;
    vm.disableEditorActions = false;
    vm.showLoadingSpinner = false;
    vm.newApi = (config.apiBaseUrl && config.apiBaseUrl.indexOf('/api/v2') !== -1);
    vm.requireCommitMessage = false;

    const DISABELD_ACTION = 'disabled';
    const REPLACE_ACTION = 'replace';
    const DELETE_ACTION = 'delete';
    const EDIT_ACTION = 'edit';
    const RENAME_ACTION = 'rename';
    const UPLOAD_ACTION = 'upload';
    const SUBFOLDER_ACTION = 'subfolder';
    const CREATE_ACTION = 'create';
    const RESET_ACTION = 'reset';
    const VALIDATE_ACTION = 'validate';
    const imageExtensions = utils.imageExtensions();
    const itemActions = [{
      name: locales.getLocaleByKey('resources_new_subfolder'),
      icon: 'fa-folder',
      action: SUBFOLDER_ACTION,
      defaultValue: locales.getLocaleByKey('new_folder')
    }, {
      name: locales.getLocaleByKey('upload_file'),
      icon: 'fa-upload',
      action: UPLOAD_ACTION
    }, {
      name: locales.getLocaleByKey('rename'),
      icon: 'fa-italic',
      action: RENAME_ACTION
    }, {
      name: locales.getLocaleByKey('delete'),
      icon: 'fa-trash',
      action: DELETE_ACTION
    }, {
      name: locales.getLocaleByKey('resources_create_new_file'),
      icon: 'fa-plus-circle',
      action: CREATE_ACTION
    }, {
      name: locales.getLocaleByKey('reset'),
      icon: 'fa-repeat',
      action: RESET_ACTION
    }];

    //init code editor
    const editor = ace.edit('editor');
    editor.setTheme('ace/theme/iplastic');
    editor.getSession().setMode('ace/mode/jade');
    editor.$blockScrolling = Infinity;
    editor.setShowPrintMargin(false);
    editor.session.setOptions({useSoftTabs: false});

    editor.getSession().on('change', function () {
      showWarningModal = (activeEditorContent && editor.getValue() !== activeEditorContent);
    });

    editor.getSession().on('changeAnnotation', function () {
      const annot = editor.getSession().getAnnotations();
      vm.editorMessage = false;
      vm.editorErrors = false;

      for (const key in annot) {
        if (annot.hasOwnProperty(key)) {
          if (annot[key].type === 'error') {
            vm.editorErrors = true;
            vm.editorMessage = {
              text: locales.getLocaleByKey('configuration_editor_code_error')
            };
            break;
          }
        }
      }
    });

    //translations
    vm.okText = locales.getLocaleByKey('ok');
    vm.cancelText = locales.getLocaleByKey('cancel');
    vm.closeText = locales.getLocaleByKey('close');
    vm.saveText = locales.getLocaleByKey('save');
    vm.resetText = locales.getLocaleByKey('reset');
    vm.validateText = locales.getLocaleByKey('validate');
    vm.renameText = locales.getLocaleByKey('rename');
    vm.deleteText = locales.getLocaleByKey('delete');
    vm.noitemselectedText = locales.getLocaleByKey('resources_no_items_elected');
    vm.missinggitsettingsText = locales.getLocaleByKey('missing_git_settings');
    vm.removeText = locales.getLocaleByKey('remove');
    vm.addparameterText = locales.getLocaleByKey('add_parameter');
    vm.viewText = locales.getLocaleByKey('view');

    vm.ownerText = locales.getLocaleByKey('resources_owner');
    vm.repoText = locales.getLocaleByKey('resources_repo');
    vm.branchText = locales.getLocaleByKey('resources_branch');
    vm.lastcommitidText = locales.getLocaleByKey('resources_last_commit_id');
    vm.resyncText = locales.getLocaleByKey('resync');
    vm.checkText = locales.getLocaleByKey('check');
    vm.filedownloadedText = locales.getLocaleByKey('resources_file_downloaded');
    vm.nofiledownloadedText = locales.getLocaleByKey('resources_no_file_downloaded');
    vm.filechangedText = locales.getLocaleByKey('resources_file_changed');
    vm.nochangesText = locales.getLocaleByKey('resources_no_changes');
    vm.filetoupdatedText = locales.getLocaleByKey('resources_file_to_update');
    vm.cannotfindformconfiguration = locales.getLocaleByKey('cannot_find_form_configuration');
    vm.changesyoumademaynotbesaved = locales.getLocaleByKey('changes_you_made_may_not_be_saved');
    vm.resyncText = locales.getLocaleByKey('resync');

    vm.directoryTree = [];
    vm.loadingTree = true;
    vm.loadingInfo = true;
    vm.activeParameters = {};
    vm.selectedItem = null;
    vm.selectedDirectory = null;

    showRightContent('preview');

    $window.onbeforeunload = function onbeforeunload() {
      if (showWarningModal) {
        return true;
      }
    };

    resourcesService.getTree().success((result) => {
      vm.directoryTree = result;
      resourcesUtils.sort(vm.directoryTree);
      vm.loadingTree = false;
      $timeout(() => {
        openTreeElementsFromParams();
      }, 100);
    }).error((error) => {
      showNotification({ error }, 5000);
    });

    function changeUrlParams(customParams) {
      const origin = $window.location.origin;
      const currentUrl = window.location.href.split('?');
      const params = [];
      customParams.map((param) => {
        if (param.action === 'add') {
          vm.activeParameters[param.key] = param.value;
        }
        if (param.action === 'remove') {
          delete vm.activeParameters[param.key];
        }
      });
      for (const key in vm.activeParameters) {
        if (vm.activeParameters.hasOwnProperty(key)) {
          params.push(`${key}=${encodeURIComponent(vm.activeParameters[key])}`);
        }
      }
      const url = `${currentUrl[0]}?${params.join('&')}`;
      $location.url(url.replace(origin, ''));
      $location.replace();
      $window.history.pushState({path: url}, '', url);
    }

    function commitMessageModal(callback) {
      if (!vm.requireCommitMessage) {
        vm.showLoadingSpinner = true;
        vm.disableEditorActions = false;
        return callback();
      }

      $uibModal.open({
        templateUrl: 'app/common/directives/modal/resources.commit.message.modal.template.html?v=' + config.version,
        controller: 'commitMessageModalController',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'commit-message-modal',
        resolve: {
          onConfirm: function () {
            return function (commitMessage) {
              utils.safeApply(vm, () => {
                vm.showLoadingSpinner = true;
              });
              callback(commitMessage);
            };
          },
          onCancel: function () {
            return function () {
              utils.safeApply(vm, () => {
                vm.disableEditorActions = false;
              });
              vm.closeActionsModal();
            };
          }
        }
      });
    }

    function openTreeElementsFromParams() {
      const params = $location.search();
      vm.activeParameters = params;
      if (params.activedirectory) {
        const options = {};
        if (params.hasOwnProperty('isdirectoryopen')) {
          options.open = (params.isdirectoryopen === 'true');
        }
        resourcesUtils.selectItemByPath(vm.directoryTree, params.activedirectory, options);
      }

      if (params.openfile && resourcesUtils.getItemByPathDipped(vm.directoryTree, params.openfile)) {
        const item = resourcesUtils.getItemByPathDipped(vm.directoryTree, params.openfile, {openSubDir: true});
        vm.editFile(item);
      }
    }

    $window.addEventListener('popstate', () => {
      openTreeElementsFromParams();
      vm.$apply();
    });

    getInfo();

    function getInfo() {
      resourcesService.getInfo().success((result) => {
        vm.requireCommitMessage = result.requireCommitMessage;

        vm.resourcesInfo = result;
        if (!result.lastCommitId) {
          vm.resourcesInfo.lastCommitId = locales.getLocaleByKey('none');
        }
        vm.loadingInfo = false;

        if (result.fileChanged && result.fileChanged.length > 0) {
          showRightContent('info');
          vm.fileChanged = result.fileChanged;
          vm.infoContentErrorMessage = locales.getLocaleByKey('resources_update_your_files');
        }
      }).error((error) => {
        vm.loadingInfo = false;
        vm.missingGitSettings = true;

        showNotification({ error }, 5000);
      });
    }

    vm.treeMainActions = function treeMainActions() {
      const data = {
        path: '/',
        type: 'directory',
        actions: [
          'subfolder',
          'upload',
          'create'
        ]
      };

      const actions = [];

      itemActions.map((item) => {
        if (data.actions.indexOf(item.action) !== -1) {
          actions.push(item);
        }
      });

      vm.treeMainActionsOptions = {
        item: data,
        actions: actions
      };
    };

    vm.checkForUpdate = function checkForUpdate() {
      if (vm.disabledInfoButtons) return;
      if (showWarningModal && !confirm(vm.changesyoumademaynotbesaved)) {
        return false;
      }

      showWarningModal = false;
      vm.disabledInfoButtons = true;
      showLoading();

      resourcesService.check().success((result) => {
        vm.hideInfo = result.newVersion;
        vm.disabledInfoButtons = false;
        showRightContent('info');
        if (result.lastCommitId) {
          vm.resourcesInfo.lastCommitId = result.lastCommitId;
          vm.fileChanged = result.fileChanged;
        } else {
          vm.fileChanged = [locales.getLocaleByKey('all_files')];
        }

        vm.showNoChanges = (vm.fileChanged.length === 0);
        vm.infoContentMessage = false;
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    };

    vm.updateFiles = function updateFiles() {
      if (vm.disableUpdate) return;
      vm.disableUpdate = true;
      vm.showUpdateLoading = true;

      resourcesService.update({}).success((result) => {
        vm.infoContentErrorMessage = false;
        vm.disableUpdate = false;
        vm.showUpdateLoading = false;
        vm.resourcesInfo.fileDownloaded = result.files;
        vm.resourcesInfo.lastCommitId = result.lastCommitId;
        vm.infoContentMessage = locales.getLocaleByKey('update_finished');
        vm.fileChanged = [];
        vm.showNoChanges = false;
        $timeout(() => {
          vm.infoContentMessage = false;
        }, 5000);
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    };

    vm.resyncFiles = function resyncFiles() {
      if (vm.disabledInfoButtons) return;
      if (showWarningModal && !confirm(vm.changesyoumademaynotbesaved)) {
        return false;
      }

      showWarningModal = false;
      vm.disabledInfoButtons = true;
      showLoading();

      resourcesService.update({resync: true}).success((result) => {
        vm.hideInfo = result.newVersion;
        vm.infoContentErrorMessage = false;
        vm.disabledInfoButtons = false;
        showRightContent('info');
        vm.resourcesInfo.fileDownloaded = result.files;
        vm.resourcesInfo.lastCommitId = result.lastCommitId;
        vm.infoContentMessage = locales.getLocaleByKey('resync_finished');
        vm.fileChanged = [];
        vm.showNoChanges = false;
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    };

    function showRightContent (content) {
      const obj = [{
        key: 'info',
        content: 'infoContent'
      }, {
        key: 'preview',
        content: 'previewContent'
      }, {
        key: 'editor',
        content: 'editorContent'
      }];

      obj.map((item) => {
        vm[item.content] = (content === item.key);
      });
    }

    function showLoading () {
      showRightContent('preview');
      vm.loadingItem = true;
      vm.hideNoItemSelected = true;
      vm.filePreviewPath = false;
    }

    function initSelectElement(element, notActiveFirst) {
      $timeout(() => {
        const filenameElement = $(element);
        filenameElement.select2({});

        if (!notActiveFirst) {
          filenameElement.val($(element + '  option:first').val()).trigger('change');
        }
      }, 20);
    }

    function updatedFileContent(selectedFile, content) {
      commitMessageModal((commitMessage) => {
        vm.showLoadingSpinner = true;

        const formData = new FormData();
        formData.append('content', (selectedFile.replace) ? content : editor.getValue());
        formData.append('path', selectedFile.path);
        formData.append('action', (selectedFile.replace) ? REPLACE_ACTION : EDIT_ACTION);
        formData.append('file', (selectedFile.replace));

        if (selectedFile.directory) {
          formData.append('directory', selectedFile.directory);
        }

        if (commitMessage) {
          formData.append('commitMessage', commitMessage);
        }

        resourcesService.updateContent(formData).success((updatedItem) => {
          if (updatedItem) {
            const item = resourcesUtils.getItemByPath(vm.directoryTree, updatedItem.path);
            if (item) {
              item.status = updatedItem.status;
              item.actions = updatedItem.actions;
            }

            if (updatedItem.actions && updatedItem.actions.indexOf(RESET_ACTION) !== -1) {
              vm.showResetButton = true;
            }
          }

          activeEditorContent = editor.getValue();
          vm.closeActionsModal();

          //get updated git info
          getInfo();

          vm.showLoadingSpinner = false;

          showNotification({
            text: locales.getLocaleByKey('resources_file_updated'),
            class: 'success'
          }, 3000);

          vm.editorErrors = false;
          vm.disableEditorActions = false;
          showWarningModal = false;
        }).error((error) => {
          vm.showLoadingSpinner = false;
          showNotification({ error }, 5000);
        });
      });
    }

    function createNewFile(selectedFile, content) {
      commitMessageModal((commitMessage) => {
        vm.showLoadingSpinner = true;

        const formData = new FormData();
        formData.append('content', content || '');
        formData.append('path', selectedFile.path);
        formData.append('action', (selectedFile.action) ? selectedFile.action : UPLOAD_ACTION);
        formData.append('file', selectedFile.upload);

        if (selectedFile.directory) {
          formData.append('directory', selectedFile.directory);
        }

        if (commitMessage) {
          formData.append('commitMessage', commitMessage);
        }

        resourcesService.createNewFile(formData).success((resultData) => {
          activeEditorContent = content || '';
          vm.closeActionsModal();

          showNotification({
            text: locales.getLocaleByKey('resources_new_file'),
            class: 'success'
          }, 3000);

          if (selectedFile.path === '/') {
            const child = resourcesUtils.getItemByPath(vm.directoryTree, resultData.path);
            if (!child) {
              resultData.level = 1;
              vm.directoryTree.push(resultData);
              resourcesUtils.sort(vm.directoryTree);
            }
          } else {
            const dir = resourcesUtils.getItemById(vm.directoryTree, selectedFile.parentId);
            if (dir.children) {
              const child = resourcesUtils.getItemByPath(dir.children, resultData.path);
              if (!child) {
                dir.children.push(resultData);
              }
            } else {
              dir.children = [resultData];
            }
            resourcesUtils.sort(dir.children);
          }

          if (selectedFile.createNewResource) {
            showWarningModal = false;
            vm.editFile(resultData);
          }

          if (selectedFile.action && selectedFile.action === CREATE_ACTION) {
            //update selected file
            selectedFile = resultData;
          }
          vm.editorErrors = false;
          vm.disableEditorActions = false;
          showWarningModal = false;
          //get updated git info
          getInfo();
          vm.showLoadingSpinner = false;
        }).error((error) => {
          showNotification({ error }, 5000);
          vm.showLoadingSpinner = false;
        });
      });
    }

    function deleteItem(deletedFile) {
      vm.showLoadingSpinner = true;
      const options = {
        path: deletedFile.path,
        type: deletedFile.type
      };

      if (deletedFile.type === 'directory') {
        commitMessageModal((commitMessage) => {
          if (commitMessage) {
            options.commitMessage = commitMessage;
          }

          resourcesService.deleteDirectory(options).success(() => {
            vm.closeActionsModal();
            //show Preview Content and clear editor if is open
            openPreviewContent(deletedFile, vm.selectedItem);

            showNotification({
              text: locales.getLocaleByKey('resources_directory_deleted'),
              class: 'success'
            }, 1000);

            resourcesUtils.removeItemById(vm.directoryTree, deletedFile.id);
            vm.showLoadingSpinner = false;
          }).error((error) => {
            showNotification({ error }, 5000);
          });
        });
      } else {
        commitMessageModal((commitMessage) => {
          if (commitMessage) {
            options.commitMessage = commitMessage;
          }
          resourcesService.deleteFile(options).success(() => {
            vm.closeActionsModal();

            //show Preview Content and clear editor if is open
            openPreviewContent(deletedFile, vm.selectedItem);

            showNotification({
              text: locales.getLocaleByKey('resources_file_deleted'),
              class: 'success'
            }, 3000);

            resourcesUtils.removeItemById(vm.directoryTree, deletedFile.id);
            vm.showLoadingSpinner = false;
          }).error((error) => {
            showNotification({ error }, 5000);
          });
        });
      }

      //get updated git info
      getInfo();
    }

    function renameFilePath(selectedFile) {
      vm.actionsModalData.disabled = true;
      const newPath = resourcesUtils.getNewItemPath(selectedFile);

      resourcesService.renameFile({
        path: selectedFile.path,
        newPath: newPath,
        type: selectedFile.type
      }).success(() => {
        vm.closeActionsModal();

        showNotification({
          text: locales.getLocaleByKey('resources_success_rename'),
          class: 'success'
        }, 3000);

        const parent = resourcesUtils.getParentFromPath(selectedFile.path);
        resourcesUtils.renameItem(vm.directoryTree, selectedFile, newPath);
        const parentDir = resourcesUtils.getItemByPath(vm.directoryTree, parent);
        resourcesUtils.sort(parentDir.children);

        //get updated git info
        getInfo();
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    }

    function resetContent(selectedFile) {
      resourcesService.resetContent({
        path: selectedFile.path,
        type: selectedFile.type
      }).success((updatedItem) => {
        vm.closeActionsModal();
        //show Preview Content and clear editor if is open
        openPreviewContent(selectedFile);

        showNotification({
          text: locales.getLocaleByKey('resources_file_reset'),
          class: 'success'
        }, 3000);

        const item = resourcesUtils.getItemByPath(vm.directoryTree, updatedItem.path);
        if (item) {
          item.status = updatedItem.status;
          item.actions = updatedItem.actions;
        }

        //get updated git info
        getInfo();
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    }

    function createNewCustomFile(options, parent) {
      vm.filePreviewPath = false;
      vm.hideNoItemSelected = true;
      vm.editorErrors = false;
      vm.editorMessage = false;
      vm.loadingItem = false;
      vm.showActionsModal = false;

      showRightContent('editor');

      editor.session.getUndoManager().reset();
      editor.getSession().setMode('ace/mode/' + parent.editor);
      editor.setValue('');
      const itemName = options.value + (options.extension || '');

      if (itemName.indexOf('.pug') !== -1) {
        editor.setShowInvisibles(true);
      }

      const parentPath = (parent.path === '/') ? '' : parent.path;
      const path = parentPath + '/' + itemName;

      vm.actionsModalData = false;
      editorOpenFilePath = path;

      createNewFile({
        path: path,
        name: itemName,
        action: options.action,
        parentId: parent.id,
        createNewResource: true
      });
    }

    function openPreviewContent(item, selectedItem) {
      let clear = false;
      if (item.type === 'directory') {
        const directoryContent = resourcesUtils.getItemByPath(vm.directoryTree, item.path);
        if (directoryContent && directoryContent.children) {
          const child = resourcesUtils.getItemByPath(directoryContent.children, editorOpenFilePath);
          if (child) {
            clear = true;
          }

          if (selectedItem) {
            const ch = resourcesUtils.getItemByPath(directoryContent.children, selectedItem.path);
            if (ch) {
              clear = true;
            }
          }
        }
      } else {
        clear = (item.path === editorOpenFilePath);
      }

      if (clear || (selectedItem && selectedItem.path === item.path)) {
        showRightContent('preview');
        vm.hideNoItemSelected = false;
        vm.filePreviewPath = false;
        vm.loadingItem = false;
        vm.editorErrors = false;
        vm.editorMessage = false;
        editor.session.getUndoManager().reset();
        editor.setValue('');
        showWarningModal = false;

        changeUrlParams([{
          key: 'openfile',
          value: item.path,
          action: 'remove'
        }]);
      }
    }

    vm.openNode = function (data) {
      resourcesUtils.removePreviewsActive(vm.directoryTree);
      data.open = !(data.open);
      data.active = true;
      if (!data.open && data.children) {
        resourcesUtils.closeChildren(data.children);
      }
      changeUrlParams([{
        key: 'activedirectory',
        value: data.path,
        action: 'add'
      }, {
        key: 'isdirectoryopen',
        value: data.open,
        action: 'add'
      }]);
    };

    vm.openDropDownMenu = function ($event, data) {
      if (!data && $event.target.className === 'tree-objects' && vm.newApi) {
        data = {
          path: '/',
          type: 'directory',
          actions: [
            'subfolder',
            'upload',
            'create'
          ]
        };
      }
      if (!data) return;
      $event.preventDefault();

      if (data && data.actions && data.actions.length > 0) {
        const windowHeight = $(window).height();
        const actions = [];

        itemActions.map((item) => {
          if (data.actions.indexOf(item.action) !== -1) {
            actions.push(item);
          }
        });

        vm.xMenuData = {
          left: $event.screenX + 1,
          top: $event.screenY - 157,
          item: data,
          actions: actions
        };

        const dropDownY = (actions.length * 32) + $event.clientY;
        if (dropDownY > windowHeight) {
          vm.xMenuData.top -= (dropDownY - windowHeight) + 15;
        }
      }
    };

    function getAction (action) {
      let obj = false;

      for (let i = 0; i < itemActions.length; i++) {
        if (itemActions[i].action === action) {
          obj = itemActions[i];
          break;
        }
      }

      return obj;
    }

    vm.resetFileEditorAction = function () {
      if (vm.disableEditorActions) return;
      vm.performItemAction(getAction(RESET_ACTION), vm.selectedItem);
    };

    vm.deleteFileEditorAction = function () {
      if (vm.disableEditorActions) return;
      vm.performItemAction(getAction(DELETE_ACTION), vm.selectedItem);
    };

    vm.renameFileEditorAction = function () {
      if (vm.disableEditorActions) return;
      vm.performItemAction(getAction(RENAME_ACTION), vm.selectedItem);
    };

    vm.validateFileEditorAction = function () {
      if (vm.disableEditorActions) return;
      validateFormContent(true, vm.selectedItem);
    };

    vm.validateFormAction = function () {
      let error = false;
      let url = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      const params = ['formValidation=true'];
      for (let i = 0; i < vm.validationModalData.params.length; i++) {
        if (vm.validationModalData.params[i].name !== '') {
          if (!vm.validationModalData.params[i].value) {
            vm.validationModalData.params[i].error = true;
            error = true;
          } else {
            vm.validationModalData.params[i].error = false;
            params.push(vm.validationModalData.params[i].name + '=' + vm.validationModalData.params[i].value);
          }
        }
      }

      if (!error) {
        const name = resourcesUtils.getFileNameFormPath(vm.validationModalData.forms.main);
        const extension = resourcesUtils.getFileExtensionFormName({
          type: 'file'
        }, name);
        const slug = name.replace(extension, '');
        vm.iframeSrc = url + '/form/' + slug + '?' + params.join('&');
        vm.validationModalData.showIframe = true;
        vm.formIframeLoading = true;
        $timeout(() => {
          document.getElementById('formIframe').onload = function () {
            vm.$apply(() => {
              vm.formIframeLoading = false;
            });
          };
        }, 0);
      }
    };

    vm.getFormValidationUrl = function () {
      const params = [];
      const temp = [];
      for (let i = 0; i < vm.validationModalData.params.length; i++) {
        if (vm.validationModalData.params[i].name !== '') {
          if (!vm.validationModalData.params[i].value || vm.validationModalData.params[i].value === '') {
            params.push(vm.validationModalData.params[i].name + '=');
          } else {
            params.push(vm.validationModalData.params[i].name + '=' + vm.validationModalData.params[i].value);
          }
          temp.push(vm.validationModalData.params[i]);
        }
      }

      const name = resourcesUtils.getFileNameFormPath(vm.validationModalData.forms.main);
      const extension = resourcesUtils.getFileExtensionFormName({
        type: 'file'
      }, name);

      const slug = name.replace(extension, '');
      $cookies.put('form-params-' + slug, (temp.length > 0) ? JSON.stringify(temp) : null, {
        expires: moment().add(1, 'days').format()
      });
      return location.origin + '/form/' + slug + '?' + params.join('&');
    };

    vm.removeFormParameter = function (index) {
      vm.validationModalData.params.splice(index, 1);
    };

    vm.addFormParameter = function () {
      vm.validationModalData.params.push({
        name: '',
        value: '',
        newParam: true
      });
    };

    vm.closeValidationForm = function () {
      vm.showValidationModal = false;
      vm.validationModalData = false;
    };

    vm.closeValidationIframe = function () {
      vm.validationModalData.showIframe = false;
    };

    function validateFormContent (validateSelected, selectedFile) {
      vm.disableEditorActions = true;
      const main = (vm.actionsModalData && !validateSelected) ? vm.actionsModalData.value : selectedFile.path;
      const formData = new FormData();
      formData.append('path', selectedFile.path);
      formData.append('main', main);
      formData.append('content', editor.getValue());

      resourcesService.getFormParams(formData).success((result) => {
        vm.disableEditorActions = false;

        if (result.notInForm) {
          vm.actionsModalData.disabled = false;
          vm.actionsModalData.error = locales.getLocaleByKey('resources_select_another_form', {
            form: selectedFile.name,
            main: main
          });
        } else {
          if (result.showModal) {
            const formsList = resourcesUtils.getFormsList(vm.directoryTree, selectedFile.path);
            vm.xMenuData = false;
            vm.showActionsModal = true;
            vm.actionsModalData = {
              action: 'form-validation-message',
              message: vm.cannotfindformconfiguration,
              item: selectedFile
            };

            //initSelectElement('.actions-filename', true);
          } else {
            const params = result.params;
            const name = resourcesUtils.getFileNameFormPath(main);
            const extension = resourcesUtils.getFileExtensionFormName({
              type: 'file'
            }, name);
            const slug = name.replace(extension, '');
            if ($cookies.get('form-params-' + slug) && $cookies.get('form-params-' + slug) !== null) {
              try {
                const tempParams = JSON.parse($cookies.get('form-params-' + slug));
                if (tempParams) {
                  for (let i = 0; i < tempParams.length; i++) {
                    let found = false;
                    for (let j = 0; j < params.length; j++) {
                      if (tempParams[i].name === params[j].name) {
                        params[j].value = tempParams[i].value;
                        found = true;
                      }
                    }
                    if (!found && tempParams[i].name !== '') {
                      params.push(tempParams[i]);
                    }
                  }
                }
              } catch (e) {
                console.log(e);
              }
            }
            params.push({
              name: '',
              value: '',
              newParam: true
            });
            vm.showActionsModal = false;
            vm.showValidationModal = true;
            vm.validationModalData = {
              header: locales.getLocaleByKey('add_form_parameters'),
              params: result.params,
              forms: {
                active: selectedFile.path,
                main: main
              }
            };
          }
        }
      }).error((error) => {
        showNotification({ error }, 5000);
      });
    }

    vm.editFile = function (file) {
      if (showWarningModal && !confirm(vm.changesyoumademaynotbesaved)) {
        return false;
      }

      vm.filePreviewPath = false;
      vm.disableEditorActions = false;
      vm.showValidateButton = false;
      vm.showDeleteButton = false;
      vm.showRenameButton = false;
      //Highlight selected item
      resourcesUtils.removePreviewsSelected(vm.directoryTree);
      file.selected = true;

      if (file.status === 'missing') {
        vm.hideNoItemSelected = false;
        showRightContent('preview');
        showNotification({
          text: locales.getLocaleByKey('missing_file'),
          class: 'error'
        }, 8000);
        return;
      }

      vm.selectedItem = file;

      changeUrlParams([{
        key: 'openfile',
        value: file.path,
        action: 'add'
      }]);
      const disabled = (file.actions && file.actions.indexOf(DISABELD_ACTION) !== -1);

      if (imageExtensions.indexOf(file.extension) !== -1) {
        if (utils.useNewApi()) {
          vm.filePreviewPath = file.path + '?resources=true&v=' + new Date().getTime();
        } else {
          vm.filePreviewPath = file.path.replace('public/', '') + '?v=' + new Date().getTime();
        }

        vm.hideNoItemSelected = true;
        vm.loadingItem = false;
        showRightContent('preview');
        return;
      }

      if ((file.actions && (file.actions.indexOf(EDIT_ACTION) !== -1 || file.actions.indexOf(DISABELD_ACTION) !== -1)) || (file.status === RESET_ACTION)) {
        vm.showResetButton = false;
        showRightContent('preview');
        vm.loadingItem = true;
        vm.hideNoItemSelected = true;
        vm.editorErrors = false;
        vm.editorMessage = false;
        editorOpenFilePath = file.path;

        resourcesService.getContent(file).success((result) => {
          vm.hideEditorActions = disabled;

          if (result.editor) {
            activeEditorContent = result.content;
            editor.session.getUndoManager().reset();
            editor.getSession().setMode('ace/mode/' + result.editor);
            if (file.extension.indexOf('.pug') !== -1) {
              editor.setShowInvisibles(true);
            }
          }

          if (file.actions) {
            if (file.actions.indexOf(RESET_ACTION) !== -1) {
              vm.showResetButton = true;
            }
            if (file.actions.indexOf(DELETE_ACTION) !== -1) {
              vm.showDeleteButton = true;
            }
            if (file.actions.indexOf(RENAME_ACTION) !== -1) {
              vm.showRenameButton = true;
            }
          }

          if (file.validatecontent) {
            vm.showValidateButton = true;
          }

          const isBPMN = file.path.split('.').pop() === 'bpmn';
          if (isBPMN) {
            vm.showViewBPMN = true;
          }

          editor.setValue(result.content);

          if (disabled) {
            editor.setReadOnly(true);
          }

          vm.loadingItem = false;
          showRightContent('editor');

          if (file.status === 'system' && !disabled) {
            showNotification({
              text: locales.getLocaleByKey('resources_system_file_message'),
              class: 'warning'
            }, 8000);
          }

          if (file.status === RESET_ACTION) {
            vm.disableEditorActions = true;
            showNotification({
              text: locales.getLocaleByKey('resources_file_content_is_reset'),
              class: 'warning'
            }, 8000);
          }
        }).error((error) => {
          showNotification({ error }, 5000);
        });
      }
    };

    vm.saveFileContent = function () {
      if (!vm.editorErrors && !vm.disableEditorActions) {
        const code = editor.getValue();
        if (code === '') {
          vm.editorErrors = true;
          showNotification({
            text: locales.getLocaleByKey('resources_empty_code_error')
          });
          $timeout(() => {
            vm.editorErrors = false;
          }, 4000);
        } else if (code === activeEditorContent) {
          vm.editorErrors = true;

          showNotification({
            text: locales.getLocaleByKey('resources_content_has_no_changes')
          }, 4000);

          $timeout(() => {
            vm.editorErrors = false;
          }, 4000);
        } else {
          vm.editorErrors = false;
          vm.disableEditorActions = true;

          if ((vm.selectedItem.action === CREATE_ACTION)) {
            createNewFile(vm.selectedItem, editor.getValue());
          } else {
            updatedFileContent(vm.selectedItem, '');
          }
        }
      }
    };

    vm.performItemAction = function (actionObj, item) {
      if (actionObj.action === EDIT_ACTION) {
        vm.editFile(item);
        vm.xMenuData = false;
      } else if (actionObj.action === SUBFOLDER_ACTION) {
        vm.xMenuData = false;
        vm.showActionsModal = true;
        vm.actionsModalData = {
          action: actionObj.action,
          header: actionObj.name,
          value: actionObj.defaultValue,
          item: item
        };
      } else if (actionObj.action === UPLOAD_ACTION) {
        const fileInput = $('#fileInput');
        if (item && item.extensions) {
          fileInput.attr('accept', item.extensions.join(','));
        } else {
          fileInput.attr('accept', '');
        }

        setTimeout(function () {
          $('#openFileInput').trigger('click');
        }, 100);

        vm.xMenuData = false;
        vm.selectedDirectory = item;
      } else if (actionObj.action === DELETE_ACTION) {
        vm.xMenuData = false;

        if (confirm(locales.getLocaleByKey('confirm_message'))) {
          deleteItem(item);
        }
      } else if (actionObj.action === RENAME_ACTION) {
        vm.xMenuData = false;
        vm.showActionsModal = true;
        vm.actionsModalData = {
          action: actionObj.action,
          header: actionObj.name,
          value: item.name.replace(item.extension, ''),
          item: item
        };

        if (item.type === 'file') {
          const parentPath = resourcesUtils.getParentFromPath(item.path);
          const parentData = resourcesUtils.getItemByPath(vm.directoryTree, parentPath);
          if (parentData.allowedfilename) {
            vm.actionsModalData.allowedfilename = parentData.allowedfilename;
            initSelectElement('.actions-filename');
          }
        }
      } else if (actionObj.action === CREATE_ACTION) {
        vm.xMenuData = false;
        vm.showActionsModal = true;
        vm.actionsModalData = {
          action: actionObj.action,
          header: actionObj.name,
          value: '',
          extensions: item.extensions,
          item: item
        };

        if (item.allowedfilename) {
          vm.actionsModalData.allowedfilename = item.allowedfilename;
          initSelectElement('.actions-filename');
        }

        initSelectElement('.actions-extensions');
      } else if (actionObj.action === RESET_ACTION) {
        vm.xMenuData = false;
        resetContent(item);
      }
    };

    vm.closeActionsModal = function () {
      vm.showActionsModal = false;
      vm.actionsModalData = false;
      vm.showLoadingSpinner = false;
    };

    vm.saveActionsModal = function () {
      if (vm.actionsModalData && vm.actionsModalData.disabled && !vm.actionsModalData.item) return;

      const selectedFile = vm.actionsModalData.item;

      if (vm.actionsModalData.action === SUBFOLDER_ACTION) {
        if (resourcesUtils.checkItemName(vm.directoryTree, selectedFile, vm.actionsModalData.value)) {
          vm.actionsModalData.error = locales.getLocaleByKey('directory_exist');
        } else {
          const parentPath = (selectedFile.path === '/') ? '' : selectedFile.path;
          vm.actionsModalData.disabled = true;

          commitMessageModal((commitMessage) => {
            const payload = {
              path: parentPath + '/' + vm.actionsModalData.value,
              name: vm.actionsModalData.value
            };

            if (commitMessage) {
              payload.commitMessage = commitMessage;
            }

            resourcesService.newDirectory(payload).success((result) => {
              if (selectedFile.path === '/') {
                result.level = 1;
                vm.directoryTree.push(result);
                resourcesUtils.sort(vm.directoryTree);
              } else {
                const dir = resourcesUtils.getItemById(vm.directoryTree, selectedFile.id);
                if (dir.children) {
                  dir.children.push(result);
                } else {
                  dir.children = [result];
                }
                resourcesUtils.sort(dir.children);
              }

              vm.closeActionsModal();
              showNotification({
                text: locales.getLocaleByKey('resources_directory_created'),
                class: 'success'
              });
            }).error((error) => {
              showNotification({ error }, 5000);
            });
          });
        }
      } else if (vm.actionsModalData.action === RENAME_ACTION) {
        if (vm.actionsModalData.value === '') {
          vm.actionsModalData.error = locales.getLocaleByKey('resources_required_name');
        } else {
          selectedFile.newPath = vm.actionsModalData.value;
          const newPath = resourcesUtils.getNewItemPath(selectedFile);
          const renamedItem = resourcesUtils.getItemByPath(vm.directoryTree, newPath);

          if (selectedFile.path === newPath) {
            vm.actionsModalData.error = locales.getLocaleByKey('resources_different_name');
          } else if (renamedItem) {
            vm.actionsModalData.error = locales.getLocaleByKey('resources_name_exist');
          } else {
            vm.actionsModalData.disabled = true;
            renameFilePath(selectedFile);
          }
        }
      } else if (vm.actionsModalData.action === CREATE_ACTION) {
        if (vm.actionsModalData.value === '') {
          vm.actionsModalData.error = locales.getLocaleByKey('resources_required_name');
        } else if (vm.actionsModalData.extension === '') {
          vm.actionsModalData.error = locales.getLocaleByKey('resources_required_extension');
        } else {
          if (selectedFile.extensions && selectedFile.extensions.indexOf(vm.actionsModalData.extension) === -1) {
            showNotification({
              text: locales.getLocaleByKey('resources_file_type_not_allowed')
            });
            return;
          }

          if (selectedFile.allowedfilename && selectedFile.allowedfilename.indexOf(vm.actionsModalData.value) === -1) {
            showNotification({
              text: locales.getLocaleByKey('resources_file_name_not_allowed')
            });
            return;
          }

          const fileName = vm.actionsModalData.value + (vm.actionsModalData.extension || '');
          if (resourcesUtils.checkItemName(vm.directoryTree, selectedFile, fileName)) {
            vm.actionsModalData.error = locales.getLocaleByKey('resources_file_exist');
          } else {
            vm.actionsModalData.disabled = true;
            createNewCustomFile(vm.actionsModalData, selectedFile);
          }
        }
      } else if (vm.actionsModalData.action === VALIDATE_ACTION) {
        if (vm.actionsModalData.value === '') {
          vm.actionsModalData.error = locales.getLocaleByKey('resources_select_form');
        } else {
          vm.actionsModalData.disabled = true;
          validateFormContent(false, selectedFile);
        }
      }
    };

    function saveFileInput (file, selectedFile) {
      vm.selectedDirectory = null;
      let exist = false;

      if (selectedFile.children && selectedFile.children.length > 0) {
        for (let i = 0; i < selectedFile.children.length; i++) {
          if (selectedFile.children[i].name === file.name) {
            exist = true;
          }
        }
      }

      let fileName = file.name;
      const extension = resourcesUtils.getFileExtensionFormName({
        type: 'file'
      }, fileName);
      fileName = fileName.replace(extension, '');

      if (selectedFile.extensions && selectedFile.extensions.indexOf(extension) === -1) {
        showNotification({
          text: locales.getLocaleByKey('resources_file_type_not_allowed')
        });
        return;
      }

      if (selectedFile.allowedfilename && selectedFile.allowedfilename.indexOf(fileName) === -1) {
        showNotification({
          text: locales.getLocaleByKey('resources_file_name_not_allowed')
        });
        return;
      }

      const parentPath = (selectedFile.path === '/') ? '' : selectedFile.path;

      if (exist) {
        if (selectedFile.actions && selectedFile.actions.indexOf(REPLACE_ACTION) !== -1) {
          updatedFileContent({
            directory: selectedFile.path,
            path: parentPath + '/' + file.name,
            replace: true,
            upload: true
          }, file);
        } else {
          showNotification({
            text: locales.getLocaleByKey('resources_file_exist')
          });
        }
      } else {
        createNewFile({
          directory: selectedFile.path,
          path: parentPath + '/' + file.name,
          parentId: selectedFile.id,
          upload: true
        }, file);
      }
    }

    $document.on('click', (event) => {
      vm.$apply(function () {
        if ($(event.target).closest('.x-dropdown-menu').length !== 0 || $(event.target).hasClass('x-dropdown-menu')) {
          return false;
        }
        if ($(event.target).closest('.nodeMenu').length !== 0 || $(event.target).hasClass('nodeMenu')) {
          return false;
        }

        vm.xMenuData = false;
      });
    });

    $('.x-layout-split').draggable({
      axis: 'x',
      containment: 'parent',
      scroll: false,
      addClasses: true,
      drag: function (event, ui) {
        const left = ui.position.left;
        if (left < 250 || left > 500) {
          return false;
        }
        const windowWidth = $(window).width();
        $('.tree-region').css({width: left + 'px'});
        $('.right-content-main').css({width: (windowWidth - (left + 5)) + 'px'});
        editor.resize();
      }
    });

    $('#fileInput').change(function () {
      const file = $('#fileInput')[0].files[0];
      if (file) {
        vm.$apply(() => {
          saveFileInput(file, vm.selectedDirectory);
          document.getElementById('fileInput').value = '';
        });
      }
    });

    function showNotification(obj, timeout) {
      if (obj.error) {
        const text = obj.error.description || obj.error.message || (obj.error.error && obj.error.error.message) || 'Something went terribly wrong!';
        vm.editorMessage = {
          text: text,
          class: 'error',
        };
      } else {
        vm.editorMessage = obj;
      }

      $timeout(() => {
        vm.editorMessage = false;
      }, (timeout) ? timeout : 4000);
    }

    vm.viewBpmn = function() {
      const content = editor.getValue();
      if (!content || content === '') return;

      $uibModal.open({
        templateUrl: 'app/common/directives/admin/manage/view.bpmn.html?v=' + config.version,
        controller: 'viewBPMNModalController',
        size: 'lg',
        windowClass: 'view-bpmn-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          item: function() {
            return { bpmn: content };
          },
          dialogOnCancel: function() {
            return function() {};
          }
        }
      });
    };
  }
})();

(function() {

  angular
    .module('onify')
    .directive('adminResources', adminResources);

  adminResources.$inject = ['config'];
  function adminResources(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/admin/resources/resources.template.html?v=' + config.version,
      controller: "resourcesController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('agentTaskLogController', agentTaskLogController);

  agentTaskLogController.$inject = ['$scope', '$interval', 'utils', 'locales', 'taskService'];

  function agentTaskLogController($scope, $interval, utils, locales, taskService) {
    let vm = $scope;
    const autorefresh = (vm.taskid && vm.autorefresh) ? Number(vm.autorefresh) : 1000;
    const somethingwentwrong = locales.getLocaleByKey('something_went_wrong');
    vm.stop = false;
    vm.taskError = (!vm.taskid) ? locales.getLocaleByKey('task_id_is_not_set') : '';

    function getTaskResult() {
      if (vm.stop) return;
      taskService.getTaskLogs(vm.taskid).success((data) => {
        vm.logs = data.log;
        if (data.result) {
          vm.stop = true;
          if (vm.stopInterval) {
            $interval.cancel(vm.stopInterval);
          }
        }
      }).error((err) => {
        vm.stop = true;
        if (err && err.error && err.error.message) {
          vm.taskError = err.error.message;
        } else {
          vm.taskError = somethingwentwrong;
        }
        if (vm.stopInterval) {
          $interval.cancel(vm.stopInterval);
        }
      });
    }

    if (vm.taskid) {
      if (autorefresh === 0) {
        getTaskResult();
      } else {
        vm.stopInterval = $interval(getTaskResult, autorefresh);
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('agentTaskLog', agentTaskLog);

  agentTaskLog.$inject = ['config'];
  function agentTaskLog(config) {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        taskid: '@',
        autorefresh: '@',
        hidetimestamp: '@'
      },
      templateUrl: 'app/common/directives/form-elements/agent-task-logs/template.html?v=' + config.version,
      controller: "agentTaskLogController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('agentTaskSubmitResultController', agentTaskSubmitResultController);

  agentTaskSubmitResultController.$inject = ['$rootScope', '$scope', '$interval', '$timeout', 'config', 'utils', 'locales', 'taskService', 'errorService'];

  function agentTaskSubmitResultController($rootScope, $scope, $interval, $timeout, config, utils, locales, taskService, errorService) {
    let vm = $scope;
    const error = 'error';
    const success = 'success';
    const autorefresh = (vm.taskid && vm.autorefresh) ? Number(vm.autorefresh) : 1000;
    const loadingText = (vm.loadingtext) ? vm.loadingtext : '...';
    const somethingwentwrong = locales.getLocaleByKey('something_went_wrong');

    vm.copytabletoclipboard = locales.getLocaleByKey('copy_table_to_clipboard');
    vm.copiedtoclipboard = locales.getLocaleByKey('copied_to_clipboard');
    vm.taskResult = (vm.taskid) ? loadingText : locales.getLocaleByKey('task_id_is_not_set');
    vm.taskClass = (vm.taskid) ? '' : error;
    vm.percent = 2;
    vm.copiedMessage = false;
    vm.stoped = $rootScope.errorRedirect || false;
    vm.hideCopyToClipboard = !(vm.hidecopytoclipboard === 'false');
    vm.allowExecuteScripts = (vm.allowscripts === 'true');

    function isBase64(str) {
      try {
        return btoa(atob(str)) === str;
      } catch (err) {
        return false;
      }
    }

    function base64Decode (str) {
      return isBase64(str) ? atob(str) : str;
    }

    function getTaskResult() {
      $rootScope.$broadcast('agent_task_result', {
        type: 'inProgress',
        taskid: vm.taskid
      });

      taskService.getTaskResult(vm.taskid).success((result) => {
        if (utils.objectLength(result) > 0) {
          if (vm.stoped || $rootScope.errorRedirect) return;
          if (result.statuscode === 408) {
            vm.stoped = true;
            $rootScope.errorRedirect = true;
            errorService.save({
              statusCode: result.statuscode,
              error: {
                message: result.statusmessage
              }
            }).success(() => {
              window.location.href = config.errorPage;
            });
            return;
          }

          vm.taskClass = (result.statuscode === 200) ? success : error;
          if (result.response) {
            if (vm.tableheader && vm.format === 'table' && result.statuscode === 200) {
              vm.tableheader = vm.tableheader.split(',');
              try {
                vm.tableResult = JSON.parse(result.response);
              } catch (e) {
                vm.taskResult = result.response;
                vm.format = '';
              }
            } else {
              vm.taskResult = base64Decode(result.response);
            }
          } else {
            vm.taskResult = result.statusmessage;
          }

          vm.percent = 100;

          $rootScope.$broadcast('agent_task_result', {
            type: 'completed',
            taskid: vm.taskid
          });
          if (vm.stopInterval) {
            $interval.cancel(vm.stopInterval);
            $interval.cancel(vm.percentageInterval);
          }
        }
      }).error((err) => {
        vm.percent = 100;
        if (vm.stopInterval) {
          $interval.cancel(vm.stopInterval);
          $interval.cancel(vm.percentageInterval);
        }
        if (err && err.error && err.error.message) {
          vm.taskResult = err.error.message;
        } else {
          vm.taskResult = somethingwentwrong;
        }
        vm.taskClass = error;
        $rootScope.$broadcast('agent_task_result', {
          type: 'completed',
          taskid: vm.taskid
        });
      });
    }

    function percentageInterval() {
      if (vm.percent >= 98) {
        vm.percent = 2;
      } else {
        vm.percent += 2;
      }
    }

    vm.copyToClipboard = () => {
      const delimiter = '\t';
      const newLine = '\n';
      let txt = '';
      function fixValue(val) {
        if (val.match && (val.match(/,/g) || val.match(/\n/) || val.match(/\"/))) {
          // Scape double quotes
          val = val.replace(new RegExp('"', 'g'), '""');
          val = '"' + val + '"';
        }
        return val;
      }
      for (let j = 0; j < vm.tableheader.length; j++) {
        txt += `${fixValue(vm.tableheader[j])}`;
        if (j !== (vm.tableheader.length - 1)) {
          txt += `${delimiter}`;
        } else {
          txt += `${newLine}`;
        }
      }
      for (let i = 0; i < vm.tableResult.length; i++) {
        for (let j = 0; j < vm.tableheader.length; j++) {
          if (vm.tableResult[i][vm.tableheader[j]]) {
            txt += `${fixValue(vm.tableResult[i][vm.tableheader[j]])}`;
          } else {
            txt += ``;
          }
          if (j !== (vm.tableheader.length - 1)) {
            txt += `${delimiter}`;
          } else {
            txt += `${newLine}`;
          }
        }
      }

      let textarea = $('<textarea class="copy_to_clipboard" style="position: absolute; left: -9999px"/>');
      if($('.copy_to_clipboard').length > 0){
        textarea = $('.copy_to_clipboard');
      }
      $('.table-result .table-actions').append(textarea);
      $(textarea).val(txt);
      $(textarea).select();
      document.execCommand("copy");

      vm.copiedMessage = true;
      $timeout(() => {
        vm.copiedMessage = false;
      }, 2000);
    };

    if (vm.taskid) {
      if (autorefresh === 0) {
        getTaskResult();
      } else {
        vm.stopInterval = $interval(getTaskResult, autorefresh);
        vm.percentageInterval = $interval(percentageInterval, 200);
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('agentTaskSubmitResult', agentTaskSubmitResult);

  agentTaskSubmitResult.$inject = ['config'];
  function agentTaskSubmitResult(config) {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        taskid: '@',
        format: '@',
        autorefresh: '@',
        loadingtext: '@',
        tableheader: '@',
        hidecopytoclipboard: '@',
        allowscripts: '@'
      },
      templateUrl: 'app/common/directives/form-elements/agent-task-submit-result/template.html?v=' + config.version,
      controller: "agentTaskSubmitResultController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('processOutputController', processOutputController);

  processOutputController.$inject = ['$rootScope', '$scope', '$interval', '$timeout', 'config', 'utils', 'locales', 'processesService'];
  function processOutputController($rootScope, $scope, $interval, $timeout, config, utils, locales, processesService) {
    const vm = $scope;
    const error = 'error';
    const success = 'success';
    const defaultAutoRefresh = 1000;
    const autorefresh = (vm.autorefresh && Number(vm.autorefresh) >= defaultAutoRefresh) ? Number(vm.autorefresh) : 1000;
    const loadingText = (vm.loadingtext) ? vm.loadingtext : '...';
    const somethingwentwrong = locales.getLocaleByKey('something_went_wrong');

    vm.copytabletoclipboard = locales.getLocaleByKey('copy_table_to_clipboard');
    vm.copiedtoclipboard = locales.getLocaleByKey('copied_to_clipboard');
    vm.processResult = (vm.processid) ? loadingText : locales.getLocaleByKey('process_id_is_not_set');
    vm.processClass = (vm.processid) ? '' : error;
    vm.percent = vm.processid ? 2 : 100;
    vm.copiedMessage = false;
    vm.stoped = $rootScope.errorRedirect || false;
    vm.hideCopyToClipboard = !(vm.hidecopytoclipboard === 'false');

    function getProcess() {
      $rootScope.$broadcast('process_output_result', {
        type: 'inProgress',
        processid: vm.processid
      });

      processesService.getProcessesOutput(vm.processid).success((result) => {
        if (vm.stoped || $rootScope.errorRedirect) return;
        vm.processResult = '';

        if (result.output) {
          const output = vm.outputvariable ? result.output[vm.outputvariable] : result.output;

          if (output) {
            if (vm.tableheader && vm.format === 'table') {
              vm.tableheader = vm.tableheader.split(',');
              try {
                vm.tableResult = JSON.parse(output);
              } catch (e) {
                vm.tableResult = output;
              }
            } else {
              vm.processResult = output;
            }
          }
        }

        if (result.status && result.status.name && result.status.name !== 'Running') {
          $interval.cancel(vm.stopInterval);
          $interval.cancel(vm.percentageInterval);
          vm.processClass = (result.status && result.status.error) ? error : success;
          vm.percent = 100;

          $rootScope.$broadcast('process_output_result', {
            type: 'completed',
            processid: vm.processid
          });

          if (!result.output) {
            vm.processResult = '';
          }
        }

        if (vm.format === 'html' && !utils.isString(vm.processResult)) {
          vm.processResult = JSON.stringify(vm.processResult);
        }
      }).error((err) => {
        vm.percent = 100;
        $interval.cancel(vm.stopInterval);
        $interval.cancel(vm.percentageInterval);
        if (err && err.error && err.error.message) {
          vm.processResult = err.error.message;
        } else {
          vm.processResult = somethingwentwrong;
        }
        vm.processClass = error;
        $rootScope.$broadcast('process_output_result', {
          type: 'completed',
          processid: vm.processid
        });
      });
    }

    function percentageInterval() {
      if (vm.percent <= 90) {
        vm.percent += 2;
      } else {
        vm.percent = 20;
      }
    }

    vm.copyToClipboard = () => {
      const delimiter = '\t';
      const newLine = '\n';
      let txt = '';
      function fixValue(val) {
        if (val.match && (val.match(/,/g) || val.match(/\n/) || val.match(/\"/))) {
          // Scape double quotes
          val = val.replace(new RegExp('"', 'g'), '""');
          val = '"' + val + '"';
        }
        return val;
      }
      for (let j = 0; j < vm.tableheader.length; j++) {
        txt += `${fixValue(vm.tableheader[j])}`;
        if (j !== (vm.tableheader.length - 1)) {
          txt += `${delimiter}`;
        } else {
          txt += `${newLine}`;
        }
      }
      for (let i = 0; i < vm.tableResult.length; i++) {
        for (let j = 0; j < vm.tableheader.length; j++) {
          if (vm.tableResult[i][vm.tableheader[j]]) {
            txt += `${fixValue(vm.tableResult[i][vm.tableheader[j]])}`;
          } else {
            txt += ``;
          }
          if (j !== (vm.tableheader.length - 1)) {
            txt += `${delimiter}`;
          } else {
            txt += `${newLine}`;
          }
        }
      }

      let textarea = $('<textarea class="copy_to_clipboard" style="position: absolute; left: -9999px"/>');
      if ($('.copy_to_clipboard').length > 0) {
        textarea = $('.copy_to_clipboard');
      }
      $('.table-result .table-actions').append(textarea);
      $(textarea).val(txt);
      $(textarea).select();
      document.execCommand('copy');

      vm.copiedMessage = true;
      $timeout(() => {
        vm.copiedMessage = false;
      }, 2000);
    };

    if (vm.processid) {
      if (autorefresh === 0) {
        getProcess();
      }

      if (autorefresh >= 1000) {
        vm.stopInterval = $interval(getProcess, autorefresh);
        vm.percentageInterval = $interval(percentageInterval, 500);
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('processOutput', processOutput);

  processOutput.$inject = ['config'];
  function processOutput(config) {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        processid: '@',
        format: '@',
        outputvariable: '@',
        autorefresh: '@',
        loadingtext: '@',
        tableheader: '@',
        hidecopytoclipboard: '@',
      },
      templateUrl: 'app/common/directives/form-elements/process-output/template.html?v=' + config.version,
      controller: "processOutputController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('runWorkflowController', runWorkflowController);

  runWorkflowController.$inject = ['$rootScope', '$scope', '$http', '$timeout', 'config', 'utils'];

  function runWorkflowController($rootScope, $scope, $http, $timeout, config, utils) {
    const timeout = Number($scope.timeout);

    function getFormData(inputStr) {
      return new Promise((resolve, reject) => {
        let input = null;

        if (inputStr) {
          try {
            input = JSON.parse(inputStr);
          } catch (error) {
            return reject(error);
          }
        }

        $scope.$on('run_workflow', (event, {parsed, error} = {}) => {
          if (error) {
            return reject(error);
          }
          resolve(parsed);
        });

        $rootScope.$broadcast('form_data_request', {
          requestedBy: 'run_workflow',
          input,
        });
      });
    }

    const runWorkflowRequest = function(workflow, input) {
      return $http({
        method: 'POST',
        url: config.apiBaseUrl + `/my/workflows/run/${workflow}`,
        headers: {
          Authorization: Cookies.get('Auth')
        },
        params: {
          timeout,
        },
        data: input
      });
    };

    function run() {
      $scope.inProgress = true;
      $scope.errorMessage = null;

      getFormData($scope.input).then((input) => {
        runWorkflowRequest($scope.workflow, input).success((result) => {
          $scope.inProgress = false;
          $scope.errorMessage = null;

          $rootScope.$broadcast('trigger_form_data_change', {
            name: $scope.name,
            data: result.output,
            excludeAsParameter: true,
          });

          const output = Array.isArray(result.output) || utils.isObject(result.output) ? JSON.stringify(result.output) : result.output;
          $(`input[name=${$scope.name}]`).val(output);
        }).error((error) => {
          $scope.errorMessage = error.message;
          $scope.inProgress = false;
        });
      }).catch((error) => {
        $scope.$apply(() => {
          $scope.errorMessage = error.message;
          $scope.inProgress = false;
        });
      });
    }

    $scope.runWorkflow = run;
  }

})();

(function() {

  angular
    .module('onify')
    .directive('runWorkflow', runWorkflow);

  runWorkflow.$inject = ['config'];
  function runWorkflow(config) {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        name: '@',
        label: '@',
        buttonlabel: '@',
        workflow: '@',
        timeout: '@',
        input: '@'
      },
      templateUrl: 'app/common/directives/form-elements/run-workflow/template.html?v=' + config.version,
      controller: "runWorkflowController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('starRatingController', starRatingController);

  starRatingController.$inject = ['$scope', '$rootScope'];

  function starRatingController($scope, $rootScope) {
    const updateStars = function() {
      $scope.ratingValue = ($scope.ratingValue) ? $scope.ratingValue : 0;
      $scope.stars = [];
      for (let i = 0; i < $scope.ratingLevels; i++) {
        $scope.stars.push({
          filled: i < $scope.ratingValue
        });
      }
    };

    $scope.toggle = function(index) {
      if ($scope.ratingReadonly && $scope.ratingReadonly === 'true') return;
      $scope.ratingValue = index + 1;
      $rootScope.$broadcast('star_rating_value', {
        rating: index + 1,
        name: $scope.ratingName
      });
      updateStars();
    };

    updateStars();
  }

})();
(function() {

  angular
    .module('onify')
    .directive('starRating', starRating);

  starRating.$inject = ['config'];

  function starRating(config) {
    return {
      restrict: 'EA',
      templateUrl: 'app/common/directives/form-elements/star-rating/template.html?v=' + config.version,
      scope: {
        ratingName: '@',
        ratingLevels: '@',
        ratingValue: '@',
        ratingSize: '@',
        ratingIcon: '@',
        ratingReadonly: '@'
      },
      controller: "starRatingController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('sidebarBottomController', sidebarBottomController);

  sidebarBottomController.$inject = ['$scope', 'widgets'];
  function sidebarBottomController($scope, widgets) {
    let vm = $scope;

    //get available widgets for this sidebar
    vm.$watch(() => {
      return widgets.watchChanges('sidebarBottom');
    }, () => {
      vm.activeWidgetsBottom = widgets.checkNavBarSupportOnMobile(widgets.get('sidebarBottom'));
    });
  }

})();
(function() {

  angular
    .module('onify')
    .directive('sidebarBottom', sidebarBottom);

  function sidebarBottom() {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/sidebars/sidebar-bottom/sidebar.bottom.template.html',
      controller: "sidebarBottomController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('sidebarLeftController', sidebarLeftController);

  sidebarLeftController.$inject = ['$scope', '$timeout', '$window', 'config', 'widgets'];
  function sidebarLeftController($scope, $timeout, $window, config, widgets) {
    const vm = $scope;

    //on scroll change sidebar position
    angular.element($window).on('scroll', () => {
      makeSidebarFixed();
    });

    //get available widgets for this sidebar
    vm.$watch(() => {
      return widgets.watchChanges('sidebarLeft');
    }, () => {
      vm.activeWidgetsLeft = widgets.checkNavBarSupportOnMobile(widgets.get('sidebarLeft'));
      $timeout(() => {
        $('[rel~=tooltip]').tooltip();
        makeSidebarFixed();
      }, 10);
    });

    vm.$watch(() => {
      return widgets.watchChanges('sidebarTop');
    }, () => {
      vm.activeWidgetsSidebarTop = widgets.get('sidebarTop');
      vm.isActiveSidebarTop = vm.activeWidgetsSidebarTop.length;
      makeSidebarFixed();
    });

    //change sidebar position make it fixed on scroll
    function makeSidebarFixed() {
      const sidebar = $(config.domElements.sidebar);
      const sidebarWidth = sidebar.outerWidth();
      const scroll = $($window).scrollTop();
      let metaWigetActive = false;
      vm.moveSidebarTop = false;

      for (let i = 0; i < vm.activeWidgetsSidebarTop.length; i++) {
        if (vm.activeWidgetsSidebarTop[i].name === 'meta') {
          metaWigetActive = true;
        }
      }

      if(!vm.isActiveSidebarTop){
        vm.moveSidebarTop = true;
      } else if(metaWigetActive && vm.isActiveSidebarTop > 1){
        vm.moveSidebarTop = true;
      } else if(!metaWigetActive && vm.isActiveSidebarTop >= 1){
        vm.moveSidebarTop = true;
      }

      const maxScroll = (!vm.moveSidebarTop) ? 155 : 130;

      if (sidebarWidth && scroll) {
        if (scroll >= maxScroll) {
          sidebar.addClass('fixed');
          sidebar.css({width: sidebarWidth + 'px'});
        } else {
          sidebar.removeClass('fixed');
          sidebar.attr('style', '');
        }
      } else {
        sidebar.removeClass('fixed');
        sidebar.attr('style', '');
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('sidebarLeft', sidebarLeft);

  sidebarLeft.$inject = ['config'];
  function sidebarLeft(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/sidebars/sidebar-left/sidebar.left.template.html?v=' + config.version,
      controller: "sidebarLeftController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('sidebarRightController', sidebarRightController);

  sidebarRightController.$inject = ['$scope', '$timeout', '$window', 'config', 'widgets'];
  function sidebarRightController($scope, $timeout, $window, config, widgets) {
    const vm = $scope;

    //on scroll change sidebar position
    angular.element($window).on('scroll', () => {
      makeSidebarFixed();
    });

    //get available widgets for this sidebar
    vm.$watch(() => {
      return widgets.watchChanges('sidebarRight');
    }, () => {
      vm.activeWidgetsRight = widgets.checkNavBarSupportOnMobile(widgets.get('sidebarRight'));
      $timeout(() => {
        $('[rel~=tooltip]').tooltip();
        makeSidebarFixed();
      }, 10);
    });

    vm.$watch(() => {
      return widgets.watchChanges('sidebarTop');
    }, () => {
      vm.activeWidgetsSidebarTop = widgets.get('sidebarTop');
      vm.isActiveSidebarTop = vm.activeWidgetsSidebarTop.length;
      makeSidebarFixed();
    });

    //change sidebar position make it fixed on scroll
    function makeSidebarFixed() {
      const sidebar = $(config.domElements.sidebar);
      const sidebarWidth = sidebar.outerWidth();
      const scroll = $($window).scrollTop();
      let metaWigetActive = false;
      vm.moveSidebarTop = false;

      for (let i = 0; i < vm.activeWidgetsSidebarTop.length; i++) {
        if (vm.activeWidgetsSidebarTop[i].name === 'meta') {
          metaWigetActive = true;
        }
      }

      if(!vm.isActiveSidebarTop){
        vm.moveSidebarTop = true;
      } else if(metaWigetActive && vm.isActiveSidebarTop > 1){
        vm.moveSidebarTop = true;
      } else if(!metaWigetActive && vm.isActiveSidebarTop >= 1){
        vm.moveSidebarTop = true;
      }

      const maxScroll = (!vm.moveSidebarTop) ? 155 : 130;

      if (sidebarWidth && scroll) {
        if (scroll >= maxScroll) {
          sidebar.addClass('fixed');
          sidebar.css({width: sidebarWidth + 'px'});
        } else {
          sidebar.removeClass('fixed');
          sidebar.attr('style', '');
        }
      } else {
        sidebar.removeClass('fixed');
        sidebar.attr('style', '');
      }
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('sidebarRight', sidebarRight);

  sidebarRight.$inject = ['config'];
  function sidebarRight(config) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/sidebars/sidebar-right/sidebar.right.template.html?v=' + config.version,
      controller: "sidebarRightController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('sidebarTopController', sidebarTopController);

  sidebarTopController.$inject = ['$scope', 'widgets'];
  function sidebarTopController($scope, widgets) {
    let vm = $scope;

    //get available widgets for this sidebar
    vm.$watch(() => {
      return widgets.watchChanges('sidebarTop');
    }, () => {
      vm.activeWidgetsTop = widgets.checkNavBarSupportOnMobile(widgets.get('sidebarTop'));
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('sidebarTop', sidebarTop);

  function sidebarTop() {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/common/directives/sidebars/sidebar-top/sidebar.top.template.html',
      controller: "sidebarTopController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('bulletinWidgetController', bulletinWidgetController);

  bulletinWidgetController.$inject = ['$scope', 'widgets', 'bulletinService'];
  function bulletinWidgetController($scope, widgets, bulletinService) {
    $scope.bulletinData = null;
    $scope.bulletinColor = 'info';

    const bulletinWidget = widgets.getWidgetByName($scope.widgetName);

    if (bulletinWidget && bulletinWidget.bulletin) {
      bulletinService.get(bulletinWidget.bulletin)
        .success((result) => {
          $scope.bulletinData = result;

          if (result.status) {
            if (result.status.toUpperCase() === 'CRITICAL') {
              $scope.bulletinColor = 'danger';
            } else if (result.status.toUpperCase() === 'WARNING') {
              $scope.bulletinColor = 'warning';
            }
          }
        })
        .error(() => {
          widgets.updateWidget(0, $scope.widgetName);
        });
    }
  }

})();

(function() {

  angular
    .module('onify')
    .directive('bulletinWidget', bulletin);

  function bulletin() {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        widgetName: '@'
      },
      templateUrl: 'app/common/directives/widgets/bulletin/bulletin.template.html',
      controller: "bulletinWidgetController"
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('filtersController', filtersController);

  filtersController.$inject = ['$scope', 'queryStringService'];
  function filtersController($scope, queryStringService) {
    let vm = $scope;

    vm.$watch(() => {
      return queryStringService.watchChanges();
    }, () => {
      //get filters if they are set
      vm.filters = queryStringService.getFilters();
    });

    vm.removeFilter = (obj) => {
      queryStringService.removeFilter(obj.filter);
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('filters', filters);

  function filters() {
    return {
      restrict: 'EA',
      transclude: false,
      scope: {
        filter: '=filterData'
      },
      templateUrl: 'app/common/directives/widgets/filters/filters.template.html',
      controller: "filtersController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('metaWidgetController', metaWidgetController);

  metaWidgetController.$inject = ['$scope', '$location', '$rootScope', '$timeout', '$cookies', 'config', 'itemSelection', 'locales', 'itemsData', 'queryStringService', 'utils', 'getItemTemplate'];

  function metaWidgetController($scope, $location, $rootScope, $timeout, $cookies, config, itemSelection, locales, itemsData, queryStringService, utils, getItemTemplate) {
    let vm = $scope;
    const workspace = $(config.domElements.currentWorkspaceId);
    const pagesize = ($location.search().hasOwnProperty('pagesize')) ? $location.search().pagesize : config.workspaceResultsPageSize;

    vm.allowedExport = workspace.attr("data-export");
    vm.resultsText = locales.getLocaleByKey('results');
    vm.deselectallText = locales.getLocaleByKey('deselect_all');
    vm.viewText = locales.getLocaleByKey('view');
    vm.cardsText = locales.getLocaleByKey('cards');
    vm.tableText = locales.getLocaleByKey('table');
    vm.exportMessage = locales.getLocaleByKey('export_current_result');
    vm.exportisnotsupported = locales.getLocaleByKey('export_is_not_supported');
    vm.exportlimit = locales.getLocaleByKey('export_limit');
    vm.disabledExport = false;

    vm.sortFields = [{
      name: locales.getLocaleByKey('name'),
      key: 'name.lower',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('key'),
      key: 'key',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('created_date'),
      key: 'createdate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('modified_date'),
      key: 'modifieddate',
      availableSorts: ['asc', 'desc'],
      defaultSort: 'asc'
    }, {
      name: locales.getLocaleByKey('relevance'),
      key: '_score',
      availableSorts: ['desc'],
      defaultSort: 'desc',
      default: true
    }];

    vm.activePageSize = 10;
    vm.pageSizeFields = [{
      name: '10',
      value: 10
    }, {
      name: '25',
      value: 25
    }, {
      name: '50',
      value: 50
    }];

    if (pagesize) {
      let add = true;
      for (let i = 0; i < vm.pageSizeFields.length; i++) {
        if (vm.pageSizeFields[i].value === Number(pagesize)) {
          add = false;
        }
      }

      if (add) {
        vm.pageSizeFields.push({
          name: pagesize,
          value: Number(pagesize)
        });
        vm.activePageSize = Number(pagesize);
      }
    }

    vm.$watch(() => {
      return queryStringService.watchChanges();
    }, () => {
      const params = queryStringService.getQueryString();
      if (params.pagesize) {
        vm.activePageSize = Number(params.pagesize);
      }
    });

    vm.pageSizeFields.sort((a, b) => {
      if (a.value < b.value)
        return -1;
      if (a.value > b.value)
        return 1;
      return 0;
    });

    const params = $location.search();
    vm.activeView = (params.view) ? params.view : 'cards';

    //show view button only if table templates are loaded
    vm.showViewButton = getItemTemplate.getLoadedStatus('table');

    function changeSelectAllButton() {
      if (!vm.totalActiveSelections) {
        if (vm.totalresults == vm.totalLoadedSelection) {
          vm.selectallText = locales.getLocaleByKey('select_all');
        } else {
          vm.selectallText = locales.getLocaleByKey('select_x_of_y', {
            x: vm.totalLoadedSelection,
            y: vm.totalresults
          });
        }
      }
    }

    vm.$watch(() => {
      return itemSelection.getTotalLoadedSelection();
    }, () => {
      vm.totalLoadedSelection = itemSelection.getTotalLoadedSelection();
      changeSelectAllButton();
    });

    //Reactive variable to show total number of items
    vm.$watch(() => {
      return itemsData.getItemsLoaded();
    }, () => {
      vm.totalresults = itemsData.totalResults();
      vm.itemsLoaded = itemsData.getItemsLoaded();
      changeSelectAllButton();
    });

    //is any reactive variable to check if there is any item with selection
    vm.$watch(() => {
      return itemSelection.showSelectAllButton();
    }, () => {
      vm.showSelectAll = itemSelection.showSelectAllButton();
    });

    vm.selectAll = () => {
      itemSelection.selectAll();
    };

    vm.deselectAll = () => {
      itemSelection.deselectAll(true);
    };

    //is any reactive variable to show selectAll or deselectAll button for selection
    vm.$watch(() => {
      return itemSelection.watchChanges();
    }, () => {
      vm.totalActiveSelections = itemSelection.getNames().length;
    });

    $('.view-option-content .dropdown-menu a').click(function() {
      const view = $(this).attr('data-view');
      const params = queryStringService.getQueryString();
      let viewChanged = false;

      if (params.view && view != params.view) {
        delete params.view;
        viewChanged = true;
      } else if (!params.view && view !== 'cards') {
        params.view = view;
        viewChanged = true;
      }

      if (viewChanged) {
        utils.safeApply(vm, () => {
          $rootScope.$broadcast('result_on_view_change', view);
          queryStringService.updateQueryString(params);
          vm.activeView = view;
        });
      }
    });

    function exportLink() {
      const exportLinkParams = itemsData.filterParams(params);
      exportLinkParams.export = 'csv';
      return `/workspace/${vm.workspaceSlug}/export?${utils.createUriFromObject(exportLinkParams)}`;
    }

    vm.getExportLink = () => {
      return exportLink();
    };

    vm.exportResult = (e) => {
      e.preventDefault();
      const anchor = angular.element('<a/>');
      anchor.attr({
        href: exportLink(),
        target: '_blank',
        download: 'export'
      })[0].click();
      anchor.remove();
    };

    vm.changeResultPageSize = (obj) => {
      if (obj.value !== vm.activePageSize) {
        utils.safeApply(vm, () => {
          vm.activePageSize = obj.value;
          $rootScope.$broadcast('result_on_page_size_change', obj.value);
        });
      }
    };

    vm.addExportTime = () => {
      vm.disabledExport = true;
      // vm.exportisnotsupported = locales.getLocaleByKey('export_limit');
      $timeout(() => {
        vm.disabledExport = false;
        // vm.exportisnotsupported = locales.getLocaleByKey('export_is_not_supported');
      }, 4000);

      // $timeout(() => {
      //   $cookies.put('export_limit', 'true', {
      //     expires: moment().add(1, 'minutes').format()
      //   });
      // }, 3000);
    };

    // if ($cookies.get('export_limit')) {
    //   vm.addExportTime();
    // }
  }

})();
(function() {

  angular
    .module('onify')
    .directive('metaWidget', metaWidget);

  metaWidget.$inject = ['config'];
  function metaWidget(config) {
    return {
      restrict: 'EA',
      transclude: false,
      templateUrl: 'app/common/directives/widgets/meta/meta.template.html?v=' + config.version,
      controller: "metaWidgetController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('tagCloudController', tagCloudController);

  tagCloudController.$inject = ['$scope', 'tagCloudService', 'queryStringService'];
  function tagCloudController($scope, tagCloudService, queryStringService) {
    let vm = $scope;

    vm.$watch(() => {
      return tagCloudService.watchChanges();
    }, () => {
      //get tags
      vm.tagCloud = tagCloudService.getTagCloud();
    });

    vm.removeTagCloud = (obj) => {
      queryStringService.removeFilter(obj.filter);
    };

    vm.addTagCloud = (obj) => {
      queryStringService.addFilter(obj.filter);
    };
  }

})();
(function() {

  angular
    .module('onify')
    .directive('tagCloud', tagCloud);

  function tagCloud() {
    return {
      restrict: 'EA',
      transclude: false,
      templateUrl: 'app/common/directives/widgets/tag-cloud/tag.cloud.template.html',
      controller: "tagCloudController"
    };
  }

})();
(function() {

  angular
    .module('onify')
    .controller('textWidgetController', textWidgetController);

  textWidgetController.$inject = ['$scope'];
  function textWidgetController($scope) {
    let vm = $scope;
  }

})();
(function() {

  angular
    .module('onify')
    .directive('textWidget', textWidget);

  function textWidget() {
    return {
      restrict: 'EA',
      transclude: false,
      templateUrl: 'app/common/directives/widgets/text-widget/text.widget.template.html',
      controller: "textWidgetController"
    };
  }

})();
(function () {

  angular
    .module('onify')
    .controller('actionSelectionController', actionSelectionController);

  actionSelectionController.$inject = ['$scope', 'utils', 'locales', 'itemSelection', 'itemsUtils', 'audit'];

  function actionSelectionController ($scope, utils, locales, itemSelection, itemsUtils, audit) {
    let vm = $scope;

    vm.$watch(() => { return itemSelection.watchChanges(); }, () => {
      const actions = itemSelection.getActiveActions();
      if (actions) {
        vm.activeActions = itemsUtils.groupActions(actions);
      } else {
        vm.activeActions = [];
      }
    });

    vm.addActionAudit = (obj) => {
      const dataItem = utils.getParamByName('item', obj.url);
      const auditObj = {
        'title': obj.name,
        'name': 'Click item action',
        'tag': [
          'action',
          'item'
        ],
        'item': utils.isString(dataItem) ? [dataItem] : dataItem
      };
      if (obj.id) {
        auditObj.data = [];
        auditObj.data.push({
          name: 'id',
          value: obj.id
        });
      }
      audit.add(auditObj);
    };
  }

})();

(function () {

  angular
    .module('onify')
    .directive('actionsSelection', actionSelection);

  actionSelection.$inject = ['config'];

  function actionSelection (config) {
    return {
      restrict: 'EA',
      transclude: false,
      templateUrl: 'app/common/directives/widgets/selection/actions/actions.selection.template.html?v=' + config.version,
      controller: 'actionSelectionController'
    };
  }

})();

(function() {

  angular
    .module('onify')
    .controller('itemsSelectionController', itemsSelectionController);

  itemsSelectionController.$inject = ['$scope', 'locales', 'itemSelection'];
  function itemsSelectionController($scope, locales, itemSelection) {
    let vm = $scope;

    vm.removeSelection = (key) => {
      itemSelection.deselect(key, true);
    };

    vm.$watch( () => { return itemSelection.watchChanges(); }, () =>{
      vm.activeSelection = itemSelection.getNames();
    });
  }

})();

(function() {

  angular
    .module('onify')
    .directive('itemsSelection', itemsSelection);

  function itemsSelection() {
    return {
      restrict: 'EA',
      transclude: false,
      templateUrl: 'app/common/directives/widgets/selection/items/items.selection.template.html',
      controller: "itemsSelectionController"
    };
  }

})();